export default {
  common: {
    actions: {
      save: 'Guardar',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      delete: 'Eliminar',
      edit: 'Editar',
      add: 'Agregar',
      close: 'Cerrar',
      back: 'Volver',
      next: 'Avanzar',
      finish: 'Finalizar',
      search: 'Buscar',
      filter: 'Filtrar',
      clear: 'Limpiar',
      download: 'Descargar',
      upload: 'Subir',
      copy: 'Copiar',
      duplicate: 'Duplicar',
      view: 'Ver',
      send: 'Enviar',
      resend: 'Reenviar',
      activate: 'Activar',
      deactivate: 'Desactivar',
      block: 'Bloquear',
      unblock: 'Desbloquear',
      approve: 'Aprobar',
      reject: 'Rechazar',
      import: 'Importar',
      export: 'Exportar',
      remove: 'Quitar',
      create: 'Crear',
      update: 'Actualizar',
      yes: 'Sí',
      no: 'No',
      ok: 'Ok',
      retry: 'Intentar de nuevo',
      refresh: 'Actualizar',
      addAnother: 'Agregar otro'
    },
    fields: {
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      document: 'Documento',
      cpf: 'CPF',
      cnpj: 'CNPJ',
      cpfOrCnpj: 'CPF/CNPJ',
      birthDate: 'Fecha de nacimiento',
      date: 'Fecha',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin',
      description: 'Descripción',
      observation: 'Observación',
      type: 'Tipo',
      status: 'Estado',
      value: 'Valor',
      code: 'Código',
      country: 'País',
      state: 'Estado',
      city: 'Ciudad',
      zipCode: 'Código postal',
      address: 'Dirección',
      number: 'Número',
      complement: 'Complemento',
      neighborhood: 'Barrio',
      period: 'Período',
      bank: 'Banco',
      agency: 'Agencia',
      account: 'Cuenta',
      digit: 'Dígito',
      pixKey: 'Clave Pix',
      notes: 'Notas',
      optional: 'Opcional'
    },
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
      pending: 'Pendiente',
      approved: 'Aprobado',
      rejected: 'Rechazado',
      cancelled: 'Cancelado',
      completed: 'Completado',
      processing: 'En procesamiento',
      waiting: 'Esperando',
      loading: 'Cargando...',
      noData: 'No se encontraron datos',
      noResults: 'No se encontraron resultados'
    },
    empty: {
      title: 'No se encontraron registros',
      subtitle: 'No hay datos para los filtros seleccionados.',
      noFilters: 'No hay registros registrados.'
    },
    tooltips: {
      copy: 'Copiar',
      copied: '¡Copiado!',
      download: 'Descargar documento',
      remove: 'Quitar',
      edit: 'Editar',
      view: 'Ver',
      add: 'Agregar',
      filter: 'Filtrar',
      closeToast: 'Cerrar'
    },
    confirm: {
      deleteTitle: '¿Eliminar registro?',
      deleteSubtitle: 'Esta acción no se puede deshacer.',
      unsavedTitle: '¿Salir sin guardar?',
      unsavedSubtitle: 'Se perderán todos los cambios no guardados, ¿desea continuar?'
    },
    feedback: {
      savedSuccess: 'Información guardada con éxito.',
      deletedSuccess: 'Registro eliminado con éxito.',
      copiedSuccess: '¡Copiado al portapapeles!',
      requiredFields: 'Hay campos obligatorios sin completar',
      loadError: 'No fue posible cargar los datos. Actualice la página (F5).',
      saveError: 'No fue posible guardar. Verifique los datos e intente de nuevo.'
    },
    filters: {
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin',
      type: 'Tipo',
      status: 'Estado',
      bank: 'Banco',
      corban: 'Corban',
      personType: 'Tipo de persona',
      cpfCnpj: 'CPF/CNPJ',
      nature: 'Naturaleza',
      operation: 'Operación',
      period: 'Período'
    },
    pagination: {
      rowsPerPage: 'Elementos por página',
      of: 'de',
      all: 'Todos'
    },
    time: {
      now: 'ahora',
      minuteAbbr: 'min',
      hourAbbr: 'h',
      dayAbbr: 'd'
    }
  },

  validation: {
    required: 'Este campo es obligatorio',
    email: 'Correo electrónico inválido',
    minLength: 'Mínimo de {min} caracteres',
    maxLength: 'Máximo de {max} caracteres',
    cpf: 'CPF inválido',
    cnpj: 'CNPJ inválido',
    cpfOrCnpj: 'CPF o CNPJ inválido',
    phone: 'Teléfono inválido',
    zipCode: 'Código postal inválido',
    passwordMatch: 'Las contraseñas deben ser iguales',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    numeric: 'Solo se permiten números',
    positiveValue: 'El valor debe ser mayor que cero',
    percentageRange: 'El porcentaje debe estar entre 0 y 100',
    partnersSum: 'La suma de las participaciones de los socios debe ser igual al 100%',
    fileType: 'Formato no permitido. Use JPEG o PNG.',
    fileSize: 'El archivo no puede superar los 5MB.',
    onlyImages: '¡Solo se aceptan archivos de imagen!',
    swiftFormat: 'Formato SWIFT inválido',
    ibanFormat: 'Formato IBAN inválido',
    stateFormat: 'Use la sigla del estado con 2 caracteres (ej: FL, CA, NY)',
    duimpSum: 'La suma de los valores DUIMP/DU-E no puede ser mayor que la cantidad en M.E. de la operación.',
    ssnFormat: 'Formato SSN/ITIN: XXX-XX-XXXX',
    requiredMultiple: 'Es obligatorio seleccionar al menos una de las opciones',
    requiredRadio: 'Es obligatorio seleccionar una de las opciones',
    emailInvalid: 'Ingrese un correo electrónico válido',
    cpfCnpjInvalid: 'Ingrese un CPF/CNPJ válido',
    cuitInvalid: 'El CUIT/CUIL no es válido. Revise los 11 dígitos',
    requiredCheckbox: 'Es obligatorio aceptar para continuar',
    passwordMin6: 'La contraseña debe tener al menos 6 caracteres',
    phoneCountryRequired: 'El código de país (DDI) es obligatorio',
    phoneInvalidDdi: 'Teléfono inválido para el código de país informado',
    swiftBicLength: 'El código SWIFT/BIC debe tener 8 u 11 caracteres (ej: CHASUS33 o CHASUS33XXX)',
    clabeLength: 'La CLABE debe tener exactamente 18 dígitos',
    debitCardLength: 'El número de tarjeta debe tener exactamente 16 dígitos',
    cvuLength: 'El CVU debe tener exactamente 22 dígitos',
    cbuLength: 'El CBU debe tener exactamente 22 dígitos',
    cvuCbuLength: 'El CVU/CBU debe tener exactamente 22 dígitos',
    postalCodeCountryInvalid: 'Código postal inválido para el país seleccionado (ej: {example})',
    postalCodeGenericInvalid: 'Código postal inválido (mínimo 3 caracteres alfanuméricos)',
    postalCodeNoDigit: 'El código postal debe contener al menos un número'
  },

  http: {
    authErrorUi: {
      noConnection: 'No fue posible conectarse. Verifique su internet e intente nuevamente.',
      unexpected: 'Algo salió mal de nuestro lado. Intente nuevamente en unos instantes.',
      genericProvider: 'ese proveedor'
    },
    apiErrorUi: {
      noServer: 'No fue posible comunicarse con el servidor. Verifique su conexión e intente nuevamente.',
      tooManyRequests: 'Demasiados intentos en poco tiempo. Espere unos minutos e intente nuevamente.',
      unavailable: 'El servicio no está disponible en este momento. Intente nuevamente en unos minutos.'
    },
    connectionUi: {
      offline: 'Su computadora está sin internet. Revise la conexión e intente de nuevo.',
      serverUnreachable: 'No fue posible conectarse con el servidor. Si este mensaje continúa, por favor, contacte al soporte técnico.',
      sessionExpired: 'Su sesión expiró. Inicie sesión nuevamente para acceder al sistema.'
    },
    toastTitles: {
      success: 'Éxito',
      error: 'Atención',
      warning: 'Aviso',
      information: 'Información',
      info: 'Información'
    },
    unauthorized: 'Su sesión expiró. Inicie sesión de nuevo.',
    forbidden: 'No tiene permiso para realizar esta acción.',
    notFound: 'Recurso no encontrado. Actualice la página (F5).',
    tooLarge: 'El archivo es mayor que el límite de 10 MB. Elija un archivo más pequeño.',
    tooManyRequests: 'Demasiados intentos. Espere un momento e intente de nuevo.',
    badGateway: 'Sistema temporalmente no disponible. Intente de nuevo en breve.',
    serviceUnavailable: 'Sistema temporalmente no disponible. Intente de nuevo en breve.',
    timeout: 'El sistema tardó en responder. Espere un momento y verifique si la acción fue completada antes de intentar de nuevo.',
    noConnection: 'No fue posible conectarse a internet. Verifique si su dispositivo está conectado.',
    requestFailed: 'No fue posible completar la acción. Intente de nuevo; si persiste, contacte al soporte.'
  },

  login: {
    emailLabel: 'Correo electrónico',
    passwordLabel: 'Contraseña',
    loginButton: 'Ingresar',
    forgotPassword: 'Olvidé mi contraseña',
    resetInstructions: 'Complete su correo electrónico para que le enviemos el código para restablecer su contraseña',
    sendCodeButton: 'Enviar código de confirmación',
    backButton: 'Volver',
    codeInstructions: 'Ingrese el código recibido en el correo {email}',
    codeLabel: 'Código de confirmación',
    confirmButton: 'Confirmar',
    newPasswordInstructions: 'Elija su nueva contraseña.',
    newPasswordLabel: 'Nueva contraseña',
    confirmPasswordLabel: 'Confirme su contraseña',
    saveButton: 'Guardar',
    codeSentSuccess: 'Enviamos el código al correo indicado',
    codeSendError: 'No fue posible enviar el código por correo. Intente de nuevo en unos instantes; si persiste, contacte al soporte.',
    codeInvalid: 'Código no confirmado. Verifique e intente de nuevo',
    passwordChangedSuccess: 'Contraseña cambiada con éxito',
    passwordChangeError: 'No fue posible restablecer la contraseña. Verifique los campos',
    credentialsRequired: 'Ingrese el correo y contraseña para acceder.'
  },

  menu: {
    breadcrumbNavUi: {
      newProfile: 'Nuevo perfil',
      editProfile: 'Editar perfil'
    },
    sections: {
      main: 'PRINCIPAL',
      operational: 'OPERACIONAL',
      reports: 'INFORMES',
      registrations: 'REGISTROS',
      administration: 'ADMINISTRACIÓN',
      others: 'OTROS'
    },
    items: {
      home: 'Inicio',
      dashboard: 'Panel',
      customers: 'Clientes',
      customerFlow: 'Flujo de registro',
      operations: 'Operaciones',
      preSale: 'Preventa',
      operationalReports: 'Informes operacionales',
      internationalRemittances: 'Remesas internacionales',
      profitRemittances: 'Ganancia / Remesas internacionales',
      touristExchange: 'Cambio turismo',
      stablecoinReports: 'Informes Stablecoin',
      duimpManagement: 'Gestión DUIMP/DU-E',
      corban: 'Corban',
      registrationsMenu: 'Registros',
      commissions: 'Comisiones',
      operationalRegistrations: 'Registros operacionales',
      operationNatures: 'Naturalezas de operación',
      banks: 'Bancos',
      spreadCurrencies: 'Spread / Monedas',
      paymentMethods: 'Métodos de pago',
      quotationApis: 'APIs de cotización',
      templates: 'Plantillas',
      users: 'Usuarios',
      profiles: 'Perfiles',
      audit: 'Auditoría',
      generateInvoices: 'Generar Facturas',
      exchangeClosing: 'Cierre mensual'
    },
    customerItems: {
      myWallets: 'Mis Billeteras',
      home: 'Inicio',
      myAccount: 'Mi Cuenta',
      myOperations: 'Mis Operaciones',
      newOperation: 'Nueva Operación'
    },
    topbar: {
      whatsapp: 'WhatsApp',
      whatsappUnread: 'WhatsApp ({count} no leídos)',
      latestUpdates: 'Últimas Actualizaciones',
      pinSidebar: 'Fijar el menú abierto (empuja el contenido)',
      unpinSidebar: 'Desfijar el menú (vuelve a abrirse al pasar el mouse)'
    },
    avatar: {
      title: 'Cambiar foto',
      choosePhoto: 'Elegir foto',
      save: 'Guardar',
      cancel: 'Cancelar',
      updatedSuccess: 'Foto actualizada con éxito.',
      formatError: 'Formato no permitido. Use JPEG o PNG.',
      sizeError: 'El archivo no puede superar los 5MB.',
      uploadError: 'No fue posible guardar la foto. Verifique los datos e intente de nuevo.'
    },
    language: {
      label: 'Idioma',
      tooltip: 'Seleccionar idioma'
    },
    notifications: {
      title: 'Notificaciones',
      tooltip: 'Notificaciones',
      select: 'Seleccionar',
      selectedCount: '{count} seleccionado | {count} seleccionados',
      markAsRead: 'Marcar como leído',
      markAsUnread: 'Marcar como no leído',
      delete: 'Eliminar',
      emptyTitle: 'Todo al día',
      emptySubtitle: 'No tiene notificaciones',
      newSection: 'Nuevas',
      previousSection: 'Anteriores',
      loading: 'Cargando…',
      loadMore: 'Cargar más',
      markAllRead: 'Marcar todas como leídas',
      viewHistory: 'Ver historial'
    },
    userMenu: {
      calculationMemory: 'Memoria de cálculo',
      changeTheme: 'Cambiar tema',
      settings: 'Configuraciones',
      emailsSent: 'Correos enviados',
      changePassword: 'Cambiar Contraseña',
      accessMethods: 'Formas de acceso',
      changePhoto: 'Cambiar Foto',
      firstSteps: 'Primeros Pasos',
      support: 'Soporte',
      logout: 'Salir'
    },
    changePassword: {
      title: 'Cambiar Contraseña',
      currentPasswordLabel: 'Contraseña actual',
      currentPasswordRequired: 'Ingrese la contraseña actual para continuar',
      newPasswordLabel: 'Nueva Contraseña',
      newPasswordRequired: 'Ingrese la nueva contraseña para continuar',
      confirmPasswordLabel: 'Confirme su contraseña',
      confirmPasswordRequired: 'Confirme la nueva contraseña para continuar',
      save: 'Guardar',
      cancel: 'Cancelar',
      successMessage: 'Contraseña cambiada con éxito',
      errorMessage: 'No fue posible cambiar la contraseña. Verifique los datos e intente de nuevo.',
      passwordMismatch: 'Las contraseñas deben ser iguales'
    },
    calculationMemory: {
      title: 'Memoria de cálculo',
      close: 'Cerrar',
      exampleLabel: 'Ejemplo',
      grossProfit: {
        term: 'Ganancia bruta',
        desc: 'Total de la operación - ganancia del banco',
        example: 'Total operado 100 - Ganancia del banco 20 = Ganancia bruta 80'
      },
      corban: {
        term: 'Corban',
        desc: 'Ganancia neta * % comisión del corban',
        example: 'Ganancia neta 60 * comisión Corban 10% = Ganancia del Corban 6'
      },
      corbanIndicator: {
        term: 'Corban indicador',
        desc: 'Ganancia neta * % comisión del indicador',
        example: 'Ganancia neta 60 * comisión Indicador 5% = Ganancia del Indicador 3'
      },
      operationTotal: {
        term: 'Total de la operación',
        forRemittance: 'Para remesa',
        forRemittanceDesc: 'Cantidad de ME * tasa del cliente',
        forRemittanceExample: 'Cantidad ME 1000 * Tasa del cliente 5,50 = Total de la Operación 5500',
        forExchange: 'Para cambio',
        forExchangeDesc: 'Cantidad de ME * tasa del cliente sin IOF',
        forExchangeExample: 'Cantidad ME 1000 * Tasa del cliente sin IOF 5,30 = Total de la Operación 5300'
      },
      pisCofins: {
        term: 'PIS/COFINS',
        desc: 'Ganancia bruta * 0.0465',
        example: 'Ganancia bruta 80 * 0.0465 = 3,72'
      },
      contractCashback: {
        term: 'Cashback del contrato',
        desc: 'Valor del contrato * % de la comisión',
        example: 'Valor del contrato 10000 * comisión 0,5% = Cashback del contrato 50'
      },
      bankProfit: {
        term: 'Ganancia del banco',
        desc: '(1 - % de la comisión) * ganancia bruta',
        example: '1 - comisión 25% * Ganancia bruta 80 = Ganancia del Banco 60'
      },
      masterCorbanProfit: {
        term: 'Ganancia corban master',
        desc: 'Ganancia bruta - ganancia del banco + cashback del contrato',
        example: 'Ganancia bruta 80 - Ganancia del banco 60 + Cashback del contrato 50 = Ganancia Corban Master 70'
      }
    },
    preSale: {
      openOperations: 'Tiene {count} operación abierta | Tiene {count} operaciones abiertas'
    },
    signupLink: {
      referClient: 'Referir cliente',
      signupLink: 'Enlace de registro'
    },
    simulate: {
      open: 'Simular operación',
      active: 'Simulando operación'
    },
    breadcrumb: {
      myWallets: 'Mis billeteras',
      home: 'Inicio',
      dashboard: 'Panel',
      customers: 'Clientes',
      newCustomer: 'Nuevo Cliente',
      editCustomer: 'Editar Cliente',
      customerFlow: 'Flujo de Registro',
      operations: 'Operaciones',
      preSale: 'Preventa',
      internationalRemittances: 'Remesas Internacionales',
      profitRemittances: 'Ganancia / Remesas',
      exchangeClosing: 'Cierre mensual',
      operationDetail: 'Detalle de la Operación',
      touristExchange: 'Cambio Turismo',
      stablecoinRemittances: 'Remesas Stablecoin',
      stablecoinProfit: 'Ganancia Stablecoin',
      duimpManagement: 'Gestión DUIMP/DU-E',
      corban: 'Corban',
      commissions: 'Comisiones',
      operationNatures: 'Naturalezas de Operación',
      banks: 'Bancos',
      spreadCurrencies: 'Spread / Monedas',
      paymentMethods: 'Métodos de Pago',
      quotationApis: 'APIs de Cotización',
      templates: 'Plantillas',
      newTemplate: 'Nueva Plantilla',
      createTemplate: 'Crear Plantilla',
      users: 'Usuarios',
      profiles: 'Perfiles',
      audit: 'Auditoría',
      settings: 'Configuraciones',
      notifications: 'Notificaciones',
      emailsSent: 'Correos Enviados',
      whatsappMessages: 'Mensajes WhatsApp',
      whatsapp: 'WhatsApp',
      newOperation: 'Nueva Operación',
      myOperations: 'Mis Operaciones',
      myAccount: 'Mi Cuenta',
      editCorban: 'Editar Corban',
      newCorban: 'Nuevo Corban',
      authorization: 'Autorización',
      editBank: 'Editar Banco',
      newBank: 'Nuevo Banco',
      editTemplate: 'Editar Plantilla'
    }
  },

  customerAccess: {
    wallets: {
      title: 'Mis billeteras',
      walletName: 'Billetera {position}',
      network: 'Red {network}',
      addressHint: 'Dirección abreviada de la billetera',
      available: 'Disponible',
      leaving: 'Saliendo en un envío',
      leavingTotal: '{amount} saliendo en envíos en curso',
      totalAvailable: 'Saldo disponible total',
      totalHint: 'Suma de las monedas digitales en dólares · actualizado a las {time}',
      updatedAt: 'Actualizado a las {time}',
      refresh: 'Actualizar',
      refreshed: 'Actualizado',
      tryAgain: 'Intentar de nuevo',
      viewWallets: 'Ver billeteras',
      emptyTitle: 'Aún no hay billeteras',
      empty: 'Las billeteras aparecen aquí después de la aprobación de su registro en operaciones digitales.',
      loadError: 'No fue posible cargar los saldos ahora. Actualice la página en unos minutos.',
      inReviewMessage: 'Su billetera se crea en cuanto se apruebe el registro.',
      unavailableMessage: 'No pudimos consultar este saldo ahora. Su dinero no fue afectado. Intente actualizar en unos minutos.',
      footnote: 'Los saldos pueden tardar hasta 1 minuto en actualizarse después de una entrada o de un envío.',
      status: {
        ready: 'Activa',
        inReview: 'En análisis',
        unavailable: 'Sin respuesta'
      }
    },
    home: {
      greeting: 'Hola, {name}',
      myOperations: 'Mis operaciones',
      noOperations: 'No se encontraron operaciones',
      viewOperations: 'Ver operaciones',
      noLimit: 'Sin límite disponible',
      noLimitDescription: 'No tiene límite disponible en ningún banco.',
      noLimitRequest: 'Solicite a su corresponsal un nuevo límite para volver a operar.',
      myLimits: 'Mis límites',
      newOperation: 'Realizar operación',
      loadBanksError: 'No fue posible cargar sus bancos y límites. Actualice la página (F5).',
      loadOperationsError: 'No fue posible cargar sus operaciones recientes. Actualice la página (F5).',
      loadPreSaleError: 'No fue posible cargar sus preventas recientes. Actualice la página (F5).'
    },
    operations: {
      title: 'Nueva operación',
      steps: {
        operationType: 'Tipo de operación',
        operationDetails: 'Detalles de la operación',
        quotation: 'Cotización',
        summary: 'Resumen',
        documents: 'Documentos de la operación',
        created: 'Operación registrada'
      },
      buttons: {
        finish: 'Finalizar',
        newOperation: 'Nueva',
        next: 'Avanzar',
        close: 'Cerrar',
        back: 'Volver'
      },
      quotationTimer: 'Cotización válida por los próximos {seconds} segundos',
      loadCurrenciesError: 'No fue posible cargar la lista de monedas. Actualice la página (F5).',
      loadCustomerError: 'No fue posible cargar sus datos de cliente. Actualice la página (F5).',
      loadBanksError: 'No fue posible cargar la lista de bancos disponibles para usted. Actualice la página (F5).',
      loadQuotationError: 'No fue posible cargar la cotización de la moneda. Intente de nuevo.',
      loadDollarError: 'No fue posible cargar la cotización del dólar. Intente de nuevo.',
      submitError: 'No fue posible enviar su solicitud de operación. Verifique los datos e intente de nuevo.',
      bankLimitExceeded: 'La operación supera el límite disponible {limit}'
    },
    account: {
      title: 'Mi Cuenta',
      tabs: {
        personalData: 'Datos de registro',
        partners: 'Socios',
        bankAccounts: 'Datos bancarios',
        documents: 'Documentos'
      },
      save: 'Guardar',
      cancel: 'Cancelar',
      unsavedConfirm: 'Se perderán todos los cambios no guardados, ¿desea continuar?',
      unsavedTitle: '¿Salir sin guardar?',
      loadError: 'No fue posible cargar los datos de su cuenta. Actualice la página (F5).',
      requiredFields: 'Hay campos obligatorios sin completar',
      savedSuccess: 'Información actualizada',
      saveError: 'No fue posible guardar los datos de su cuenta. Verifique los datos e intente de nuevo.'
    },
    retrospective: {
      title: 'Su retrospectiva {year}',
      bannerTitle: 'Su retrospectiva {year}',
      bannerText: 'Vea hasta dónde ya llegó su dinero este año.',
      open: 'Ver retrospectiva',
      yourYear: 'Su {year}',
      moved: 'Hasta ahora, usted movió',
      operations: '{n} operación concluida | {n} operaciones concluidas',
      countries: 'Su dinero llegó a {n} país | Su dinero llegó a {n} países',
      noCountries: 'Su dinero viajó este año',
      bestMonth: 'Su mejor mes hasta ahora',
      thanks: 'Gracias por seguir con nosotros',
      thanksText: 'Vamos a llevar su dinero aún más lejos.',
      next: 'Continuar'
    },
    journey: {
      received: 'Pedido recibido',
      processing: 'Procesando',
      processed: 'Procesado',
      done: 'Concluido'
    },
    detail: {
      sections: {
        customer: 'Cliente',
        operationNature: 'Naturaleza de la operación',
        bankAccount: 'Cuenta bancaria',
        intermediary: 'Intermediario',
        values: 'Valores',
        others: 'Otros'
      },
      fields: {
        code: 'Código:',
        name: 'Nombre:',
        cpfCnpj: 'CPF/CNPJ:',
        bank: 'Banco:',
        agency: 'Agencia:',
        account: 'Cuenta:',
        swift: 'SWIFT:',
        accountNumber: 'CUENTA:',
        holder: 'Titular:',
        routingAba: 'ROUTING/ABA:',
        ffc: 'FFC (For Further Credit):',
        iban: 'IBAN:',
        swiftBic: 'Código Swift/BIC:',
        status: 'Estado',
        bankLabel: 'Banco',
        operationDate: 'Fecha de operación',
        exchangeRate: 'Tipo de cambio:',
        iof: 'IOF:',
        ir: 'IR:',
        cide: 'CIDE:',
        tariff: 'Tarifa:',
        vet: 'VET:',
        createdAt: 'Fecha de creación:',
        observationLabel: 'Observación:',
        operationLabel: 'Op:'
      },
      operationTypes: {
        receive: 'Recibir',
        send: 'Enviar'
      },
      back: 'Volver',
      operationIdMissing: 'ID de la operación no proporcionado',
      loadError: 'No fue posible cargar los datos de la operación. Vuelva a la lista y abra la operación de nuevo.'
    },
    report: {
      title: 'Mis operaciones',
      incomeTaxExtract: 'Extracto para IR',
      tabs: {
        inProgress: 'En curso',
        completed: 'Finalizadas'
      },
      empty: {
        inProgressTitle: 'No se encontraron operaciones',
        inProgressSubtitle: 'No hay operaciones para los filtros seleccionados.',
        completedTitle: 'No se encontraron operaciones finalizadas',
        completedSubtitle: 'No hay operaciones finalizadas para los filtros seleccionados.'
      },
      cancelledAlert: 'Una operación recibe el estado de <b>Cancelada</b> cuando no cumple los criterios exigidos o cuando su análisis no se concluye en el plazo estipulado.',
      loadOperationsError: 'No fue posible cargar sus operaciones. Actualice la página (F5).',
      searchLabel: 'Buscar operación',
      searchPlaceholder: 'Número, moneda, monto o banco',
      loadSketchesError: 'No fue posible cargar sus preventas. Actualice la página (F5).',
      sketchStatus: {
        cancelled: 'Cancelada',
        pending: 'Esperando',
        inReview: 'En análisis'
      }
    },
    bankSearch: {
      placeholder: 'Ingrese el nombre de la cuenta bancaria',
      tooltip: 'Buscar cuenta bancaria'
    },
    bankCard: {
      accountName: 'Nombre de la cuenta',
      fields: {
        holder: 'Titular',
        bank: 'Banco',
        agency: 'Agencia',
        checkingAccount: 'Cuenta corriente',
        pix: 'Pix',
        iban: 'IBAN',
        swiftBic: 'Código Swift/BIC',
        routingAba: 'Número ABA/Routing',
        ffc: 'For Further Credit'
      }
    },
    intermediaryBank: {
      title: 'Banco intermediario',
      fields: {
        country: 'País',
        bankName: 'Nombre del banco',
        swiftBic: 'Código Swift/BIC'
      }
    },
    bankLimitCard: {
      limitsAvailable: 'Límites disponibles',
      limitAvailable: 'Límite disponible',
      inOut: 'Entrada / Salida',
      in: 'Entrada',
      out: 'Salida',
      expired: 'Vencido',
      available: 'Disponible',
      valid: 'Válido'
    },
    operationCard: {
      viewOperation: 'Ver operación'
    },
    filterDrawer: {
      title: 'Filtro',
      operationType: 'Tipo de Operación',
      exchangeTypes: {
        all: 'Compra/Venta',
        buy: 'Compra',
        sell: 'Venta'
      },
      statusWaiting: 'Esperando',
      statusAnalysis: 'En análisis'
    },
    bankSelector: {
      notFound: 'Ningún banco encontrado',
      notFoundDescription: 'No se encontró ningún banco con el término buscado.',
      bankLabel: 'Banco',
      limitLabel: 'Límite disponible'
    },
    exchangeRates: {
      loadError: 'No fue posible cargar las tasas de cambio. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.'
    },
    operationCreated: {
      title: 'Operación registrada',
      subtitle: 'Su operación fue enviada para <strong>análisis</strong> de su corresponsal bancario.',
      paymentData: 'Datos para el pago',
      paymentDataSubtitle: 'Para efectuar su operación, realice el pago a los datos indicados a continuación.',
      valueToReceive: 'Valor a recibir',
      valueToPay: 'Valor a pagar',
      fields: {
        cnpj: 'CNPJ',
        beneficiary: 'Beneficiario'
      }
    },
    quotationPreview: {
      iofPercent: 'IOF (%)',
      irPercent: 'IR (%)',
      cidePercent: 'CIDE (%)',
      iofValue: 'Valor IOF',
      irValue: 'Valor IR',
      cideValue: 'Valor CIDE',
      vet: 'VET (Valor efectivo total)',
      tariff: 'Tarifa',
      tariffUsd: 'Tarifa ({amount})',
      valueToReceive: 'Valor a recibir',
      valueToPay: 'Valor a pagar'
    },
    quotationStep: {
      valueToSend: 'Valor que deseo enviar',
      valueToReceive: 'Valor que recibiré'
    },
    resumeStep: {
      title: 'Revise la información antes de continuar'
    },
    typeStep: {
      outOfHours: 'Fuera del horario de operación',
      outOfHoursDescription: 'El horario para realizar esta operación en línea es de lunes a viernes, de las {min}h a las {max}h',
      outOfHoursContact: 'Por favor, intente de nuevo dentro de este período o',
      outOfHoursContactLink: '¡hable con nuestro equipo!',
      question: '¿Qué desea realizar?',
      bankQuestion: '¿Con qué banco desea operar?',
      bankStatus: {
        inactive: 'Inactivo',
        noLimit: 'Sin límite',
        expired: 'Expirado'
      },
      bankStatusSeparator: ' y '
    },
    detailsStep: {
      operationQuestion: '¿Cuál es la operación pretendida?',
      operationTypeLabel: 'Tipo de operación',
      accountQuestion: 'Seleccione la cuenta que {direction} el dinero',
      accountDirectionOut: 'saldrá',
      accountDirectionIn: 'recibirá',
      notFound: 'No se encontró ninguna cuenta',
      notFoundDescription: 'No se encontró ninguna cuenta con el término buscado.'
    },
    noAccountsAlert: {
      titleNational: 'Sin cuenta en Brasil',
      titleInternational: 'Sin cuenta en el exterior',
      descriptionNational: 'No tiene una cuenta en Brasil registrada. Registre una cuenta para operar.',
      descriptionInternational: 'No tiene una cuenta en el exterior registrada. Registre una cuenta para operar.',
      registerNow: 'Registrar ahora'
    }
  },

  stablecoin: {
    paymentStatusRetryUi: {
      approvalNeeded: 'El cliente necesita autorizar este nuevo envío en su billetera. {email} En cuanto lo apruebe, el pago se realiza automáticamente.',
      approvalEmailSent: 'Enviamos el enlace al correo electrónico del cliente.',
      approvalEmailPending: 'El correo con el enlace no se envió ahora; el sistema lo intentará de nuevo en unos minutos.'
    },
    remittanceApprovalPendingStatusUi: {
      label: 'Nueva aprobación'
    },
    stablecoinConstantsUi: {
      accountPurpose: {
        businessExpenses: 'Gastos comerciales',
        ecommerceRetailPayments: 'Pagos de e-commerce/minoristas',
        investmentPurposes: 'Inversiones',
        receivePayments: 'Recibir pagos por bienes/servicios',
        purchaseGoods: 'Comprar bienes y servicios',
        personalLiving: 'Gastos personales o de subsistencia',
        protectWealth: 'Proteger el patrimonio',
        paymentsAbroad: 'Pagos a amigos/familiares en el exterior',
        taxOptimization: 'Optimización fiscal',
        charitable: 'Donaciones benéficas',
        thirdPartyMoneyTransmission: 'Transmisión de dinero a terceros',
        payroll: 'Nómina de sueldos',
        treasuryManagement: 'Gestión de tesorería',
        other: 'Otro'
      },
      businessType: {
        soleProprietorship: 'Empresa unipersonal',
        partnership: 'Sociedad',
        corporation: 'Corporación',
        llc: 'LLC (Sociedad de responsabilidad limitada)',
        nonProfit: 'Sin fines de lucro',
        other: 'Otro'
      },
      businessIndustry: {
        naics111998: 'Otros Cultivos Agrícolas Diversos',
        naics112120: 'Cría de Ganado Lechero y Producción de Leche',
        naics113310: 'Extracción de Madera',
        naics115114: 'Actividades Poscosecha',
        naics211120: 'Extracción de Petróleo Crudo',
        naics212114: 'Minería de Carbón a Cielo Abierto',
        naics213112: 'Actividades de Apoyo a la Explotación de Petróleo y Gas',
        naics221310: 'Suministro de Agua y Sistemas de Riego',
        naics236115: 'Construcción de Viviendas Unifamiliares Nuevas',
        naics236220: 'Construcción de Edificios Comerciales e Institucionales',
        naics237310: 'Construcción de Carreteras, Calles y Puentes',
        naics238210: 'Contratistas de Instalaciones Eléctricas',
        naics311421: 'Conservas de Frutas y Verduras',
        naics312130: 'Bodegas Vitivinícolas',
        naics313110: 'Hilado de Fibras, Hilos e Hilados',
        naics315990: 'Accesorios y Otros Artículos de Vestir',
        naics322220: 'Fabricación de Bolsas de Papel y Papel Tratado',
        naics325412: 'Fabricación de Preparados Farmacéuticos',
        naics334111: 'Fabricación de Computadoras Electrónicas',
        naics334118: 'Fabricación de Terminales y Periféricos de Computadoras',
        naics334210: 'Fabricación de Aparatos Telefónicos',
        naics336110: 'Fabricación de Automóviles y Vehículos Livianos',
        naics336390: 'Fabricación de Otros Componentes para Vehículos',
        naics337121: 'Fabricación de Muebles Tapizados para el Hogar',
        naics339112: 'Fabricación de Instrumentos Quirúrgicos y Médicos',
        naics339910: 'Fabricación de Joyas y Artículos de Plata',
        naics339920: 'Fabricación de Artículos Deportivos',
        naics339930: 'Fabricación de Muñecas, Juguetes y Juegos',
        naics423110: 'Venta Mayorista de Automóviles y Vehículos Motorizados',
        naics423430: 'Venta Mayorista de Computadoras y Periféricos',
        naics423510: 'Centros de Servicio y Venta Mayorista de Metales',
        naics423690: 'Venta Mayorista de Otros Componentes Electrónicos',
        naics423830: 'Venta Mayorista de Maquinaria y Equipos Industriales',
        naics423840: 'Venta Mayorista de Suministros Industriales',
        naics423940: 'Venta Mayorista de Joyas y Piedras Preciosas',
        naics424210: 'Venta Mayorista de Medicamentos y Productos Farmacéuticos',
        naics424410: 'Venta Mayorista de Alimentos en General',
        naics424480: 'Venta Mayorista de Frutas y Verduras Frescas',
        naics424690: 'Venta Mayorista de Otros Productos Químicos',
        naics424990: 'Venta Mayorista de Otros Bienes No Durables Diversos',
        naics444110: 'Tiendas de Materiales para el Hogar y la Construcción',
        naics445110: 'Supermercados y Otros Almacenes',
        naics445320: 'Tiendas de Bebidas Alcohólicas',
        naics446120: 'Tiendas de Cosméticos, Perfumes y Productos de Belleza',
        naics449210: 'Tiendas de Electrónica y Electrodomésticos',
        naics454110: 'Comercio Electrónico y Ventas por Catálogo',
        naics455110: 'Tiendas por Departamentos',
        naics455219: 'Otros Minoristas de Mercaderías en General',
        naics456110: 'Farmacias y Droguerías',
        naics456120: 'Minoristas de Cosméticos y Perfumes',
        naics457110: 'Estaciones de Servicio con Tienda de Conveniencia',
        naics458110: 'Tiendas de Ropa y Accesorios',
        naics458210: 'Zapaterías',
        naics458310: 'Joyerías',
        naics459120: 'Tiendas de Pasatiempos, Juguetes y Juegos',
        naics459210: 'Librerías y Puestos de Diarios',
        naics481111: 'Transporte Aéreo Regular de Pasajeros',
        naics483111: 'Transporte Marítimo Internacional de Carga',
        naics484121: 'Transporte de Cargas por Carretera, Larga Distancia',
        naics485210: 'Transporte por Carretera Interurbano y Rural',
        naics488510: 'Agencias de Transporte de Carga',
        naics493110: 'Almacenamiento y Depósito General',
        naics511210: 'Edición de Software',
        naics512250: 'Producción y Distribución de Grabaciones',
        naics513130: 'Editoriales',
        naics513210: 'Edición de Software',
        naics516120: 'Canales de Televisión',
        naics517111: 'Operadores de Telecomunicaciones por Cable',
        naics517112: 'Operadores de Telecomunicaciones Inalámbricas',
        naics517410: 'Telecomunicaciones Satelitales',
        naics518210: 'Procesamiento de Datos, Alojamiento y Servicios Relacionados',
        naics519130: 'Publicación y Transmisión por Internet',
        naics519290: 'Portales de Búsqueda y Otros Servicios de Información',
        naics522110: 'Bancos Comerciales',
        naics522210: 'Emisión de Tarjetas de Crédito',
        naics522320: 'Procesamiento de Transacciones Financieras',
        naics523150: 'Banca de Inversión e Intermediación de Valores',
        naics523940: 'Gestión de Carteras y Asesoría de Inversiones',
        naics523999: 'Otras Actividades de Inversión Financiera',
        naics524113: 'Aseguradoras de Vida',
        naics531110: 'Alquiler de Inmuebles Residenciales',
        naics531120: 'Alquiler de Inmuebles No Residenciales',
        naics531130: 'Alquiler de Minidepósitos y Guardamuebles',
        naics531190: 'Alquiler de Otros Inmuebles',
        naics531210: 'Corredores Inmobiliarios',
        naics531311: 'Administración de Propiedades Residenciales',
        naics531312: 'Administración de Propiedades No Residenciales',
        naics531320: 'Tasadores de Inmuebles',
        naics531390: 'Otras Actividades Inmobiliarias',
        naics532111: 'Alquiler de Automóviles',
        naics541110: 'Estudios Jurídicos',
        naics541211: 'Estudios Contables',
        naics541213: 'Servicios de Declaración de Impuestos',
        naics541214: 'Servicios de Liquidación de Sueldos',
        naics541219: 'Otros Servicios Contables',
        naics541330: 'Servicios de Ingeniería',
        naics541430: 'Diseño Gráfico',
        naics541511: 'Desarrollo de Software a Medida',
        naics541512: 'Diseño de Sistemas Informáticos',
        naics541519: 'Otros Servicios Informáticos',
        naics541611: 'Consultoría en Gestión Administrativa',
        naics541618: 'Otros Servicios de Consultoría Empresarial',
        naics541715: 'Investigación y Desarrollo en Ciencias',
        naics541810: 'Agencias de Publicidad',
        naics541922: 'Fotografía Comercial',
        naics541930: 'Traducción e Interpretación',
        naics541940: 'Servicios Veterinarios',
        naics541990: 'Otros Servicios Profesionales y Técnicos',
        naics551112: 'Holdings y Sociedades de Participación',
        naics561311: 'Agencias de Empleo y Reclutamiento',
        naics561422: 'Telemarketing y Call Centers',
        naics561499: 'Otros Servicios de Apoyo Empresarial',
        naics561510: 'Agencias de Viajes',
        naics561612: 'Seguridad Privada y Vigilancia',
        naics561730: 'Paisajismo y Jardinería',
        naics561740: 'Limpieza de Alfombras y Tapizados',
        naics562111: 'Recolección de Residuos Sólidos',
        naics562920: 'Reciclaje y Recuperación de Materiales',
        naics611110: 'Escuelas Primarias y Secundarias',
        naics611310: 'Facultades y Universidades',
        naics611410: 'Escuelas de Negocios y Secretariado',
        naics611710: 'Servicios de Apoyo Educativo',
        naics621111: 'Consultorios Médicos',
        naics621210: 'Consultorios Odontológicos',
        naics621399: 'Otros Profesionales de la Salud',
        naics621511: 'Laboratorios de Análisis Clínicos',
        naics621910: 'Servicios de Ambulancia',
        naics622110: 'Hospitales Generales y Quirúrgicos',
        naics623110: 'Residencias Geriátricas y de Cuidados de Enfermería',
        naics623220: 'Centros de Salud Mental y Rehabilitación',
        naics624410: 'Guarderías y Educación Inicial',
        naics711110: 'Compañías de Teatro',
        naics711211: 'Equipos y Clubes Deportivos',
        naics711410: 'Agentes y Representantes Artísticos',
        naics711510: 'Artistas Independientes y Creadores de Contenido',
        naics712110: 'Museos',
        naics713110: 'Parques de Diversiones y Temáticos',
        naics713210: 'Casinos',
        naics721110: 'Hoteles y Moteles',
        naics722511: 'Restaurantes de Servicio Completo',
        naics722513: 'Restaurantes de Comida Rápida',
        naics811111: 'Talleres Mecánicos',
        naics811210: 'Mantenimiento de Equipos Electrónicos',
        naics812111: 'Barberías',
        naics812112: 'Salones de Belleza',
        naics812199: 'Otros Servicios de Cuidado Personal',
        naics813110: 'Organizaciones Religiosas',
        naics813211: 'Fundaciones de Financiamiento y Donaciones',
        naics813219: 'Otros Servicios de Filantropía y Donaciones',
        sector11: 'Agricultura, Silvicultura, Pesca y Caza',
        sector21: 'Minería, Extracción de Petróleo y Gas',
        sector22: 'Servicios Públicos',
        sector23: 'Construcción',
        sector31_33: 'Manufactura',
        sector42: 'Comercio Mayorista',
        sector44_45: 'Comercio Minorista',
        sector48_49: 'Transporte y Almacenamiento',
        sector51: 'Información',
        sector52: 'Finanzas y Seguros',
        sector53: 'Inmuebles y Alquiler',
        sector54: 'Servicios Profesionales, Científicos y Técnicos',
        sector55: 'Gestión de Empresas',
        sector56: 'Servicios Administrativos y de Apoyo',
        sector61: 'Servicios Educativos',
        sector62: 'Asistencia Médica y Social',
        sector71: 'Artes, Entretenimiento y Recreación'
      },
      annualRevenue: {
        lessThan100k: 'Menos de $100.000',
        moreThan10m: 'Más de $10.000.000'
      },
      sourceOfWealth: {
        employment: 'Empleo',
        businessOwnership: 'Propiedad de un negocio',
        investment: 'Inversiones',
        inheritance: 'Herencia',
        realEstate: 'Inmuebles',
        savings: 'Ahorros',
        family: 'Familia',
        other: 'Otro'
      }
    },
    customerApprovalConstantsUi: {
      messages: {
        linkNoLongerValid: 'Este enlace ya no es válido. Si todavía necesita realizar esta operación, comuníquese con quien le envió el enlace.',
        codeSent: 'Código enviado. Revise su bandeja de entrada y la carpeta de spam.',
        codeWait: 'Acabamos de enviarle un código. Espere unos segundos antes de pedir otro.',
        codeWrong: 'Código incorrecto. Revise su correo electrónico e ingréselo nuevamente.',
        codeExpired: 'Este código venció. Pida uno nuevo en "reenvíe el código".',
        tooMany: 'Demasiados intentos. Espere 10 minutos e intente nuevamente.',
        cancelled: 'Usted no aprobó el pago. Cuando quiera, haga clic en Cerrar operación.',
        noConnection: 'Sin conexión con el servidor. Revise su conexión a internet e intente nuevamente. (Ref.: SEM-CONEXAO)',
        debitNotConnected: 'No se conectó ninguna cuenta. La cuenta debe estar a su nombre. Intente de nuevo o pague por transferencia.',
        quoteUpdated: 'Los valores de esta operación se actualizaron. Revise los valores a continuación y haga clic en Cerrar operación.',
        quoteUpdatedSummary: 'La cotización cambió. Haga clic en Continuar para ver los nuevos valores y aprobar nuevamente.',
        approvalChanged: 'La cotización cambió y también la forma de aprobar. Le enviamos un nuevo código a su correo electrónico: ingréselo para ver los nuevos valores y aprobar.',
        approvalChangedCodeFailed: 'La cotización cambió y también la forma de aprobar, pero no pudimos enviarle el nuevo código ahora. Pida uno nuevo en "reenvíe el código".',
        quoteRefreshFailed: 'No fue posible actualizar los valores de la cotización ahora. Antes de aprobar, haga clic en Actualizar valores.',
        quoteUnavailable: 'No fue posible calcular los valores ahora. Intente nuevamente en unos minutos.',
        quoteRefused: 'No fue posible calcular los valores de esta operación. Comuníquese con quien le envió este enlace.',
        paymentUnavailable: 'En este momento no podemos realizar esta operación. Comuníquese con quien le envió este enlace.',
        walletPreparing: 'Estamos preparando su billetera digital. Esto puede demorar unos segundos.',
        walletNotReady: 'No fue posible preparar su billetera digital ahora. Intente nuevamente en unos minutos.',
        walletUnavailable: 'No fue posible preparar su billetera digital. Comuníquese con quien le envió este enlace.',
        newApproval: 'Necesitamos que apruebe esta operación nuevamente. Le llevará menos de un minuto.',
        notConfirmed: 'No pudimos confirmar su aprobación. Haga clic en Cerrar operación nuevamente.',
        generic: 'No fue posible continuar ahora. Intente nuevamente en unos instantes.',
        signing: 'Confirmando en su billetera…'
      },
      pendingType: {
        linkSent: 'Esperando la aprobación del cliente',
        awaitingPayment: 'Esperando el pago del cliente',
        approvalRequired: 'Esperando una nueva aprobación del cliente'
      },
      pendingReason: {
        expired: 'Motivo: la aprobación anterior venció.',
        depositExpired: 'Motivo: venció el plazo del depósito en el socio de pagos.',
        insufficientBalance: 'Motivo: el saldo de la billetera es menor que el valor de la operación.',
        amountChanged: 'Motivo: el valor de la operación cambió.'
      },
      preSaleState: {
        awaitingCustomer: 'Esperando al cliente',
        approved: 'Aprobada por el cliente',
        unknown: 'Estado no disponible'
      },
      notes: {
        escalated: 'El cliente no respondió a los recordatorios y se avisó al equipo.'
      },
      remindResult: {
        sent: 'Recordatorio enviado al cliente.',
        failed: 'El recordatorio no fue enviado. Revise el correo electrónico en el registro del cliente y envíe el recordatorio nuevamente.',
        closed: 'El recordatorio no fue enviado porque el enlace venció o fue cancelado. Si venció, use "Renovar y reenviar enlace"; si fue cancelado, envíe un enlace nuevo desde la pantalla de la operación.',
        escalated: 'El plazo de los recordatorios terminó y se avisó al equipo. Comuníquese con el cliente o reenvíe el recordatorio.',
        unknown: 'No fue posible confirmar el envío del recordatorio. Revise el historial del enlace.'
      },
      reprocessOutcome: {
        queued: 'Envío reanudado. La operación vuelve a la cola de envío en los próximos minutos.',
        alreadyRunning: 'El envío de esta operación ya está en curso. Sígalo en la línea de la operación.',
        funded: 'Envío reanudado.',
        fundingInProgressOrDone: 'El envío ya está en curso o fue completado.',
        fundingWindowExpired: 'El plazo para el envío venció. Reenvíe el recordatorio para que el cliente apruebe nuevamente.',
        noNewApproval: 'El cliente todavía no aprobó nuevamente, así que no hay nada que reanudar. Reenvíe el recordatorio.',
        unknown: 'No fue posible confirmar la reanudación del envío. Revise el estado en la línea de la operación.'
      },
      actionMessages: {
        renewFailed: 'No fue posible reenviar el enlace. Actualice la lista para revisar el estado del enlace e intente nuevamente.',
        remindFailed: 'No fue posible enviar el recordatorio al cliente. Revise el correo electrónico en el registro del cliente e intente nuevamente.',
        reprocessFailed: 'No fue posible reanudar el envío al exterior. Actualice la página para revisar el estado de la operación e intente nuevamente.',
        pendingUnavailable: 'No fue posible verificar qué operaciones esperan una nueva aprobación del cliente. El resto del informe está actualizado.'
      },
      progressStep: {
        paymentCreated: 'Datos de pago generados',
        pixCreated: 'PIX generado',
        transfer: 'Enviando al beneficiario',
        completed: 'Completado: valor enviado al beneficiario',
        completedPayInOnly: 'Completado: valor en la billetera del cliente'
      },
      progressProblem: {
        emailFailed: 'El correo electrónico no salió. Envíe el enlace por WhatsApp.',
        linkExpired: 'El enlace venció antes del pago. Reenvíe el enlace desde Preventa.',
        linkCancelled: 'Enlace cancelado.',
        linkReplaced: 'Este enlace fue reemplazado por uno más nuevo.',
        paymentExpired: 'Los datos de pago ya no son válidos. El cliente puede generar nuevos desde el mismo enlace.',
        pixExpired: 'El PIX ya no es válido. El cliente puede generar otro desde el mismo enlace.',
        refunded: 'Valor devuelto al cliente.',
        transferFailed: 'El envío al beneficiario no avanzó. Véalo en Informes Stablecoin › Remesas internacionales.'
      },
      events: {
        linkEmailed: 'Enlace enviado al correo electrónico del cliente',
        linkEmailFailed: 'El correo electrónico con el enlace no fue enviado',
        linkOpened: 'El cliente abrió el enlace',
        linkExpired: 'El enlace venció',
        emailMismatch: 'Intento de abrir el enlace con otro correo electrónico',
        codeRequested: 'Código solicitado al correo electrónico del cliente',
        codeVerified: 'El cliente confirmó el código del correo electrónico',
        codeFailed: 'El cliente ingresó un código incorrecto',
        approvalPrepared: 'El cliente revisó los valores',
        customerApproved: 'El cliente aprobó la operación',
        approvalRequested: 'El sistema solicitó una nueva aprobación',
        approvalExecuted: 'El valor salió de la billetera del cliente',
        approvalExpired: 'La autorización del cliente venció',
        payinCreated: 'Pago generado (PIX o datos de transferencia)',
        payoutCreated: 'Envío realizado desde la billetera',
        providerRefused: 'El servicio de pagos no aceptó generar el PIX (o los datos de transferencia). La cotización se rehízo con otro y el cliente necesita aprobar los nuevos valores',
        payerAccountConnected: 'El cliente conectó una cuenta en EE. UU. para el débito automático',
        debitAuthorized: 'El cliente autorizó el débito en la cuenta en EE. UU.',
        reminderSent: 'Recordatorio enviado por correo electrónico',
        reminderFailed: 'El recordatorio no fue enviado',
        escalated: 'Equipo avisado porque el cliente no respondió'
      },
      terms: {
        title: 'Términos de la operación',
        approveEachTitle: 'Usted aprueba cada operación',
        approveEachText: 'Antes de pagar, usted revisa los valores y la cuenta de quien recibe, y aprueba la operación. Su aprobación vale solo para estos valores y esta operación, una única vez.',
        checkBeforeTitle: 'Revise antes de aprobar',
        checkBeforeText: 'Usted es responsable de revisar el valor, la moneda y los datos de quien recibe. Una vez confirmado su pago, el valor se envía al destinatario.',
        walletTitle: 'Billetera digital',
        walletText: 'Cuando la operación usa una billetera digital a su nombre, vinculada al correo electrónico de su registro, también le enviamos un código de 6 dígitos a su correo electrónico. Solo usted puede autorizar la salida de valores de ella: la plataforma no mueve el saldo por su cuenta.',
        emailTitle: 'Cuide su correo electrónico',
        emailText: 'Quien tenga acceso a su correo electrónico puede abrir el enlace y aprobar operaciones. No comparta el código ni el enlace de la operación con nadie. Si pierde el acceso a su correo electrónico, comuníquese con quien le envió el enlace antes de realizar nuevas operaciones.',
        partnersTitle: 'Socios',
        partnersText: 'La billetera digital es provista por Privy, nuestra socia tecnológica. El pago y el envío del valor al destinatario los realizan los socios de pago de la operación.',
        recordTitle: 'Registro de su aprobación',
        recordText: 'Guardamos la fecha, la hora, la dirección de internet (IP) y el navegador de su aprobación, junto con los valores y el destinatario que usted aprobó. Usamos su nombre, correo electrónico y los datos de la operación solo para ejecutar y registrar la operación, de acuerdo con la Ley General de Protección de Datos de Brasil (LGPD).',
        changesTitle: 'Cambios',
        changesText: 'Si estos términos cambian, verá la nueva versión para aceptarla antes de la próxima aprobación.'
      }
    },
    approvalEventFormatUi: {
      unknownEvent: 'Paso registrado',
      revokeReplaced: 'reemplazado por un enlace nuevo para el mismo cliente',
      revokeOperator: 'cancelado por el operador',
      revokePresaleRemoved: 'cancelado porque se eliminó la preventa',
      requirementNone: 'sin aprobación en la billetera (pasa directo al PIX)',
      requirementDeposit: 'aprobación solicitada después del PIX',
      scopeCustomer: 'solo para este cliente',
      scopeAll: 'para todos los clientes por unos minutos',
      browserOnSystem: '{browser} en {system}',
      unknownBrowser: 'navegador no identificado',
      firstTime: 'primera vez',
      typedEmail: 'correo ingresado: {email}',
      blankEmail: 'correo en blanco',
      byUser: 'por {name}',
      emailMismatchNote: 'Hubo 1 intento de abrir el enlace con otro correo electrónico. | Hubo {count} intentos de abrir el enlace con otro correo electrónico.',
      reminderNote: '1 recordatorio enviado al cliente. | {count} recordatorios enviados al cliente.'
    },
    stablecoinFormattersUi: {
      status: {
        deprecated: 'Obsoleto',
        complianceRequest: 'Revisión de compliance pendiente',
        partiallyRejected: 'Aprobación parcial pendiente',
        active: 'Activa',
        inactive: 'Inactiva',
        verified: 'Verificada',
        accepted: 'Aceptado',
        linked: 'Vinculado',
        expired: 'Vencido'
      }
    },
    digitalQuotationConstantsUi: {
      walletPreparing: 'Preparando la billetera digital del cliente. Esto puede demorar unos segundos…',
      walletGaveUp: 'No fue posible preparar la billetera del cliente ahora. Intente nuevamente en unos minutos.',
      autoRenewStopped: 'La cotización venció y ya no se renueva automáticamente. Para continuar, haga clic en Nueva cotización.',
      providerRefusedPayin: 'El proveedor no aceptó este pago ahora. La cotización se rehízo con otro: revise los valores y genere nuevamente.',
      providerRefusedPayout: 'El proveedor no aceptó este pago ahora. La cotización se rehízo con otro: revise los valores y envíe nuevamente.'
    },
    payoutOnlyFlowUi: {
      loadingBalance: 'Consultando el saldo de la billetera...',
      balanceUnavailable: 'Saldo de la billetera no disponible ahora — revíselo en la cotización',
      noBalance: 'Billetera sin saldo. Primero haga un ingreso en la pestaña Pay-in',
      availableBalance: 'Saldo disponible: {balances}'
    },
    paymentStatusBankAccountCardUi: {
      swiftCode: 'Código Swift/BIC'
    },
    paymentStatusDetailsUi: {
      provider: 'Proveedor',
      payOutBlocked: 'Salida retenida para revisión. Esta salida no se volverá a enviar hasta que el equipo la revise.'
    },
    stablecoinLimitsDialogUi: {
      operationNumber: 'Operación #{id}'
    },
    pixPaymentPanelUi: {
      transferFallback: 'transferencia'
    },
    customerOperationApprovalUi: {
      secureEnvironment: 'Entorno seguro',
      brandBy: 'by {name}',
      processedByProvider: 'Pago procesado por el PSAV autorizado {provider}',
      linkUnavailable: 'Enlace no disponible',
      linkValidUntil: 'Enlace válido hasta {date}',
      copyUnavailable: 'No se pudo copiar automáticamente. Dejamos el código seleccionado: tóquelo y elija Copiar.',
      paymentDone: 'Pago realizado',
      pageTitle: 'Confirmar operación'
    },
    receiverPendingIssuesModalUi: {
      pathWithProblem: '{path} con problema.'
    },
    operationDetail: {
      loadErrorTitle: 'No fue posible cargar la operación',
      loadErrorMessage: 'No fue posible cargar los datos de la operación #{id}.',
      operationTitle: 'Operación #{id}',
      buy: 'Compra',
      sell: 'Venta',
      relaunch: 'Relanzar operación',
      changeHistoryTitle: 'Cambios en la operación',
      loadError: 'Los datos de la operación no cargaron. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
      changeHistoryError: 'No fue posible cargar los cambios de la operación. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.'
    },

    tosCallback: {
      processing: 'Procesando aceptación de términos...',
      redirecting: 'Espere, será redirigido automáticamente.'
    },

    approval: {
      // Pay-in pelo link: compra de USDC para a carteira do cliente
      payIn: {
        summarySubtitle: 'Compra de USDC para su billetera. Revise antes de continuar.',
        summaryCaption: 'Usted recibe en {currency} en su billetera. El monto exacto aparece en el siguiente paso, con la cotización.',
        youReceive: 'Usted recibe en su billetera',
        walletLabel: 'Su billetera',
        walletOwner: 'A su nombre. Solo usted la mueve.',
        approveTitle: 'Confirme la compra',
        approveSubtitle: 'Revise cuánto paga y cuánto entra en su billetera.',
        confirmButton: 'Confirmar compra',
        authorizationText: 'Al confirmar, generamos el PIX. Cuando se pague, los USDC entran en su billetera. No hace falta firmar en la billetera, porque el dinero solo entra en ella.',
        debitAuthorizationText: 'Al confirmar, solicitamos el débito a su banco. Cuando llegue el valor, los USDC entran en su billetera. No hace falta firmar en la billetera, porque el dinero solo entra en ella.',
        pixDestination: 'Después del pago, {amount} entran en su billetera.',
        stageProcessingMessage: 'Estamos comprando sus USDC. Entran en su billetera en instantes. Puede cerrar esta página: le avisamos por correo cuando termine.',
        stageDelayed: 'Compra en curso',
        stageDelayedMessage: 'Su pago ya fue recibido, pero la compra está tardando más de lo normal. No necesita hacer nada: le avisamos por correo cuando los USDC entren en su billetera.',
        stageDone: 'USDC en su billetera',
        stageDoneMessage: 'La compra se completó y el valor ya está en su billetera. No necesita hacer nada más.',
        valueCredited: 'USDC en su billetera',
        received: 'Usted recibió',
        paid: 'Usted pagó'
      },
      payOut: {
        summarySubtitle: 'Envío desde su billetera a la cuenta de abajo. Revise antes de continuar.',
        youSend: 'Sale de su billetera',
        approveTitle: 'Confirme el envío',
        approveSubtitle: 'Revise cuánto sale de su billetera y cuánto llega a la cuenta.',
        confirmButton: 'Confirmar envío',
        authorizationText: 'Al confirmar, autorizamos este envío desde su billetera a la cuenta de arriba, por estos valores. Una vez enviado, no se puede deshacer por aquí.',
        approved: 'Envío aprobado',
        stageProcessing: 'Envío aprobado',
        received: 'Llegó a la cuenta',
        sent: 'Salió de su billetera',
        stageProcessingMessage: 'Estamos enviando el valor a la cuenta de destino. Puede cerrar esta página.',
        stageDelayed: 'Envío en curso',
        stageDelayedMessage: 'El envío está tardando más de lo normal. Quien le envió este enlace hace el seguimiento y le contactará si necesita algo.',
        stageDoneMessage: 'El valor fue enviado a la cuenta de destino. No necesita hacer nada más.'
      },
      enterCode: 'Ingrese el código',
      approvePayment: 'Apruebe el pago',
      emailLabel: 'Su correo electrónico',
      termsLink: 'términos de la operación',
      paymentValue: 'Valor a pagar',
      steps: {
        code: 'Código',
        sign: 'Firmar',
        summary: 'Resumen',
        status: 'Estado'
      },
      stepsAriaLabel: 'Etapas',
      stepReview: 'Revisar',
      stepConfirm: 'Confirmar',
      stepPay: 'Pagar',
      codeSentTo: 'Enviamos un código de 6 dígitos a {email}.',
      codeAriaLabel: 'Código de 6 dígitos',
      notReceived: '¿No lo recibió? Revise el spam o',
      resendIn: 'reenvíe en {seconds}s',
      resendCode: 'reenvíe el código',
      approveSubtitle: 'Revise cuánto paga, cuánto llega y a quién va.',
      youPay: 'Usted paga',
      recipientReceives: 'El destinatario recibirá',
      operationAmount: 'Valor de la operación',
      quoteNotUpdated: 'Cotización de las {time} · no actualizada',
      quoteCaptionSimple: 'Cotización de las {time}',
      quoteCaptionWithRefresh: 'Cotización de las {time} · {refresh}',
      refreshing: 'actualizando...',
      refreshesIn: 'actualiza en {time}',
      authorizationText: 'Al aprobar, autoriza esta operación una única vez, solo con estos valores.',
      transferAuthorizationText: 'Al aprobar, autoriza esta operación solo con estos valores. La autorización vence en el plazo de la operación.',
      updateValues: 'Actualizar valores',
      notNow: 'Ahora no',
      recipientFields: {
        bank: 'Banco',
        routing: 'ABA/Routing',
        swift: 'Swift/BIC',
        account: 'Cuenta',
        iban: 'IBAN',
        accountOrIban: 'Cuenta/IBAN',
        accountType: 'Tipo de cuenta',
        accountClass: 'Tipo de cuenta',
        ffc: 'FFC',
        intermediary: 'Banco intermediario',
        ifsc: 'IFSC de la sucursal',
        sortCode: 'Sort code',
        speiClabe: 'CLABE',
        speiDebitCard: 'Tarjeta de débito',
        speiPhone: 'Celular',
        institutionCode: 'Código de la institución',
        transfersType: 'Tipo de cuenta',
        transfersAccount: 'Cuenta',
        bankCode: 'Código del banco',
        document: 'Documento',
        pixKey: 'Clave PIX',
        agency: 'Agencia',
        nationalAccount: 'Cuenta'
      },
      accountTypes: {
        checking: 'Cuenta corriente',
        savings: 'Cuenta de ahorros',
        individual: 'Individual',
        business: 'Empresarial'
      },
      transferMethods: {
        pix: 'PIX',
        wire: 'Wire (EE. UU.)',
        ach: 'ACH (EE. UU.)',
        rtp: 'RTP (EE. UU.)',
        sepa: 'SEPA (Europa)',
        faster_payments: 'Faster Payments (Reino Unido)',
        international_swift: 'SWIFT internacional',
        spei: 'SPEI (México)',
        transfers_3: 'Transfers 3.0 (Argentina)',
        ach_colombia: 'ACH (Colombia)'
      },
      closeOperation: 'Cerrar operación',
      payerAccountNotice: 'El pago debe hacerse desde una cuenta a nombre del titular de la operación:',
      greeting: 'Hola',
      greetingNamed: 'Hola, {name}',
      summarySubtitle: 'Revise los datos de su operación antes de continuar.',
      recipientWillReceive: 'El destinatario recibirá',
      yourEmail: 'Su correo electrónico',
      emailHint: 'Use el correo de su registro.',
      emailHintWithKnown: 'Correo del registro: {email}',
      acceptTermsText: 'He leído y acepto los',
      continueButton: 'Continuar',
      fetchingQuote: 'Buscando la cotización actualizada…',
      invalidEmail: 'Ingrese un correo electrónico válido.',
      stagePix: 'Preparando su PIX',
      stageProcessing: 'Pago recibido',
      stageDelayed: 'Envío en proceso',
      stageRefunded: 'Valor devuelto',
      stageDone: 'Operación completada',
      stagePixMessage: 'Estamos preparando su PIX. En instantes el código aparece aquí.',
      stageProcessingMessage: 'Estamos enviando el valor al destinatario. Puede cerrar esta página: le avisamos por correo cuando termine.',
      stageDelayedMessage: 'Su pago ya fue recibido, pero el envío al destinatario está tardando más de lo normal. No necesita hacer nada: le avisamos por correo cuando el valor llegue.',
      stageRefundedMessage: 'El valor que usted pagó fue devuelto. Esta operación no continuará: para hacer una nueva, hable con quien envió este enlace.',
      stageDoneMessage: 'El valor fue enviado al destinatario. No necesita hacer nada más.',
      generatePix: 'Generar el PIX',
      pixPaid: 'PIX pagado',
      journeyConfirmed: 'Operación confirmada',
      journeySending: 'Enviando',
      journeySent: 'Enviado',
      journeyBuying: 'Compra del USDC',
      journeyDelivered: 'Entregado',
      journeyInWallet: 'En su billetera',
      journeyReceived: 'El destinatario recibió',
      valueSent: 'Valor enviado al destinatario',
      valueRefunded: 'Valor devuelto a usted',
      termsClose: 'Cerrar',
      termsAccept: 'He leído y acepto',
      payWithMethod: 'Pague con {method}',
      // Débito automático (ACH pull): el valor sale de la cuenta del cliente en EE. UU., conectada por él
      debit: {
        methodLabel: 'ACH (débito automático)',
        title: '¿Cómo quiere pagar?',
        debitOption: 'Débito automático',
        debitHint: 'Usted autoriza una vez y nosotros cobramos el valor directo de su cuenta en EE. UU. Sin transferencia.',
        transferOption: 'Transferencia bancaria (ACH)',
        transferHint: 'Usted mismo transfiere desde la app de su banco, con los datos y el código que mostramos al final.',
        accountLabel: 'Cuenta que va a pagar',
        accountText: '{bank} terminada en {last4}',
        bankFallback: 'Cuenta en EE. UU.',
        accountTypes: { checking: 'Cuenta corriente', savings: 'Cuenta de ahorro' },
        noAccount: 'Aún no hay ninguna cuenta conectada. Conecte la suya para pagar por débito.',
        connect: 'Conectar cuenta en EE. UU.',
        connectAnother: 'Conectar otra cuenta',
        secureHint: 'Usted entra a su banco por el sitio seguro de nuestro socio. No vemos ni guardamos su contraseña.',
        refused: 'Su banco no autorizó el débito y no salió ningún valor de su cuenta. Elija otra cuenta o pague por transferencia.',
        unavailable: 'El débito automático no está disponible en este momento. Pague por transferencia bancaria (ACH).',
        authorization: 'Autorizo debitar {amount} de mi cuenta {account} una única vez, solo para esta operación y con estos valores.',
        requestedTitle: 'Débito solicitado a su banco',
        requestedSubtitle: 'Usted no necesita hacer nada más. Le avisaremos por correo electrónico cuando llegue el valor.',
        waiting: 'Esperando que el banco libere el valor',
        receiptBank: 'Banco',
        receiptAccount: 'Cuenta',
        receiptAmount: 'Valor solicitado',
        receiptRequestedAt: 'Solicitado el',
        feeActivation: 'Activación del débito automático',
        feeActivationHint: 'Se cobra solo en el primer débito, para activar su cuenta. Ya está en el valor de arriba.',
        fee: 'Tarifa del débito automático',
        feeHint: 'Ya está en el valor de arriba.'
      },
      pixInstructions: 'En la app de su banco, use PIX Copia y Pega o escanee el código QR.',
      pixValidFor: 'Válido por {time}',
      copiedCode: 'Código copiado',
      copyPixCode: 'Copiar código PIX',
      generateNewPix: 'Generar nuevo PIX',
      qrCodeAriaLabel: 'Código QR del PIX',
      pixTimerAriaLabel: 'Tiempo restante del PIX',
      pixWaiting: 'Esperando el pago del PIX',
      paymentWaiting: 'Esperando el pago. En cuanto se confirme, esta pantalla cambia sola.',
      pixExpired: 'Este PIX venció. Genere uno nuevo para pagar.',
      pixUnavailable: 'Este PIX ya no está disponible. Genere uno nuevo para pagar.',
      progressTitle: 'Estado del enlace',
      progressUnavailable: 'No fue posible cargar el estado ahora. Lo intentaremos de nuevo en instantes.',
      progressUpdatedAt: 'Actualizado a las {time}',
      viewOperation: 'Ver operación',
      confirmSend: 'Confirmar envío',
      sendAnyway: 'Enviar de todas formas',
      doNotSend: 'No enviar',
      linkSentToCustomer: 'Enlace enviado al cliente',
      copyLink: 'Copiar enlace',
      linkCopied: 'Enlace copiado',
      openLink: 'Abrir enlace',
      historyTitle: 'Historial del enlace',
      historyUnavailable: 'No fue posible cargar el historial ahora. Cierre y vuelva a abrir en instantes.',
      historyEmpty: 'Ningún paso registrado en este enlace aún.',
      historyAndProgressTitle: 'Estado e historial del enlace de {name}',
      historyAndProgressTitleGeneric: 'Estado e historial del enlace',
      linkValid: 'Enlace válido',
      linkCancelled: 'Enlace cancelado',
      linkExpired: 'Enlace vencido',
      pixNumber: 'PIX nº {id}',
      recipientLabel: 'Destinatario',
      transferType: 'Tipo de transferencia',
      pixKeyLabel: 'Clave PIX',
      accountLabel: 'Cuenta',
      bankLabel: 'Banco',
      accountEnding: 'final {ending}',
      loadingLink: 'Generando el enlace…',
      loadingLinkText: 'Estamos creando el enlace de la operación y enviándolo al correo del cliente. Tarda unos segundos.',
      errorLinkTitle: 'El enlace no fue generado',
      linkGeneratedTitle: 'Enlace generado',
      renewingLink: 'Reenviando el enlace…',
      renewingLinkText: 'Estamos renovando el plazo y enviando el enlace al correo del cliente. Tarda unos segundos.',
      errorLinkRenewTitle: 'El enlace no fue reenviado',
      linkRenewedTitle: 'Plazo del enlace renovado',
      trackingHintWithProgress: 'Puede cerrar esta ventana y seguir el avance más tarde con el botón "Ver avance" o desde Preventa.',
      trackingHintWithoutProgress: 'Siga la aprobación en Preventa, en la pestaña Operaciones Stablecoin.'
    },

    paymentStatus: {
      title: 'Estado del Pago',
      payin: 'Entrada',
      payout: 'Salida',
      retry: 'Intentar de nuevo'
    },
    limits: {
      title: 'Mis Límites',
      increaseTitle: 'Solicitar Aumento de Límite',
      pendingIncrease: 'Solicitud pendiente',
      rejectedIncrease: 'Solicitud rechazada'
    },
    documents: {
      checklistTitle: 'Documentos necesarios',
      analysisTitle: 'Análisis de documentos'
    },
    provider: {
      choiceTitle: 'Elegir proveedor',
      linkOnly: 'Solo vincular',
      unknown: 'Desconocido'
    },
    tos: {
      title: 'Términos de servicio',
      successTitle: 'Términos aceptados'
    },
    validation: {
      reactivateTitle: 'Reactivar registro'
    },
    rfi: {
      title: 'Documentación adicional solicitada',
      removeFile: 'Quitar archivo'
    },
    // Modal único de pendientes del proveedor (TC-1727)
    providerPending: {
      title: 'Registro en {provider}',
      titleFallback: 'Registro en el proveedor',
      close: 'Cerrar',
      tryAgain: 'Intentar de nuevo',
      loadError: 'No fue posible abrir el registro en el proveedor ahora. Intente de nuevo en unos instantes.',
      actionError: 'No fue posible completar ahora. Intente de nuevo en unos instantes.',
      operationsEnabled: 'Operaciones habilitadas',
      steps: {
        sent: 'Registro enviado',
        request: 'Pendientes',
        review: 'En análisis',
        result: 'Resultado'
      },
      actions: {
        respond: 'Responder al proveedor',
        submit: 'Enviar respuesta al proveedor',
        saveAndSend: 'Guardar y enviar al proveedor',
        retry: 'Intentar de nuevo ahora',
        retryWithTerms: 'Enviar de nuevo al proveedor',
        reonboard: 'Ver el motivo y volver a registrar',
        refetch: 'Buscar la solicitud de nuevo',
        copyLink: 'Copiar enlace para el cliente',
        openLink: 'Abrir el enlace'
      },
      itemStatus: {
        ready: 'Listo',
        missing: 'Falta',
        optional: 'Opcional',
        error: 'Corregir',
        withCustomer: 'Con el cliente'
      },
      notices: {
        requestChanged: 'La solicitud cambió en el proveedor. Actualizamos la pantalla.',
        validationFailed: 'El proveedor no aceptó la respuesta. No se envió nada.',
        localCheck: 'La revisión del registro señaló:',
        errorDetail: 'El sistema registró:'
      },
      form: {
        progress: '{ready} de {total} solicitudes listas',
        progressAria: 'Progreso de la respuesta al proveedor',
        archiveNotice: 'Los archivos adjuntos también quedan en la ficha del cliente, en el tipo de documento correspondiente o en "Otros", con el nombre del ítem.',
        missing: 'Falta completar: {items}',
        allReady: 'Todo listo para enviar.',
        fixInFormFirst: 'Corrija en la ficha los ítems de arriba (botón Completar en la ficha) y después envíe.'
      },
      list: {
        headerRespond: 'Qué responder',
        headerResolve: 'Qué resolver',
        countOne: '1 solicitud',
        countMany: '{count} solicitudes',
        countWithTemplates: '{count} · {templates} con modelo para completar',
        hasTemplate: 'Tiene modelo para completar',
        providerReason: 'Motivo del proveedor: {reason}'
      },
      item: {
        reasonLabel: 'Motivo:',
        providerTextLabel: 'Texto del proveedor:',
        fillInForm: 'Completar en la ficha',
        downloadTemplate: 'Descargar el modelo del proveedor',
        linkCopied: 'Enlace copiado',
        copyFailed: 'No fue posible copiar el enlace. Selecciónelo y cópielo manualmente.',
        optionalSuffix: '{label} · opcional',
        patternInvalid: 'Formato no aceptado por el proveedor',
        genericLabel: 'Información solicitada'
      },
      question: {
        liveness: {
          title: 'Verificación de vida',
          guidance: 'El cliente debe abrir el enlace y realizar la verificación de vida. Copie el enlace y envíeselo. Cuando la concluya, regístrelo aquí y envíe la respuesta al proveedor.',
          answerLabel: 'Confirmación de que el cliente concluyó la verificación'
        },
        sourceOfFunds: {
          title: 'Origen de los fondos',
          guidance: 'Envíe documentos que muestren de dónde provienen los fondos, como extractos bancarios, estados financieros o declaración de impuestos. El texto del proveedor abajo indica el período y los documentos aceptados.'
        },
        idDocument: {
          title: 'Documento de identidad',
          guidance: 'Envíe el documento de identidad solicitado. El texto del proveedor abajo indica de quién es y qué corregir.'
        },
        proofOfAddress: {
          title: 'Comprobante de domicilio',
          guidance: 'Envíe un comprobante de domicilio reciente. El texto del proveedor abajo indica a nombre de quién debe estar y qué corregir.'
        },
        relationship: {
          title: 'Relación con la empresa',
          guidance: 'Explique la relación mencionada por el proveedor en el texto de abajo.'
        },
        shareholderRegistry: {
          title: 'Registro de socios',
          guidance: 'Envíe el documento con los socios de la empresa y la participación de cada uno.'
        },
        businessRegistration: {
          title: 'Registro de la empresa',
          guidance: 'Envíe el documento de registro de la empresa, como el contrato social. El texto del proveedor abajo indica qué empresa y qué se exige.'
        },
        website: {
          title: 'Sitio web de la empresa',
          guidance: 'Responda sobre el sitio web de la empresa según el texto del proveedor abajo.'
        },
        accountPurpose: {
          title: 'Finalidad de la cuenta',
          guidance: 'Explique cómo usará la cuenta el cliente, según el texto del proveedor abajo.'
        },
        additionalMedia: {
          title: 'Presencia en línea',
          guidance: 'Informe otros canales del cliente, como sitio web o redes sociales, según el texto del proveedor abajo.'
        },
        labels: {
          answer: 'Su respuesta',
          supportingDocuments: 'Documentos de respaldo',
          explanation: 'Explicación',
          idDocumentType: 'Tipo de documento',
          idDocumentFile: 'Archivo del documento',
          documentFront: 'Frente del documento',
          documentBack: 'Reverso del documento',
          proofOfAddressType: 'Tipo de comprobante',
          proofOfAddressFile: 'Archivo del comprobante',
          shareholderRegistryDocuments: 'Documentos del registro de socios',
          businessRegistrationDocuments: 'Documentos de registro de la empresa'
        },
        options: {
          BANK_STATEMENT: 'Extracto bancario',
          DRIVERS_LICENSE: 'Licencia de conducir',
          GOVERNMENT_LETTER: 'Correspondencia del gobierno',
          LEASE_AGREEMENT: 'Contrato de alquiler',
          NATIONAL_ID: 'Documento de identidad',
          PASSPORT: 'Pasaporte',
          UTILITY_BILL: 'Factura de servicios'
        }
      },
      history: {
        title: 'Historial con el proveedor',
        requested: 'El proveedor pidió más información',
        submitted: 'Respuesta enviada al proveedor',
        cancelled: 'El proveedor canceló la solicitud',
        expired: 'Venció el plazo para responder',
        approved: 'El proveedor aprobó el registro'
      },
      rejection: {
        reasonLabel: 'Motivo del proveedor:',
        reasonMissing: 'El proveedor no informó el motivo.',
        checkBefore: 'Antes de volver a registrar, verifique:',
        checkDocument: 'Documento de identidad legible y vigente (frente y dorso)',
        checkSelfie: 'Selfie clara, en vivo, en un lugar iluminado',
        checkAddress: 'Comprobante de domicilio de los últimos 3 meses',
        checkData: 'Datos de la ficha iguales a los del documento (nombre, documento, fecha de nacimiento)'
      },
      technical: {
        title: 'Detalles para soporte',
        reference: 'Referencia',
        attempts: 'Intentos',
        firstAttempt: 'Primer intento',
        lastAttempt: 'Último intento'
      },
      messages: {
        retried: 'Envío reanudado',
        refetched: 'Solicitud actualizada',
        submitted: 'Respuesta enviada al proveedor',
        fixHint: 'Corrija los campos aquí o en la ficha. Al guardar la ficha, el registro vuelve al proveedor.',
        saved: 'Información guardada. El registro vuelve al proveedor.',
        reonboarded: 'Nuevo registro enviado al proveedor.',
        reonboardError: 'No fue posible rehacer el registro ahora. Intente de nuevo en unos instantes.',
        reonboardUnavailable: 'Este proveedor no permite rehacer el registro por el sistema. Corrija la ficha y comuníquese con soporte.'
      },
      chip: {
        requestDescription: 'Solicitud del proveedor',
        requestHint: 'Ítems para responder',
        requestApprovedHint: 'Operaciones habilitadas',
        requestApprovedUntil: 'Operaciones habilitadas · responder hasta el {day}',
        requestUntil: 'Responder hasta el {day}',
        fixDescription: 'Pendiente',
        fixHint: 'Ítems para resolver',
        providerErrorHint: 'El proveedor no respondió'
      },
      kanban: {
        dataToFixTitle: 'Registro con datos para corregir',
        dataToFixHint: 'Al guardar la ficha corregida, el registro vuelve al proveedor.',
        requestExpired: 'El plazo de la solicitud del proveedor venció el {day}',
        requested: 'El proveedor pidió más información',
        respondUntil: 'Responder hasta el {day}.',
        rejectedFinal: 'El proveedor rechazó el registro de forma definitiva',
        rejected: 'El proveedor rechazó el registro',
        requestNotLoaded: 'La solicitud del proveedor no se cargó',
        providerNoResponse: 'El proveedor no respondió al envío',
        providerGeneric: 'Pendiente con el proveedor',
        bankGeneric: 'Pendiente con el banco'
      },
      timeline: {
        requestOpened: 'El proveedor pidió más información',
        responseSent: 'Respuesta enviada al proveedor',
        requestExpired: 'Venció el plazo de la solicitud del proveedor',
        requestCancelled: 'El proveedor canceló la solicitud',
        requestClosedApproved: 'El proveedor aprobó el registro y cerró la solicitud',
        rejected: 'El proveedor rechazó el registro',
        dataToFix: 'Registro con dato para corregir',
        requestNotLoaded: 'La solicitud del proveedor no se cargó',
        providerError: 'El proveedor no respondió al envío',
        issueResolved: 'Pendiente resuelto',
        respondUntil: 'Responder hasta el {day}',
        attempts: '{count} intentos',
        respondedBy: 'Respondido por: {author}'
      },
      files: {
        defaultRfiMessage: 'El proveedor pidió más información sobre el registro de este cliente.',
        upTo: 'Hasta {max} archivos',
        invalidType: 'El archivo "{name}" no se acepta. Envíe PDF, JPG o PNG.',
        tooLarge: 'El archivo "{name}" supera {max} MB. Envíe un archivo más pequeño.'
      }
    },
    receiver: {
      pendingIssuesTitle: 'Pendientes del registro'
    },

    paymentStatusModal: {
      title: 'Estado de pagos',
      loading: 'Cargando pagos...',
      close: 'Cerrar',
      clientPaid: 'Cliente pagó',
      clientReceived: 'Cliente recibió',
      unknown: 'Desconocido',
      notAvailable: 'N/A',
      paymentById: 'Pago #{id}',
      paymentByIndex: 'Pago {index}',
      receiptById: 'Recibo #{id}',
      receiptByIndex: 'Recibo {index}',
      boletoPayById: 'Pago de boleto #{id}',
      pixPayById: 'Pago de PIX #{id}',
      returnedToCustomer: 'Devuelto al cliente',
      statusPayIn: {
        pending: 'Pendiente',
        processing: 'Procesando',
        completed: 'Liquidado',
        failed: 'No completado',
        expired: 'Expirado',
        cancelled: 'Cancelado',
        ignored: 'Ignorado',
        refunded: 'Reembolsado',
        onHold: 'En espera',
        awaitingDeposit: 'Esperando pago'
      },
      statusPayOut: {
        pending: 'Pendiente',
        approvalRequired: 'Aprobación requerida',
        approved: 'Aprobado',
        processing: 'Procesando',
        completed: 'Liquidado',
        failed: 'No completado',
        cancelled: 'Cancelado',
        ignored: 'Ignorado',
        refunded: 'Reembolsado',
        onHold: 'En espera',
        awaitingDeposit: 'Esperando envío de billetera'
      }
    },

    paymentStatusPayIn: {
      paymentMethod: 'Método de Pago',
      pixCode: 'Código PIX',
      paymentDate: 'Fecha de Pago',
      completedDate: 'Fecha de Conclusión',
      transactionHash: 'Hash de la Transacción',
      pixCopied: '¡Código PIX copiado!',
      pixNotCopied: 'El código PIX no fue copiado. Seleccione el código y cópielo manualmente (Ctrl+C).',
      arsTransferRefunded: 'El valor volvió a la cuenta de origen. En pesos argentinos esto ocurre cuando la transferencia sale de una cuenta de otro CUIT/CUIL o llega después del plazo de pago. Confirme con el cliente desde qué cuenta pagó.'
    },

    paymentStatusPayOut: {
      receiptDate: 'Fecha de Recepción',
      completedDate: 'Fecha de Conclusión',
      transactionHash: 'Hash de la Transacción',
      quoteDescription: 'Descripción de la Cotización',
      returnedAlert: 'El valor fue devuelto al cliente. Este pago no será enviado de nuevo.',
      retryButton: 'Reenviar pago en {currency}'
    },

    paymentStatusBankAccount: {
      title: 'Datos de la Cuenta Bancaria',
      accountName: 'Nombre de la Cuenta',
      type: 'Tipo',
      accountNumber: 'Número de Cuenta',
      beneficiaryName: 'Nombre del Beneficiario'
    },

    paymentStatusTracking: {
      imad: 'Código de rastreo (IMAD)',
      uetr: 'Código de rastreo (UETR)'
    },

    paymentStatusRetry: {
      title: 'Nuevo pago',
      amountLabel: 'Valor',
      accountLabel: 'Cuenta para recepción',
      noAccount: 'Ninguna cuenta disponible',
      quoteLabel: 'Cotización del PayOut',
      execute: 'Ejecutar',
      cancel: 'Cancelar',
      loadError: 'Las cuentas del cliente no cargaron. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
      retryError: 'El nuevo envío no fue realizado. Verifique la cuenta de destino e intente de nuevo; si persiste, contacte al soporte.'
    },

    receiverPendingIssues: {
      title: 'Pendientes con el banco',
      loading: 'Cargando pendientes...',
      retry: 'Intentar de nuevo',
      noIssues: 'No se encontraron pendientes para este cliente.',
      noIssuesCaption: 'El cliente no tiene pendientes relacionados al registro en el banco digital.',
      customerLabel: 'Cliente',
      bankLabel: 'Banco',
      pendingFieldsTitle: 'Campos a corregir',
      firstAttempt: 'Primer intento',
      lastAttempt: 'Último intento',
      instructionRfi: 'El banco solicitó más información. Envíe la respuesta para que el registro vuelva a análisis.',
      instructionFix: 'Después de corregir y guardar el cliente, el registro será reenviado automáticamente al banco digital.',
      answerBank: 'Responder al banco',
      resendToBank: 'Reenviar al banco',
      resendToBankTooltip: 'Reenviar registro al banco para nuevo análisis',
      fixPending: 'Corregir pendientes',
      close: 'Cerrar',
      noCustomer: 'Seleccione un cliente para ver los pendientes.',
      loadError: 'Los pendientes no cargaron. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
      noDataMessage: 'Detalle no disponible. Intente de nuevo o contacte al soporte.',
      categories: {
        missingData: 'Datos faltantes',
        invalidData: 'Datos inválidos',
        kycRejected: 'Documentación rechazada por el banco',
        apiError: 'Sin respuesta del sistema',
        complianceRequest: 'Solicitud de información del banco',
        unknown: 'Pendiente'
      },
      statuses: {
        failed: 'No completado',
        pending: 'Pendiente',
        resolved: 'Resuelto'
      },
      noPayloadData: 'Sin datos disponibles.',
      documentFields: {
        imageUrl: 'Foto del cliente',
        selfieFile: 'Selfie',
        idDocFrontFile: 'Documento de identidad (frente)',
        idDocBackFile: 'Documento de identidad (reverso)',
        proofOfAddressDocFile: 'Comprobante de domicilio',
        incorporationDocFile: 'Contrato social',
        proofOfOwnershipDocFile: 'Estructura societaria',
        sourceOfFundsDocFile: 'Comprobante de origen de los fondos'
      }
    },

    documentChecklist: {
      saveBeforeResend: 'Guarde el registro antes de reenviar',
      noDocuments: 'Ningún documento adjunto',
      missingDocumentsFooter: 'Adjunte los documentos faltantes en la pestaña Documentos'
    },

    limitsDialog: {
      title: 'Historial de movimientos {provider}',
      entryLimits: 'Límites de Entrada',
      exitLimits: 'Límites de Salida',
      perTransaction: 'Por transacción',
      daily: 'Diario',
      monthly: 'Mensual',
      historySubheader: 'Historial de movimientos',
      noRecords: 'Ningún registro en el período seleccionado.',
      requestIncrease: 'Solicitar aumento de límite',
      close: 'Cerrar',
      noLimits: 'Este cliente aún no tiene límites aprobados en DolsPay.',
      noLimitsGeneric: 'Este cliente aún no tiene límites aprobados en {provider}.',
      loadError: 'Los límites del cliente no cargaron. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
      loadErrorGeneric: 'No fue posible cargar los límites de {provider}.',
      loadTimeout: 'Los límites están tardando en cargar. Mostrando historial disponible.',
      periods: {
        all: 'Todos',
        today: 'Hoy',
        yesterday: 'Ayer',
        thisWeek: 'Esta semana',
        thisMonth: 'Mes actual',
        lastMonth: 'Último mes',
        threeMonths: '3 meses',
        sixMonths: '6 meses',
        lastYear: 'Último año',
        lastThreeMonths: 'Últimos 3 meses',
        lastSixMonths: 'Últimos 6 meses'
      },
      eventTypes: {
        syncSnapshot: 'Sincronización',
        limitIncreaseRequested: 'Solicitud de aumento',
        limitIncreaseApproved: 'Aumento aprobado',
        limitIncreaseRejected: 'Aumento rechazado',
        payinCompleted: 'Entrada',
        payoutCompleted: 'Salida'
      },
      statusLabels: {
        inReview: 'En análisis',
        approved: 'Aprobado',
        rejected: 'Rechazado'
      }
    },

    limitIncreaseDialog: {
      title: 'Solicitar aumento de límite',
      perTransactionLabel: 'Por transacción*',
      dailyLabel: 'Diario*',
      monthlyLabel: 'Mensual*',
      documentSupportTitle: 'Documento de soporte',
      documentSupportSubtitle: 'Seleccione un documento ya adjunto al registro que ayude a aprobar su solicitud.',
      requestNew: 'Solicitar nuevo aumento',
      close: 'Cerrar',
      cancel: 'Cancelar',
      submit: 'Enviar solicitud',
      limitDailyBelowTx: 'El límite diario debe ser mayor o igual al límite por transacción.',
      limitMonthlyBelowDaily: 'El límite mensual debe ser mayor o igual al límite diario.',
      limitPerTxBelowCurrent: 'Los nuevos límites deben ser mayores que los actuales. Ingrese un valor por transacción mayor al actual.',
      limitDailyBelowCurrent: 'Los nuevos límites deben ser mayores que los actuales. Ingrese un límite diario mayor al actual.',
      limitMonthlyBelowCurrent: 'Los nuevos límites deben ser mayores que los actuales. Ingrese un límite mensual mayor al actual.',
      ruleMinError: 'Debe ser mayor que el límite actual (US$ {min}).',
      waitUpload: 'Espere a que termine la subida del documento.',
      selectDocument: 'Seleccione un tipo de documento o suba un nuevo documento.',
      submittedSuccess: 'Solicitud enviada para análisis.',
      submitError: 'La solicitud de aumento de límite no fue enviada. Verifique los documentos adjuntos e intente de nuevo.',
      selectDocumentTypeFirst: 'Seleccione el tipo de documento antes de subir.',
      uploadSuccess: '¡Documento subido con éxito!',
      uploadError: 'El documento no fue enviado. Verifique que el archivo sea PDF, JPG o PNG e intente de nuevo.',
      docTypes: {
        individualBankStatement: 'Extracto bancario',
        individualTaxReturn: 'Declaración de impuesto sobre la renta',
        individualProofOfIncome: 'Comprobante de ingresos',
        businessBankStatement: 'Extracto bancario empresarial',
        businessFinancialStatements: 'Estados financieros (Balance/ERI)',
        businessTaxReturn: 'Declaración de impuesto empresarial'
      },
      documentFoundLabel: 'Documento encontrado. Puede cargar un nuevo documento para reemplazarlo:',
      documentNotFoundLabel: 'No se encontró ningún documento de este tipo. Cargue un nuevo documento:'
    },

    pendingLimitIncrease: {
      title: 'Solicitud en análisis',
      subtitle: 'Espere el análisis de la solicitud anterior antes de enviar una nueva.',
      requestedAt: 'Solicitado el {date}',
      perTransaction: 'Por transacción',
      daily: 'Diario',
      monthly: 'Mensual'
    },

    rejectedLimitIncrease: {
      title: 'Solicitud rechazada',
      subtitle: 'Su solicitud anterior fue rechazada. Puede enviar una nueva solicitud.',
      requestedAt: 'Solicitado el {date}',
      rejectedAt: 'Rechazado el {date}',
      perTransaction: 'Por transacción',
      daily: 'Diario',
      monthly: 'Mensual'
    },

    technicalDetails: {
      header: 'Ver detalles técnicos (para soporte)',
      kycWarningsLabel: 'Alertas KYC:',
      operatorActionLabel: 'Acción sugerida:',
      payloadLabel: 'Datos enviados al banco asociado. Si necesita ayuda, copie y envíe al soporte:',
      errorSources: {
        blindpayApi: 'Rechazo del banco asociado',
        localValidation: 'Validación local'
      }
    },

    documentAnalysis: {
      high: 'Alta',
      medium: 'Media',
      low: 'Baja',
      highTooltip: 'Documento de buena calidad',
      mediumText: 'El documento puede necesitar ajustes',
      lowText: 'Recomendamos cambiar este documento'
    },

    rfiModal: {
      title: 'Responder al banco',
      primaryButton: 'Enviar respuesta',
      secondaryButton: 'Cerrar',
      deadline: 'Plazo del banco: {deadline}',
      refreshButton: 'Buscar la solicitud de nuevo en el banco',
      defaultMessage: 'El banco solicitó más información sobre el registro de este cliente.',
      loadError: 'No fue posible abrir la solicitud del banco. Intente de nuevo en unos instantes.',
      refreshError: 'No fue posible buscar la solicitud en el banco. Intente de nuevo en unos instantes.',
      fillRequired: 'Complete lo que el banco solicitó: {fields}.',
      submitSuccess: 'Respuesta enviada al banco. El registro vuelve a análisis.',
      submitError: 'La respuesta no fue enviada al banco. Verifique la información e intente de nuevo.'
    },

    operationOrigin: {
      section: 'Operado por',
      user: 'Usuario',
      systemUser: 'Usuario del sistema',
      access: 'Acceso',
      profile: 'Perfil',
      channel: 'Canal',
      startedAt: 'Iniciada el',
      notRecorded: 'No registrado',
      notRecordedHint: 'Operación anterior al registro de quién opera',
      accessGoogle: 'Accedió con la cuenta de Google {email}',
      accessPassword: 'Accedió con correo y contraseña',
      accessCode: 'Accedió con el código enviado al correo',
      customerName: '{name} (App DolsPay)',
      profiles: { administrative: 'Administrativo', corban: 'Corban', customer: 'Cliente' },
      channels: { web: 'Pantalla de operación', app: 'App DolsPay' }
    },

    operationDetailCenter: {
      customerSection: 'Cliente',
      cpfCnpj: 'CPF/CNPJ',
      companyName: 'Razón social',
      personName: 'Nombre',
      fantasyName: 'Nombre de fantasía',
      detailsSection: 'Detalles de la operación',
      type: 'Tipo',
      typeBuy: 'Compra',
      typeSell: 'Venta',
      nature: 'Naturaleza',
      status: 'Estado',
      valuesSection: 'Valores',
      amountForeign: 'Valor M.E.',
      customerRate: 'Tasa cliente',
      totalValue: 'Valor total',
      spread: 'Spread',
      recipientSection: 'Destinatario',
      recipientName: 'Nombre',
      recipientDocument: 'Documento',
      recipientPhone: 'Celular',
      bankSection: 'Banco y comisiones',
      changeCorban: 'Cambiar corban',
      bank: 'Banco',
      agent: 'Agente (Corban)',
      indicator: 'Corban indicador'
    },

    operationDetailDocuments: {
      documentsSection: 'Documentos',
      ccLabel: 'Contrato de cambio (CC)',
      view: 'Ver',
      pending: 'Pendiente',
      swiftLabel: 'Swift',
      paymentReceiptLabel: 'Comprobante de pago',
      boletoLabel: 'Boleto',
      authorizationLabel: 'Autorización',
      paymentSection: 'Pago',
      payInStatus: 'Estado BRL (PayIn)',
      payOutStatus: 'Estado ME (PayOut)',
      paymentFlow: 'Flujo de pago',
      intermediaryBank: 'Banco intermediario',
      recipientAccountSection: 'Cuenta bancaria del destinatario',
      account: 'Cuenta',
      beneficiary: 'Beneficiario',
      datesSection: 'Fechas',
      createdAt: 'Creación',
      creditedAt: 'Crédito',
      updatedAt: 'Actualización'
    },

    moneyFlight: {
      ariaLabel: 'Ruta del dinero: de {from} a {to}',
      europe: 'Europa'
    },
    moneyJourney: {
      title: 'Camino del dinero',
      starting: 'Operación iniciada',
      current: 'Etapa actual: {stage}',
      complete: 'Operación concluida',
      verifying: 'Estamos verificando esta etapa'
    },
    operationDetailTimeline: {
      loadError: 'No fue posible cargar la línea de tiempo de la operación.',
      empty: 'Ningún evento registrado para esta operación.',
      sections: {
        preSale: 'Preventa',
        paymentBrl: 'Pago en BRL',
        assetPurchase: 'Compra de activos',
        settlement: 'Liquidación',
        operation: 'Operación'
      },
      stages: {
        preSale: 'Preventa',
        payment: 'Pago',
        assets: 'Activos',
        settlement: 'Liquidación',
        quotation: 'Cotización',
        operation: 'Operación'
      }
    },
    validationModal: {
      title: 'Validación de registro para Stablecoin',
      correctPending: 'Corregir pendencias',
      sendToBank: 'Enviar al banco',
      cancel: 'Cancelar',
      pendingsTitle: 'Pendencias',
      pendingsHint: 'Corrija para continuar',
      clientLinkHint: 'No impiden el envío: el cliente envía estos documentos por el enlace de la institución.',
      filledFieldsTitle: 'Campos completados',
      completionLabel: '{percent}% completado',
      stepsCount: '{count} etapas',
      confirmationMessage: 'Existen pendencias obligatorias que impiden el envío al banco. Corrija los campos marcados antes de continuar.',
      confirmationTitle: '¿Continuar?',
      correctPendingButton: 'Corregir pendencia',
      notInformed: 'No informado',
      summaryHasPending: 'Registro con pendencias obligatorias, revise la información e intente de nuevo.',
      summaryValid: 'Registro validado y listo para enviar a DolsPay.'
    },
    pendingStepCard: {
      required: 'Obligatorio',
      partnerRequired: 'Socio {index} · Obligatorio',
      lastSentValue: 'Último valor enviado:',
      requiredBy: 'Exigido por {name}',
      sentByClientLink: 'El cliente envía en el enlace'
    },
    tosModal: {
      title: 'Términos de Servicio',
      loading: 'Cargando términos de servicio...',
      acceptRequired: 'Aceptación Necesaria',
      acceptDescription: 'Para utilizar este banco, es necesario aceptar los términos de servicio.',
      copyLink: 'Copiar Enlace de Aceptación',
      or: 'o',
      acceptTerms: 'Aceptar Términos de Servicio',
      newTabMessage: 'Se abrirá una nueva pestaña para aceptar los términos.',
      waitingAccept: 'Espere la aceptación para continuar...',
      linkCopiedAlert: '✅ ¡Enlace copiado! Envíelo al cliente y espere la aceptación.',
      monitoringAccept: 'Monitoreando aceptación del cliente...',
      loadError: 'No fue posible cargar los términos de servicio. Intente de nuevo.',
      cancel: 'Cancelar',
      errorNoCustomerId: 'ID del cliente no encontrado.',
      errorGenerateTos: 'No fue posible generar los términos de servicio. Intente de nuevo.',
      errorNoUrl: 'URL no disponible. Intente de nuevo.',
      linkCopiedSuccess: '¡Enlace copiado! Envíelo al cliente para aceptar los términos.'
    },
    tosSuccess: {
      bankAdded: '¡Banco agregado!',
      termsAccepted: '¡Términos aceptados!',
      bankAddedWithName: 'El banco {bankName} fue agregado al registro.',
      bankAddedNoName: 'El banco fue agregado al registro.',
      termsApprovedWithName: 'Los términos del banco {bankName} fueron aceptados.',
      termsApprovedNoName: 'Los términos seleccionados fueron aceptados.',
      sentForAnalysis: 'El registro de este banco fue enviado para análisis.',
      followProcess: 'Ahora siga todo el proceso en el flujo de registro.',
      sentWithDocuments: 'El registro se enviará con los documentos. Siga el proceso en el panel Proveedores.',
      saveAndGo: 'Guardar e ir al flujo de registro',
      stayHere: 'Continuar en esta pantalla'
    },
    linkOnly: {
      title: 'Vinculación de cuenta',
      alreadyRegistered: 'El cliente ya está registrado en DolsPay. Solo se realizará la vinculación de la cuenta.',
      customerSection: 'Cliente',
      receiverSection: 'Receptor (DolsPay)',
      limitsSection: 'Límites',
      cpfCnpjLabel: 'CPF/CNPJ',
      emailLabel: 'Correo electrónico',
      phoneLabel: 'Teléfono',
      addressLabel: 'Dirección',
      kycLine: 'KYC: {status} · Tipo: {type} · {receiverType}',
      entryLimits: 'Entrada',
      exitLimits: 'Salida',
      perTransaction: 'Por transacción',
      daily: 'Diario',
      monthly: 'Mensual',
      accountsTitle: 'Cuentas en DolsPay ({count})',
      noAccounts: 'No hay cuentas registradas en DolsPay.',
      continue: 'Continuar',
      cancel: 'Cancelar',
      loadError: 'No fue posible cargar las cuentas del cliente. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
      kycStatuses: {
        approved: 'Aprobado',
        verifying: 'En verificación',
        rejected: 'Rechazado'
      },
      receiverTypes: {
        individual: 'Persona Física',
        business: 'Persona Jurídica'
      },
      bankAccountTypes: {
        pix: 'PIX',
        ach: 'ACH',
        wire: 'Wire',
        internationalSwift: 'SWIFT',
        pixSafe: 'PIX Safe'
      },
      recipientRelationships: {
        firstParty: 'Propio',
        employee: 'Empleado',
        independentContractor: 'Contratista',
        vendorOrSupplier: 'Proveedor',
        subsidiaryOrAffiliate: 'Subsidiaria',
        merchantOrPartner: 'Socio',
        customer: 'Cliente',
        landlord: 'Propietario',
        family: 'Familia',
        other: 'Otro'
      }
    },
    providerChoice: {
      title: '¿A dónde enviar el registro?',
      intro: 'Elija a qué instituciones se enviará el registro del cliente. Si sabe que una de ellas lo rechazará, envíe solo a la otra.',
      continue: 'Continuar',
      cancel: 'Cancelar',
      allProviders: 'Todas ({names})',
      singleProvider: 'Solo {name}',
      joinSeparator: ' y ',
      withTermsHint: 'Requiere aceptación de términos de servicio y la selfie del cliente.',
      withoutTermsHint: 'Sin términos de servicio: los datos y documentos del registro se envían directamente.'
    }
  },

  dashboard: {
    flowMap: {
      title: 'Flujo por país',
      empty: 'Sin operaciones con país informado en este período'
    },
    chartDisplayLabelsUi: {
      weekdays: {
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miércoles',
        thursday: 'Jueves',
        friday: 'Viernes',
        saturday: 'Sábado',
        sunday: 'Domingo'
      },
      months: {
        jan: 'Ene',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Abr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Ago',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dic'
      },
      cohortMonth: 'Mes {month}',
      individual: 'Persona Física',
      legalEntity: 'Persona Jurídica',
      segments: {
        frequent: 'Frecuentes (>10 ops)',
        regular: 'Regulares (6-10 ops)',
        occasional: 'Ocasionales (2-5 ops)',
        oneTime: 'Únicos (1 op)'
      }
    },
    widgetPropsUi: {
      cards: {
        cardTarifaCliente: {
          description: 'Tarifa pagada por el cliente',
          info: 'Total que los clientes pagaron de tarifa bancaria en el período.'
        },
        cardTarifaBanco: {
          description: 'Tarifa cobrada por el banco',
          info: 'Total que el banco cobró de tarifa en las operaciones del período.'
        },
        cardSaldoTarifa: {
          description: 'Saldo de tarifa',
          info: 'Diferencia entre lo que pagaron los clientes y lo que cobró el banco. Negativo = el contratante absorbió la diferencia.'
        },
        cardVolumePayin: {
          description: 'Volumen Pay In',
          info: 'Valor total de los depósitos (ingresos) concluidos en el período.'
        },
        cardVolumePayout: {
          description: 'Volumen Pay Out',
          info: 'Valor total de los retiros (egresos) concluidos en el período, en USD.'
        },
        cardPayinsConcluidos: {
          description: 'Pay Ins concluidos'
        },
        cardPayoutsConcluidos: {
          description: 'Pay Outs concluidos'
        },
        cardDiasComOperacao: {
          description: 'Días con operación',
          info: 'Cantidad de días del período en los que hubo al menos una operación.'
        },
        cardMaiorVolumeDia: {
          description: 'Mayor volumen en un día',
          info: 'Mayor volumen operado en un solo día del período.'
        },
        cardOperacaoMediaUsd: {
          description: 'Operación promedio (USD)',
          info: 'Valor promedio por operación en USD.'
        },
        cardLucroLiquido: {
          description: 'Resultado neto',
          info: 'Resultado después de la deducción de PIS/COFINS. Calculado a partir del netProfit real de las operaciones.'
        },
        cardMargemLiquida: {
          description: 'Margen neto',
          info: 'Porcentaje del resultado neto sobre el resultado bruto. Indica eficiencia tributaria.'
        },
        cardTotalIof: {
          description: 'IOF total',
          info: 'Suma del IOF cobrado en todas las operaciones del período.'
        },
        cardPisCofins: {
          description: 'PIS/COFINS',
          info: 'Costo tributario de PIS/COFINS que incide sobre el resultado bruto de las operaciones.'
        },
        cardVolumePendente: {
          description: 'Volumen pendiente',
          info: 'Volumen financiero de operaciones todavía no liquidadas en el período.'
        },
        cardTaxaLiquidacao: {
          description: 'Tasa de liquidación',
          info: 'Porcentaje de operaciones que fueron liquidadas. Indica eficiencia operativa.'
        },
        cardVetMedio: {
          description: 'VET promedio',
          info: 'Valor Efectivo Total promedio de las operaciones. Métrica regulatoria exigida por el Banco Central de Brasil.'
        },
        cardSpreadMinimo: {
          description: 'Spread mínimo',
          info: 'Menor spread aplicado en las operaciones del período. Indica el piso de precios.'
        },
        cardTotalIr: {
          description: 'IR total',
          info: 'Suma del Impuesto a la Renta retenido en todas las operaciones del período.'
        },
        cardTotalCide: {
          description: 'CIDE total',
          info: 'Suma de la CIDE (Contribución de Intervención en el Dominio Económico) de las operaciones del período.'
        },
        cardCotacaoMedia: {
          description: 'Cotización promedio',
          info: 'Cotización promedio ponderada de las operaciones del período.'
        },
        cardVolumeMoedaEstrangeira: {
          description: 'Volumen en moneda extranjera',
          info: 'Suma del valor en moneda extranjera de todas las operaciones del período.'
        },
        cardSaldoCompraVenda: {
          description: 'Saldo compra vs. venta',
          info: 'Diferencia entre el volumen de compra y el volumen de venta en el período.'
        },
        cardVolumeVenda: {
          description: 'Volumen de venta',
          info: 'Volumen total de las operaciones de venta de moneda extranjera en el período.'
        },
        cardVolumeCompra: {
          description: 'Volumen de compra',
          info: 'Volumen total de las operaciones de compra de moneda extranjera en el período.'
        },
        cardTempoPreenchimentoFicha: {
          description: 'Tiempo promedio de llenado',
          info: 'Tiempo promedio que tarda el lead en completar la ficha de registro. Promedio calculado sobre los clientes que completaron esta etapa específica. Como cada etapa puede tener un conjunto distinto de clientes, los promedios por etapa pueden ser mayores que el tiempo total.'
        },
        cardTempoAnaliseInterna: {
          description: 'Tiempo promedio de análisis',
          info: 'Tiempo promedio del análisis interno del registro. Promedio calculado sobre los clientes que completaron esta etapa específica. Como cada etapa puede tener un conjunto distinto de clientes, los promedios por etapa pueden ser mayores que el tiempo total.'
        },
        cardTempoAprovacaoBanco: {
          description: 'Tiempo de aprobación del banco',
          info: 'Tiempo promedio que tarda el banco en aprobar el registro. Promedio calculado sobre los clientes que completaron esta etapa específica. Como cada etapa puede tener un conjunto distinto de clientes, los promedios por etapa pueden ser mayores que el tiempo total.'
        },
        cardTempoTotalCadastro: {
          description: 'Tiempo total de registro',
          info: 'Tiempo promedio total del flujo de registro completo (del envío a la finalización). Promedio calculado sobre los clientes que completaron todo el flujo de registro. Como incluye solo a los clientes que finalizaron todas las etapas, puede ser menor que los promedios de las etapas individuales.'
        },
        cardTaxaConversaoCadastro: {
          description: 'Tasa de conversión',
          info: 'Porcentaje de clientes que completaron el flujo de registro interno (enviado → finalizado).'
        },
        cardClientesParadosFluxo: {
          description: 'Clientes detenidos',
          info: 'Clientes que iniciaron el registro pero no lo finalizaron en el período.'
        },
        cardTaxaPendenciaBanco: {
          description: 'Tasa de pendientes del banco',
          info: 'Porcentaje de clientes que recibieron pendientes del banco (retrabajo).'
        },
        cardTaxaAprovacaoBanco: {
          description: 'Tasa de aprobación del banco',
          info: 'Porcentaje de clientes enviados al banco que fueron aprobados.'
        },
        cardLtvMedio: {
          description: 'LTV promedio',
          info: 'Valor promedio de resultado bruto por cliente a lo largo del tiempo'
        },
        cardReceitaMediaCliente: {
          description: 'Ingreso promedio/cliente',
          info: 'Resultado bruto total dividido por el número de clientes activos en el período'
        },
        cardFrequenciaMedia: {
          description: 'Frecuencia promedio',
          info: 'Número promedio de operaciones por cliente en el período'
        },
        cardTempoVidaMedio: {
          description: 'Tiempo de vida promedio',
          info: 'Promedio de días entre la primera y la última operación de cada cliente'
        },
        cardTaxaRetencao: {
          description: 'Tasa de retención',
          info: 'Porcentaje de clientes que operaron en más de un mes distinto'
        },
        cardTaxaChurn: {
          description: 'Pérdida de clientes (churn)',
          info: 'Porcentaje de clientes de la base histórica que no operaron en el período seleccionado (cuanto mayor, peor la retención)'
        },
        cardClientesAltoValor: {
          description: 'Clientes de alto valor',
          info: 'Clientes con LTV en el percentil 75 o superior'
        },
        cardBaseClientesLtv: {
          description: 'Base de clientes LTV',
          info: 'Total de clientes considerados en las métricas de LTV en el período'
        }
      },
      charts: {
        chartOperadoBanco: {
          title: 'Valor operado por banco'
        },
        chartOperadoMoeda: {
          title: 'Total operado por moneda'
        },
        chartOpsPorMoeda: {
          title: 'Distribución de operaciones por moneda'
        },
        chartVolumePorBanco: {
          title: 'Volumen por banco'
        },
        chartClientesRegiao: {
          title: 'Clientes por región'
        },
        chartTopClientes: {
          title: 'Top 10 clientes por volumen'
        },
        chartDistribuicaoLucros: {
          title: 'Distribución de resultados'
        },
        chartVolumeCorrespondente: {
          title: 'Volumen por corresponsal'
        },
        chartSegmentacaoClientes: {
          title: 'Segmentación de clientes'
        },
        chartAnaliseSpread: {
          title: 'Análisis de spread por moneda'
        },
        chartEvolucaoVolume: {
          title: 'Evolución del volumen'
        },
        chartRentabilidadeNatureza: {
          title: 'Rentabilidad por naturaleza de operación'
        },
        chartCargaTributaria: {
          title: 'Composición de la carga tributaria'
        },
        chartVolumeMensal: {
          title: 'Volumen mensual'
        },
        chartLucroMensal: {
          title: 'Resultado mensual'
        },
        chartOpsPorNatureza: {
          title: 'Operaciones por naturaleza'
        },
        chartCompraVsVenda: {
          title: 'Compra vs. venta'
        },
        chartClientesPorMes: {
          title: 'Clientes activos por mes'
        },
        chartTempoEtapasFluxo: {
          title: 'Tiempo por etapa del flujo'
        },
        chartEvolucaoTempoCadastro: {
          title: 'Evolución del tiempo de registro'
        },
        chartFunilCadastral: {
          title: 'Embudo de conversión de registro'
        },
        chartDistribuicaoPfPj: {
          title: 'Distribución PF vs. PJ por etapa'
        },
        chartClientesPorStatus: {
          title: 'Clientes por estado actual'
        },
        chartSegmentacaoLtv: {
          title: 'Segmentación por LTV'
        },
        chartEvolucaoLtv: {
          title: 'Evolución del LTV'
        },
        chartTopClientesLtv: {
          title: 'Top clientes por LTV'
        },
        chartRetencaoCoorte: {
          title: 'Retención por cohorte'
        },
        chartHeatmapOperacoes: {
          title: 'Mapa de calor de operaciones'
        },
        chartHistoricoCotacao: {
          title: 'Historial de cotización'
        }
      },
      columns: {
        bank: 'Banco',
        percentage: 'Porcentaje',
        currency: 'Moneda',
        value: 'Valor',
        volume: 'Volumen',
        state: 'Estado',
        quantity: 'Cantidad',
        customer: 'Cliente',
        category: 'Categoría',
        correspondent: 'Corresponsal',
        segment: 'Segmento',
        averageSpread: 'Spread promedio',
        date: 'Fecha',
        nature: 'Naturaleza',
        margin: 'Margen',
        tax: 'Tributo',
        month: 'Mes',
        result: 'Resultado',
        type: 'Tipo',
        customers: 'Clientes',
        stage: 'Etapa',
        time: 'Tiempo',
        typeStage: 'Tipo - Etapa',
        status: 'Estado',
        averageLtv: 'LTV promedio',
        ltv: 'LTV',
        cohortMonth: 'Cohorte - Mes',
        retention: 'Retención',
        dayHour: 'Día/Hora',
        operations: 'Operaciones',
        lastQuotation: 'Última cotización'
      },
      values: {
        opsPerCustomer: '{n} ops./cliente',
        days: '{n} días',
        cohortMonth: '{cohort} Mes {month}'
      },
      series: {
        averageTime: 'Tiempo promedio',
        total: 'Total'
      },
      totals: {
        banks: '{n} bancos',
        operations: '{n} operaciones',
        customers: '{n} clientes',
        correspondents: '{n} corresponsales',
        threeStages: '3 etapas',
        months: '{n} meses',
        segments: '{n} segmentos',
        cohorts: '{n} cohortes',
        currencies: '{n} monedas'
      }
    },
    internationalMixinUi: {
      cards: {
        cardTotalOperado: {
          description: 'Total operado',
          info: 'Suma del valor total de todas las operaciones en el período (ingreso bruto).'
        },
        cardTotalOperacoes: {
          description: 'Total de operaciones',
          info: 'Número total de operaciones realizadas en el período seleccionado.'
        },
        cardClientesAtivos: {
          description: 'Clientes activos',
          info: 'Cantidad de clientes que tuvieron al menos una operación en el período.'
        },
        cardLucroBruto: {
          description: 'Resultado bruto total',
          info: 'Suma del resultado bruto de todas las operaciones (ingreso menos costos directos).'
        },
        cardOpsPorCliente: {
          description: 'Operaciones por cliente activo',
          info: 'Promedio de operaciones por cliente que operó en el período.'
        },
        cardVolumePorBanco: {
          description: 'Volumen promedio por banco',
          info: 'Ingreso total dividido por el número de bancos activos en el período.'
        },
        cardTicketMedio: {
          description: 'Ticket promedio',
          info: 'Valor promedio por operación (volumen total dividido por el número de operaciones).'
        },
        cardSpreadMedio: {
          description: 'Spread promedio',
          info: 'Porcentaje promedio de spread aplicado en las operaciones del período.'
        },
        cardMaiorOperacao: {
          description: 'Mayor operación',
          info: 'Valor de la mayor operación (en ingreso) en el período.'
        },
        cardMenorOperacao: {
          description: 'Menor operación',
          info: 'Valor de la menor operación (en ingreso) en el período.'
        },
        cardBancosAtivos: {
          description: 'Bancos activos',
          info: 'Cantidad de bancos que tuvieron al menos una operación en el período.'
        },
        cardMoedasOperadas: {
          description: 'Monedas operadas',
          info: 'Cantidad de monedas distintas utilizadas en las operaciones del período.'
        },
        cardClientesTotais: {
          description: 'Clientes activos en el período',
          info: 'Cantidad de clientes que realizaron al menos una operación en el período seleccionado.'
        },
        cardClientesAprovados: {
          description: 'Clientes aprobados',
          info: 'Clientes con registro aprobado en al menos un banco.'
        },
        cardClientesRecorrentes: {
          description: 'Clientes recurrentes',
          info: 'Clientes que realizaron más de una operación en el período.'
        },
        cardTicketPorCliente: {
          description: 'Ticket promedio por cliente',
          info: 'Valor promedio operado por cliente activo (volumen total dividido por el número de clientes activos).'
        },
        cardLucroPorReal: {
          description: 'Resultado por real operado',
          info: 'Cuánto resultado bruto se genera por cada real movido por el cliente.'
        },
        cardComissaoMedia: {
          description: 'Comisión promedio por operación',
          info: 'Total de comisiones dividido por el número de operaciones en el período.'
        },
        cardMargemBruta: {
          description: 'Margen bruto',
          info: 'Porcentaje del resultado bruto en relación con el ingreso total.'
        },
        cardTotalComissoes: {
          description: 'Total de comisiones',
          info: 'Suma de todas las comisiones: Corban, Indicador, TechCambio y Banco.'
        },
        cardLucroCorban: {
          description: 'Resultado SOCIO',
          info: 'Suma del resultado destinado al Socio (agente) en las operaciones del período.'
        },
        cardLucroIndicador: {
          description: 'Resultado INDICADOR',
          info: 'Suma del resultado destinado al Indicador en las operaciones del período.'
        },
        cardLucroMaster: {
          description: 'Resultado CORBAN',
          info: 'Suma del resultado de la plataforma (TechCambio/Corban) en las operaciones del período.'
        },
        cardLucroBanco: {
          description: 'Resultado BANCOS',
          info: 'Suma del resultado destinado al banco en las operaciones del período.'
        },
        cardSpreadMaximo: {
          description: 'Spread máximo',
          info: 'Mayor spread aplicado en una operación en el período.'
        },
        cardLucroPorCliente: {
          description: 'Resultado por cliente activo',
          info: 'Resultado bruto total dividido por el número de clientes activos en el período.'
        },
        cardTaxaRecorrencia: {
          description: 'Tasa de recurrencia',
          info: 'Porcentaje de clientes activos que realizaron más de una operación en el período.'
        },
        cardConcentracaoTop10: {
          description: 'Concentración top 10',
          info: 'Porcentaje del volumen total operado por los 10 mayores clientes.'
        },
        cardVolumeRecorrentes: {
          description: 'Participación del volumen de recurrentes',
          info: 'Porcentaje del volumen operado por clientes que hicieron más de una operación en el período.'
        },
        cardOpsPorDia: {
          description: 'Operaciones/día (promedio)',
          info: 'Promedio de operaciones por día (total de operaciones dividido por 30 días).'
        },
        cardConcentracaoTop1: {
          description: 'Concentración top 1',
          info: 'Porcentaje del volumen total operado por el mayor cliente en el período.'
        },
        cardLucroPorOperacao: {
          description: 'Resultado/operación',
          info: 'Resultado bruto promedio por operación en el período.'
        },
        cardCorrespondentesAtivos: {
          description: 'Corresponsales activos',
          info: 'Cantidad de corresponsales (Corbans) que tuvieron al menos una operación en el período.'
        },
        cardVolumeCorrespondentes: {
          description: 'Volumen de corresponsales',
          info: 'Suma del volumen operado por todos los corresponsales en el período.'
        },
        cardComissoesPagas: {
          description: 'Comisiones pagadas',
          info: 'Total de comisiones pagadas a los corresponsales en el período.'
        },
        cardMediaOpsCorresp: {
          description: 'Promedio de ops./corresponsal',
          info: 'Promedio de operaciones por corresponsal (total de operaciones dividido por el número de corresponsales activos).'
        },
        cardClientesUnicos: {
          description: 'Clientes únicos',
          info: 'Clientes clasificados como únicos en la segmentación (realizaron solo 1 operación).'
        },
        cardClientesFrequentes: {
          description: 'Clientes frecuentes',
          info: 'Clientes clasificados como frecuentes en la segmentación.'
        },
        cardClientesRegulares: {
          description: 'Clientes regulares',
          info: 'Clientes clasificados como regulares en la segmentación.'
        },
        cardClientesOcasionais: {
          description: 'Clientes ocasionales',
          info: 'Clientes clasificados como ocasionales en la segmentación.'
        }
      },
      series: {
        totalOperated: 'Total operado',
        volumeOperated: 'Volumen operado',
        profitDistribution: 'Distribución de resultados',
        averageSpread: 'Spread promedio',
        volumeBrl: 'Volumen (R$)',
        volume: 'Volumen',
        customersByRegion: 'Clientes por región',
        resultBrl: 'Resultado (R$)',
        taxBurden: 'Carga tributaria',
        grossResult: 'Resultado bruto',
        activeCustomers: 'Clientes activos',
        volumeByNature: 'Volumen por naturaleza',
        ltvSegmentation: 'Segmentación LTV',
        ltvBrl: 'LTV (R$)',
        buyRate: 'Tipo de cambio de compra'
      },
      values: {
        noName: 'Sin nombre',
        customerCount: '{n} cliente | {n} clientes'
      }
    },
    stablecoinMixinUi: {
      totals: {
        receivers: '{n} beneficiarios',
        wallets: '{n} billeteras',
        quotes: '{n} cotizaciones'
      },
      profit: {
        bank: 'Ganancia del banco (USD)',
        master: 'Ganancia {theme} (USD)',
        corban: 'Ganancia del Corban (USD)',
        indicator: 'Ganancia del Corban indicador (USD)'
      },
      series: {
        profit: 'Ganancia',
        receivers: 'Beneficiarios',
        wallets: 'Billeteras',
        volume: 'Volumen',
        volumeOperated: 'Volumen operado',
        grossProfit: 'Ganancia bruta',
        quotes: 'Cotizaciones'
      },
      wallets: {
        linked: 'Vinculadas',
        unlinked: 'No vinculadas'
      },
      quotes: {
        active: 'Activas',
        expired: 'Vencidas'
      },
      cards: {
        operationsInPeriod: 'Operaciones en el período',
        activeCustomers: 'Clientes activos',
        payInVolume: 'Volumen Pay In',
        payInVolumeInfo: 'Valor total de los depósitos (ingresos) concluidos en el período. Puede ser mayor que el total operado si los clientes depositan más de lo que operaron.',
        payOutVolume: 'Volumen Pay Out',
        payOutVolumeInfo: 'Valor total de los retiros (egresos) concluidos en el período, en USD. Suele ser cercano al total operado.',
        payInsCompleted: 'Pay Ins concluidos',
        payOutsCompleted: 'Pay Outs concluidos',
        daysWithOperation: 'Días con operación',
        daysWithOperationInfo: 'Cantidad de días del período en los que hubo al menos una operación.',
        maxDayVolume: 'Mayor volumen en un día',
        maxDayVolumeInfo: 'Mayor volumen operado en un solo día del período.',
        totalOperated: 'Total operado',
        totalOperatedInfo: 'Ingresos (Fiat to Fiat y Pay-in). Egresos de la billetera (Payout) en el período: {value} — es el mismo dinero que ya ingresó, por eso queda fuera de la suma.',
        averageSpread: 'Spread promedio',
        averageOperation: 'Operación promedio',
        grossProfit: 'Ganancia bruta',
        grossProfitInfo: 'Ganancia bruta = Total de la operación - Ganancia del banco',
        corbanProfit: 'Ganancia del Corban',
        corbanProfitInfo: 'Ganancia del Corban en USD (OAS).',
        indicatorProfit: 'Ganancia del Corban indicador',
        indicatorProfitInfo: 'Ganancia del Corban indicador en USD (OAS).',
        masterProfit: 'Ganancia {theme}',
        masterProfitInfo: 'Ganancia {theme} = Ganancia bruta - Ganancia del banco + Cashback del contrato',
        bankProfit: 'Ganancia del banco',
        bankProfitInfo: 'Ganancia del banco = (1 - % de la comisión) * Ganancia bruta'
      }
    },
    calculationMemoryUi: {
      cardTotalOperado: {
        details: {
          d1: 'Considera solo operaciones efectivizadas (liquidadas).',
          d2: 'El valor de cada operación ya está convertido a reales según el tipo de cambio usado al momento de la operación.',
          d3: 'Es el volumen movido por el cliente, no la ganancia ni el ingreso de la empresa.'
        },
        title: 'Total operado',
        description: 'Cuánto dinero se movió en todas las operaciones de cambio en el período. Este valor es del cliente, no es ingreso de la empresa.',
        formula: 'Total operado = suma del valor en reales de cada operación'
      },
      cardTotalOperacoes: {
        details: {
          d1: 'Respeta los filtros aplicados (tipo, estado, banco, moneda).',
          d2: 'Cada operación se cuenta una sola vez, sin importar el valor.'
        },
        title: 'Total de operaciones',
        description: 'Cuántas operaciones de cambio se realizaron en el período.',
        formula: 'Total de operaciones = cantidad de operaciones realizadas'
      },
      cardClientesAtivos: {
        details: {
          d1: 'Si un cliente hizo 5 operaciones, cuenta como 1 cliente activo.',
          d2: 'Basta con haber hecho una operación en el período para ser considerado activo.'
        },
        title: 'Clientes activos',
        description: 'Cuántos clientes distintos hicieron al menos una operación en el período.',
        formula: 'Clientes activos = cantidad de clientes distintos que operaron'
      },
      cardLucroBruto: {
        details: {
          d1: 'Resultado bruto de cada operación = ingreso de la operación - costos directos - tarifa bancaria.',
          d2: 'La tarifa bancaria se descuenta directamente del resultado bruto antes de calcular PIS/COFINS y comisiones.',
          d3: 'Incluye las partes de todos los involucrados: corresponsal, indicador, plataforma y banco.',
          d4: 'No descuenta impuestos como IOF, PIS/COFINS, IR o CIDE.'
        },
        title: 'Resultado bruto total',
        description: 'Cuánto resultado generaron todas las operaciones, antes de descontar impuestos. Ya considera la deducción de la tarifa bancaria.',
        formula: 'Resultado bruto = (diferencia de subtotales) - tarifa bancaria'
      },
      chartOperadoBanco: {
        details: {
          d1: 'Gráfico de torta con la porción de cada banco.',
          d2: 'Solo aparecen los bancos que tuvieron operaciones en el período.'
        },
        title: 'Valor operado por banco',
        description: 'Muestra cómo se divide el volumen total entre los bancos.',
        formula: 'Porcentaje del banco = (valor operado por el banco / valor total operado) x 100'
      },
      chartOperadoMoeda: {
        details: {
          d1: 'Ayuda a identificar qué monedas concentran más negocios.'
        },
        title: 'Total operado por moneda',
        description: 'Muestra cuánto se operó en cada moneda extranjera.',
        formula: 'Volumen por moneda = suma del valor en reales de las operaciones en esa moneda'
      },
      cardOpsPorCliente: {
        details: {
          d1: 'Cuanto mayor, más comprometidos están los clientes.'
        },
        title: 'Operaciones por cliente',
        description: 'En promedio, cuántas operaciones hizo cada cliente en el período.',
        formula: 'Operaciones por cliente = total de operaciones / clientes activos'
      },
      cardVolumePorBanco: {
        details: {
          d1: 'Muestra la concentración promedio de volumen por banco.'
        },
        title: 'Volumen por banco',
        description: 'En promedio, cuánto movió cada banco en el período.',
        formula: 'Volumen por banco = total operado / bancos activos'
      },
      cardTicketMedio: {
        details: {
          d1: 'Ayuda a entender si las operaciones son grandes o pequeñas en promedio.'
        },
        title: 'Ticket promedio',
        description: 'Valor promedio de cada operación realizada.',
        formula: 'Ticket promedio = total operado en reales / total de operaciones'
      },
      cardSpreadMedio: {
        details: {
          d1: 'El spread es la diferencia entre el precio de compra y el precio de venta de la moneda.',
          d2: 'Representa el margen que genera la operación.'
        },
        title: 'Spread promedio',
        description: 'Margen promedio cobrado en las operaciones, en porcentaje.',
        formula: 'Spread promedio = promedio del margen porcentual de todas las operaciones'
      },
      cardMaiorOperacao: {
        details: {
          d1: 'Identifica la operación de mayor valor.'
        },
        title: 'Mayor operación',
        description: 'Valor de la operación más alta realizada en el período.',
        formula: 'Mayor operación = mayor valor en reales entre todas las operaciones'
      },
      cardMenorOperacao: {
        details: {
          d1: 'Identifica la operación de menor valor.'
        },
        title: 'Menor operación',
        description: 'Valor de la operación más baja realizada en el período.',
        formula: 'Menor operación = menor valor en reales entre todas las operaciones'
      },
      cardBancosAtivos: {
        details: {
          d1: 'Cada banco se cuenta una sola vez.'
        },
        title: 'Bancos activos',
        description: 'Cuántos bancos distintos se usaron en las operaciones.',
        formula: 'Bancos activos = cantidad de bancos distintos en las operaciones'
      },
      cardMoedasOperadas: {
        details: {
          d1: 'Ejemplo: si se operó dólar y euro, son 2 monedas.'
        },
        title: 'Monedas operadas',
        description: 'Cuántas monedas distintas se negociaron en el período.',
        formula: 'Monedas operadas = cantidad de monedas distintas en las operaciones'
      },
      chartOpsPorMoeda: {
        details: {
          d1: 'Gráfico de barras que compara el volumen por moneda.'
        },
        title: 'Operaciones por moneda',
        description: 'Cuánto se operó en cada moneda extranjera.',
        formula: 'Volumen por moneda = suma del valor en reales de las operaciones en esa moneda'
      },
      chartVolumePorBanco: {
        details: {
          d1: 'Gráfico de barras que compara el volumen por banco.'
        },
        title: 'Volumen por banco',
        description: 'Cuánto movió cada banco en el período.',
        formula: 'Volumen por banco = suma del valor en reales de las operaciones de ese banco'
      },
      chartOpsPorNatureza: {
        details: {
          d1: 'Ayuda a ver qué tipos de operación mueven más dinero.'
        },
        title: 'Operaciones por naturaleza',
        description: 'Cuánto se operó en cada tipo de naturaleza (remesa, importación, etc.).',
        formula: 'Volumen por naturaleza = suma del valor en reales de las operaciones de esa naturaleza'
      },
      chartCompraVsVenda: {
        details: {
          d1: 'Muestra el equilibrio entre compra y venta en el período.'
        },
        title: 'Compra vs. venta',
        description: 'Comparación entre el volumen de compra y el volumen de venta de divisas.',
        formula: 'Volumen de compra = suma de las operaciones de compra | Volumen de venta = suma de las operaciones de venta'
      },
      chartHeatmapOperacoes: {
        details: {
          d1: 'Las áreas más oscuras indican los horarios con más movimiento.'
        },
        title: 'Mapa de calor de operaciones',
        description: 'Muestra en qué días y horarios ocurren más operaciones.',
        formula: 'Para cada día y hora = cantidad de operaciones en ese momento'
      },
      cardClientesTotais: {
        details: {
          d1: 'Considera el período y los filtros seleccionados.'
        },
        title: 'Clientes totales',
        description: 'Cuántos clientes hicieron operaciones en el período.',
        formula: 'Clientes totales = cantidad de clientes con al menos una operación'
      },
      cardClientesAprovados: {
        details: {
          d1: 'El cliente debe tener un vínculo aprobado con el banco.'
        },
        title: 'Clientes aprobados',
        description: 'Cuántos clientes tienen el registro aprobado en al menos un banco.',
        formula: 'Clientes aprobados = cantidad de clientes con aprobación en un banco'
      },
      cardClientesRecorrentes: {
        details: {
          d1: 'Indica fidelización: son clientes que volvieron a operar.'
        },
        title: 'Clientes recurrentes',
        description: 'Cuántos clientes hicieron más de una operación en el período.',
        formula: 'Clientes recurrentes = cantidad de clientes con 2 o más operaciones'
      },
      cardTicketPorCliente: {
        details: {
          d1: 'Muestra el volumen promedio movido por cliente (valor del cliente, no ingreso).'
        },
        title: 'Ticket por cliente',
        description: 'En promedio, cuánto movió cada cliente en reales.',
        formula: 'Ticket por cliente = volumen total operado / clientes activos'
      },
      chartClientesRegiao: {
        details: {
          d1: 'Muestra la concentración geográfica de los clientes.'
        },
        title: 'Clientes por región',
        description: 'Dónde están ubicados los clientes, por estado.',
        formula: 'Clientes por estado = cantidad de clientes registrados en ese estado'
      },
      chartTopClientes: {
        details: {
          d1: 'Ordenado de mayor a menor volumen.'
        },
        title: 'Top clientes',
        description: 'Los 10 clientes que más dinero movieron.',
        formula: 'Volumen del cliente = suma del valor de todas sus operaciones (muestra los 10 mayores)'
      },
      chartClientesPorMes: {
        details: {
          d1: 'Muestra la tendencia de crecimiento o caída a lo largo del tiempo.'
        },
        title: 'Clientes activos por mes',
        description: 'Cómo varió la cantidad de clientes activos mes a mes.',
        formula: 'Clientes en el mes = cantidad de clientes distintos que operaron en ese mes'
      },
      cardLucroPorReal: {
        details: {
          d1: 'Ejemplo: si el valor es R$ 0,015, significa que por cada R$ 1,00 operado la empresa genera 1,5 centavos de resultado.',
          d2: 'Cuanto mayor, más eficiente es la operación.'
        },
        title: 'Resultado por real operado',
        description: 'Cuánto resultado bruto se genera por cada real que mueve el cliente.',
        formula: 'Resultado por real = Resultado bruto / Volumen total operado'
      },
      cardComissaoMedia: {
        details: {
          d1: 'Incluye todas las comisiones: corresponsal, indicador, plataforma y banco.'
        },
        title: 'Comisión promedio',
        description: 'Cuánta comisión se pagó, en promedio, por operación.',
        formula: 'Comisión promedio = total de comisiones / total de operaciones'
      },
      cardMargemBruta: {
        details: {
          d1: 'Indica cuánto del volumen movido se convirtió en resultado.',
          d2: 'El volumen operado es el valor del cliente, no ingreso propio.'
        },
        title: 'Margen bruto',
        description: 'Qué porcentaje del volumen operado se convirtió en resultado bruto.',
        formula: 'Margen bruto = (Resultado bruto / Volumen total operado) x 100'
      },
      cardTotalComissoes: {
        details: {
          d1: 'Incluye todas las partes distribuidas entre los involucrados.'
        },
        title: 'Total de comisiones',
        description: 'Cuánto se pagó en comisiones en total.',
        formula: 'Total de comisiones = comisión del corresponsal + comisión del indicador + comisión de la plataforma + comisión del banco'
      },
      cardLucroCorban: {
        details: {
          d1: 'Valor total pagado al corresponsal en el período.'
        },
        title: 'Resultado SOCIO',
        description: 'Cuánto recibió de comisión el corresponsal cambiario (Corban).',
        formula: 'Resultado SOCIO = suma de la parte del corresponsal en cada operación'
      },
      cardLucroIndicador: {
        details: {
          d1: 'Valor total pagado al indicador en el período.'
        },
        title: 'Resultado INDICADOR',
        description: 'Cuánto recibió de comisión el indicador.',
        formula: 'Resultado INDICADOR = suma de la parte del indicador en cada operación'
      },
      cardLucroMaster: {
        details: {
          d1: 'Valor total retenido por la plataforma en el período.'
        },
        title: 'Resultado CORBAN',
        description: 'Cuánto retuvo de comisión la plataforma.',
        formula: 'Resultado CORBAN = suma de la parte de la plataforma en cada operación'
      },
      cardLucroBanco: {
        details: {
          d1: 'Valor total pagado al banco de cambio en el período.'
        },
        title: 'Resultado BANCOS',
        description: 'Cuánto recibió de comisión el banco.',
        formula: 'Resultado BANCOS = suma de la parte del banco en cada operación'
      },
      chartDistribuicaoLucros: {
        details: {
          d1: 'El gráfico muestra la porción de cada uno en el resultado total.'
        },
        title: 'Distribución de resultados',
        description: 'Cómo se divide el resultado bruto entre los involucrados.',
        formula: 'Resultado bruto = corresponsal + indicador + plataforma + banco'
      },
      chartLucroMensal: {
        details: {
          d1: 'Muestra la tendencia del resultado a lo largo del tiempo.'
        },
        title: 'Resultado mensual',
        description: 'Cómo varió el resultado bruto mes a mes.',
        formula: 'Resultado del mes = suma del resultado bruto de las operaciones de ese mes'
      },
      chartVolumeMensal: {
        details: {
          d1: 'Muestra la evolución del volumen operado mes a mes.'
        },
        title: 'Volumen mensual',
        description: 'Cuánto se operó en cada mes.',
        formula: 'Volumen del mes = suma del valor en reales de las operaciones de ese mes'
      },
      cardCorrespondentesAtivos: {
        details: {
          d1: 'Cada corresponsal se cuenta una sola vez.'
        },
        title: 'Corresponsales activos',
        description: 'Cuántos corresponsales (Corbans) tuvieron operaciones en el período.',
        formula: 'Corresponsales activos = cantidad de corresponsales distintos en las operaciones'
      },
      cardVolumeCorrespondentes: {
        details: {
          d1: 'Valor total en reales operado por corresponsales.'
        },
        title: 'Volumen de corresponsales',
        description: 'Cuánto movieron todos los corresponsales en conjunto.',
        formula: 'Volumen de corresponsales = suma del valor de las operaciones vinculadas a corresponsales'
      },
      cardComissoesPagas: {
        details: {
          d1: 'Total de comisiones pagadas a todos los corresponsales.'
        },
        title: 'Comisiones pagadas',
        description: 'Cuánto se pagó en comisiones a los corresponsales.',
        formula: 'Comisiones pagadas = suma de la comisión de cada corresponsal'
      },
      cardMediaOpsCorresp: {
        details: {
          d1: 'Indica la productividad promedio de los corresponsales.'
        },
        title: 'Promedio de ops./corresponsal',
        description: 'En promedio, cuántas operaciones hizo cada corresponsal.',
        formula: 'Promedio = total de operaciones de corresponsales / corresponsales activos'
      },
      cardClientesUnicos: {
        details: {
          d1: 'Son clientes que operaron una sola vez.'
        },
        title: 'Clientes únicos',
        description: 'Clientes que hicieron solo 1 operación en el período.',
        formula: 'Clientes únicos = cantidad de clientes con exactamente 1 operación'
      },
      cardClientesFrequentes: {
        details: {
          d1: 'Son clientes con frecuencia moderada de operaciones.'
        },
        title: 'Clientes frecuentes',
        description: 'Clientes que hicieron entre 2 y 5 operaciones en el período.',
        formula: 'Clientes frecuentes = cantidad de clientes con 2 a 5 operaciones'
      },
      cardClientesRegulares: {
        details: {
          d1: 'Son clientes con alta frecuencia de operaciones.'
        },
        title: 'Clientes regulares',
        description: 'Clientes que hicieron entre 6 y 10 operaciones en el período.',
        formula: 'Clientes regulares = cantidad de clientes con 6 a 10 operaciones'
      },
      cardClientesOcasionais: {
        details: {
          d1: 'Son los clientes más activos del período.'
        },
        title: 'Clientes ocasionales',
        description: 'Clientes que hicieron más de 10 operaciones en el período.',
        formula: 'Clientes ocasionales = cantidad de clientes con más de 10 operaciones'
      },
      chartVolumeCorrespondente: {
        details: {
          d1: 'Gráfico de barras que compara el volumen de cada corresponsal.'
        },
        title: 'Volumen por corresponsal',
        description: 'Cuánto movió cada corresponsal en el período.',
        formula: 'Volumen del corresponsal = suma del valor de sus operaciones'
      },
      chartSegmentacaoClientes: {
        details: {
          d1: 'El gráfico muestra la proporción de clientes en cada grupo.'
        },
        title: 'Segmentación de clientes',
        description: 'Cómo se dividen los clientes según la frecuencia de operaciones.',
        formula: 'Único = 1 operación | Frecuente = 2 a 5 | Regular = 6 a 10 | Ocasional = más de 10'
      },
      cardSpreadMaximo: {
        details: {
          d1: 'Muestra el techo de margen aplicado.'
        },
        title: 'Spread máximo',
        description: 'El mayor margen porcentual aplicado en una operación en el período.',
        formula: 'Spread máximo = mayor margen entre todas las operaciones'
      },
      cardLucroPorCliente: {
        details: {
          d1: 'Indica la rentabilidad promedio por cliente.'
        },
        title: 'Resultado por cliente',
        description: 'En promedio, cuánto resultado generó cada cliente.',
        formula: 'Resultado por cliente = Resultado bruto total / Clientes activos'
      },
      cardTaxaRecorrencia: {
        details: {
          d1: 'Cuanto mayor, mejor la fidelización de los clientes.'
        },
        title: 'Tasa de recurrencia',
        description: 'Qué porcentaje de los clientes volvió a operar más de una vez.',
        formula: 'Tasa de recurrencia = (Clientes recurrentes / Clientes activos) x 100'
      },
      cardConcentracaoTop10: {
        details: {
          d1: 'Si este número es muy alto, significa dependencia de pocos clientes.'
        },
        title: 'Concentración top 10',
        description: 'Cuánto del volumen total está concentrado en los 10 mayores clientes.',
        formula: 'Concentración top 10 = (volumen de los 10 mayores / volumen total) x 100'
      },
      cardVolumeRecorrentes: {
        details: {
          d1: 'Muestra cuánto del negocio depende de clientes fieles.'
        },
        title: 'Volumen de recurrentes',
        description: 'Cuánto del volumen total proviene de clientes que operaron más de una vez.',
        formula: 'Volumen de recurrentes = (volumen de los clientes recurrentes / volumen total) x 100'
      },
      cardOpsPorDia: {
        details: {
          d1: 'Usa 30 días como referencia para el promedio diario.'
        },
        title: 'Operaciones por día',
        description: 'En promedio, cuántas operaciones ocurren por día.',
        formula: 'Operaciones por día = total de operaciones / 30 días'
      },
      cardConcentracaoTop1: {
        details: {
          d1: 'Si este número es muy alto, hay gran dependencia de un único cliente.'
        },
        title: 'Concentración top 1',
        description: 'Cuánto del volumen total está en el mayor cliente.',
        formula: 'Concentración top 1 = (volumen del mayor cliente / volumen total) x 100'
      },
      cardLucroPorOperacao: {
        details: {
          d1: 'Indica la rentabilidad promedio de cada operación.'
        },
        title: 'Resultado por operación',
        description: 'En promedio, cuánto resultado generó cada operación.',
        formula: 'Resultado por operación = Resultado bruto total / Total de operaciones'
      },
      chartAnaliseSpread: {
        details: {
          d1: 'Gráfico de barras que compara el margen promedio por moneda.'
        },
        title: 'Análisis de spread',
        description: 'Cuál es el margen promedio aplicado en cada moneda.',
        formula: 'Spread por moneda = promedio del margen de las operaciones en esa moneda'
      },
      chartEvolucaoVolume: {
        details: {
          d1: 'Muestra la tendencia de crecimiento o caída del volumen.'
        },
        title: 'Evolución del volumen',
        description: 'Cómo varió el volumen operado a lo largo del tiempo.',
        formula: 'Volumen por período = suma del valor en reales de las operaciones en ese período'
      },
      cardLucroLiquido: {
        details: {
          d1: 'Es el resultado real después de los descuentos tributarios.'
        },
        title: 'Resultado neto',
        description: 'Cuánto resultado queda después de descontar los impuestos (PIS/COFINS).',
        formula: 'Resultado neto = Resultado bruto - PIS/COFINS'
      },
      cardMargemLiquida: {
        details: {
          d1: 'Cuanto mayor, menor el impacto de los impuestos en el resultado.'
        },
        title: 'Margen neto',
        description: 'Qué porcentaje del resultado bruto quedó después de los impuestos.',
        formula: 'Margen neto = (Resultado neto / Resultado bruto) x 100'
      },
      cardTotalIof: {
        details: {
          d1: 'El IOF es el Impuesto sobre Operaciones Financieras, cobrado en operaciones de cambio.'
        },
        title: 'IOF total',
        description: 'Cuánto IOF se cobró en todas las operaciones.',
        formula: 'IOF total = suma del IOF de cada operación'
      },
      cardPisCofins: {
        details: {
          d1: 'Este impuesto incide sobre el resultado bruto de las operaciones.'
        },
        title: 'PIS/COFINS',
        description: 'Cuánto PIS/COFINS incidió sobre el resultado de las operaciones.',
        formula: 'PIS/COFINS = suma del PIS/COFINS de cada operación'
      },
      cardVolumePendente: {
        details: {
          d1: 'Son operaciones en curso, a la espera de su finalización.'
        },
        title: 'Volumen pendiente',
        description: 'Cuánto dinero está en operaciones que todavía no se liquidaron.',
        formula: 'Volumen pendiente = suma del valor de las operaciones no liquidadas'
      },
      cardTaxaLiquidacao: {
        details: {
          d1: 'Cuanto mayor, más eficiente es el proceso de liquidación.'
        },
        title: 'Tasa de liquidación',
        description: 'Qué porcentaje de las operaciones ya se liquidó.',
        formula: 'Tasa de liquidación = (operaciones liquidadas / total de operaciones) x 100'
      },
      cardVetMedio: {
        details: {
          d1: 'VET = tipo de cambio + IOF + tarifas. Es el costo total real para el cliente.'
        },
        title: 'VET promedio',
        description: 'Valor Efectivo Total promedio de las operaciones. Es una exigencia del Banco Central de Brasil.',
        formula: 'VET promedio = promedio del VET de todas las operaciones'
      },
      cardSpreadMinimo: {
        details: {
          d1: 'Muestra el piso de margen aplicado.'
        },
        title: 'Spread mínimo',
        description: 'El menor margen porcentual aplicado en el período.',
        formula: 'Spread mínimo = menor margen entre todas las operaciones'
      },
      cardTotalIr: {
        details: {
          d1: 'IR retenido en la fuente sobre operaciones de cambio.'
        },
        title: 'IR total',
        description: 'Cuánto Impuesto a la Renta se retuvo en las operaciones.',
        formula: 'IR total = suma del IR de cada operación'
      },
      cardTotalCide: {
        details: {
          d1: 'La CIDE es la Contribución de Intervención en el Dominio Económico.'
        },
        title: 'CIDE total',
        description: 'Cuánto CIDE se cobró en las operaciones.',
        formula: 'CIDE total = suma de la CIDE de cada operación'
      },
      chartRentabilidadeNatureza: {
        details: {
          d1: 'Permite comparar qué tipos de operación son más rentables.'
        },
        title: 'Rentabilidad por naturaleza',
        description: 'Cuál es el margen de resultado de cada tipo de operación.',
        formula: 'Margen por naturaleza = (resultado de la naturaleza / volumen de la naturaleza) x 100'
      },
      chartCargaTributaria: {
        details: {
          d1: 'El gráfico muestra la proporción de cada tributo en el costo total.'
        },
        title: 'Composición tributaria',
        description: 'Cómo se dividen los impuestos entre IOF, PIS/COFINS, IR y CIDE.',
        formula: 'Total de tributos = IOF + PIS/COFINS + IR + CIDE'
      },
      cardCotacaoMedia: {
        details: {
          d1: 'Refleja el tipo de cambio efectivo aplicado en el período.'
        },
        title: 'Cotización promedio',
        description: 'Cuál fue la cotización promedio de la moneda extranjera en las operaciones.',
        formula: 'Cotización promedio = promedio ponderado de la cotización (las operaciones más grandes pesan más)'
      },
      cardVolumeMoedaEstrangeira: {
        details: {
          d1: 'Ejemplo: si se operaron 10.000 dólares y 5.000 euros, muestra el total en moneda extranjera.'
        },
        title: 'Volumen en moneda extranjera',
        description: 'Cuánto se operó en total en moneda extranjera (sin convertir a reales).',
        formula: 'Volumen ME = suma del valor en moneda extranjera de cada operación'
      },
      cardSaldoCompraVenda: {
        details: {
          d1: 'Positivo = se compró más de lo que se vendió.',
          d2: 'Negativo = se vendió más de lo que se compró.'
        },
        title: 'Saldo compra vs. venta',
        description: 'La diferencia entre lo que se compró y lo que se vendió en divisas.',
        formula: 'Saldo = Volumen de compra - Volumen de venta'
      },
      cardVolumeVenda: {
        details: {
          d1: 'Considera solo operaciones de tipo venta.'
        },
        title: 'Volumen de venta',
        description: 'Cuánto se movió en operaciones de venta de moneda extranjera.',
        formula: 'Volumen de venta = suma del valor en reales de las operaciones de venta'
      },
      cardVolumeCompra: {
        details: {
          d1: 'Considera solo operaciones de tipo compra.'
        },
        title: 'Volumen de compra',
        description: 'Cuánto se movió en operaciones de compra de moneda extranjera.',
        formula: 'Volumen de compra = suma del valor en reales de las operaciones de compra'
      },
      cardVolumePayin: {
        details: {
          d1: 'Considera solo depósitos finalizados. Valor en reales.'
        },
        title: 'Volumen Pay In',
        description: 'Cuánto dinero ingresó (depósitos) en el período.',
        formula: 'Volumen Pay In = suma del valor de los depósitos concluidos'
      },
      cardVolumePayout: {
        details: {
          d1: 'Considera solo retiros finalizados. Valor en dólares.'
        },
        title: 'Volumen Pay Out',
        description: 'Cuánto dinero salió (retiros) en el período.',
        formula: 'Volumen Pay Out = suma del valor de los retiros concluidos'
      },
      cardPayinsConcluidos: {
        details: {
          d1: 'Solo transacciones de entrada finalizadas.'
        },
        title: 'Pay Ins concluidos',
        description: 'Cuántos depósitos se finalizaron con éxito.',
        formula: 'Pay Ins concluidos = cantidad de depósitos finalizados'
      },
      cardPayoutsConcluidos: {
        details: {
          d1: 'Solo transacciones de salida finalizadas.'
        },
        title: 'Pay Outs concluidos',
        description: 'Cuántos retiros se finalizaron con éxito.',
        formula: 'Pay Outs concluidos = cantidad de retiros finalizados'
      },
      cardDiasComOperacao: {
        details: {
          d1: 'Cada día se cuenta una sola vez.'
        },
        title: 'Días con operación',
        description: 'En cuántos días del período hubo al menos una operación.',
        formula: 'Días con operación = cantidad de días con al menos una operación'
      },
      cardMaiorVolumeDia: {
        details: {
          d1: 'Identifica el día pico.'
        },
        title: 'Mayor volumen en un día',
        description: 'Cuál fue el día con más dinero movido.',
        formula: 'Mayor volumen = mayor volumen diario entre todos los días'
      },
      cardOperacaoMediaUsd: {
        details: {
          d1: 'Muestra el tamaño promedio de las operaciones stablecoin.'
        },
        title: 'Operación promedio (USD)',
        description: 'En promedio, cuánto vale cada operación en dólares.',
        formula: 'Operación promedio = volumen total en dólares / total de operaciones'
      },
      cardTempoPreenchimentoFicha: {
        details: {
          d1: 'Considera solo clientes que terminaron de completar la ficha.',
          d2: 'El promedio de una etapa puede ser mayor que el tiempo total, ya que cada etapa tiene un grupo distinto de clientes.'
        },
        title: 'Tiempo promedio de llenado',
        description: 'Cuánto tiempo tarda, en promedio, el cliente en completar la ficha de registro.',
        formula: 'Tiempo promedio = promedio del tiempo de llenado de los clientes que completaron la etapa'
      },
      cardTempoAnaliseInterna: {
        details: {
          d1: 'Considera solo clientes que pasaron por esta etapa.'
        },
        title: 'Tiempo promedio de análisis',
        description: 'Cuánto tiempo tarda, en promedio, el análisis interno del registro.',
        formula: 'Tiempo promedio = promedio del tiempo entre el envío del registro y la conclusión del análisis'
      },
      cardTempoAprovacaoBanco: {
        details: {
          d1: 'Considera solo clientes que recibieron respuesta del banco.'
        },
        title: 'Tiempo de aprobación del banco',
        description: 'Cuánto tiempo tarda, en promedio, el banco en aprobar el registro.',
        formula: 'Tiempo promedio = promedio del tiempo entre el envío al banco y la respuesta'
      },
      cardTempoTotalCadastro: {
        details: {
          d1: 'Desde el envío de la ficha hasta la finalización completa.',
          d2: 'Puede ser menor que los promedios individuales, ya que solo incluye a quienes terminaron todo.'
        },
        title: 'Tiempo total de registro',
        description: 'Cuánto tiempo tarda, en promedio, todo el proceso de registro de principio a fin.',
        formula: 'Tiempo total = promedio del tiempo total de los clientes que completaron todas las etapas'
      },
      cardTaxaConversaoCadastro: {
        details: {
          d1: 'Mide la eficiencia del proceso de registro.'
        },
        title: 'Tasa de conversión',
        description: 'Qué porcentaje de los clientes que iniciaron el registro logró finalizarlo.',
        formula: 'Tasa de conversión = (clientes finalizados / clientes que iniciaron) x 100'
      },
      cardClientesParadosFluxo: {
        details: {
          d1: 'Puede indicar problemas o cuellos de botella en el proceso.'
        },
        title: 'Clientes detenidos',
        description: 'Cuántos clientes comenzaron el registro pero no lo terminaron.',
        formula: 'Clientes detenidos = cantidad de clientes con registro iniciado y no finalizado'
      },
      cardTaxaPendenciaBanco: {
        details: {
          d1: 'Indica cuánto retrabajo está ocurriendo en la aprobación bancaria.'
        },
        title: 'Tasa de pendientes del banco',
        description: 'Qué porcentaje de los clientes recibió pendientes del banco.',
        formula: 'Tasa de pendientes = (clientes con pendientes / clientes enviados al banco) x 100'
      },
      cardTaxaAprovacaoBanco: {
        details: {
          d1: 'Mide la efectividad del proceso de aprobación.'
        },
        title: 'Tasa de aprobación del banco',
        description: 'Qué porcentaje de los clientes enviados al banco fue aprobado.',
        formula: 'Tasa de aprobación = (clientes aprobados / clientes enviados al banco) x 100'
      },
      chartTempoEtapasFluxo: {
        details: {
          d1: 'Gráfico de barras que compara el tiempo de cada etapa.'
        },
        title: 'Tiempo por etapa',
        description: 'Cuánto tiempo tarda, en promedio, cada etapa del registro.',
        formula: 'Tiempo por etapa = promedio del tiempo de los clientes que pasaron por esa etapa'
      },
      chartEvolucaoTempoCadastro: {
        details: {
          d1: 'Muestra si el proceso se está volviendo más rápido o más lento.'
        },
        title: 'Evolución del tiempo de registro',
        description: 'Cómo varió el tiempo total de registro mes a mes.',
        formula: 'Tiempo en el mes = promedio del tiempo total de los registros finalizados en ese mes'
      },
      chartFunilCadastral: {
        details: {
          d1: 'El formato de embudo muestra dónde se están deteniendo los clientes.'
        },
        title: 'Embudo de conversión',
        description: 'Cuántos clientes llegaron a cada etapa del registro.',
        formula: 'Clientes por etapa = cantidad de clientes que alcanzaron ese punto'
      },
      chartDistribuicaoPfPj: {
        details: {
          d1: 'Gráfico de barras que muestra la proporción PF vs. PJ por etapa.'
        },
        title: 'Distribución PF vs. PJ',
        description: 'Cuántos son Persona Física y cuántos son Persona Jurídica en cada etapa.',
        formula: 'PF y PJ por etapa = cantidad de cada tipo en cada etapa del registro'
      },
      chartClientesPorStatus: {
        details: {
          d1: 'Muestra la foto actual del flujo de registro.'
        },
        title: 'Clientes por estado actual',
        description: 'Cuántos clientes están en cada estado del registro en este momento.',
        formula: 'Clientes por estado = cantidad de clientes en cada estado actual'
      },
      cardLtvMedio: {
        details: {
          d1: 'LTV significa el valor que el cliente genera a lo largo del tiempo.',
          d2: 'Cuanto mayor, más valioso es el cliente para el negocio.'
        },
        title: 'LTV promedio',
        description: 'En promedio, cuánto resultado generó cada cliente a lo largo de toda la relación.',
        formula: 'LTV promedio = resultado bruto total de todos los clientes / cantidad de clientes'
      },
      cardReceitaMediaCliente: {
        details: {
          d1: 'Muestra cuánto contribuye cada cliente en promedio.'
        },
        title: 'Ingreso promedio/cliente',
        description: 'En promedio, cuánto ingreso generó cada cliente activo.',
        formula: 'Ingreso por cliente = Resultado bruto total / Clientes activos'
      },
      cardFrequenciaMedia: {
        details: {
          d1: 'Cuanto mayor, más comprometidos están los clientes.'
        },
        title: 'Frecuencia promedio',
        description: 'En promedio, cuántas operaciones hizo cada cliente en el período.',
        formula: 'Frecuencia promedio = total de operaciones / clientes activos'
      },
      cardTempoVidaMedio: {
        details: {
          d1: 'Muestra durante cuánto tiempo los clientes permanecen activos.'
        },
        title: 'Tiempo de vida promedio',
        description: 'En promedio, cuántos días dura la relación con cada cliente.',
        formula: 'Tiempo de vida = promedio de los días entre la primera y la última operación de cada cliente'
      },
      cardTaxaRetencao: {
        details: {
          d1: 'Cuanto mayor, mejor la capacidad de retener clientes.'
        },
        title: 'Tasa de retención',
        description: 'Qué porcentaje de los clientes operó en más de un mes.',
        formula: 'Tasa de retención = (clientes que operaron en 2+ meses / total de clientes) x 100'
      },
      cardTaxaChurn: {
        details: {
          d1: 'Cuanto mayor este número, peor la retención de clientes.'
        },
        title: 'Pérdida de clientes (churn)',
        description: 'Qué porcentaje de los clientes dejó de operar en el período.',
        formula: 'Churn = (clientes que no operaron en el período / base histórica de clientes) x 100'
      },
      cardClientesAltoValor: {
        details: {
          d1: 'Son los clientes más valiosos para el negocio.'
        },
        title: 'Clientes de alto valor',
        description: 'Cuántos clientes están entre el 25% que más resultado genera.',
        formula: 'Clientes de alto valor = cantidad de clientes en el 25% superior por resultado generado'
      },
      cardBaseClientesLtv: {
        details: {
          d1: 'Es la base usada para calcular todas las métricas de valor del cliente.'
        },
        title: 'Base de clientes LTV',
        description: 'Cuántos clientes se consideraron en el cálculo del valor del cliente.',
        formula: 'Base = cantidad de clientes con al menos una operación en el período'
      },
      chartSegmentacaoLtv: {
        details: {
          d1: 'El gráfico muestra la distribución de los clientes por rango de valor.'
        },
        title: 'Segmentación por valor del cliente',
        description: 'Cómo se dividen los clientes por rango de valor generado (alto, medio, bajo).',
        formula: 'Clientes por rango = cantidad de clientes en cada rango de valor'
      },
      chartEvolucaoLtv: {
        details: {
          d1: 'Muestra la tendencia del valor del cliente a lo largo del tiempo.'
        },
        title: 'Evolución del valor del cliente',
        description: 'Cómo varió el valor promedio generado por cliente mes a mes.',
        formula: 'LTV en el mes = resultado promedio acumulado por cliente en ese mes'
      },
      chartTopClientesLtv: {
        details: {
          d1: 'Ranking de los clientes más valiosos.'
        },
        title: 'Top clientes por valor',
        description: 'Los 10 clientes que más resultado generaron a lo largo del tiempo.',
        formula: 'Valor del cliente = suma de todo el resultado que generó (muestra los 10 mayores)'
      },
      chartRetencaoCoorte: {
        details: {
          d1: 'Agrupados por el mes de la primera operación. Áreas más oscuras = mayor retención.'
        },
        title: 'Retención por grupo',
        description: 'Durante cuánto tiempo los clientes siguen operando después de la primera operación.',
        formula: 'Retención = (clientes que siguieron operando / clientes del grupo original) x 100'
      }
    },
    drilldownColumnsUi: {
      customer: 'Cliente',
      foreignAmount: 'Monto ME',
      valueBrl: 'Monto BRL',
      date: 'Fecha',
      name: 'Nombre',
      city: 'Ciudad',
      registrationDate: 'Fecha de registro',
      operationsCount: 'Cant. operaciones',
      totalVolume: 'Volumen total',
      grossProfit: 'Ganancia bruta',
      bank: 'Banco',
      commission: 'Comisión',
      marginPercent: 'Margen %',
      totalCommission: 'Comisión total',
      correspondentProfit: 'Ganancia corresp.',
      indicatorProfit: 'Ganancia indicador',
      masterProfit: 'Ganancia master',
      bankProfit: 'Ganancia banco',
      correspondent: 'Corresponsal',
      totalProfit: 'Ganancia total',
      profit: 'Ganancia',
      netProfit: 'Ganancia neta',
      iofValue: 'Monto IOF',
      irValue: 'Monto IR',
      cideValue: 'Monto CIDE',
      quotation: 'Cotización',
      type: 'Tipo',
      fillingTime: 'Tiempo de completado',
      analysisTime: 'Tiempo de análisis',
      approvalTime: 'Tiempo de aprobación',
      totalTime: 'Tiempo total',
      currentStep: 'Etapa actual',
      bankStatus: 'Estado en el banco',
      nature: 'Naturaleza',
      agent: 'Agente',
      segment: 'Segmento',
      tax: 'Tributo',
      taxValue: 'Monto del tributo',
      stageTime: 'Tiempo en la etapa',
      cohort: 'Cohorte',
      currency: 'Moneda',
      buyRate: 'Tasa de compra',
      sellRate: 'Tasa de venta',
      quotationType: 'Tipo de cotización',
      dateTime: 'Fecha/Hora'
    },
    drilldownCardConfigsUi: {
      titles: {
        cardTotalOperado: 'Operaciones - Total operado',
        cardTotalOperacoes: 'Operaciones - Total de operaciones',
        cardLucroBruto: 'Operaciones - Ganancia bruta',
        cardClientesAtivos: 'Clientes activos',
        cardClientesTotais: 'Clientes totales',
        cardClientesAprovados: 'Clientes aprobados',
        cardClientesRecorrentes: 'Clientes recurrentes',
        cardTicketPorCliente: 'Clientes - Ticket por cliente',
        cardOpsPorCliente: 'Operaciones por cliente',
        cardVolumePorBanco: 'Operaciones - Volumen por banco',
        cardTicketMedio: 'Operaciones - Ticket promedio',
        cardSpreadMedio: 'Operaciones - Spread promedio',
        cardBancosAtivos: 'Operaciones - Bancos activos',
        cardMoedasOperadas: 'Operaciones - Monedas operadas',
        cardLucroPorReal: 'Ganancia por real operado',
        cardComissaoMedia: 'Operaciones - Comisión promedio',
        cardMargemBruta: 'Operaciones - Margen bruto',
        cardTotalComissoes: 'Operaciones - Total de comisiones',
        cardLucroCorban: 'Operaciones - Ganancia del corresponsal',
        cardLucroIndicador: 'Operaciones - Ganancia del indicador',
        cardLucroMaster: 'Operaciones - Ganancia master',
        cardLucroBanco: 'Operaciones - Ganancia del banco',
        cardCorrespondentesAtivos: 'Operaciones - Corresponsales activos',
        cardVolumeCorrespondentes: 'Operaciones - Volumen por corresponsal',
        cardComissoesPagas: 'Operaciones - Comisiones pagadas',
        cardMediaOpsCorresp: 'Operaciones - Promedio por corresponsal',
        cardClientesUnicos: 'Clientes únicos',
        cardClientesFrequentes: 'Clientes frecuentes',
        cardClientesRegulares: 'Clientes regulares',
        cardClientesOcasionais: 'Clientes ocasionales',
        cardSpreadMaximo: 'Operaciones - Spread máximo',
        cardLucroPorCliente: 'Clientes - Ganancia por cliente',
        cardTaxaRecorrencia: 'Clientes recurrentes',
        cardConcentracaoTop10: 'Top 10 clientes por volumen',
        cardVolumeRecorrentes: 'Volumen de clientes recurrentes',
        cardOpsPorDia: 'Operaciones por día',
        cardConcentracaoTop1: 'Top 1 cliente por volumen',
        cardLucroPorOperacao: 'Operaciones - Ganancia por operación',
        cardVolumePayin: 'Pay Ins - Volumen',
        cardVolumePayout: 'Pay Outs - Volumen',
        cardPayinsConcluidos: 'Pay Ins completados',
        cardPayoutsConcluidos: 'Pay Outs completados',
        cardDiasComOperacao: 'Operaciones - Días con operación',
        cardMaiorVolumeDia: 'Operaciones - Mayor volumen en un día',
        cardOperacaoMediaUsd: 'Operaciones - Valor promedio (USD)',
        cardLucroLiquido: 'Operaciones - Ganancia neta',
        cardMargemLiquida: 'Operaciones - Margen neto',
        cardTotalIof: 'Operaciones - Total IOF',
        cardTotalIr: 'Operaciones - Total IR',
        cardTotalCide: 'Operaciones - Total CIDE',
        cardPisCofins: 'Operaciones - PIS/COFINS',
        cardVolumePendente: 'Operaciones - Volumen pendiente',
        cardTaxaLiquidacao: 'Operaciones - Tasa de liquidación',
        cardVetMedio: 'Operaciones - VET promedio',
        cardSpreadMinimo: 'Operaciones - Spread mínimo',
        cardCotacaoMedia: 'Operaciones - Cotización promedio',
        cardVolumeMoedaEstrangeira: 'Operaciones - Volumen en moneda extranjera',
        cardSaldoCompraVenda: 'Operaciones - Saldo compra vs. venta',
        cardVolumeVenda: 'Operaciones - Volumen de venta',
        cardVolumeCompra: 'Operaciones - Volumen de compra',
        cardTempoPreenchimentoFicha: 'Clientes - Tiempo de completado',
        cardTempoAnaliseInterna: 'Clientes - Tiempo de análisis',
        cardTempoAprovacaoBanco: 'Clientes - Tiempo de aprobación del banco',
        cardTempoTotalCadastro: 'Clientes - Tiempo total de registro',
        cardTaxaConversaoCadastro: 'Clientes - Tasa de conversión',
        cardClientesParadosFluxo: 'Clientes detenidos en el flujo',
        cardTaxaPendenciaBanco: 'Clientes - Pendiente en el banco',
        cardTaxaAprovacaoBanco: 'Clientes - Aprobación del banco',
        cardLtvMedio: 'Clientes - LTV promedio',
        cardReceitaMediaCliente: 'Clientes - Ingreso promedio',
        cardFrequenciaMedia: 'Clientes - Frecuencia promedio',
        cardTempoVidaMedio: 'Clientes - Tiempo de vida',
        cardTaxaRetencao: 'Clientes retenidos',
        cardTaxaChurn: 'Clientes perdidos (churn)',
        cardClientesAltoValor: 'Clientes de alto valor',
        cardBaseClientesLtv: 'Base de clientes LTV'
      }
    },
    drilldownChartConfigsUi: {
      titles: {
        chartOperadoBanco: 'Operaciones por banco',
        chartOperadoMoeda: 'Operaciones por moneda',
        chartOpsPorMoeda: 'Operaciones por moneda',
        chartVolumePorBanco: 'Volumen por banco',
        chartOpsPorNatureza: 'Operaciones por naturaleza',
        chartCompraVsVenda: 'Operaciones por tipo',
        chartHeatmapOperacoes: 'Operaciones por día/hora',
        chartClientesRegiao: 'Clientes por región',
        chartTopClientes: 'Operaciones del cliente',
        chartClientesPorMes: 'Clientes activos en el mes',
        chartDistribuicaoLucros: 'Operaciones por agente',
        chartLucroMensal: 'Operaciones del mes',
        chartVolumeCorrespondente: 'Operaciones del corresponsal',
        chartSegmentacaoClientes: 'Clientes por segmento',
        chartAnaliseSpread: 'Operaciones por rango de spread',
        chartEvolucaoVolume: 'Operaciones del período',
        chartVolumeMensal: 'Operaciones del mes',
        chartRentabilidadeNatureza: 'Operaciones por naturaleza',
        chartCargaTributaria: 'Operaciones por tipo de tributo',
        chartTempoEtapasFluxo: 'Clientes por etapa del flujo',
        chartEvolucaoTempoCadastro: 'Clientes por mes de registro',
        chartFunilCadastral: 'Clientes por etapa del embudo',
        chartDistribuicaoPfPj: 'Clientes por tipo y etapa',
        chartSegmentacaoLtv: 'Clientes por segmento LTV',
        chartEvolucaoLtv: 'Operaciones del mes',
        chartTopClientesLtv: 'Operaciones del cliente',
        chartRetencaoCoorte: 'Clientes de la cohorte',
        chartHistoricoCotacao: 'Detalles del snapshot de cotización'
      }
    },
    tabIconsUi: {
      dashboard: 'Panel',
      currency: 'Moneda',
      users: 'Usuarios',
      wallet: 'Billetera',
      handshake: 'Alianza',
      chartLine: 'Gráfico de líneas',
      chartBar: 'Gráfico de barras',
      chartPie: 'Gráfico circular',
      trendUp: 'Tendencia al alza',
      trendDown: 'Tendencia a la baja',
      bank: 'Banco',
      receipt: 'Recibo',
      money: 'Dinero',
      percent: 'Porcentaje',
      target: 'Objetivo',
      calendar: 'Calendario',
      clock: 'Reloj',
      globe: 'Globo',
      briefcase: 'Maletín',
      building: 'Edificio',
      star: 'Estrella',
      medal: 'Medalla',
      crown: 'Corona',
      lightning: 'Rayo',
      fire: 'Fuego'
    },
    widgetRegistryUi: {
      categories: {
        visaoGeral: {
          label: 'Visión general',
          description: 'Métricas generales y resumen ejecutivo'
        },
        operacoes: {
          label: 'Operaciones',
          description: 'Detalles sobre las operaciones realizadas'
        },
        clientes: {
          label: 'Clientes',
          description: 'Información sobre los clientes'
        },
        financeiro: {
          label: 'Finanzas',
          description: 'Análisis financieros y resultados'
        },
        correspondentes: {
          label: 'Corresponsales',
          description: 'Métricas de corresponsales'
        },
        performance: {
          label: 'Rendimiento',
          description: 'Indicadores de rendimiento'
        },
        tributario: {
          label: 'Tributario y liquidación',
          description: 'Impuestos, liquidaciones y salud financiera'
        },
        stablecoin: {
          label: 'Stablecoin',
          description: 'Indicadores de operaciones con stablecoins'
        },
        fluxoCadastral: {
          label: 'Flujo de registro',
          description: 'Métricas de tiempo del flujo de registro'
        },
        ltv: {
          label: 'LTV y retención',
          description: 'Métricas de Lifetime Value y retención de clientes'
        }
      },
      widgets: {
        cardTotalOperado: 'Total operado',
        cardTotalOperacoes: 'Total de operaciones',
        cardClientesAtivos: 'Clientes activos',
        cardLucroBruto: 'Resultado bruto',
        chartOperadoBanco: 'Valor operado por banco',
        chartOperadoMoeda: 'Porcentaje operado por moneda',
        chartHistoricoCotacao: 'Historial de cotización',
        cardOpsPorCliente: 'Operaciones por cliente',
        cardVolumePorBanco: 'Volumen por banco',
        cardTicketMedio: 'Ticket promedio',
        cardSpreadMedio: 'Spread promedio',
        cardMaiorOperacao: 'Mayor operación',
        cardMenorOperacao: 'Menor operación',
        cardBancosAtivos: 'Bancos activos',
        cardMoedasOperadas: 'Monedas operadas',
        chartOpsPorMoeda: 'Operaciones por moneda',
        chartVolumePorBanco: 'Volumen por banco',
        cardClientesTotais: 'Clientes totales',
        cardClientesAprovados: 'Clientes aprobados',
        cardClientesRecorrentes: 'Clientes recurrentes',
        cardTicketPorCliente: 'Ticket por cliente',
        chartClientesRegiao: 'Clientes por región',
        chartTopClientes: 'Top clientes',
        cardLucroPorReal: 'Resultado por real operado',
        cardComissaoMedia: 'Comisión promedio',
        cardMargemBruta: 'Margen bruto',
        cardTotalComissoes: 'Total de comisiones',
        cardLucroCorban: 'Resultado SOCIO',
        cardLucroIndicador: 'Resultado INDICADOR',
        cardLucroMaster: 'Resultado CORBAN',
        cardLucroBanco: 'Resultado BANCOS',
        cardTarifaCliente: 'Tarifa pagada por el cliente',
        cardTarifaBanco: 'Tarifa cobrada por el banco',
        cardSaldoTarifa: 'Saldo de tarifa',
        chartDistribuicaoLucros: 'Distribución de resultados',
        cardCorrespondentesAtivos: 'Corresponsales activos',
        cardVolumeCorrespondentes: 'Volumen de corresponsales',
        cardComissoesPagas: 'Comisiones pagadas',
        cardMediaOpsCorresp: 'Promedio ops/corresponsal',
        cardClientesUnicos: 'Clientes únicos',
        cardClientesFrequentes: 'Clientes frecuentes',
        cardClientesRegulares: 'Clientes regulares',
        cardClientesOcasionais: 'Clientes ocasionales',
        chartVolumeCorrespondente: 'Volumen por corresponsal',
        chartSegmentacaoClientes: 'Segmentación de clientes',
        cardSpreadMaximo: 'Spread máximo',
        cardLucroPorCliente: 'Resultado por cliente',
        cardTaxaRecorrencia: 'Tasa de recurrencia',
        cardConcentracaoTop10: 'Concentración top 10',
        cardVolumeRecorrentes: 'Volumen recurrentes',
        cardOpsPorDia: 'Operaciones por día',
        cardConcentracaoTop1: 'Concentración top 1',
        cardLucroPorOperacao: 'Resultado por operación',
        cardVolumePayin: 'Volumen Pay In',
        cardVolumePayout: 'Volumen Pay Out',
        cardPayinsConcluidos: 'Pay Ins completados',
        cardPayoutsConcluidos: 'Pay Outs completados',
        cardDiasComOperacao: 'Días con operación',
        cardMaiorVolumeDia: 'Mayor volumen en un día',
        cardOperacaoMediaUsd: 'Operación promedio (USD)',
        chartAnaliseSpread: 'Análisis de spread',
        chartEvolucaoVolume: 'Evolución del volumen',
        cardLucroLiquido: 'Resultado neto',
        cardMargemLiquida: 'Margen neto',
        cardTotalIof: 'IOF total',
        cardPisCofins: 'PIS/COFINS',
        cardVolumePendente: 'Volumen pendiente',
        cardTaxaLiquidacao: 'Tasa de liquidación',
        cardVetMedio: 'VET promedio',
        cardSpreadMinimo: 'Spread mínimo',
        chartRentabilidadeNatureza: 'Rentabilidad por naturaleza',
        chartCargaTributaria: 'Composición tributaria',
        cardTotalIr: 'IR total',
        cardTotalCide: 'CIDE total',
        cardCotacaoMedia: 'Cotización promedio',
        cardVolumeMoedaEstrangeira: 'Volumen en moneda extranjera',
        cardSaldoCompraVenda: 'Saldo compra vs. venta',
        cardVolumeVenda: 'Volumen de venta',
        cardVolumeCompra: 'Volumen de compra',
        chartVolumeMensal: 'Volumen mensual',
        chartLucroMensal: 'Resultado mensual',
        chartOpsPorNatureza: 'Operaciones por naturaleza',
        chartCompraVsVenda: 'Compra vs. venta',
        chartClientesPorMes: 'Clientes activos por mes',
        cardTempoPreenchimentoFicha: 'Tiempo promedio de completado',
        cardTempoAnaliseInterna: 'Tiempo promedio de análisis',
        cardTempoAprovacaoBanco: 'Tiempo de aprobación del banco',
        cardTempoTotalCadastro: 'Tiempo total de registro',
        chartTempoEtapasFluxo: 'Tiempo por etapa',
        chartEvolucaoTempoCadastro: 'Evolución del tiempo de registro',
        cardTaxaConversaoCadastro: 'Tasa de conversión',
        cardClientesParadosFluxo: 'Clientes detenidos',
        cardTaxaPendenciaBanco: 'Tasa de pendientes en el banco',
        cardTaxaAprovacaoBanco: 'Tasa de aprobación del banco',
        chartFunilCadastral: 'Embudo de conversión',
        chartDistribuicaoPfPj: 'Distribución PF vs. PJ',
        chartClientesPorStatus: 'Clientes por estado actual',
        cardLtvMedio: 'LTV promedio',
        cardReceitaMediaCliente: 'Ingreso promedio/cliente',
        cardFrequenciaMedia: 'Frecuencia promedio',
        cardTempoVidaMedio: 'Tiempo de vida promedio',
        cardTaxaRetencao: 'Tasa de retención',
        cardTaxaChurn: 'Pérdida de clientes (churn)',
        cardClientesAltoValor: 'Clientes de alto valor',
        cardBaseClientesLtv: 'Base de clientes LTV',
        chartSegmentacaoLtv: 'Segmentación por LTV',
        chartEvolucaoLtv: 'Evolución del LTV',
        chartTopClientesLtv: 'Top clientes por LTV',
        chartRetencaoCoorte: 'Retención por cohorte',
        chartHeatmapOperacoes: 'Mapa de calor de operaciones'
      },
      simpleDescriptions: {
        cardLtvMedio: 'Valor promedio de resultado generado por cliente a lo largo de la relación.',
        chartSegmentacaoLtv: 'Distribución de los clientes por rangos de valor generado a lo largo de la relación.',
        chartEvolucaoLtv: 'Evolución del valor promedio generado por cliente a lo largo del tiempo.',
        chartTopClientesLtv: 'Clientes que más resultado generaron en el período.',
        cardVetMedio: 'Promedio del VET (valor final de la operación), indicador regulatorio exigido por el Banco Central de Brasil.',
        cardPisCofins: 'Total de PIS/COFINS cobrado en las operaciones del período.',
        cardTotalIof: 'Total de IOF cobrado en las operaciones del período.',
        cardTotalIr: 'Total de Impuesto a la Renta cobrado en las operaciones del período.',
        cardTotalCide: 'Total de CIDE cobrado en las operaciones del período.',
        cardTaxaChurn: 'Porcentaje de clientes que dejaron de operar en el período.',
        chartRetencaoCoorte: 'Tiempo de permanencia de los clientes operando después del inicio de la relación.'
      },
      defaultName: 'Indicador',
      chartDescription: 'Análisis de {name} en el período seleccionado, que facilita comparaciones y tendencias.',
      cardDescription: 'Resumen de {name} en el período seleccionado.'
    },
    scenarioValidationUi: {
      nameMaxLength: 'El nombre debe tener como máximo 100 caracteres'
    },
    dashboardChartUi: {
      goal: 'Meta: {value}',
      series: 'Serie',
      noData: 'Sin datos'
    },
    internationalDashboardUi: {
      customersSeries: 'Clientes',
      sharedScenario: 'Escenario compartido',
      cannotDeleteOnlyScenario: 'No es posible eliminar el único escenario disponible'
    },
    customerDashboard: {
      emptyTitle: 'Dashboard no configurado',
      emptyMessage: 'No se ha configurado ningún dashboard para su perfil. Contacte al administrador.',
      errorLoadIndicators: 'No fue posible cargar los indicadores del dashboard. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadScenario: 'No fue posible cargar el escenario del dashboard de su perfil. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorApplyFilter: 'No fue posible aplicar el filtro del dashboard. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.'
    },
    internationalDashboard: {
      btnEdit: 'Editar',
      btnFinish: 'Finalizar',
      btnManageTabs: 'Gestionar Pestañas',
      btnTheme: 'Tema',
      emptyTitle: 'Configure su dashboard',
      emptyMessage: 'Seleccione o cree un escenario arriba para personalizar sus pestañas y widgets. Todos los indicadores (tarjetas y gráficos) están disponibles como widgets en el modo "Editar Dashboard".',
      errorLoadIndicators: 'No fue posible cargar los indicadores del dashboard. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorApplyFilter: 'No fue posible aplicar el filtro del dashboard. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      errorSaveFilter: 'No fue posible guardar el filtro en el escenario. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorSaveFilterScenario: 'No fue posible guardar el filtro en el escenario del dashboard. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      successSaveFilter: 'Filtro guardado en el escenario',
      errorNoActiveScenario: 'Ningún escenario activo para guardar el filtro',
      errorNoUser: 'No fue posible identificar al usuario. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorTimeout: 'El servidor tardó demasiado en responder. Verifique si el backend está funcionando e inténtelo de nuevo.',
      errorLoadOperations: 'No fue posible cargar las operaciones del dashboard. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadFilterCustomers: 'No fue posible cargar la lista de clientes del filtro. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadCustomerCount: 'No fue posible cargar la cantidad de clientes del dashboard. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadTotals: 'No fue posible cargar los totales del dashboard. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadPeriodChart: 'No fue posible cargar el gráfico de operaciones por período. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadBankChart: 'No fue posible cargar el gráfico de operaciones por banco. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadCurrencyChart: 'No fue posible cargar el gráfico de operaciones por moneda. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadTopCustomers: 'No fue posible cargar la lista de principales clientes. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadCorbanIndicators: 'No fue posible cargar los indicadores de los corbanes. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadCustomerSegmentation: 'No fue posible cargar la segmentación de clientes. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadActiveScenario: 'No fue posible cargar el escenario activo. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorChangeScenario: 'No fue posible cambiar el escenario. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadDashboardData: 'No fue posible cargar los datos del dashboard. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadSharedScenario: 'No fue posible cargar el escenario compartido. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadDefaultScenario: 'No fue posible cargar el escenario predeterminado del perfil. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      successCreateScenario: 'Escenario creado con éxito',
      errorCreateScenario: 'No fue posible crear el escenario. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      successRenameScenario: 'Escenario renombrado con éxito',
      errorRenameScenario: 'No fue posible renombrar el escenario. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      successDeleteScenario: 'Escenario eliminado con éxito',
      errorDeleteScenario: 'No fue posible eliminar el escenario. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      errorReloadTabs: 'No fue posible recargar las pestañas. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorSaveLayout: 'No fue posible guardar el layout. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorSaveTheme: 'No fue posible guardar el tema del dashboard. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    cardDashboard: {
      tooltipOpenDetails: 'Abrir detalles de la operación',
      tooltipViewDetails: 'Haga clic para ver detalles'
    },
    filterDrawer: {
      btnFilter: 'Filtrar',
      title: 'Filtro',
      labelPeriod: 'Período',
      labelStartDate: 'Fecha de inicio',
      labelEndDate: 'Fecha de fin',
      labelOperation: 'Operación',
      labelType: 'Tipo',
      labelCurrency: 'Moneda',
      labelBank: 'Banco',
      bankInactive: '(inactivo)',
      labelCorban: 'Corban',
      labelPersonType: 'Tipo de Persona',
      labelCpfCnpj: 'CPF/CNPJ',
      btnClear: 'Limpiar',
      btnSaveFilter: 'Guardar y filtrar',
      exchangeBuyLabel: 'Compra',
      exchangeSellLabel: 'Venta',
      errorLoadCurrencies: 'No fue posible cargar la lista de monedas del filtro. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadBanks: 'No fue posible cargar la lista de bancos del filtro. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadCorbans: 'No fue posible cargar la lista de correspondientes del filtro. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    periodItems: {
      TODAY: 'Hoy',
      THIS_WEEK: 'Esta semana',
      THIS_MONTH: 'Este mes',
      LAST_12_MONTHS: 'Últimos 12 meses',
      LAST_MONTH: 'Mes pasado',
      LAST_3_MONTHS: 'Últimos 3 meses',
      LAST_6_MONTHS: 'Últimos 6 meses',
      LAST_YEAR: 'Último año',
      CUSTOM: 'Personalizado'
    },
    scenarioSelector: {
      fallbackName: 'Escenario',
      validationNameRequired: 'El nombre del escenario es obligatorio',
      validationNameDuplicate: 'Ya existe un escenario con este nombre',
      deleteTitle: 'Eliminar Escenario',
      deleteMessage: '<p>¿Está seguro de que desea eliminar el escenario <strong>{name}</strong>?</p>',
      deleteIrreversibleMessage: 'Esta acción no se puede deshacer. Todas las pestañas y widgets de este escenario serán eliminados permanentemente.',
      deleteKeyword: 'ELIMINAR',
      deleteInputPlaceholder: 'Escriba "ELIMINAR" para confirmar',
      errorLimitReached: 'Ha alcanzado el límite de 10 escenarios por usuario',
      warningNameUnchanged: 'El nombre no fue modificado',
      duplicateSuffix: 'Copia'
    },
    scenarioCreateDialog: {
      title: 'Crear Nuevo Escenario',
      labelName: 'Nombre del Escenario',
      placeholder: 'Ej: Panel Ejecutivo',
      warningLimit: 'Está cerca del límite de 10 escenarios por usuario. Actualmente tiene {count} escenario(s).',
      btnCancel: 'Cancelar',
      btnCreate: 'Crear escenario'
    },
    scenarioRenameDialog: {
      title: 'Renombrar escenario',
      labelName: 'Nombre del Escenario',
      btnCancel: 'Cancelar',
      btnRename: 'Renombrar'
    },
    scenarioActionButtons: {
      btnNew: 'Nuevo',
      btnRename: 'Renombrar',
      btnDuplicate: 'Duplicar',
      btnShare: 'Compartir',
      btnManageSharing: 'Gestionar comparticiones',
      btnDelete: 'Eliminar Escenario'
    },
    tabManagerDialog: {
      title: 'Gestionar pestañas',
      sectionTitle: 'Mis Pestañas',
      btnAddTab: 'Agregar pestaña',
      dragHint: 'Arrastre las pestañas para reordenar. Los cambios se guardan automáticamente.',
      btnClose: 'Cerrar'
    },
    widgetLibrary: {
      title: 'Biblioteca de Widgets',
      searchLabel: 'Buscar widgets',
      searchPlaceholder: 'Escriba el nombre del widget...',
      allCategory: 'Todos',
      emptyTitle: 'Ningún widget encontrado.',
      emptySubtitle: 'Intente ajustar los filtros o el término de búsqueda.',
      btnClose: 'Cerrar',
      errorNoActiveTab: 'Ninguna pestaña activa para agregar el widget',
      errorWidgetExists: 'Este widget ya existe en la pestaña actual'
    },
    tabFormDialog: {
      titleCreate: 'Crear Nueva Pestaña',
      titleEdit: 'Editar Pestaña',
      labelName: 'Nombre de la pestaña',
      placeholder: 'Ej: Mis Métricas',
      labelIcon: 'Ícono de la pestaña',
      btnSave: 'Guardar Cambios',
      btnCreate: 'Crear pestaña',
      btnCancel: 'Cancelar',
      validationNameRequired: 'El nombre es obligatorio',
      validationNameEmpty: 'El nombre no puede estar vacío'
    },
    maxValueDialog: {
      title: 'Meta del indicador',
      descriptionPrefix: 'Defina el valor de la meta para',
      labelTarget: 'Meta',
      btnConfirm: 'Confirmar',
      btnCancel: 'Cancelar',
      validationPositive: 'El valor debe ser mayor que cero'
    },
    tabList: {
      orderLabel: 'Orden: {n}',
      emptyTitle: 'Ninguna pestaña creada aún.',
      emptySubtitle: 'Haga clic en "Agregar Pestaña" para crear su primera pestaña personalizada.'
    },
    tabManager: {
      deleteTitle: 'Eliminar Pestaña',
      deleteMessage: '¿Está seguro de que desea eliminar la pestaña <strong>{name}</strong>? Todos los widgets posicionados en ella serán eliminados permanentemente.',
      successDelete: 'Pestaña eliminada con éxito',
      errorDelete: 'No fue posible eliminar la pestaña. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      successReorder: 'Orden de las pestañas actualizado con éxito',
      errorReorder: 'No fue posible reordenar las pestañas. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      validationNameRequired: 'El nombre de la pestaña es obligatorio',
      successCreate: 'Pestaña creada con éxito',
      errorCreate: 'No fue posible crear la pestaña. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      successUpdate: 'Pestaña actualizada con éxito',
      errorUpdate: 'No fue posible actualizar la pestaña. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    scenarioSelectInput: {
      fallbackName: 'Escenario',
      sharedWithMe: 'Compartidos conmigo',
      viaProfile: 'Vía perfil: {name}'
    },
    sharingModal: {
      title: 'Compartir escenario',
      tabUsers: 'Usuarios',
      tabProfiles: 'Perfiles',
      searchLabel: 'Buscar usuario por nombre o correo',
      searchPlaceholder: 'Escriba para buscar...',
      noUserFound: 'Ningún usuario encontrado',
      searchMinChars: 'Escriba al menos 2 caracteres para buscar',
      recipientsTitle: 'Destinatarios',
      noRecipients: 'Ningún destinatario agregado aún.',
      loadingProfiles: 'Cargando perfiles...',
      noProfiles: 'Ningún perfil disponible para compartir.',
      alreadyShared: 'Ya compartido',
      btnConfirm: 'Confirmar',
      btnCancel: 'Cancelar',
      permissionView: 'Visualización',
      permissionEdit: 'Edición',
      duplicateUser: 'Este usuario ya fue agregado',
      successShared: 'Escenario compartido con éxito',
      errorLoadProfiles: 'No fue posible cargar los perfiles. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorSearchUsers: 'No fue posible buscar usuarios. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorShare: 'No fue posible compartir el escenario. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    manageSharingsModal: {
      title: 'Gestionar comparticiones',
      tabUsers: 'Usuarios',
      tabProfiles: 'Perfiles',
      noUsersShared: 'El escenario aún no fue compartido con ningún usuario',
      noProfilesShared: 'El escenario aún no fue compartido con ningún perfil',
      btnClose: 'Cerrar',
      permissionView: 'Visualización',
      permissionEdit: 'Edición',
      errorLoadUserSharings: 'No fue posible cargar las comparticiones. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorUpdatePermission: 'No fue posible actualizar el permiso. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorRevokeAccess: 'No fue posible revocar el acceso. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      errorLoadProfileSharings: 'No fue posible cargar las comparticiones por perfil. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    drilldownModal: {
      loadingText: 'Cargando datos...',
      emptyText: 'Ningún registro encontrado para este filtro',
      btnExportCsv: 'Exportar CSV',
      btnClose: 'Cerrar',
      errorLoad: 'No fue posible cargar los datos del detalle. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      defaultTitle: 'Detalle'
    },
    themePicker: {
      title: 'Seleccionar tema',
      btnClose: 'Cerrar'
    },
    calculationMemory: {
      whatIs: '¿Qué es?',
      formula: 'Cálculo',
      details: 'Detalles'
    },
    defaultTab: {
      colProfile: 'Perfil',
      colDefaultDashboard: 'Dashboard Predeterminado',
      colActions: 'Acciones',
      noScenarioText: 'Ningún escenario encontrado. Cree escenarios en el dashboard primero.',
      notConfigured: 'No configurado',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      emptyProfiles: 'Ningún perfil encontrado.',
      removeTitle: 'Eliminar Dashboard Predeterminado',
      removeMessage: '¿Desea eliminar el dashboard predeterminado del perfil <strong>{name}</strong>?',
      successSave: 'Dashboard predeterminado configurado con éxito.',
      successRemove: 'Dashboard predeterminado eliminado con éxito.',
      errorLoad: 'No fue posible cargar los dashboards predeterminados. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadScenarios: 'No fue posible cargar los escenarios disponibles. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorSave: 'No fue posible guardar la configuración. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorRemove: 'No fue posible eliminar el dashboard predeterminado. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.'
    },
    gridLayout: {
      preparing: 'Preparando dashboard...'
    },
    widgetContentRenderer: {
      tooltipOpenOperation: 'Abrir operación'
    },
    chartTypeSelector: {
      title: 'Tipo de gráfico',
      titleNewWidget: 'Agregar gráfico',
      subtitle: 'Elija cómo se mostrará este widget',
      subtitleNewWidget: 'Elija cómo se mostrará este gráfico en el dashboard',
      tooltipDisabled: 'No adecuado para los datos de este gráfico',
      btnCancel: 'Cancelar',
      btnApply: 'Aplicar',
      typeBar: 'Columnas',
      typeHorizontalBar: 'Barras',
      typeFunnel: 'Embudo',
      typeArea: 'Área',
      typeDonut: 'Dona',
      typePie: 'Pastel',
      typeTreemap: 'Mapa de Área',
      typeRadar: 'Radar',
      typeRadialBar: 'Radial'
    },
    chart: {
      noDetailTitle: 'Detalle no disponible',
      noDetailMessage: 'Este elemento no tiene datos detallados para mostrar.',
      noDetailIdentifyMessage: 'No fue posible identificar el elemento seleccionado. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
    }
  },

  reports: {
    duimpDueOperationReportUi: {
      totalMe: 'Total ME',
      pendingDuimp: 'DUIMP pendiente'
    },
    exchangeOperationReportUi: {
      totalValue: 'Valor total'
    },
    approvalActionsUi: {
      renewLink: 'Renovar y reenviar enlace',
      remind: 'Reenviar recordatorio',
      history: 'Ver progreso e historial',
      resumeForeign: 'Reanudar envío al exterior'
    },
    stablecoinRemittanceOperationReportUi: {
      payment: 'Pago',
      tooltipPayIn: 'Monto en {token} recibido en la wallet del cliente después del pago fiat',
      tooltipPayOut: 'Monto en {token} enviado desde la wallet del cliente al destino fiat',
      tooltipFull: 'Monto en {token} procesado en la operación completa (entrada y salida)',
      tooltipBoleto: 'Pago de boleto bancario realizado con stablecoin de la wallet del cliente',
      tooltipPix: 'Pago PIX realizado con stablecoin de la wallet del cliente',
      tooltipForeign: 'Monto en moneda extranjera de la operación',
      payableDescription: 'Pago de {kind}',
      payableDescriptionTo: 'Pago de {kind} a {beneficiary}'
    },
    remittanceOperationManagementReportUi: {
      operationalExpense: 'Gasto operativo',
      operationalExpenseTooltip: 'Total de tarifas bancarias cobradas por el banco de cambio al contratante en el período, en las operaciones en las que el cliente no pagó la tarifa.',
      customerPaidExpense: 'Gasto pagado por el cliente',
      customerPaidExpenseTooltip: 'Total de tarifas bancarias pagadas por los clientes en el período. Representa un ingreso para el contratante.',
      residualExpense: 'Gasto residual',
      residualExpenseTooltip: 'Diferencia entre lo que el contratante recibió de tarifa de los clientes y lo que pagó al banco. Un valor negativo indica que el contratante pagó más de lo que recibió.',
      corbanMaster: 'Corban master'
    },
    managementExportUi: {
      title: 'GANANCIA / REMESAS INTERNACIONALES',
      period: 'Período: {start} a {end}',
      exportedAt: 'Exportado el: {date}',
      summary: 'RESUMEN',
      indicator: 'Indicador',
      value: 'Valor',
      operations: 'OPERACIONES',
      currency: 'Moneda',
      amountMe: 'Valor ME',
      spreadPercent: 'Spread (%)',
      grossProfit: 'Ganancia bruta',
      corbanMasterProfit: 'Ganancia Corban Master',
      corbanProfit: 'Ganancia Corban',
      bankCommission: 'Comisión banco (%)',
      corbanCommission: 'Comisión Corban (%)',
      indicatorCommission: 'Comisión Indicador (%)'
    },
    searchPlaceholder: 'Buscar en todos los campos (cliente, banco, valores, documentos, etc.)',
    stablecoinSearchPlaceholder: 'Buscar en todos los campos...',
    customerApproval: 'Aprobación del cliente',
    lastUpdated: 'Última actualización: {date}',
    exchangeBuy: 'Compra',
    exchangeSell: 'Venta',
    emptyTitle: 'Ningún registro encontrado',
    actions: 'Acciones',
    options: 'Opciones',
    editing: 'En edición por {user}',
    pixExpired: 'Expirado',
    tooltips: {
      downloadBankProduct: 'Descargar documento de producto bancario',
      manageDuimp: 'Gestionar DUIMPs',
      downloadDoc: 'Descargar documento',
      viewRefusal: 'Ver motivo del rechazo',
      manageInvoices: 'Gestionar Facturas',
      editShippingDate: 'Editar fecha de embarque',
      edit: 'Editar'
    },
    expand: {
      operation: 'Operación',
      taxes: 'Tasas y valores',
      taxesAndTributes: 'Tasas y tributos',
      taxesAndResult: 'Tasas y resultado',
      result: 'Resultado',
      tributes: 'Tributos',
      parties: 'Partes involucradas',
      operationNum: 'Nº de OP',
      opNum: 'N° de OP',
      nature: 'Naturaleza de la operación',
      natureShort: 'Naturaleza',
      bankProduct: 'Producto bancario',
      originDestination: 'Origen / Destino',
      noTaxRate: 'Tasa sin IOF',
      customerRate: 'Tasa del cliente',
      subtotal: 'Subtotal',
      vet: 'VET',
      vetTooltip: 'Valor efectivo total',
      deliveryCost: 'Costo de entrega',
      corban: 'Corban',
      corbanIndicator: 'Corban indicador',
      bank: 'Banco',
      agent: 'Agente',
      observation: 'Observación',
      delivery: 'Entrega',
      profit: 'Ganancia',
      currentProfit: 'Ganancia actual',
      spotForecast: 'SPOT previsto',
      spotCurrent: 'SPOT actual',
      updatingIn: 'Actualizando en {seconds}s',
      tariff: 'Tarifa',
      iof: 'IOF',
      ir: 'IR',
      bankAccount: 'Cuenta bancaria',
      accountType: 'Tipo',
      accountName: 'Nombre',
      accountNumber: 'Número de cuenta',
      routingNumber: 'Routing Number',
      beneficiaryName: 'Nombre del beneficiario',
      quoteDescription: 'Descripción de cotización',
      loadingAccount: 'Cargando datos de la cuenta...',
      loadingDescription: 'Cargando descripción...',
      tariffPaidByClient: 'Tarifa pagada por el cliente',
      tariffPaidByContractor: 'Tarifa pagada por el contratante',
      balance: 'Saldo'
    },
    columns: {
      bank: 'Banco',
      date: 'Fecha',
      customer: 'Cliente',
      deliveryType: 'Entrega',
      type: 'Tipo',
      currency: 'M.E.',
      amountMe: 'Valor M.E.',
      valueME: 'Valor M.E',
      subtotal: 'Subtotal',
      totalValue: 'Valor total',
      commission: 'Comisión',
      bankSlip: 'Boleto',
      paySlip: 'Comp. de pago',
      authDoc: 'Autorización',
      status: 'Estado',
      actions: 'Acciones',
      liquidation: 'Liquidación',
      sourceAmount: 'Moneda origen',
      destAmount: 'Moneda destino',
      clientRate: 'Tasa cliente.',
      clientRateShort: 'Tasa cliente',
      clientRateFull: 'Tasa del cliente',
      nature: 'Naturaleza',
      cc: 'C.C.',
      swift: 'SWIFT',
      code: 'Código',
      duimpCoverage: 'Cobertura DUIMP',
      delay: 'Retraso (días)',
      duimpStatus: 'Estado DUIMP',
      supplier: 'Proveedor',
      bankRate: 'Tasa del banco',
      grossProfit: 'Ganancia bruta',
      corbanMasterProfit: 'Ganancia corban master',
      extraCosts: 'Costos extras',
      adjustedProfit: 'Ganancia ajustada',
      corbanProfit: 'Ganancia corban',
      indicatorProfit: 'Ganancia indicador',
      pixExpiration: 'Expiración PIX',
      netProfit: 'Ganancia neta',
      sourceStatus: 'Estado origen',
      destStatus: 'Estado destino',
      contract: 'Contrato',
      duimpNumber: 'DUIMP/DU-E'
    },
    menu: {
      viewOperation: 'Ver operación',
      registerPendencies: 'Registrar pendencias',
      analysisPendencies: 'Análisis de pendencias',
      viewHistory: 'Ver historial',
      cancelOperation: 'Cancelar operación',
      relaunchOperation: 'Relanzar operación',
      documents: 'Documentos',
      edit: 'Editar',
      editAndFinish: 'Editar y concluir',
      copySimulation: 'Copiar simulación del cliente',
      changeHistory: 'Historial de cambios',
      newOperationSameValues: 'Nueva operación con los mismos valores',
      finish: 'Concluir',
      noSolution: 'Sin solución',
      resendDocumentsToBank: 'Reenviar documentos al banco',
      resendDuimpRequest: 'Reenviar solicitud de DUIMPs/DUEs',
      chargeHistory: 'Historial de cobros',
      responseHistory: 'Historial de respuestas',
      timeline: 'Línea de tiempo',
      consultPayments: 'Consultar pagos',
      returnedToCustomer: 'Devuelta al cliente',
      createPixOperation: 'Crear operación PIX'
    },
    duimp: {
      sectionTitle: 'DUIMPs',
      noDuimp: 'Ningún DUIMP registrado',
      approved: 'Aprobado',
      rejected: 'Rechazado',
      columnKey: 'Clave de acceso',
      columnDate: 'Fecha de inserción',
      columnValue: 'Valor M.E.',
      columnDoc: 'Doc.',
      columnApproval: 'Aprobación',
      columnDetails: 'Detalles'
    },
    invoice: {
      sectionTitle: 'Facturas',
      noInvoice: 'Ninguna factura registrada',
      columnNumber: 'Número',
      columnDate: 'Fecha',
      columnShipping: 'Prev. embarque',
      columnDoc: 'Doc.'
    },
    openOps: {
      emptySubtitle: 'No hay operaciones abiertas para hoy.',
      bankDigital: 'Operación con banco digital'
    },
    preSale: {
      internalTab: 'Operaciones internas',
      externalTab: 'Operaciones externas',
      customerTab: 'Operaciones de clientes',
      stablecoinTab: 'Operaciones Stablecoin'
    },
    operationPendency: {
      title: 'Pendencias de la operación',
      history: 'Historial de pendencias',
      empty: 'Ninguna pendencia registrada para esta operación.',
      newLabel: 'Nueva pendencia',
      placeholder: 'Describa lo que falta para que la operación avance',
      sendEmail: 'Enviar correo al cliente',
      register: 'Registrar pendencia',
      required: 'Describa la pendencia antes de registrar.',
      loadError: 'No fue posible cargar las pendencias de la operación. Intente de nuevo en unos instantes.',
      emailSent: 'Correo enviado al cliente',
      noEmail: 'Sin correo al cliente',
      registered: 'Pendencia registrada.',
      inAnalysis: 'En análisis de pendencias'
    },
    exchange: {
      emptySubtitle: 'No hay operaciones de Cambio Turismo para el período seleccionado.',
      delivery: 'Entrega a domicilio',
      storePickup: 'Retiro en tienda',
      cancelTitle: '¿Cancelar operación?',
      pendencyModalTitle: 'Información complementaria',
      complementaryInfo: 'Informaciones complementarias'
    },
    remittance: {
      emptySubtitle: 'No hay operaciones de Cambio Remesa para el período seleccionado.',
      updateCommissionsMass: 'Actualizar comisiones en masa',
      exportExcel: 'Exportar Excel',
      tariffTitle: 'Detalle de tarifa',
      tariffCustomerLabel: 'Tarifa pagada por el cliente',
      tariffContractorLabel: 'Tarifa pagada por el contratante',
      tariffBalanceLabel: 'Saldo',
      tariffCustomerHint: 'valor cobrado al cliente en la operación (campo "Tasa del cliente").',
      tariffContractorHint: 'valor que el banco de cambio cobra por operación cuando el cliente no paga la tarifa.',
      tariffBalanceHint: 'diferencia entre lo recibido de los clientes y lo pagado al banco. Positivo = ganancia, negativo = pérdida.',
      updateModalTitle: 'Actualizar comisiones en masa',
      commissionLabel: 'Comisión(%)',
      updateBtn: 'Actualizar'
    },
    management: {
      fantasyName: 'Nombre de fantasía:',
      name: 'Nombre:',
      date: 'Fecha:',
      amountME: 'Valor ME:',
      clientRate: 'Tasa del cliente:',
      grossProfit: 'Ganancia bruta:',
      bankRate: 'Tasa del banco:',
      corbanProfit: 'Ganancia Corban:',
      indicatorProfit: 'Ganancia indicador:',
      bankRateLabel: 'Tasa del banco',
      comissionBank: 'Comisión del banco: {value}%',
      comissionCorban: 'Comisión del Corban: {value}',
      comissionIndicator: 'Comisión del Corban indicador: {value}'
    },
    duimpReport: {
      emptySubtitle: 'No hay operaciones de DUIMP/DU-E para el período seleccionado.',
      operationData: 'Datos de la operación',
      confirmResendTitle: 'Confirmar reenvío',
      confirmResendMessage: '¿Desea reenviar la solicitud de DUIMPs/DUEs al cliente?',
      rejectionModalTitle: 'Motivo del rechazo',
      sendRejectionEmailBtn: 'Enviar email de rechazo al cliente',
      close: 'Cerrar',
      duimpLabel: 'DUIMP',
      dateTimeRefusal: 'Fecha/hora del rechazo',
      originalValue: 'Valor original (antes del rechazo)',
      rejectionMessageLabel: 'Mensaje para el cliente'
    },
    stablecoin: {
      deskClosingTab: 'Cierre por mesa',
      customerClosingTab: 'Cierre por cliente',
      noContractTooltip: 'La operación de la app no tiene contrato de cambio',
      noContractIsolatedTooltip: 'La operación solo de entrada o solo de salida no tiene contrato de cambio'
    },
    cards: {
      operations: 'Operaciones',
      totalOperated: 'Total operado',
      spread: 'Spread',
      netProfit: 'Ganancia neta',
      corban: 'Corban',
      corbanIndicator: 'Corban indicador',
      bankProfit: 'Ganancia banco'
    },
    errors: {
      loadCurrencies: 'No fue posible cargar la lista de monedas del filtro. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      loadBanks: 'No fue posible cargar la lista de bancos del filtro. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      attachmentNotAdded: 'El adjunto no fue agregado. Verifique si el archivo es PDF, JPG o PNG e intente de nuevo.',
      noPermissionAttachment: '¡No tiene permiso para agregar este adjunto!',
      copyError: 'El texto no fue copiado. Selecciónelo y cópielo manualmente (Ctrl+C).',
      cancelOperation: 'No fue posible cancelar la operación. Intente de nuevo en unos instantes; si continúa, comuníquese con el soporte.',
      pendencyEmail: 'No fue posible enviar el correo de pendencia de la operación. Intente de nuevo en unos instantes; si continúa, comuníquese con el soporte.',
      addCustomerDoc: 'No fue posible adjuntar el documento operacional del cliente. Intente de nuevo en unos instantes; si continúa, comuníquese con el soporte.',
      removeCustomerDoc: 'No fue posible eliminar el documento operacional del cliente. Intente de nuevo en unos instantes; si continúa, comuníquese con el soporte.',
      registerDocReceipt: 'No fue posible registrar la recepción de los documentos de la operación. Intente de nuevo en unos instantes; si continúa, comuníquese con el soporte.',
      sendDuimpRequest: 'No fue posible enviar la solicitud de DUIMP/DU-E al cliente. Intente de nuevo en unos instantes; si continúa, comuníquese con el soporte.',
      noSolution: 'No fue posible marcar el DUIMP de la operación como sin solución. Intente de nuevo en unos instantes; si continúa, comuníquese con el soporte.',
      sendDocumentsToBank: 'No fue posible enviar documentos al banco. Intente de nuevo en unos instantes; si continúa, comuníquese con el soporte.',
      loadDuimp: 'No fue posible cargar el informe de DUIMP/DU-E. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      loadExchange: 'No fue posible cargar el informe de operaciones de cambio. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      loadRemittance: 'No fue posible cargar el informe de operaciones de remesa. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      loadManagement: 'No fue posible cargar el informe de gestión de remesas. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      loadStablecoin: 'No fue posible cargar el informe de operaciones en stablecoin. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      loadOperationCount: 'No fue posible cargar la cantidad de operaciones del informe. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      loadManagementTotals: 'No fue posible cargar los totales del informe de gestión de remesas. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      saveOperation: 'No fue posible guardar los cambios de la operación. Verifique los datos e intente de nuevo; si continúa, comuníquese con el soporte.',
      updateCommissions: 'No fue posible actualizar las comisiones de las operaciones seleccionadas. Verifique los datos e intente de nuevo; si continúa, comuníquese con el soporte.',
      loadHistory: 'No fue posible cargar el historial de estados. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      loadNatures: 'No fue posible cargar la lista de naturalezas de operación del filtro. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      loadPreSale: 'No fue posible cargar la lista de preventa. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      finishOperation: 'No fue posible concluir la operación. Verifique los datos e intente de nuevo; si continúa, comuníquese con el soporte.',
      lockPreSale: 'No fue posible bloquear esta preventa para edición. Intente de nuevo en unos instantes; si continúa, comuníquese con el soporte.',
      sendFinishEmail: 'No fue posible enviar el correo de cierre de la operación. Intente de nuevo en unos instantes; si continúa, comuníquese con el soporte.',
      sendIndicationEmail: 'No fue posible enviar el correo de notificación de indicación. Intente de nuevo en unos instantes; si continúa, comuníquese con el soporte.',
      fetchQuoteUsd: 'No fue posible obtener cotización USD. Intente de nuevo.',
      usdParity: 'No fue posible calcular la paridad USD. Intente de nuevo.',
      noServerConnection: 'No fue posible conectarse al servidor. Intente recargar la página.',
      operationConcludedSketchRemove: 'La operación fue concluida, pero no fue posible eliminar la preventa de la lista. Actualice la página (F5) para verificar; si continúa, comuníquese con el soporte.',
      operationConcludedDocAttach: 'La operación fue concluida, pero no fue posible adjuntar los documentos. Abra la operación, verifique los documentos y adjunte de nuevo los que falten; si continúa, comuníquese con el soporte.',
      loadPreSaleData: 'No fue posible cargar los datos de la preventa. Actualice la página (F5) e intente de nuevo; si continúa, comuníquese con el soporte.',
      savePreSale: 'No fue posible guardar los cambios de la preventa. Verifique los datos e intente de nuevo; si continúa, comuníquese con el soporte.',
      rejectionEmail: 'No fue posible enviar el correo de rechazo. Intente de nuevo en unos instantes; si continúa, comuníquese con el soporte.',
      downloadDocument: 'No fue posible descargar el documento. Intente de nuevo; si continúa, comuníquese con el soporte.'
    },
    success: {
      documentSent: '¡Documento enviado con éxito!',
      duimpSentToCustomer: '¡Solicitud de envío de DUIMP/DU-E enviada con éxito!',
      pendencyEmailSent: '¡Correo de pendencia documental enviado con éxito!',
      operationCancelled: '¡La operación fue cancelada!',
      noSolutionSet: 'Estado DUIMP actualizado a Sin solución.',
      documentsSentToBank: '¡Documentos enviados al banco con éxito!',
      downloading: 'Descargando documento',
      observationSaved: '¡Observación guardada con éxito!',
      copiedToClipboard: 'Mensaje copiado al portapapeles',
      rejectionEmailSent: 'Correo de rechazo enviado al cliente con éxito.'
    },
    openOperations: {
      templateNotConfigured: 'Plantilla no configurada. Acceda a Configuraciones > Mensaje de Operación.',
      copyMessageError: 'No fue posible copiar el mensaje. Seleccione el texto y cópielo manualmente (Ctrl+C).',
      preSaleBeingEdited: 'Esta preventa está siendo editada por {userName}. Espere hasta que sea liberada.',
      editingBy: 'En edición por {userName}',
      editAction: 'Editar',
      editAndFinish: 'Editar y Concluir'
    }
  },

  configurations: {
    operationMessageTitlesUi: {
      customerRemittancePurchase: 'Cliente - Remesa de compra',
      customerRemittanceSaleSameOwner: 'Cliente - Remesa de venta (misma titularidad)',
      customerRemittanceSaleOtherOwner: 'Cliente - Remesa de venta (otra titularidad)',
      customerExchangePurchaseCash: 'Cliente - Cambio compra (efectivo)',
      customerExchangePurchaseOtherPayments: 'Cliente - Cambio compra (otros medios de pago)',
      customerExchangeSalePickupCash: 'Cliente - Cambio venta con retiro (efectivo)',
      customerExchangeSalePickupOtherPayments: 'Cliente - Cambio venta con retiro (otros medios de pago)',
      customerExchangeSaleDelivery: 'Cliente - Cambio venta con entrega',
      customerWhatsappSwiftSettlement: 'Cliente — WhatsApp liquidación SWIFT',
      bankRemittancePurchase: 'Banco - Remesa de compra',
      bankRemittanceSaleWithoutFfc: 'Banco - Remesa de venta (sin FFC)',
      bankRemittanceSaleWithFfc: 'Banco - Remesa de venta (con FFC)',
      bankExchangePurchase: 'Banco - Cambio compra',
      bankExchangeSalePickup: 'Banco - Cambio venta con retiro',
      bankExchangeSaleDelivery: 'Banco - Cambio venta con entrega'
    },
    configurationsMenuUi: {
      remittance: 'Remesa',
      remittanceEmailTemplates: 'Plantillas de e-mail - Remesa',
      customer: 'Cliente',
      individual: 'Persona física',
      legalEntity: 'Persona jurídica',
      bank: 'Banco',
      corban: 'Corresponsal',
      user: 'Usuario',
      users: 'Usuarios',
      tourism: 'Turismo',
      tourismEmailTemplates: 'Plantillas de e-mail - Cambio turismo',
      buyPickup: 'Compra con retiro',
      sellPickup: 'Venta con retiro',
      sellDelivery: 'Venta con entrega a domicilio',
      receiptSending: 'Envío de comprobante',
      general: 'General',
      signatures: 'Firmas',
      termsAndConditions: 'Términos y condiciones',
      emailProvider: 'Proveedor de correos electrónicos',
      emailLayout: 'Diseño de correo electrónico',
      operationMessages: 'Mensajes de operación',
      defaultDashboard: 'Dashboard predeterminado',
      holidays: 'Feriados',
      notices: 'Informativos',
      categoryCommunication: 'Comunicación',
      categoryTransactionalEmails: 'Correos electrónicos transaccionales',
      categoryDocuments: 'Documentos',
      categoryIntegrations: 'Integraciones',
      categorySystem: 'Sistema'
    },
    pageRegistryUi: {
      noItemSelected: 'No hay ningún elemento de configuración seleccionado.',
      pageNotFound: 'No se encontró la página de configuración para "{identifier}". Verifique el registro de páginas.'
    },
    signatureCredentialsUi: {
      fallbackTitle: 'Firmas',
      hint: 'Players usados para enviar fichas de registro para firma electrónica. Marque uno de ellos como predeterminado; cada banco aún puede usar un player específico en su registro.',
      playerDescription: 'Firma electrónica de fichas de registro',
      autentiqueNotConfigured: 'Configure las credenciales de Autentique para usarlo como player de firma.',
      docusignNotConfigured: 'Configure las credenciales de Docusign para usarlo como player de firma.',
      defaultSwitch: 'Predeterminado'
    },
    stablecoinConfigurationUi: {
      payInTitle: 'Spread stablecoins — PayIn (app móvil)',
      payInLabel: 'Spread stablecoins — PayIn',
      payInDescription: 'Seleccione el spread utilizado en los PayIns de la app móvil DolsPay. Déjelo vacío para usar automáticamente el primer spread activo.',
      payOutTitle: 'Spread stablecoins — PayOut (app móvil)',
      payOutLabel: 'Spread stablecoins — PayOut',
      payOutDescription: 'Seleccione el spread utilizado en los PayOuts de la app móvil DolsPay. Déjelo vacío para usar automáticamente el primer spread activo.',
      defaultAgentTitle: 'Corban predeterminado (app móvil)',
      defaultAgentDescription: 'Seleccione el corban de las preventas y operaciones hechas por el cliente en la app. Déjelo vacío para que queden sin corban.',
      defaultAgentLabel: 'Corban predeterminado',
      defaultAgentLoadError: 'No fue posible cargar la lista de corbans. Actualice la página (F5) e intente de nuevo; si continúa, hable con soporte.',
      corbanSpreadTitle: 'Rango de spread del corresponsal',
      corbanSpreadDescription: 'Escriba el porcentaje y la coma se agrega sola: 15 se convierte en 1,5%. Déjelo en 0,0 para no tener límite.',
      corbanSpreadNoLimit: 'Sin límite: el corresponsal puede usar todos los spreads.',
      corbanSpreadAllowed: 'El corresponsal podrá usar: {spreads}',
      corbanSpreadNoneAllowed: 'Ningún spread registrado entra en este rango: el corresponsal se quedará sin spread para operar.',
      corbanSpreadMinLabel: 'Spread mínimo',
      corbanSpreadMaxLabel: 'Spread máximo',
      corbanSpreadInvalidRange: 'El spread mínimo no puede ser mayor que el máximo.',
    },
    webhookStablecoinUi: {
      noResponse: 'sin respuesta'
    },
    breadcrumb: {
      root: 'Configuraciones'
    },
    emailAlert: 'Para que se envíe un correo transaccional, el disparador correspondiente debe estar configurado como "Activo" en esta pantalla y también debe tener una plantilla configurada. Asegúrese de que todos los disparadores deseados estén activados para garantizar el envío correcto de las comunicaciones.',
    credentialsAlert: 'Asegúrese de que, al cambiar alguna credencial, la nueva credencial ingresada sea válida, para que el envío de correos y de documentos para firma siga funcionando.',
    editBtn: 'Editar',
    closeBtn: 'Cerrar',
    credential: {
      smtpTitle: 'Credenciales SMTP',
      autentiqueTitle: 'Credenciales Autentique',
      docusignTitle: 'Credenciales Docusign',
      descriptionLabel: 'Descripción',
      urlBase: 'URL base',
      method: 'Método',
      apiKey: 'Clave de API',
      sandboxEnv: 'Entorno sandbox',
      integrationKey: 'Clave de integración',
      accountId: 'ID de cuenta',
      userId: 'ID de usuario',
      authServer: 'Servidor de autenticación',
      privateKey: 'Clave privada',
      smtpSaveError: 'No fue posible guardar las credenciales de SMTP. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.',
      autentiqueSaveError: 'No fue posible guardar las credenciales de Autentique. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.',
      docusignSaveError: 'No fue posible guardar las credenciales de DocuSign. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.'
    },
    general: {
      valueLabel: 'Valor',
      percentLabel: 'Porcentaje',
      allowedSitesLabel: 'Sitios autorizados',
      allowedSitesSaveBtn: 'Guardar sitios',
      allowedSitesPlaceholder: 'https://www.tusitio.com',
      invalidSiteError: 'Dirección no aceptada: {sites}. Use la dirección completa con https, sin ruta. Ejemplo: https://www.tusitio.com',
      maxSitesError: 'Ingrese como máximo {max} sitios.',
      sitesSavedWithItems: 'Sitios guardados. En hasta 1 minuto el registro ya puede mostrarse en ellos.',
      sitesSavedEmpty: 'Lista vacía guardada. En hasta 1 minuto el registro solo se abre en el propio sistema.',
      defaultCorrespondentLabel: 'Corban predeterminado',
      defaultCorrespondentDescription: 'Corban que recibe a los clientes registrados por el enlace general o por la app, cuando el registro llega sin corban. Vacío: el cliente queda sin corban.',
      defaultCorrespondentSaved: 'Corban predeterminado guardado. Los próximos registros sin corban irán a él.',
      defaultCorrespondentRemoved: 'Corban predeterminado eliminado. Los próximos registros sin corban quedan sin corban.',
      defaultCorrespondentSaveError: 'No fue posible guardar el corban predeterminado. Intente de nuevo.',
      saveError: 'No fue posible guardar los sitios. Verifique las direcciones e intente de nuevo.',
      percentRangeError: 'Ingrese un porcentaje entre {min} y {max}.'
    },
    emailProvider: {
      defaultTitle: 'Proveedor de correos',
      sectionHint: 'Servidor SMTP usado en todos los correos transaccionales: operaciones, fichas de registro, cobros y restablecimiento de contraseña.',
      smtpDescription: 'Servidor de envío de correos',
      smtpNotConfigured: 'Sin estas credenciales el sistema no envía correos: envíos de operación, fichas de registro y restablecimiento de contraseña no estarán disponibles.',
      fieldServer: 'Servidor',
      fieldPort: 'Puerto',
      fieldTls: 'Conexión segura (TLS)',
      fieldUser: 'Usuario / cuenta',
      fieldPassword: 'Contraseña',
      fieldSender: 'Remitente',
      yes: 'Sí',
      no: 'No',
      loadError: 'No fue posible cargar las credenciales de SMTP. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.'
    },
    emailLayout: {
      alertText: 'Configure el encabezado y pie de página aplicados automáticamente en los correos transaccionales. Construya el diseño arrastrando los bloques del editor: el resultado sigue la misma estructura de las plantillas de correo y no se rompe en los clientes de correo.',
      title: 'Diseño Global de Correo',
      saveBtn: 'Guardar Configuraciones',
      headerLabel: 'Encabezado de Correo',
      footerLabel: 'Pie de Correo',
      savedSuccess: '¡Configuraciones guardadas con éxito!',
      loadError: 'No fue posible cargar las configuraciones del diseño del correo. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
      saveError: 'No fue posible guardar las configuraciones. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.',
      editorError: 'No fue posible cargar el editor de correo.'
    },
    webhookConfig: {
      tabGeneral: 'General',
      tabStablecoin: 'Stablecoin',
      tabHistory: 'Historial',
      urlLabel: 'URL del Webhook',
      urlPlaceholder: 'https://ejemplo.com/webhook'
    },
    webhookHistory: {
      eventLabel: 'Evento',
      statusLabel: 'Estado',
      startLabel: 'Inicio',
      endLabel: 'Fin',
      filterBtn: 'Filtrar',
      headerDate: 'Fecha/Hora',
      headerEvent: 'Evento',
      headerUrl: 'URL',
      headerStatus: 'Estado',
      headerActions: 'Acciones',
      payloadTitle: 'Payload del webhook',
      closeBtn: 'Cerrar',
      statusSent: 'Enviado',
      statusFailed: 'No completado',
      statusTimeout: 'Timeout',
      statusPending: 'En espera',
      loadError: 'No fue posible cargar el historial. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
      resendSuccess: '¡Webhook reenviado con éxito!',
      resendError: 'No fue posible reenviar el webhook. Intente de nuevo en unos instantes; si continúa, contacte al soporte.'
    },
    webhookStablecoin: {
      urlLabel: 'URL del Webhook',
      urlPlaceholder: 'https://ejemplo.com/webhook',
      exampleBtn: 'Ejemplo',
      testBtn: 'Probar',
      payloadExampleTitle: 'Payload de ejemplo',
      payloadHint: 'Este es el formato JSON que se enviará vía POST a la URL configurada.',
      copyBtn: 'Copiar',
      closeBtn: 'Cerrar',
      copiedSuccess: '¡Payload copiado!',
      loadExampleError: 'No fue posible cargar el ejemplo. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
      sentSuccess: '¡Webhook enviado con éxito!',
      sentFailed: 'No completado: {error}'
    },
    whatsapp: {
      loading: 'Cargando información de WhatsApp...',
      deviceTitle: 'Información del Dispositivo',
      disconnectBtn: 'Desconectar',
      profilePhotoAlt: 'Foto de perfil',
      noName: 'Sin nombre',
      business: 'Business',
      personal: 'Personal',
      labelPhone: 'Número',
      labelDevice: 'Dispositivo',
      labelMessage: 'Mensaje',
      noDeviceAlert: 'Ningún dispositivo conectado. Genere un código QR para conectarse.',
      deviceLoadError: 'No fue posible cargar los datos del dispositivo.',
      disconnectSuccess: 'Instancia desconectada con éxito.',
      disconnectError: 'No fue posible desconectar WhatsApp. Intente de nuevo.',
      instanceTitle: 'Entorno y Estado de la Instancia',
      refreshBtn: 'Actualizar',
      labelInstance: 'Instancia',
      labelPlan: 'Plan',
      labelExpiration: 'Vencimiento',
      labelConnection: 'Conexión',
      connected: 'Conectado',
      disconnected: 'Desconectado',
      labelSmartphone: 'Smartphone',
      instanceLoadError: 'No fue posible cargar los datos de la conexión.',
      qrcodeTitle: 'Código QR',
      generateQr: 'Generar Código QR',
      qrHint: 'Escanee el código QR con WhatsApp del dispositivo en menos de 20 segundos.',
      generateNewQr: 'Generar Nuevo Código QR',
      qrError: 'No fue posible generar el código QR. Intente de nuevo.',
      confirmDisconnectTitle: 'Desconectar Instancia',
      confirmDisconnectMessage: '¿Está seguro de que desea desconectar WhatsApp de esta instancia? Todas las funcionalidades de WhatsApp estarán no disponibles hasta volver a conectar.',
      confirmDisconnectPrimary: 'Desconectar',
      confirmDisconnectSecondary: 'Cancelar'
    },
    credentialCard: {
      statusVerifying: 'Verificando…',
      statusConfigured: 'Configurado',
      statusNotConfigured: 'No configurado',
      statusUnavailable: 'Servicio no disponible',
      editBtn: 'Editar',
      retryBtn: 'Verificar de nuevo',
      configureBtn: 'Configurar',
      unavailableText: 'No fue posible verificar las credenciales: el servicio no respondió. Aún puede editarlas.',
      defaultNotConfiguredText: 'Aún no configurado. Configure para activar la integración.'
    },
    smtpWizard: {
      stepServer: 'Servidor',
      stepAccount: 'Cuenta y remitente',
      stepTest: 'Prueba y conclusión',
      step1Hint: 'Datos del servidor de envío proporcionados por su proveedor de correo (ej.: SendGrid, SendPulse, Gmail).',
      step2Hint: 'Credenciales de autenticación en el servidor e identidad que aparece para quien recibe los correos.',
      step3Hint: 'Revise los datos y pruebe la conexión antes de guardar.',
      tlsLabel: 'Forzar conexión segura (TLS) — normalmente usado con el puerto 465',
      testAlertInfo: 'Recomendamos probar la conexión antes de guardar, para garantizar que los correos del sistema se envíen.',
      backBtn: 'Volver',
      deleteBtn: 'Eliminar credenciales',
      closeBtn: 'Cerrar',
      continueBtn: 'Continuar',
      testBtn: 'Probar conexión',
      saveBtn: 'Guardar',
      deleteConfirmTitle: 'Eliminar credenciales de SMTP',
      deleteConfirmMessage: 'El servidor de envío dejará de estar configurado y el sistema no enviará ningún correo hasta que se ingresen nuevas credenciales.',
      deleteConfirmPrimary: 'Eliminar',
      deleteConfirmSecondary: 'Cancelar',
      testSuccess: '¡Conexión establecida con éxito! Las credenciales son válidas.',
      testError: 'No fue posible conectar al servidor SMTP. Intente de nuevo en unos instantes; si continúa, contacte al soporte.',
      missingConfigsError: 'Las claves de configuración SMTP no se encontraron en la base de datos. Ejecute las migraciones del backend.',
      savedSuccess: '¡Credenciales de SMTP guardadas!',
      saveError: 'No fue posible guardar las credenciales de SMTP. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.',
      deletedSuccess: 'Credenciales de SMTP eliminadas.',
      deleteError: 'No fue posible eliminar las credenciales de SMTP. Intente de nuevo en unos instantes; si continúa, contacte al soporte.',
      summaryServer: 'Servidor',
      summaryPort: 'Puerto',
      summaryTls: 'Conexión segura (TLS)',
      summaryUser: 'Usuario / cuenta',
      summarySender: 'Remitente',
      yes: 'Sí',
      no: 'No'
    },
    signatureModal: {
      note: 'Los datos no se validan al guardar — si están incorrectos, el aviso solo aparece en el próximo envío de ficha para firma.',
      savedSuccess: '¡Credenciales de {player} guardadas!',
      saveError: 'No fue posible guardar las credenciales de {player}. Verifique si el servicio de firmas está activo.',
      hintAutentique: 'Clave de API de Autentique, usada para enviar fichas de registro para firma electrónica.',
      hintDocusign: 'Credenciales de integración JWT de Docusign, usadas para enviar fichas de registro para firma electrónica.'
    },
    templateItem: {
      markAllHeaders: 'Marcar todos los encabezados',
      unmarkAllHeaders: 'Desmarcar todos los encabezados',
      markAllFooters: 'Marcar todos los pies de página',
      unmarkAllFooters: 'Desmarcar todos los pies de página',
      useHeader: 'Usar encabezado',
      useFooter: 'Usar pie de página',
      closeBtn: 'Cerrar',
      saveBtn: 'Guardar',
      templateNotFound: 'Plantilla no encontrada.',
      loadError: 'No fue posible cargar la lista de plantillas. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
      updateError: 'No fue posible actualizar la plantilla. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.',
      noneLoaded: 'Ninguna configuración cargada para guardar.',
      termsSaved: 'Términos y condiciones guardados con éxito.',
      termsError: 'No fue posible guardar los términos y condiciones. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.'
    },
    smtp: {
      title: 'Configuración de SMTP',
      server: 'Servidor SMTP',
      port: 'Puerto',
      tls: 'Forzar conexión segura (TLS)',
      user: 'Usuario / cuenta SMTP',
      password: 'Contraseña',
      senderName: 'Nombre del remitente',
      senderEmail: 'Correo del remitente',
      serverPlaceholder: 'smtp.ejemplo.com',
      senderNamePlaceholder: 'Mi Corredora',
      senderEmailPlaceholder: 'contacto@ejemplo.com',
      deleteTitle: 'Eliminar credenciales de SMTP',
      savedSuccess: '¡Credenciales de SMTP guardadas!',
      deletedSuccess: 'Credenciales de SMTP eliminadas.'
    },
    signature: {
      playerPlaceholder: 'Seleccione un player ...',
      toggleDefaultHint: 'Para cambiar el player predeterminado, actívelo en el otro player.',
      playerNotFound: 'Configuración de player predeterminado no encontrada. Recargue la página.',
      playerSetDefault: '{player} definido como player predeterminado.',
      changeDefaultError: 'No fue posible cambiar el player predeterminado. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    template: {
      selectPlaceholder: 'Seleccione una plantilla ...',
      previewTooltip: 'Vista previa de la plantilla'
    },
    webhook: {
      viewPayload: 'Ver payload',
      resend: 'Reenviar'
    }
  },

  customers: {
    kanbanColumnsUi: {
      customer: {
        '1': 'Registro enviado',
        '2': 'Registro en curso',
        '3': 'Esperando análisis',
        '4': 'Registro en análisis',
        '5': 'Pendiente',
        '6': 'Finalizado'
      },
      bank: {
        '1': 'Esperando firma',
        '2': 'Enviado al banco',
        '3': 'Pendiente',
        '4': 'Límite preaprobado',
        '5': 'Finalizado',
        '6': 'Bloqueado'
      }
    },
    bankCustomerAuthorizationUi: {
      updateStatusError: 'No fue posible cambiar el estado del registro del cliente en el banco. Revise los datos e intente nuevamente; si continúa, comuníquese con soporte.',
      sendLimitApprovalMessage: '¿Desea enviar la aprobación de límite al cliente?',
      sendLimitApprovalTitle: '¿Enviar aprobación de límite?',
      limitApprovalSent: '¡Aprobación de límite enviada con éxito!',
      sendLimitApprovalError: 'No fue posible enviar la aprobación de límite del cliente. Intente nuevamente en unos instantes; si continúa, comuníquese con soporte.'
    },
    customerAuthorizationUi: {
      sendAccessEmailError: 'No fue posible enviar el correo de acceso al cliente. Intente nuevamente en unos instantes; si continúa, comuníquese con soporte.',
      updateStatusError: 'No fue posible cambiar el estado del registro del cliente. Revise los datos e intente nuevamente; si continúa, comuníquese con soporte.'
    },
    corbanSignupLinkUi: {
      linkUnavailable: 'El enlace de registro todavía no está disponible. Comuníquese con soporte.',
      linkCopied: '¡Enlace de registro copiado! Envíelo a su cliente.',
      copyFailed: 'No fue posible copiar automáticamente. Enlace: {link}'
    },
    formCustomerFinallyUi: {
      successAlt: 'Registro finalizado con éxito'
    },
    customerDocumentsExternalAccessUi: {
      complementaryTitle: 'Documentos Complementarios'
    },
    timeline: {
      noStatusHistory: 'No hay cambios de estado registrados',
      historyTitle: 'Historial del Cliente',
      banksTitle: 'Historial de Bancos',
      noBanks: 'No hay bancos registrados',
      observationLabel: 'Observación:',
      changedBy: 'Modificado por: {name}',
      changedByCustomer: 'Modificado por el cliente'
    },
    bankTimeline: {
      unknownStatus: 'Estado desconocido',
      sentDocumentsCount: 'ningún documento enviado | {count} documento enviado | {count} documentos enviados',
      customerDocuments: 'Documentos del cliente',
      operationalDocuments: 'Documentos operativos',
      partnerDocuments: 'Documentos de los socios',
      unnamedDocument: 'Documento sin nombre',
      viewDocument: 'Ver documento',
      downloadDocument: 'Descargar documento',
      downloadError: 'No fue posible descargar el documento. Actualice la página (F5) e intente de nuevo; si continúa, hable con soporte.'
    },
    unifiedTimeline: {
      turismo: 'Turismo',
      remessa: 'Remesa',
      unknown: 'Desconocido'
    },
    timelineDetail: {
      type: 'Tipo',
      bank: 'Banco',
      nameOrCompanyName: 'Nombre / Razón social',
      phone: 'Teléfono',
      email: 'Correo electrónico',
      statusHistoryTitle: 'Historial de cambios de estado',
      openFullDetails: 'Ver ficha completa',
      errorLoadCustomerHistory: 'No fue posible cargar el historial de estado del cliente. Actualice la página (F5) e intente de nuevo.',
      errorLoadBankHistory: 'No fue posible cargar el historial de estado del banco. Actualice la página (F5) e intente de nuevo.'
    },
    kanbanSearch: 'Escriba para buscar...',
    selfieCapture: 'Capturar selfie',
    kanbanSearchBar: {
      refresh: 'Actualizar datos',
      searchPlaceholder: 'Escriba para buscar...',
      filterByType: 'Filtrar por tipo:',
      individual: 'Persona Física',
      company: 'Persona Jurídica'
    },
    kanbanBoard: {
      emptyColumn: 'No hay elementos en esta columna'
    },
    cardActions: {
      whatsapp: 'Conversar en WhatsApp',
      statusHistory: 'Historial de estado',
      viewRegistration: 'Ver registro',
      registerPendency: 'Registrar pendencia',
      resendRegistration: 'Reenviar ficha de registro',
      moveTo: 'Mover a',
      editObservation: 'Editar observación',
      addObservation: 'Agregar observación'
    },
    kanbanCard: {
      emailUnavailable: 'Correo electrónico no disponible para copiar.',
      emailCopied: '¡Correo electrónico copiado al portapapeles!',
      emailCopyError: 'No fue posible copiar el correo electrónico. Seleccione el texto y cópielo manualmente (Ctrl+C).',
      phoneUnavailable: 'Teléfono no disponible para copiar.',
      phoneCopied: '¡Teléfono copiado al portapapeles!',
      phoneCopyError: 'No fue posible copiar el teléfono. Seleccione el texto y cópielo manualmente (Ctrl+C).',
      whatsappPhoneUnavailable: 'Teléfono no disponible para abrir WhatsApp.'
    },
    control: {
      addButton: 'Agregar',
      preRegistrationButton: 'Enviar pre-registro',
      loadingDetails: 'Cargando información del cliente',
      optionsTooltip: 'Opciones',
      operate: 'Operar',
      viewPendencies: 'Ver pendencias',
      viewPendenciesOf: 'Ver pendencias - {provider}',
      updateRegistration: 'Actualización de registro',
      resendForm: 'Reenviar ficha',
      deactivateTitle: '¿Inactivar cliente?',
      deactivateMessage: '¿Desea realmente inactivar al cliente <strong>{name}</strong>?',
      complementaryInfoTitle: 'Información complementaria',
      complementaryInfoLabel: 'Informaciones complementarias',
      cellphone: 'Cel.:',
      landline: 'Fijo:',
      unknownStatus: 'Estado desconocido',
      columns: {
        id: 'Código',
        customer: 'Cliente',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        status: 'Estado',
        createdAt: 'Fecha de registro',
        actions: 'Acciones'
      },
      expandedColumns: {
        status: 'Estado',
        type: 'Tipo',
        linkedBank: 'Banco vinculado',
        approvedNatures: 'Naturalezas aprobadas',
        incoming: 'Entrada',
        outgoing: 'Salida',
        validity: 'Vigencia',
        actions: 'Acciones'
      },
      errorLoadDetails: 'No fue posible cargar los detalles del cliente. Actualice la página (F5) e intente de nuevo.',
      errorLoadCorbans: 'No fue posible cargar la lista de corbanes del filtro. Actualice la página (F5) e intente de nuevo.',
      errorLoadCustomers: 'No fue posible cargar la lista de clientes. Actualice la página (F5) e intente de nuevo.',
      errorLoadCount: 'No fue posible cargar la cantidad de clientes. Actualice la página (F5) e intente de nuevo.',
      preSaveSavedSuccess: '¡Cliente guardado con éxito!',
      preSaveSaveError: 'No fue posible guardar el pre-registro del cliente. Verifique los datos e intente de nuevo.',
      statusUpdatedSuccess: '¡Estado actualizado con éxito!',
      statusUpdateError: 'No fue posible cambiar la situación del registro del cliente. Verifique los datos e intente de nuevo.',
      complementaryInfoSentSuccess: '¡Solicitud de actualización de registro enviada con éxito!',
      resendSuccess: '¡Registro reenviado al banco con éxito!',
      resendError: 'No fue posible reenviar. Verifique los datos e intente de nuevo.'
    },
    bankBoard: {
      cannotMoveStatus: 'No es posible mover a este estado',
      integrate: 'Integrar',
      integrated: 'Integrado',
      editObservation: 'Editar observación',
      addObservation: 'Agregar observación',
      update: 'Actualizar',
      observationLabel: 'Observación',
      confirmationTitle: 'Confirmación',
      confirmYes: 'Sí',
      confirmUnderstood: 'Entendido',
      editPendency: 'Editar pendencia',
      saveObservationSuccess: '¡Observación guardada con éxito!',
      saveObservationError: 'No fue posible guardar la observación. Intente de nuevo.',
      loadError: 'No fue posible actualizar el tablero de bancos de clientes. Actualice la página (F5) e intente de nuevo.',
      loadBankCustomersError: 'No fue posible cargar los bancos de clientes en análisis. Actualice la página (F5) e intente de nuevo.',
      loadCustomerDataError: 'Los datos del cliente no cargaron. Actualice la página (F5) e intente de nuevo.',
      saveLimitError: 'No fue posible guardar el límite del cliente. Verifique los valores e intente de nuevo.',
      changeBankStatusError: 'No fue posible cambiar el estado del banco del cliente. Intente de nuevo.',
      changeBankStatusRevertError: 'No fue posible cambiar el estado del banco del cliente y el card volvió a la columna anterior. Intente de nuevo.',
      sendPendencyEmailSuccess: '¡Correo de pendencia de registro enviado con éxito!',
      registerPendencySuccess: '¡Pendencia registrada con éxito!',
      registerPendencyError: 'No fue posible registrar la pendencia del banco. Verifique el texto e intente de nuevo.',
      resendAccessEmailSuccess: 'Correo de primer acceso reenviado',
      resendAccessEmailError: 'No fue posible reenviar el correo de primer acceso. Intente de nuevo.',
      integrationSuccess: '¡Cliente integrado con éxito!',
      integrationOnlineUnavailableTitle: 'Integración en línea no disponible',
      integrationOnlineUnavailableMessage: 'El proceso de integración en línea no está disponible para clientes extranjeros. El registro se realizará por el flujo offline.',
      integrationFailedTitle: 'Integración bancaria no concluida',
      integrationFailedMessage: 'La integración bancaria no fue concluida. ¿Desea mantener el banco registrado por el flujo manual?',
      integrationRequest: '¿Enviar para integración bancaria?',
      rfiPending: 'Pendencia de compliance (RFI) en espera de resolución.',
      rfiRejected: 'El banco no aceptó el registro. Revise los datos y documentos del cliente.'
    },
    formAuthorization: {
      cancelar: 'Cancelar',
      registerPendency: 'Registrar pendencia',
      statusUpdatedSuccess: '¡Estado actualizado con éxito!',
      statusUpdateError: 'No fue posible cambiar la situación del registro del cliente. Verifique los datos e intente de nuevo.',
      bankStatusUpdateError: 'No fue posible cambiar la situación del registro del cliente en el banco. Verifique los datos e intente de nuevo.',
      pendencyEmailSentSuccess: '¡Correo de pendencia de registro enviado con éxito!',
      pendencyEmailError: 'No fue posible enviar el correo de pendencia de registro al cliente. Intente de nuevo.'
    },
    statusChange: {
      selectLabel: 'Seleccione el estado deseado',
      noDataText: 'Seleccione un estado',
      additionalInfo: 'Información adicional',
      defaultTitle: 'Cambiar estado'
    },
    addLimit: {
      title: 'Límite aprobado',
      valueIn: 'Valor entrada',
      valueOut: 'Valor salida',
      expireAt: 'Fecha de vencimiento'
    },
    filterDrawer: {
      title: 'Filtro'
    },
    authorization: {
      internalOnboarding: 'Incorporación interna',
      bankOnboarding: 'Incorporación en Bancos',
      confirmationTitle: 'Confirmación',
      loadListError: 'No fue posible cargar la lista de clientes en análisis. Actualice la página (F5) e intente de nuevo.',
      loadCountError: 'No fue posible cargar la cantidad de clientes en análisis. Actualice la página (F5) e intente de nuevo.',
      dataNotFound: 'Datos del banco o cliente no encontrados.',
      limitAdded: '¡Límite agregado con éxito!',
      limitAddError: 'No fue posible agregar el límite del cliente. Verifique los datos e intente de nuevo.',
      updateError: 'Los datos no fueron actualizados. Actualice la página (F5) e intente de nuevo.'
    },
    selfie: {
      loadingCamera: 'Cargando cámara...',
      positionFace: 'Coloque su rostro en el área indicada',
      faceDetectedMsg: '¡Perfecto! Haga clic en el botón para tomar la foto',
      cameraError: 'No fue posible acceder a la cámara',
      permissionDeniedHint: 'Si denegó el acceso, haga clic en el ícono de candado o información en la barra de direcciones del navegador y permita el uso de la cámara para este sitio.',
      noCameraBtn: 'No tengo cámara (usar celular)',
      photoPreviewTitle: 'Su selfie:',
      photoAlt: 'Selfie capturada',
      retake: 'Tomar de nuevo',
      errors: {
        notAllowed: 'Se denegó el permiso para acceder a la cámara. Haga clic en "Intentar de nuevo" y permita el acceso a la cámara.',
        notFound: 'No se encontró ninguna cámara en su dispositivo. Verifique si hay una cámara conectada.',
        notReadable: 'La cámara está siendo utilizada por otra aplicación. Cierre otros programas que puedan estar usando la cámara.',
        overconstrained: 'La configuración de la cámara no es compatible. Intente usar un navegador más reciente.',
        generic: 'No fue posible acceder a la cámara. Verifique si su navegador permite el acceso a la cámara e intente de nuevo.'
      }
    },
    selfiePage: {
      title: 'Verificación de Identidad',
      subtitle: 'Para finalizar su registro, necesitamos confirmar su identidad',
      instructionsStep: 'Instrucciones',
      selfieStep: 'Selfie',
      confirmationStep: 'Confirmación',
      howToTitle: '¿Cómo tomar su selfie?',
      captureTitle: 'Capture su selfie',
      yourSelfieTitle: 'Su selfie enviada:',
      startCapture: 'Iniciar captura',
      noCamera: 'No tengo cámara',
      tips: {
        removeAccessories: 'Retire gafas, gorras o accesorios',
        goodLighting: 'Esté en un lugar bien iluminado',
        centerFace: 'Mantenga el rostro centrado',
        neutralExpression: 'Mantenga una expresión neutral'
      }
    },
    documents: {
      title: 'Documentos',
      partnersTitle: 'Documentos de los Socios',
      nestedPartnersTitle: 'Documentos de los Socios de los Socios'
    },
    finally: {
      successTitle: '¡Registro enviado con éxito!',
      goToSite: 'Ir al sitio web'
    },
    reactivationModal: {
      title: 'Reactivar registro',
      hint: 'Elija adónde vuelve el registro. No es necesario rehacer la actualización del registro ni volver a pasar por el flujo.',
      primaryButton: 'Reactivar registro',
      cancel: 'Cancelar',
      reasonLabel: 'Motivo de reactivación',
      reasonHint: 'Queda registrado en el historial de estados del cliente.',
      reactivated: 'Registro reactivado. Ahora está en "{status}".',
      reactivateError: 'No fue posible reactivar el registro. Intente de nuevo.',
      reasonRequired: 'Informe el motivo de reactivación',
      targetOptions: {
        finalized: {
          title: 'Finalizado',
          hint: 'Permite al cliente operar. Úselo cuando el registro ya fue verificado y aprobado por el banco.'
        },
        inAnalysis: {
          title: 'Registro en análisis',
          hint: 'Vuelve a la cola de análisis del equipo, sin pedir nada al cliente.'
        }
      }
    }
  },

  registrations: {
    templatesUi: {
      typeFallback: 'Tipo {id}'
    },
    formTemplateUi: {
      example1Start: 'Hola',
      example1Middle: 'tu operación',
      example1End: 'fue aprobada',
      example2Start: 'Operación de compra generada para',
      example3Start: 'Aprobación para el cliente',
      example3Middle: 'en la naturaleza'
    },
    operationNature: {
      examplePlaceholder: 'Ej.: Serv. Téc./Prof./Adm. Salida'
    },
    common: {
      btnAdd: 'Agregar',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      btnClose: 'Cerrar',
      btnBack: 'Volver',
      colActions: 'Acciones',
      tooltipEdit: 'Editar'
    },
    exchangeBanks: {
      colLogo: 'Logo',
      colCreatedAt: 'Fecha de registro',
      colCompanyName: 'Razón social',
      colFantasyName: 'Nombre comercial',
      colCnpj: 'CNPJ',
      colProfitPercentage: '% Ganancia comisiones',
      colStatus: 'Estado',
      colActions: 'Acciones',
      tooltipExternalId: 'Banco importado con ID externo {id}',
      tooltipEdit: 'Editar',
      tooltipView: 'Ver',
      labelProfitPercentage: '% Ganancia comisiones',
      editDialogSave: 'Guardar',
      editDialogCancel: 'Cancelar',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      btnBack: 'Volver',
      successSaveProfitPercentage: 'Porcentaje de ganancia para comisiones actualizado con éxito.',
      errorLoad: 'No fue posible cargar la lista de bancos. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorSaveProfitPercentage: 'No fue posible guardar el porcentaje de ganancia en stablecoin del banco. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.',
      errorLoadFormData: 'No fue posible cargar los datos del banco. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorLoadCurrencies: 'No fue posible cargar la lista de monedas. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorBankHours: 'Complete el horario de funcionamiento del banco antes de guardar.',
      errorLiquidationHours: 'Complete el horario límite D+0 para todas las monedas antes de guardar.',
      successSaveBank: '¡Banco guardado con éxito!',
      errorCreateBank: 'No fue posible registrar el banco. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.',
      errorUpdateBank: 'No fue posible guardar los cambios del banco. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.'
    },
    rateApiRoutes: {
      colName: 'Nombre',
      colActive: 'Activo',
      colActions: 'Acciones',
      tooltipSetActive: 'Definir como activo',
      errorLoad: 'No fue posible cargar la lista de rutas de cotización. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorSetActive: 'No fue posible activar la ruta de cotización. Intente nuevamente en unos instantes; si continúa, contacte al soporte.'
    },
    bilateralAgreements: {
      title: 'Países con acuerdo bilateral',
      colCountry: 'País',
      colIr: 'IR venta(%)',
      colActions: 'Acciones',
      tooltipEdit: 'Editar',
      modalTitle: 'Acuerdo bilateral',
      labelCountry: 'País',
      labelIr: 'IR venta(%)',
      errorAdd: 'No fue posible registrar el país del acuerdo bilateral. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.',
      errorUpdate: 'No fue posible guardar los cambios del país del acuerdo bilateral. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.'
    },
    currencies: {
      colCode: 'Código',
      colPriority: 'Prioridad',
      colName: 'Nombre',
      colMinSell: 'Mínimo venta remesa(%)',
      colRecSell: 'Recomendado venta remesa(%)',
      colMaxSell: 'Máximo venta remesa(%)',
      colMinBuy: 'Mínimo compra remesa(%)',
      colRecBuy: 'Recomendado compra remesa(%)',
      colMaxBuy: 'Máximo compra remesa(%)',
      colPrecision: 'Decimales',
      colActions: 'Acciones',
      tooltipEdit: 'Editar',
      priorityMax: 'Máxima',
      priorityHigh: 'Alta',
      priorityMedium: 'Media',
      priorityLow: 'Baja',
      priorityMin: 'Mínima',
      modalTitle: 'Monedas',
      labelCode: 'Código',
      labelName: 'Nombre',
      labelPrecision: 'Decimales',
      labelPriority: 'Prioridad',
      labelMinSell: 'Spread mínimo venta remesa(%)',
      labelRecSell: 'Spread recomendado venta remesa(%)',
      labelMaxSell: 'Spread máximo venta remesa(%)',
      labelMinBuy: 'Spread mínimo compra remesa(%)',
      labelRecBuy: 'Spread recomendado compra remesa(%)',
      labelMaxBuy: 'Spread máximo compra remesa(%)',
      errorLiquidation: 'Complete los horarios de liquidación para todos los bancos antes de guardar.',
      errorLoad: 'No fue posible cargar la lista de monedas. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorLoadBanks: 'No fue posible cargar la lista de bancos activos. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorAdd: 'No fue posible registrar la moneda. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.',
      errorUpdate: 'No fue posible guardar los cambios de la moneda. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.'
    },
    operationNatures: {
      colCode: 'Código',
      colName: 'Nombre',
      colIofBuy: 'IOF compra(%)',
      colIof: 'IOF venta(%)',
      colIrBuy: 'IR compra(%)',
      colIr: 'IR venta(%)',
      colCideBuy: 'CIDE compra(%)',
      colCide: 'CIDE venta(%)',
      colDuimp: 'DUIMP/DU-E',
      colActions: 'Acciones',
      tooltipEdit: 'Editar',
      modalTitle: 'Naturalezas de Operación',
      labelCode: 'Código',
      labelName: 'Nombre',
      labelShortName: 'Nombre corto',
      labelUseDiDue: '¿Usa DUIMP/DU-E?',
      radioYes: 'SÍ',
      radioNo: 'NO',
      labelIofBuy: 'IOF compra(%)',
      labelIof: 'IOF venta(%)',
      labelIrBuy: 'IR compra(%)',
      labelIr: 'IR venta(%)',
      labelCide: 'CIDE venta(%)',
      labelCideBuy: 'CIDE compra(%)',
      labelObservation: 'Observaciones',
      errorLoad: 'No fue posible cargar la lista de naturalezas de operación. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorAdd: 'No fue posible registrar la naturaleza de operación. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.',
      errorUpdate: 'No fue posible guardar los cambios de la naturaleza de operación. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.',
      errorLoadBilateral: 'No fue posible cargar la lista de países con acuerdo bilateral. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.'
    },
    paymentMethodsReg: {
      colCode: 'Código',
      colName: 'Nombre',
      colActions: 'Acciones',
      tooltipEdit: 'Editar',
      modalTitle: 'Métodos de pago',
      labelName: 'Nombre',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      errorLoad: 'No fue posible cargar la lista de formas de pago. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorAdd: 'No fue posible registrar la forma de pago. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.',
      errorUpdate: 'No fue posible guardar los cambios de la forma de pago. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.'
    },
    templates: {
      labelDescription: 'Descripción',
      labelSubject: 'Asunto',
      labelFormat: 'Formato',
      labelOrientation: 'Orientación',
      typeUndefined: 'Tipo no definido',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      btnClose: 'Cerrar',
      requiredField: 'Información obligatoria',
      variablesDialogTitle: 'Variables para asunto',
      variablesDialogText: 'Tenemos algunas variables disponibles para usar en el campo asunto',
      variablesExamples: 'Algunos ejemplos de uso:',
      variableFullName: 'Nombre completo o razón social del cliente',
      variableFirstName: 'Primer nombre del cliente persona física',
      variableFantasyName: 'Nombre comercial del cliente',
      variableCpfCnpj: 'CPF o CNPJ del cliente',
      variableNature: 'Nombre de la naturaleza en la operación',
      variableNatureCode: 'Código de la naturaleza en la operación',
      variableOperationCode: 'Código de la operación',
      successUpdate: 'Plantilla actualizada',
      errorUpdate: 'No fue posible actualizar la plantilla. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.',
      errorUnlayer: 'No fue posible cargar el editor de e-mail. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      warningLegacyEmail: 'Esta plantilla fue creada en el editor anterior. La re-edición en el nuevo editor puede alterar el formato original.',
      errorLoadTemplate: 'No fue posible obtener la plantilla para edición. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      successAdd: 'Plantilla registrada',
      errorAdd: 'No fue posible registrar la plantilla. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.',
      confirmAbandonEdit: '¿Hay datos completados, desea realmente abandonar la edición?',
      confirmAbandonCreate: '¿Hay datos completados, desea realmente abandonar el registro?',
      confirmAbandonPrimary: 'Sí, abandonar',
      confirmAbandonSecondary: 'No',
      confirmAbandonTitle: '¿Abandonar cambios?',
      typeSelectorTitle: '¿Qué tipo de plantilla desea crear?',
      typeEmail: 'E-mails',
      typeOperationMessage: 'Mensaje de Operación',
      typeCustomerSheet: 'Ficha del Cliente',
      typeIssuedDocuments: 'Documentos Emitidos',
      inUseTitle: 'Plantilla en uso',
      inUseSingle: 'está vinculada al elemento siguiente',
      inUseMultiple: 'está vinculada a {n} elementos',
      inUseRemoveHint: 'Elimine el vínculo antes de borrar.',
      inUseBankHint: 'Los vínculos de ficha de registro se modifican en el registro del banco, no en Configuraciones.',
      inUseVerify: 'Verificar configuración',
      inUseBankBadge: 'registro bancario',
      colCode: 'Código',
      colDescription: 'Descripción',
      colSubject: 'Asunto',
      colCreatedAt: 'Fecha de registro',
      colActions: 'Acciones',
      tabAll: 'Todos',
      tooltipOptions: 'Opciones',
      menuEdit: 'Editar',
      menuPreview: 'Vista previa',
      menuDuplicate: 'Duplicar',
      menuDelete: 'Eliminar',
      deleteTitle: '¿Eliminar plantilla?',
      deleteMessage: 'La plantilla "{name}" será eliminada.',
      deletePrimary: 'Eliminar',
      successDelete: '¡Plantilla eliminada con éxito!',
      successDuplicate: '¡Plantilla duplicada con éxito!',
      errorDelete: 'No fue posible eliminar la plantilla. Intente nuevamente en unos instantes; si continúa, contacte al soporte.',
      errorDuplicate: 'No fue posible duplicar la plantilla. Intente nuevamente en unos instantes; si continúa, contacte al soporte.',
      errorCheckUsage: 'No fue posible verificar dónde se usa la plantilla antes de eliminar. Intente nuevamente en unos instantes; si continúa, contacte al soporte.',
      errorLoad: 'No fue posible cargar la lista de plantillas. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorLoadTypes: 'No fue posible cargar los tipos de plantilla. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.'
    }
  },

  operations: {
    bankLedger: {
      optionalHint: 'Opcional',
      modalTitle: 'Registrar variación',
      launchButton: 'Registrar',
      hintText: 'Variación en la cuenta del banco. Positivo es crédito y aumenta la ganancia ajustada de la operación; negativo es costo cobrado por el banco y la reduce.',
      operationLabel: 'Operación (nº)',
      bankLabel: 'Banco',
      descriptionLabel: 'Descripción',
      positive: 'Positivo',
      negative: 'Negativo',
      amountLabel: 'Valor',
      competenceDateLabel: 'Fecha de competencia',
      requiredField: 'Campo obligatorio',
      bankOrOperationRequired: 'Indique el banco o la operación',
      amountRequired: 'Indique un valor mayor que cero.',
      saveSuccess: 'Registro realizado en la cuenta del banco.',
      saveError: 'No fue posible registrar el costo. Verifique la operación o el banco, la descripción, el valor y la fecha, e intente de nuevo.'
    },
    ledgerTable: {
      dateHeader: 'Fecha',
      typeHeader: 'Tipo',
      descriptionHeader: 'Descripción',
      operationHeader: 'Operación',
      userHeader: 'Usuario',
      valueHeader: 'Valor',
      balanceHeader: 'Saldo',
      empty: 'Sin registros en el período.',
      system: 'Sistema'
    },
    ledgerCard: {
      title: 'Costos y ganancia de la operación',
      launchVariation: 'Registrar variación',
      profitCredited: 'Ganancia acreditada',
      variations: 'Variaciones',
      adjustedProfit: 'Ganancia ajustada',
      loadError: 'No fue posible cargar la cuenta corriente de la operación. Actualice la página; si continúa, contacte al soporte.'
    },
    cancelNotify: {
      notifyCustomer: 'Enviar e-mail de cancelación al cliente',
      notifyBank: 'Enviar e-mail de cancelación al banco'
    },
    changeCorban: {
      title: 'Cambiar corban',
      primaryButton: 'Cambiar',
      hintText: 'Las comisiones de agente e indicador se recalculan con los porcentajes del registro del nuevo corban.',
      newCorbanLabel: 'Nuevo corban',
      selectCorbanRequired: 'Elija el nuevo corban',
      loadCorbansError: 'No fue posible cargar la lista de corbans. Cierre y abra de nuevo esta ventana; si continúa, contacte al soporte.',
      saveSuccess: 'Corban cambiado y comisiones recalculadas.',
      saveError: 'No fue posible cambiar el corban. Actualice la página para verificar el corban actual de la operación e intente de nuevo.'
    },
    bankMark: {
      unknown: 'Banco no informado'
    },
    bankIntegration: {
      title: 'Banco integrado',
      ticketLabel: 'Ticket en el banco',
      contractLabel: 'Contrato de cambio',
      updatedAtLabel: 'Actualizado el',
      resendExpired: 'El reenvío al banco solo vale el día en que se creó la operación. Cancele la operación y cree otra.',
      notConfirmed: 'La operación se guardó, pero el banco no confirmó el envío. Use Resincronizar estado para ver si llegó al banco.',
      registerError: 'El banco tuvo un error al registrar la operación y lo está analizando. Contacte al soporte del banco con el ticket {ticket}. El estado se vuelve a actualizar solo cuando el banco lo resuelva.',
      overduePending: 'La fecha de liquidación informada por el banco ({date}) ya pasó y la operación sigue esperando al banco. El banco no cancela por la fecha: hable con el backoffice del banco con el ticket {ticket}.',
      syncButton: 'Resincronizar estado',
      resendButton: 'Reenviar al banco',
      syncSuccess: 'Estado verificado en el banco.',
      syncError: 'No fue posible verificar el estado en el banco. Intente de nuevo en unos instantes.',
      resendSuccess: 'Operación reenviada al banco.',
      resendError: 'No fue posible reenviar la operación al banco. Intente de nuevo en unos instantes.',
      status: {
        submissionError: 'Envío no concluido',
        pending: 'Esperando al banco',
        registered: 'Registrada en el banco',
        completed: 'Liquidada por el banco',
        cancelled: 'Cancelada en el banco',
        failed: 'Rechazada por el banco',
        registerError: 'Error en el registro del banco'
      },
      resendModal: {
        title: 'Reenviar al banco',
        confirmButton: 'Guardar y reenviar',
        intro: 'La operación no llegó al banco. Verifique la nueva tasa y las cuentas antes de reenviar.',
        loadError: 'No fue posible cargar los datos para reenviar la operación. Intente de nuevo en unos instantes.',
        quotationError: 'No fue posible cotizar en {bankName}. Intente actualizar la cotización.',
        quotationRequired: 'Elija una cotización del banco antes de reenviar.',
        resendError: 'No fue posible reenviar la operación al banco. Verifique los datos e intente de nuevo.'
      },
      documents: {
        contract: 'Contrato',
        swift: 'SWIFT',
        notDownloaded: 'El documento del banco todavía no fue descargado. Intente de nuevo en unos minutos.',
        downloadError: 'No fue posible descargar el documento del banco. Intente de nuevo en unos minutos.',
        uploadBlocked: 'El contrato y el SWIFT de esta operación vienen del banco integrado. Use Resincronizar estado en la operación.'
      }
    },
    changeHistory: {
      emptyTitle: 'Ningún cambio registrado',
      changedBy: 'Modificado por: {name}',
      preSale: 'Pre-venta'
    },
    timeline: {
      emptyTitle: 'Ningún cambio de estado registrado',
      changedBy: 'Modificado por: {name}',
      observation: 'Observación:',
      addObservation: 'Agregar observación'
    },
    timelineDetail: {
      title: 'Historial de estado',
      operationLabel: 'Operación #{id}',
      editObservation: 'Editar observación',
      addObservation: 'Agregar observación',
      loadError: 'No fue posible cargar el historial. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      saveObservationSuccess: '¡Observación guardada con éxito!',
      saveObservationError: 'No fue posible guardar la observación. Verifique los datos e intente nuevamente; si continúa, contacte al soporte.'
    },
    sketchHistory: {
      title: 'Historial de cambios',
      preSaleLabel: 'Pre-venta #{id}',
      loadError: 'No fue posible cargar el historial de la pre-venta. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.'
    }
  },

  commissions: {
    commissionPaymentOrderDialogUi: {
      aboveBalance: 'Monto superior al saldo disponible ({balance})',
      remainingBalance: 'Después de esta solicitud, tu saldo disponible quedará en {balance}',
      insufficientBalance: 'Saldo insuficiente. Disponible: {balance}',
      minimumValue: 'El monto mínimo para solicitar el pago es {min}',
      exceedsBalance: 'El monto informado supera el saldo disponible del corresponsal. Saldo: {balance}'
    },
    corbanComissionsControlUi: {
      noRequest: 'Pago sin solicitud',
      paymentPending: 'Pago pendiente'
    },
    search: 'Buscar',
    emptyTitle: 'No se encontraron registros',
    noCredited: 'No hay operaciones acreditadas para el período seleccionado.',
    noRequests: 'No hay solicitudes de pago para el período seleccionado.',
    paymentOrder: {
      brazil: 'Brasil',
      abroad: 'Exterior',
      brazilAccount: 'Cuenta Brasil',
      abroadAccount: 'Cuenta exterior',
      requestedValue: 'Valor Solicitado',
      invoice: 'Factura',
      paidValue: 'Valor Pagado',
      paymentProof: 'Comprobante de Pago',
      titleAdmin: 'Crear orden de pago - {name}',
      titleCorban: 'Solicitar pago',
      step1: 'Cuenta de Recepción',
      step2: 'Valor y Documentos',
      legendAccount: '¿En qué cuenta desea recibir?',
      accountBrazilTitle: 'Cuenta bancaria de Brasil',
      accountAbroadTitle: 'Cuenta bancaria en el exterior - {name}',
      fieldBank: 'Banco - {val}',
      fieldAgency: 'Agencia - {val}',
      fieldAccount: 'Cuenta - {val}',
      fieldDigit: 'Dígito - {val}',
      fieldPix: 'Pix - {val}',
      fieldIban: 'IBAN - {val}',
      fieldSwift: 'Código Swift/BIC - {val}',
      fieldRouting: 'Número ABA/Routing - {val}',
      fieldFfc: 'FFC - {val}',
      fieldOwner: 'Nombre del titular - {val}',
      insufficientBalanceAlert: 'Saldo insuficiente. Mínimo: {min}',
      minimumAmountAlert: 'Monto mínimo para solicitar: {min}',
      summaryTitle: 'Resumen de la solicitud',
      btnCancel: 'Cancelar',
      btnNext: 'Siguiente',
      btnBack: 'Volver',
      btnSave: 'Guardar'
    },
    filters: {
      startDate: 'Fecha Inicial',
      endDate: 'Fecha Final',
      periodLabel: 'Período rápido',
      periodCurrentMonth: 'Mes Actual',
      periodLastMonth: 'Mes Anterior',
      periodLast3Months: 'Últimos 3 Meses',
      periodLast6Months: 'Últimos 6 Meses',
      periodCurrentYear: 'Este Año'
    },
    administrative: {
      alertCredit: 'El crédito mensual de las comisiones ahora se realiza en',
      alertCreditLink: 'Cierre mensual',
      tabCorrespondents: 'Corresponsales',
      tabOpenRequests: 'Solicitudes abiertas',
      colCode: 'Código',
      colName: 'Nombre',
      colType: 'Tipo',
      colMasterCorban: 'Corban Master Vinculado',
      colLinkedIndicators: 'Indicadores vinculados',
      colBalance: 'Saldo',
      colLastPayment: 'Último Pago',
      colLastCredit: 'Fecha de Crédito',
      colActions: 'Acciones',
      colRequestDate: 'Fecha de Solicitud',
      colCorbanName: 'Nombre/Razón Social',
      colValue: 'Valor',
      colNF: 'Factura',
      colProof: 'Comprobante',
      loadingAccounts: 'Cargando cuentas...',
      loadingRequests: 'Cargando solicitudes...',
      tooltipOptions: 'Opciones',
      menuStatement: 'Estado de Cuenta',
      menuAddPayment: 'Agregar Pago',
      urgent: 'Urgente',
      indicatorsCount: '{n} indicadores',
      noData: 'No hay información',
      errorLoadCorrespondents: 'No fue posible cargar la lista de corresponsales. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorLoadAccounts: 'No fue posible cargar las cuentas de comisión de los corresponsales. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      successCreatePaymentOrder: '¡Orden de pago creada con éxito!',
      errorCreatePaymentOrder: 'No fue posible registrar la orden de pago de la comisión. Verifique los datos y los anexos e intente nuevamente; si continúa, contacte al soporte.',
      errorAddDocument: 'El anexo no fue agregado. Verifique si el archivo es PDF, JPG o PNG e intente nuevamente.'
    },
    corban: {
      cardBalanceDesc: 'Saldo Disponible',
      cardPeriodTotalDesc: 'Total del Período',
      colType: 'Tipo',
      typeTourism: 'Turismo',
      typeRemittance: 'Remesa',
      tourismShare: 'Incluye {value} de cambio turismo',
      btnRequestPayment: 'Solicitar pago',
      insufficientBalanceTooltip: 'Saldo insuficiente. Mínimo: {min}',
      tabCreditedOps: 'Operaciones acreditadas',
      tabPaymentRequests: 'Solicitudes de pago',
      colDate: 'Fecha',
      colCustomerName: 'Nombre / Razón Social',
      colOperationCode: 'Código Operación',
      colCommission: 'Comisión',
      colRequestDate: 'Fecha de Solicitud',
      colPaymentDate: 'Fecha de Pago',
      colValue: 'Valor',
      colNF: 'Factura',
      colProof: 'Comprobante',
      drawerTitle: 'Filtro',
      btnClearFilter: 'Limpiar',
      btnFilter: 'Filtrar',
      loadingOps: 'Cargando operaciones...',
      loadingRequests: 'Cargando solicitudes...',
      noData: 'No hay información',
      errorLoadAccount: 'No fue posible cargar el saldo de comisiones. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorLoadCorban: 'No fue posible cargar los datos de su corresponsal. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      successPaymentRequest: '¡Solicitud abierta con éxito!',
      errorCreatePaymentOrder: 'No fue posible solicitar el pago de la comisión. Verifique el valor y la factura e intente nuevamente; si continúa, contacte al soporte.',
      errorAddDocumentNf: '¡Solo puede agregar documentos del tipo Factura!',
      errorAddDocument: 'El anexo no fue agregado. Verifique si el archivo es PDF, JPG o PNG e intente nuevamente.'
    },
    statement: {
      title: 'Estado de Comisiones - {name}',
      cardPeriodTotal: 'Total del Período',
      colType: 'Tipo',
      typeTourism: 'Turismo',
      typeRemittance: 'Remesa',
      tourismShare: 'Incluye {value} de cambio turismo',
      cardBalance: 'Saldo Disponible',
      colOperation: 'Operación',
      colCustomer: 'Cliente',
      colDate: 'Fecha',
      colCorbanCommission: 'Comisiones Corban',
      colIndicatorCommission: 'Comisiones Indicador',
      colWithdrawals: 'Retiros',
      colNF: 'Factura',
      colProof: 'Comprobante',
      noData: 'No hay información',
      btnClose: 'Cerrar',
      errorLoad: 'No fue posible cargar datos del estado de cuenta. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorAddDocument: 'El anexo no fue agregado. Verifique si el archivo es PDF, JPG o PNG e intente nuevamente.'
    }
  },

  exchangeClosing: {
    exchangeClosingDateModalUi: {
      operation: 'Operación'
    },
    intro: 'Paso a paso del cierre mensual: verificar con los bancos, acreditar las comisiones de los corbans y revisar el resumen del mes.',
    steps: {
      check: 'Verificación',
      creditCommissions: 'Acreditar comisiones',
      summary: 'Resumen del mes'
    },
    situations: {
      running: 'Mes en curso',
      open: 'En cierre',
      checked: 'Verificado',
      credited: 'Comisiones acreditadas',
      closed: 'Cerrado'
    },
    stepLabel: 'Paso {current} de {total}',
    confirmCheckButton: 'Confirmar verificación y avanzar',
    closeButton: 'Concluir cierre',
    sendReportTitle: '¿Enviar informe de comisiones?',
    sendReportMessage: 'Comisiones acreditadas. ¿Desea enviar el informe de cierre a los corbans con crédito de comisión disponible?',
    sendReportConfirm: 'Enviar',
    sendReportLater: 'Ahora no',
    messages: {
      commissionsCredited: 'Comisiones acreditadas en la cuenta de los corbans.',
      loadError: 'No se pudo cargar el cierre del mes. Actualice la página (F5) y vuelva a intentarlo.',
      reloadError: 'No se pudo recargar el cierre del mes. Haga clic en Actualizar.',
      saveBankCheckError: 'No fue posible guardar la verificación del banco. Verifique si el valor está completo y vuelva a intentarlo.',
      actError: 'No fue posible completar esta etapa del cierre. Actualice la página para ver la situación actual del mes y vuelva a intentarlo.',
      confirmCheckSuccess: 'Verificación confirmada.',
      closeSuccess: 'Cierre del mes concluido.',
      reportsSent: 'Informes de comisiones enviados a los corbans con crédito disponible.',
      reportsError: 'No fue posible enviar los informes de comisiones a los corbans. Vuelva a intentarlo en unos minutos; si continúa, contacte al soporte.'
    },
    header: {
      competence: 'Mes de competencia',
      situation: 'Situación',
      lastUpdate: 'Última actualización',
      refresh: 'Actualizar'
    },
    bankCheck: {
      descriptionBefore: 'Lo que {company} determinó en el mes, por banco, con las operaciones liquidadas. Abra el extracto de cada banco, ingrese el valor que muestra al lado y verifique.',
      descriptionHighlight: 'Solo avance cuando todo coincida.',
      descriptionAfter: 'Una diferencia se corrige en el origen o queda registrada con justificación. Todo se guarda y puede modificarse hasta concluir el cierre.',
      stablecoinCommission: 'incluye {amount} de stablecoin por la paridad del día',
      commissionEstimate: 'estimación hasta el crédito',
      defaultCompany: 'la empresa',
      banksTitle: 'Bancos del mes',
      tableHeaders: {
        bank: 'Banco',
        operations: 'Operaciones',
        houseProfitLabel: 'Ganancia propia',
        houseProfitLabelBranded: 'Ganancia de {name}',
        informedByBank: 'Informado por el banco',
        check: 'Verificación',
        corbanCommission: 'Comisión corbans'
      },
      noOperations: 'Ninguna operación liquidada en este mes.',
      collapseOperations: 'Contraer operaciones',
      expandOperations: 'Expandir operaciones',
      justificationPlaceholder: 'Justificación de la diferencia',
      startCheckButton: 'Iniciar verificación',
      filterSearch: 'Buscar',
      filterSituation: 'Situación',
      filterCurrency: 'Moneda',
      filterVariation: 'Variaciones',
      filterDateFrom: 'Desde',
      filterDateTo: 'Hasta',
      clearFilters: 'Limpiar filtros',
      filterAll: 'Todas',
      situationChecked: 'Verificadas',
      situationPending: 'Pendientes',
      variationWith: 'Con variación',
      variationWithout: 'Sin variación',
      checkedCount: '{checked} de {total} verificadas',
      deselectAll: 'Desmarcar todas',
      selectAll: 'Marcar todas',
      confirmButton: 'Confirmar',
      noOperationsWithFilters: 'Ninguna operación encontrada con estos filtros.',
      movedTo: 'movida a {date}',
      movedToTooltip: 'Estaba en este mes en {from}. Movida a {to} por {user} el {changedAt}. No entra en los totales de este mes.',
      cameFrom: 'vino de {date}',
      cameFromTooltip: 'Fecha cambiada de {from} a {to} por {user}',
      checkedChip: 'Verificada',
      variationsCaption: 'Variaciones',
      missingItemsTitle: 'Para confirmar la verificación, falta:',
      kpis: {
        grossProfit: 'Ganancia bruta',
        operations: 'Operaciones',
        houseProfit: 'Ganancia propia',
        corbanCommission: 'Comisión de corbans'
      },
      launchVariation: 'Registrar variación',
      changeDate: 'Cambiar fecha',
      checkStatus: {
        pending: 'Esperando el valor',
        match: 'Coincide',
        bankHigher: 'banco mayor',
        bankLower: 'banco menor',
        difference: 'Diferencia de {amount} ({side})'
      }
    },
    commissions: {
      creditedTitle: 'Comisiones acreditadas',
      notCreditedTitle: 'Comisiones aún no acreditadas',
      subtitle: 'Al acreditar, la comisión de cada corban en las operaciones liquidadas del mes entra en su saldo.',
      creditButton: 'Acreditar comisiones',
      creditedMessage: '{amount} de comisión de {who} acreditados{when}. El valor ya está en el saldo de comisión de cada corban.',
      creditedWhen: ' el {date}',
      corban: '{count} corban | {count} corbans'
    },
    summary: {
      description: 'Desempeño del mes en las operaciones liquidadas, comparado con el mes anterior, y la situación de cada corban. Verifique y concluya el cierre.',
      corbansTitle: 'Corbans del mes',
      tourismShare: '{value} de cambio turismo',
      tableHeaders: {
        corban: 'Corban',
        generatedCommission: 'Comisión generada',
        monthProfit: 'Ganancia del mes',
        previousBalance: 'Saldo anterior',
        totalBalance: 'Saldo total'
      },
      noCorbans: 'Ningún corban con comisión en este mes.',
      closedNote: 'Verificación y crédito de las comisiones de este mes están registrados.',
      closedTitle: 'Cierre concluido el {date}.',
      missingItemsTitle: 'Para concluir el cierre, falta:',
      kpis: {
        operations: 'Operaciones',
        volume: 'Volumen en reales',
        houseProfit: 'Ganancia propia',
        houseProfitBranded: 'Ganancia de {name}',
        corbanCommission: 'Comisión de corbans'
      },
      comparison: {
        noHistory: 'sin operaciones el mes anterior',
        same: 'igual al mes anterior',
        change: '{sign}{percent}% vs. mes anterior'
      },
      operation: '{count} operación | {count} operaciones',
      ticketMedioLabel: 'ticket promedio {amount}',
      spreadMedioLabel: 'spread promedio {spread}%',
      stablecoinCommission: 'incluye {amount} de stablecoin por la paridad del día',
      commissionEstimate: 'estimación hasta el crédito',
      stablecoinProfit: '+ {amount} en stablecoin'
    },
    dateModal: {
      title: 'Cambiar fecha de la operación',
      description: 'La fecha de la operación define el mes en que entra en el cierre.',
      currentDate: 'Fecha actual',
      newDate: 'Nueva fecha',
      historyTitle: 'Historial de fechas',
      historyEmpty: 'La fecha de esta operación nunca fue modificada.',
      changedBy: 'por {user} el {date}',
      messages: {
        noDateError: 'Informe la nueva fecha.',
        savedSuccess: 'Fecha de la operación #{id} cambiada.',
        saveError: 'No fue posible cambiar la fecha de la operación. Vuelva a intentarlo; si continúa, contacte al soporte.'
      }
    }
  },

  correspondents: {
    correspondentsControlUi: {
      preRegisterError: 'No fue posible registrar el corban. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.'
    },
    correspondentTypeSelectorUi: {
      title: '¿Qué tipo de registro desea realizar?'
    },
    publicSignup: {
      emailHint: 'Recibirá el enlace del formulario para continuar el registro cuando lo desee.'
    },
    control: {
      add: 'Agregar',
      sendPreRegister: 'Enviar pre-registro',
      colCorban: 'Corban / Indicador',
      colEmail: 'Correo de acceso',
      colType: 'Tipo',
      colRegistration: 'Registro',
      colSignupLink: 'Enlace de registro',
      colActions: 'Acciones',
      colCode: 'Código',
      colName: 'Nombre',
      colDate: 'Fecha de registro',
      empty: 'Ningún corban encontrado para esta búsqueda.',
      collapseIndicators: 'Contraer indicadores',
      expandIndicators: 'Expandir indicadores',
      externalIdTooltip: 'Corban importado con ID externo {id}',
      indicator: 'indicador | indicadores',
      typeIndicator: 'Indicador',
      typeMaster: 'Corban master',
      copyLink: 'Copiar enlace de registro',
      edit: 'Editar',
      errors: {
        loadList: 'No fue posible cargar la lista de corbans. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
        loadPersonTypes: 'No fue posible cargar los tipos de persona del corban. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.'
      }
    },
    form: {
      cancel: 'Cancelar',
      save: 'Guardar',
      requiredFields: 'Hay campos obligatorios sin completar',
      successSave: '¡Guardado con éxito!',
      successSaveCorban: '¡Corban guardado con éxito!',
      errors: {
        loadCorban: 'No fue posible cargar los datos del corban. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
        loadPersonTypes: 'No fue posible cargar los tipos de persona del corban. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
        createCorban: 'No fue posible registrar el corban. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.',
        createIndicated: 'No fue posible registrar el corban indicador. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.',
        updateCorban: 'No fue posible guardar los cambios del corban. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.',
        sendTrigger: 'No fue posible enviar el correo de acceso al corban. Intente de nuevo en unos instantes; si continúa, contacte al soporte.'
      }
    },
    signup: {
      unavailableTitle: 'Enlace de registro no disponible',
      unavailableText: 'Este enlace no existe o fue desactivado. Solicite un nuevo enlace a quien se lo envió.',
      title: '¿Cómo desea registrarse?',
      profileSubtitle: '¿Cuál es su perfil?',
      submitButton: 'Continuar al formulario',
      externalAccessTitle: 'Registro de cliente',
      personKind: {
        pf: { title: 'Persona Física', description: 'Registro a su nombre' },
        pj: { title: 'Persona Jurídica', description: 'Registro de su empresa' }
      },
      registerType: {
        1: 'Operaciones de turismo y viajes',
        2: 'Remesas básicas al exterior',
        3: 'Remesas completas al exterior',
        default: 'Registro de cliente'
      },
      registerTypeLimit: {
        2: 'Hasta 100 mil reales',
        3: 'Más de 100 mil reales'
      },
      errors: {
        signup: 'No fue posible enviar su registro. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.'
      }
    }
  },

  formExchangeBank: {
    bankBrandAssetsUi: {
      title: 'Identidad visual',
      iconLabel: 'El ícono de la marca',
      iconFileLabel: 'Ícono de la marca (.svg)',
      iconMarkupLabel: 'SVG del ícono',
      iconHint: 'Símbolo compacto del banco, usado en listas y tarjetas',
      logoLabel: 'El logotipo de la marca',
      logoFileLabel: 'Logotipo de la marca (.svg)',
      logoMarkupLabel: 'SVG del logotipo',
      logoHint: 'Logotipo completo del banco, usado en pantallas y documentos'
    },
    bankCoverUi: {
      title: 'Datos de registro',
      operationTypes: 'Tipos de operación',
      companyName: 'Razón social',
      fantasyName: 'Nombre de fantasía',
      useRegisterForm: '¿Trabaja con ficha de registro?',
      pfRegisterForm: 'Ficha de registro persona humana',
      pjRegisterForm: 'Ficha de registro persona jurídica',
      hasBankingIntegration: 'Tiene integración bancaria',
      businessHours: 'Horario de atención',
      openingTime: 'Apertura',
      closingTime: 'Cierre',
      integrationPlayerRequired: 'Seleccioná el player de integración'
    },
    bankContactEmailUi: {
      title: 'E-mails de contacto',
      missingEmailPrefix: 'Sin e-mail configurado en',
      missingEmailSuffix: '. El banco no recibe los mensajes de estos temas.',
      individualTab: 'Persona humana',
      companyTab: 'Persona jurídica',
      copyFromIndividual: 'Copiar de los e-mails de Persona humana',
      duimpChargeTitle: 'Cobro DUIMP/DU-E',
      enableDuimpCharge: 'Habilitar cobro de DUIMP/DU-E por e-mail',
      initialDaysLabel: 'Días para el primer envío',
      resendDaysLabel: 'Días entre reenvíos',
      deadlineTitle: 'Plazo de envío',
      deadlinePrefix: 'El plazo de',
      deadlineDays: '{days} días',
      deadlineMiddle: 'empieza a contar a partir de la',
      deadlineShipmentDate: 'fecha prevista de embarque',
      deadlineSuffix: 'informada en la invoice al cierre del cambio.',
      deadlineNewDate: 'Si el cliente informa una nueva fecha de embarque, el sistema va a tomar la última fecha informada para iniciar los cobros.',
      deadlineExample: 'Ejemplo: embarque previsto el 01/06/2025 → primer e-mail enviado el {date}.',
      sectionRegister: 'Registro',
      sectionOperation: 'Operación',
      sectionDocuments: 'Documentos operativos',
      sectionDuimp: 'DUIMP/DU-E',
      sectionFinancial: 'Finanzas',
      firstEmail: 'Primer e-mail',
      secondEmail: 'Segundo e-mail',
      thirdEmail: 'Tercer e-mail',
      listJoin: '{list} y {last}'
    },
    bankFinancialUi: {
      title: 'Datos bancarios',
      usePaymentAccount: 'Usa cuenta de pago',
      linkedBank: 'Banco vinculado',
      inOutLimit: '¿Límite de entrada y salida?',
      limitCurrency: '¿Límite en qué moneda?',
      feeCurrency: '¿Tarifa en qué moneda?',
      feeCashback: '¿Cashback de tarifa?',
      usdOption: 'Dólar estadounidense - USD',
      brlOption: 'Real - BRL',
      fee: 'Tarifa',
      commission: 'Comisión(%)',
      profitPercentage: '% Ganancia p/ comisiones',
      profitPercentageHint: '0-100%. Define cuánto de la ganancia del corresponsal entra en el cálculo de comisiones',
      paymentMethodsTitle: 'Métodos de pago internacionales habilitados',
      paymentMethodsHint: 'Seleccioná los métodos disponibles en el registro de cuentas en el exterior. Si no se selecciona ningún método, se van a habilitar todos.',
      profitRequired: 'Campo obligatorio para bancos digitales',
      profitRange: 'Debe estar entre 0 y 100'
    },
    exchangeBankLiquidationConfigUi: {
      title: 'Control de horarios de liquidación',
      subtitle: 'Define el horario límite para operaciones con liquidación en el mismo día (D+0).',
      bulkFillTitle: 'Completar todas las monedas',
      sell: 'Venta',
      buy: 'Compra',
      applyToAll: 'Aplicar a todos',
      bulkFillHint: 'Los horarios ingresados van a sobrescribir los valores ya completados en todas las monedas.',
      emptyState: 'No hay ninguna moneda disponible. Las monedas se cargan automáticamente al abrir el formulario.',
      afterBankEnd: 'El horario límite no puede ser posterior al cierre del horario de atención del banco ({time}).',
      beforeBankStart: 'El horario límite no puede ser anterior a la apertura del horario de atención del banco ({time}).'
    },
    bankContactNumberUi: {
      title: 'Teléfonos de contacto',
      contactName: 'Nombre del contacto',
      department: 'Departamento',
      landline: 'Teléfono fijo',
      cellphone: 'Celular'
    },
    spreadsUi: {
      title: 'Spreads',
      sell: 'Venta',
      buy: 'Compra',
      costSell: 'Costo de la ME Venta(%)',
      deliveryExemption: 'Monto para exención de delivery',
      minProfitSell: 'Ganancia mínima Venta(%)',
      recProfitSell: 'Ganancia recomendada Venta(%)',
      maxProfitSell: 'Ganancia máxima Venta(%)',
      costBuy: 'Costo de la ME Compra(%)',
      minProfitBuy: 'Ganancia mínima Compra(%)',
      recProfitBuy: 'Ganancia recomendada Compra(%)',
      maxProfitBuy: 'Ganancia máxima Compra(%)'
    },
    exchangeStoresUi: {
      title: 'Sucursales / Spreads',
      modalTitle: 'Sucursal',
      companyName: 'Razón social',
      storeName: 'Nombre de la sucursal',
      landline: 'Teléfono fijo',
      cellphone: 'Celular',
      deliveryTypes: 'Tipos de entrega',
      withdrawalTime: 'Tiempo para retiro',
      withdrawalDays: 'Días de retiro',
      deliveryDays: 'Días de delivery',
      weekdays: 'Días de semana',
      sunday: 'Domingo',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      businessHours: 'Horario de atención',
      deliveryTime: 'Horario del delivery',
      deliveryCost: 'Costo del delivery',
      observations: 'Observaciones',
      colCreatedAt: 'Creado el',
      colEmail: 'Email',
      colActions: 'Acciones'
    },
    cover: {
      playerPlaceholder: 'Seleccione un player ...',
      openHoursHint: 'Inicio del horario del banco',
      closeHoursHint: 'Fin del horario del banco'
    },
    financial: {
      requiredHint: 'Este campo es obligatorio',
      percentageHint: '0-100%'
    },
    stores: {
      editTooltip: 'Editar',
      duplicateTooltip: 'Duplicar'
    },
    digitalSignatureTitle: 'Firma digital',
    creationFlow: {
      signatureTitle: 'Firma digital',
      signatureMessage: '¿Desea enviar el formulario de registro para firma digital del cliente?',
      bankRegisterSuccess: '¡Formulario de registro enviado al banco con éxito!',
      signatureSuccess: '¡Formulario de registro enviado para firma del cliente!',
      invalidCustomer: 'Cliente inválido. No es posible enviar documentos.',
      sendBankRegisterError: 'No fue posible enviar la ficha de registro al banco. Verifique los documentos elegidos e inténtelo de nuevo; si continúa, contacte al soporte.',
      sendSignatureError: 'No fue posible enviar la ficha de registro para que el cliente firme. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.'
    }
  },

  auth: {
    identities: {
      title: 'Formas de acceso',
      emptyTitle: 'No hay cuentas vinculadas',
      emptySubtitle: 'Para vincular, cierre sesión y haga clic en Iniciar sesión con Google en la pantalla de inicio.',
      intro: 'Formas en que puede acceder al sistema.',
      emailAndPassword: 'Correo electrónico y contraseña',
      alwaysActive: 'Siempre activo',
      unlink: 'Desvincular',
      confirmUnlinkTitle: '¿Desvincular cuenta {label}?',
      confirmUnlinkAccountRef: 'esta cuenta {label}',
      confirmUnlinkMessage: 'Ya no podrá acceder con {accountRef}. Su correo electrónico y contraseña seguirán funcionando. Si lo desea, puede vincularla de nuevo.',
      linkedAt: 'Vinculada el {date}',
      notYetUsed: 'Aún no utilizada para acceder',
      lastLogin: 'Último acceso el {date} a las {time}',
      loadError: 'No fue posible cargar sus formas de acceso. Intente de nuevo.',
      unlinkedSuccess: 'Cuenta {label} desvinculada.'
    },
    googleButton: 'Iniciar sesión con Google',
    googleAriaLabel: 'Google',
    emailLabel: 'Correo electrónico',
    passwordLabel: 'Contraseña',
    divider: 'o',
    checkingAccount: 'Verificando su cuenta {name}…',
    linkStep: {
      title: 'Vincule su cuenta {label}',
      instruction: 'Por su seguridad, confirme el correo electrónico y la contraseña que usa en el sistema.',
      submitButton: 'Vincular e ingresar',
      hint: 'Las próximas veces, solo haga clic en Iniciar sesión con {label}.',
      forgotPassword: 'Olvidé mi contraseña',
      emailPasswordRequired: 'Ingrese el correo electrónico y la contraseña que usa en el sistema.',
      linkedSuccess: 'Cuenta {label} vinculada. Las próximas veces, solo haga clic en Iniciar sesión con {label}.',
      accountFallback: 'Cuenta {label}'
    }
  },

  currencyHolidays: {
    emptyTitle: 'No hay monedas registradas',
    labelYear: 'Año',
    btnExclusions: 'Excluidos',
    tabHolidays: 'Feriados',
    tabCurrencyConfig: 'Configuración de Monedas',
    errorLoadHolidays: 'No fue posible cargar los feriados. Actualice la página; si continúa, contacte al soporte.',
    errorLoadExclusions: 'No fue posible cargar los feriados excluidos. Actualice la página; si continúa, contacte al soporte.',
    errorAddHoliday: 'No fue posible agregar el feriado. Verifique la moneda, la fecha y el nombre del feriado e intente de nuevo.',
    errorRemoveHoliday: 'No fue posible quitar el feriado. Actualice la página para verificar la lista e intente de nuevo.',
    errorRenameHoliday: 'No fue posible renombrar el feriado. Verifique si el nombre está completo e intente de nuevo.',
    errorUpdateCountry: 'No fue posible actualizar el país de la moneda. Verifique el país elegido e intente de nuevo.',
    errorRestoreExclusion: 'No fue posible restaurar el feriado. Actualice la página para verificar la lista e intente de nuevo.',
    card: {
      dateLabel: 'Fecha del feriado',
      nameLabel: 'Nombre del feriado',
      saveTooltip: 'Guardar nombre',
      cancelTooltip: 'Cancelar edición',
      editTooltip: 'Editar nombre',
      removeTooltip: 'Quitar feriado',
      deleteTitle: 'Eliminar feriado',
      addBtn: 'Agregar',
      emptyNoHolidays: 'Ningún feriado registrado para {year}.',
      deleteConfirmMessage: '¿Está seguro de que desea eliminar el feriado {text}?',
      deleteConfirmBtn: 'Eliminar',
      cancelBtn: 'Cancelar',
      errorSelectDate: 'Seleccione una fecha para el feriado.',
      errorNameRequired: 'Ingrese el nombre del feriado.',
      errorDateExists: 'Ya existe un feriado registrado en esta fecha para esta moneda.',
      errorEditNameRequired: 'Ingrese un nombre para el feriado.'
    },
    exclusions: {
      title: 'Feriados Excluidos',
      emptyTitle: 'No hay feriados excluidos',
      closeBtn: 'Cerrar',
      colCountry: 'País',
      colDate: 'Fecha',
      colName: 'Nombre',
      colDeletedAt: 'Eliminado en',
      colActions: 'Acciones',
      restoreBtn: 'Restaurar'
    },
    searchCountry: 'Buscar país',
    noCountryFound: 'Ningún país encontrado para "{search}".',
    countryConfig: {
      searchCurrency: 'Buscar moneda',
      colCode: 'Código',
      colName: 'Nombre',
      colCountry: 'País',
      colHolidays: 'Feriados en {year}',
      saveBtn: 'Guardar',
      editTooltip: 'Editar',
      emptyMsg: 'No hay monedas registradas'
    },
    countryCard: {
      errorDateExists: 'Ya existe un feriado en esta fecha para este país.',
      errorLoadHolidays: 'No fue posible cargar los feriados. Actualice la página e intente de nuevo.',
      errorAddHoliday: 'No fue posible agregar el feriado. Verifique la fecha y el nombre e intente de nuevo.',
      errorRenameHoliday: 'No fue posible cambiar el nombre del feriado. Inténtelo de nuevo.',
      errorRemoveHoliday: 'No fue posible eliminar el feriado. Actualice la página e intente de nuevo.'
    },
    modal: {
      title: 'Países vinculados — {name} ({code})',
      titleFallback: 'Países vinculados',
      addCountryLabel: 'Agregar país',
      saveBtn: 'Guardar',
      cancelBtn: 'Cancelar',
      removeTooltip: 'Eliminar país',
      emptyCountries: 'Ningún país vinculado',
      colCountry: 'País',
      errorSave: 'No fue posible guardar los países. Inténtelo de nuevo.'
    }
  },

  audit: {
    beforeAfterBlockUi: {
      arrayItem: 'Ítem {n}',
      others: 'Otros'
    },
    auditConstantsUi: {
      removedItemsSection: 'Elementos eliminados al guardar',
      removedItems: 'Listas que disminuyeron (antes y después)',
      agency: 'Sucursal',
      mainActivity: 'Actividad principal',
      active: 'Activo',
      updatedAt: 'Actualizado el',
      neighborhood: 'Barrio',
      bank: 'Banco',
      linkedBank: 'Banco vinculado',
      exchangeBankSection: 'Banco de cambio',
      bankAndCorban: 'Banco y corresponsal',
      internationalBanks: 'Bancos internacionales',
      nationalBanks: 'Bancos nacionales',
      exchangeBanks: 'Bancos de cambio',
      exchangeBanksSection: 'Bancos de cambio',
      bankCnpj: 'CNPJ del banco',
      publicAgentCpf: 'CPF del agente público',
      spouseCpf: 'CPF del cónyuge',
      customerCpfCnpj: 'CPF/CNPJ del cliente',
      corbanCpfCnpj: 'CPF/CNPJ del corresponsal',
      correspondentCpfCnpj: 'CPF/CNPJ del corresponsal',
      bankingChannels: 'Canales bancarios',
      paidInCapital: 'Capital social integrado',
      position: 'Cargo',
      publicAgentPosition: 'Cargo del agente público',
      registrationResponsiblePosition: 'Cargo del responsable del registro',
      positionTitle: 'Cargo/Posición',
      exchangeStores: 'Casas de cambio',
      linkedExchangeStores: 'Casas de cambio vinculadas',
      contractCashback: 'Cashback del contrato',
      exchangeContractCashback: 'Cashback del contrato de cambio',
      cellphone: 'Celular',
      internationalCellphone: 'Celular internacional',
      correspondentCellphone: 'Celular del corresponsal',
      registrationResponsibleCellphone: 'Celular del responsable del registro',
      pixKey: 'Clave PIX',
      city: 'Ciudad',
      customer: 'Cliente',
      commission: 'Comisión',
      corbanCommission: 'Comisión del corresponsal',
      indicatorCommission: 'Comisión del referidor',
      commissions: 'Comisiones',
      commissionsAndCosts: 'Comisiones y costos',
      complement: 'Complemento',
      complianceUpdatedAt: 'Compliance actualizado el',
      complianceCreatedAt: 'Compliance creado el',
      exchangeBuy: 'Compra de divisas',
      settings: 'Configuración',
      spreadSettings: 'Configuración de spread',
      account: 'Cuenta',
      internationalAccount: 'Cuenta internacional',
      paymentAccount: 'Cuenta de pago',
      paymentAccountSection: 'Cuenta de pago',
      customerAccount: 'Cuenta del cliente',
      accounts: 'Cuentas',
      foreignAccounts: 'Cuentas en el exterior',
      contacts: 'Contactos',
      corban: 'Corresponsal',
      currencyQuotation: 'Cotización de la moneda',
      creditedAt: 'Acreditado el',
      createdAt: 'Creado el',
      deliveryCost: 'Costo de entrega',
      exchangeContractCost: 'Costo del contrato de cambio',
      contractCostBrl: 'Costo del contrato en BRL',
      costs: 'Costos',
      financialCalculations: 'Cálculos financieros',
      code: 'Código',
      intermediaryAbaSwiftCode: 'Código ABA/SWIFT del intermediario',
      swiftBicCode: 'Código SWIFT/BIC',
      currencyCode: 'Código de la moneda',
      natureCode: 'Código de la naturaleza',
      operationNatureCode: 'Código de la naturaleza de operación',
      bankCode: 'Código del banco',
      positionCode: 'Código del cargo',
      countryCode: 'Código del país',
      cellphoneDdi: 'Código de país del celular',
      landlineDdi: 'Código de país del teléfono fijo',
      fatcaCrsData: 'Datos FATCA/CRS (campos derivados)',
      administrativeData: 'Datos administrativos',
      bankData: 'Datos bancarios',
      brazilBankData: 'Datos bancarios en Brasil',
      basicData: 'Datos básicos',
      registrationData: 'Datos de registro',
      companyData: 'Datos de la empresa',
      complianceData: 'Datos de compliance',
      systemData: 'Datos del sistema',
      positionData: 'Datos del cargo/función ejercida',
      customerData: 'Datos del cliente',
      financialData: 'Datos financieros',
      legalEntityData: 'Datos para persona jurídica',
      effectiveOperationDate: 'Fecha efectiva de la operación',
      lastChangeDate: 'Fecha de la última modificación',
      approvalDate: 'Fecha de aprobación',
      boardElectionDate: 'Fecha de elección del directorio',
      documentIssueDate: 'Fecha de emisión del documento',
      deliveryDate: 'Fecha de entrega',
      practiceEndDate: 'Fecha de fin del ejercicio',
      foundingDate: 'Fecha de fundación',
      practiceStartDate: 'Fecha de inicio del ejercicio',
      birthDate: 'Fecha de nacimiento',
      documentDueDate: 'Fecha de vencimiento del documento',
      purposeDescription: 'Descripción del propósito',
      customerDescription: 'Descripción para el cliente',
      identificationDocument: 'Documento de identificación',
      documents: 'Documentos',
      customerOperationalDocuments: 'Documentos operativos del cliente',
      operationDocuments: 'Documentos de la operación',
      operationDocumentsSection: 'Documentos de la operación',
      operationalDocuments: 'Documentos operativos',
      taxDomicileSection: 'Domicilio fiscal (TC-1662)',
      taxDomicileAbroad: 'Domicilio fiscal en el exterior (CRS derivado)',
      usPerson: 'Domicilio fiscal en EE. UU. (FATCA derivado)',
      taxDomiciles: 'Domicilios fiscales',
      digit: 'Dígito',
      email: 'Correo electrónico',
      registrationResponsibleEmail: 'Correo electrónico del responsable del registro',
      diDueEmails: 'Correos electrónicos DUIMP/DU-E',
      registerEmails: 'Correos electrónicos de registro',
      documentationEmails: 'Correos electrónicos de documentación',
      notificationEmails: 'Correos electrónicos de notificación',
      operationEmails: 'Correos electrónicos de operación',
      financialEmails: 'Correos electrónicos de finanzas',
      company: 'Empresa',
      companyPublicAgency: 'Empresa/Organismo público',
      address: 'Dirección',
      state: 'Estado',
      maritalStatus: 'Estado civil',
      issuingState: 'Estado emisor',
      politicallyExposedPerson: '¿Ejerce o ejerció un cargo o función relevante?',
      formOfIncorporation: 'Forma de constitución',
      formsAndServices: 'Formularios y servicios',
      suppliers: 'Proveedores',
      dependentKinship: 'Grado de parentesco del dependiente',
      additionalId: 'ID adicional',
      externalId: 'ID externo',
      exchangeTypeId: 'ID tipo de cambio',
      exchangeStoreId: 'ID de la casa de cambio',
      accountId: 'ID de la cuenta',
      currencyId: 'ID de la moneda',
      natureId: 'ID de la naturaleza',
      operationNatureId: 'ID de la naturaleza de operación',
      operationId: 'ID de la operación',
      bankId: 'ID del banco',
      customerId: 'ID del cliente',
      contactId: 'ID del contacto',
      corbanId: 'ID del corresponsal',
      documentId: 'ID del documento',
      countryId: 'ID del país',
      purposeId: 'ID del propósito',
      spreadId: 'ID del spread',
      iofBuy: 'IOF compra',
      irBuy: 'IR compra',
      cideBuy: 'CIDE compra',
      usItin: 'ITIN estadounidense (heredado)',
      taxes: 'Impuestos',
      buyTaxes: 'Impuestos de compra',
      sellTaxes: 'Impuestos de venta',
      additionalInformation: 'Información adicional',
      additionalInformationSection: 'Información adicional',
      basicInformation: 'Información básica',
      currencyInformation: 'Información de la moneda',
      contactInformation: 'Información de contacto',
      generalInformation: 'Información general',
      initialInformation: 'Información inicial',
      personalInformation: 'Información personal',
      intermediary: 'Intermediario',
      importedOrExportedBefore: 'Ya importó/exportó antes',
      reducedLimit: 'Límite reducido',
      limits: 'Límites',
      limitsAndControl: 'Límites y control',
      limitsAndControls: 'Límites y controles',
      liquidationBrlDays: 'Liquidación BRL (D+)',
      liquidationFxDays: 'Liquidación ME (D+)',
      exchangeStoreList: 'Lista de casas de cambio',
      contactList: 'Lista de contactos',
      countryList: 'Lista de países',
      birthplace: 'Lugar de nacimiento',
      location: 'Ubicación',
      grossProfit: 'Ganancia bruta',
      netProfit: 'Ganancia neta',
      habilitationMode: 'Modo de habilitación',
      operatingMode: 'Modo de operación',
      paymentMode: 'Modo de pago',
      operationalModes: 'Modos operativos',
      currency: 'Moneda',
      intendedCurrency: 'Moneda pretendida',
      operationNatureSection: 'Naturaleza de la operación',
      operationNatureUpdatedAt: 'Naturaleza de operación actualizada el',
      operationNatureCreatedAt: 'Naturaleza de operación creada el',
      operationNature: 'Naturaleza de operación',
      natureAndCurrency: 'Naturaleza y moneda',
      name: 'Nombre',
      fantasyName: 'Nombre comercial',
      bankFantasyName: 'Nombre comercial del banco',
      exchangeStoreName: 'Nombre de la casa de cambio',
      accountName: 'Nombre de la cuenta',
      currencyName: 'Nombre de la moneda',
      motherName: 'Nombre de la madre',
      natureName: 'Nombre de la naturaleza',
      operationNatureName: 'Nombre de la naturaleza de operación',
      relatedPublicAgentName: 'Nombre del agente público relacionado',
      bankName: 'Nombre del banco',
      intermediaryBankName: 'Nombre del banco intermediario',
      customerName: 'Nombre del cliente',
      corbanName: 'Nombre del corresponsal',
      correspondentName: 'Nombre del corresponsal',
      spouseName: 'Nombre del cónyuge',
      dependentName: 'Nombre del dependiente',
      documentName: 'Nombre del documento',
      fatherName: 'Nombre del padre',
      countryName: 'Nombre del país',
      registrationResponsibleName: 'Nombre del responsable del registro',
      ownerName: 'Nombre del titular',
      newInternationalAccount: 'Nueva cuenta internacional',
      number: 'Número',
      ibanNumber: 'Número IBAN',
      numberEmployees: 'Número de empleados',
      routingNumber: 'Número de ruteo',
      documentNumber: 'Número de documento',
      tinDocumentNumber: 'Número de documento (TIN)',
      observation: 'Observación',
      operationNatureObservation: 'Observación de la naturaleza de operación',
      occupation: 'Ocupación',
      occupationUpdatedAt: 'Ocupación actualizada el',
      occupationCreatedAt: 'Ocupación creada el',
      otherBusinessPurpose: 'Otro propósito de la relación comercial',
      pep: 'PEP - Persona expuesta políticamente',
      forFurtherCredit: 'Para crédito adicional',
      parity: 'Paridad',
      assets: 'Patrimonio',
      country: 'País',
      birthCountry: 'País de nacimiento',
      destinationCountry: 'País de destino de los fondos',
      taxDomicileCountry: 'País del domicilio fiscal (heredado)',
      intermediaryCountry: 'País del intermediario',
      bilateralAgreementCountries: 'Países del acuerdo bilateral',
      bilateralAgreementCountriesSection: 'Países del acuerdo bilateral',
      relationshipPublicAgent: '¿Tiene relación con un agente público?',
      precision: 'Precisión',
      currencyPrecision: 'Precisión de la moneda',
      firstDiDueEmail: 'Primer correo electrónico DUIMP/DU-E',
      firstFinancialEmail: 'Primer correo electrónico de finanzas',
      firstRegisterEmail: 'Primer correo electrónico de registro',
      firstDocumentationEmail: 'Primer correo electrónico de documentación',
      firstOperationEmail: 'Primer correo electrónico de operación',
      priority: 'Prioridad',
      currencyPriority: 'Prioridad de la moneda',
      products: 'Productos',
      profession: 'Profesión',
      businessPurposeSection: 'Propósito de la relación comercial',
      businessPurposes: 'Propósitos de la relación comercial',
      companyName: 'Razón social',
      bankCompanyName: 'Razón social del banco',
      annualGrossRevenue: 'Facturación bruta anual',
      marriageSystem: 'Régimen matrimonial',
      registeredDiLast6Months: 'DI registrada en los últimos 6 meses',
      publicAgentRelationship: 'Relación con agente público',
      averageMonthlyIncome: 'Ingreso mensual promedio',
      answerCrimes: 'Respuesta sobre delitos',
      street: 'Calle',
      secondEmail: 'Segundo correo electrónico',
      secondDiDueEmail: 'Segundo correo electrónico DUIMP/DU-E',
      secondFinancialEmail: 'Segundo correo electrónico de finanzas',
      secondRegisterEmail: 'Segundo correo electrónico de registro',
      secondDocumentationEmail: 'Segundo correo electrónico de documentación',
      secondOperationEmail: 'Segundo correo electrónico de operación',
      signatureService: 'Servicio de firma',
      sector: 'Sector',
      sectorActivity: 'Sector de actividad',
      sex: 'Sexo',
      maximumSpreadBuy: 'Spread máximo de compra',
      maximumSpreadSell: 'Spread máximo de venta',
      minimumSpreadBuy: 'Spread mínimo de compra',
      minimumSpreadSell: 'Spread mínimo de venta',
      recommendedSpreadBuy: 'Spread recomendado de compra',
      recommendedSpreadSell: 'Spread recomendado de venta',
      buySpread: 'Spread de compra',
      sellSpread: 'Spread de venta',
      currencySpreads: 'Spreads de monedas',
      status: 'Estado',
      operationStatus: 'Estado de la operación',
      registerStatus: 'Estado del registro',
      statusAndLiquidation: 'Estado y liquidación',
      operationSubTotal: 'Subtotal de la operación',
      bankSubTotal: 'Subtotal del banco',
      taxDomicileAbroadTin: 'TIN del domicilio fiscal en el exterior (heredado)',
      bankRate: 'Tipo de cambio del banco',
      customerRate: 'Tipo de cambio del cliente',
      customerRateNoIof: 'Tipo de cambio del cliente sin IOF',
      customerRates: 'Tipos de cambio del cliente',
      ratesAndTaxes: 'Tipos de cambio e impuestos',
      landline: 'Teléfono fijo',
      internationalLandline: 'Teléfono fijo internacional',
      pfRegisterFormTemplate: 'Plantilla de formulario PF',
      pjRegisterFormTemplate: 'Plantilla de formulario PJ',
      thirdDiDueEmail: 'Tercer correo electrónico DUIMP/DU-E',
      thirdFinancialEmail: 'Tercer correo electrónico de finanzas',
      thirdRegisterEmail: 'Tercer correo electrónico de registro',
      thirdDocumentationEmail: 'Tercer correo electrónico de documentación',
      thirdOperationEmail: 'Tercer correo electrónico de operación',
      timestamps: 'Fechas de registro',
      registerType: 'Tipo de registro',
      exchangeType: 'Tipo de cambio',
      documentTypeShort: 'Tipo de documento',
      personType: 'Tipo de persona',
      exportedProductsType: 'Tipo de productos exportados',
      relationshipType: 'Tipo de relación',
      documentType: 'Tipo de documento',
      identificationDocumentType: 'Tipo de documento de identificación',
      levies: 'Tributos',
      useUsdContract: 'Usar contrato USD',
      useUsdExchangeContract: 'Usar contrato de cambio USD',
      useDiDue: 'Usar DUIMP/DU-E',
      useRegisterForm: 'Usar formulario de registro',
      useUsdLimit: 'Usar límite USD',
      useInOutLimit: 'Usar límite de entrada/salida',
      amount: 'Monto',
      estimatedAmount: 'Monto estimado',
      totalValue: 'Monto total',
      cambioHojeCommissionValue: 'Monto de la comisión Câmbio Hoje',
      bankCommissionValue: 'Monto de la comisión del banco',
      corbanCommissionValue: 'Monto de la comisión del corresponsal',
      indicatorCommissionValue: 'Monto de la comisión del referidor',
      cideValue: 'Monto del CIDE',
      cashbackValue: 'Monto del cashback',
      iofValue: 'Monto del IOF',
      irValue: 'Monto del IR',
      estimatedAnnualVolumeUsd: 'Volumen anual estimado (USD)',
      website: 'Sitio web',
      isBrazilian: 'Es brasileño',
      issuingAgency: 'Organismo emisor'
    },
    showAll: 'Mostrar todos los datos',
    hideEmpty: 'Ocultar campos no completados',
    control: {
      filter: 'Filtrar',
      viewRecord: 'Ver registro',
      viewRecordTitle: 'Ver registro: {entity} {id}',
      drawerTitle: 'Filtro',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin',
      userLabel: 'Usuario',
      entityLabel: 'Entidad',
      clearBtn: 'Limpiar',
      applyFilter: 'Filtrar',
      externalAccess: 'Acceso externo',
      beforeCreate: 'Antes de la creación',
      beforeUpdate: 'Antes de la modificación',
      afterCreate: 'Después de la creación',
      afterUpdate: 'Datos modificados',
      colDate: 'Fecha de registro',
      colEntity: 'Entidad',
      colLinkedEntity: 'Entidad vinculada',
      colAction: 'Acción',
      colLinkedUser: 'Usuario vinculado',
      colObservation: 'Observación',
      colActions: 'Acciones',
      errors: {
        loadUsers: 'No fue posible cargar la lista de usuarios del filtro. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
        loadAudit: 'No fue posible cargar el historial de auditoría. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.'
      }
    },
    block: {
      linkedUser: 'Usuario vinculado',
      entity: 'Entidad',
      linkedEntity: 'Entidad vinculada',
      action: 'Acción',
      date: 'Fecha',
      observation: 'Observación',
      externalAccess: 'Acceso externo'
    },
    section: {
      lastUpdate: 'Última actualización el {date}'
    }
  },

  whatsapp: {
    chatMessageInputUi: {
      previewAlt: 'Vista previa',
      fileTooLarge: 'El archivo supera el límite de 10MB'
    },
    searchPlaceholder: 'Buscar conversación...',
    phoneDdiHint: 'DDI + número (ej: 5521999999999)',
    inbox: {
      serviceDisabled: 'El servicio WhatsApp no está configurado. Póngase en contacto con el administrador.',
      connecting: 'Conectando al servidor...',
      imageContent: '[Imagen]',
      documentContent: '[Documento: {name}]',
      errorLoadConversations: 'No fue posible cargar conversaciones. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorLoadMessages: 'No fue posible cargar mensajes. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      errorSelectFile: 'No fue posible seleccionar archivo. Verifique si el archivo es JPG, PNG o PDF e intente nuevamente.'
    },
    indicator: {
      verifying: 'Verificando...',
      verified: 'WhatsApp verificado',
      notWhatsapp: 'No es WhatsApp',
      clickToVerify: 'Haga clic para verificar WhatsApp'
    },
    newConversation: {
      title: 'Nueva conversación',
      phoneLabel: 'Número de teléfono',
      errorVerify: 'No fue posible verificar el número. Inténtelo nuevamente.',
      errorNoWhatsapp: 'Este número no tiene WhatsApp.'
    },
    messagePanel: {
      noConversationTitle: 'Ninguna conversación seleccionada',
      noConversationSubtitle: 'Seleccione una conversación al lado o inicie una nueva.',
      loadMore: 'Cargar anteriores',
      imageAlt: 'Imagen',
      document: 'Documento',
      today: 'Hoy',
      yesterday: 'Ayer'
    },
    conversationList: {
      title: 'Conversaciones',
      empty: 'Ninguna conversación encontrada'
    },
    messageInput: {
      placeholderCaption: 'Agregue una leyenda...',
      placeholderMessage: 'Escriba un mensaje...'
    }
  },

  clara: {
    chatMessageUi: {
      addBank: 'Enviar registro a un nuevo banco',
      viewCustomer: 'Consultar datos del cliente',
      operateWithBank: 'Operar con {bank}',
      createOperation: 'Realizar operación',
      viewOperation: 'Consultar operación'
    },
    claraPanelUi: {
      panelAriaLabel: 'Clara AI, asistente',
      resizeAriaLabel: 'Redimensionar a Clara',
      todayAt: 'Hoy {time}',
      processError: 'No fue posible procesar su pregunta. Intente de nuevo en unos instantes; si persiste, contacte al soporte.',
      responseInterrupted: 'Respuesta interrumpida',
      connectionError: 'No fue posible conectarse con Clara. Verifique su conexión e intente de nuevo.'
    },
    customerPickerPlaceholder: 'Nombre o CPF/CNPJ',
    chatInput: {
      placeholder: 'Pregunta sobre el sistema...',
      cancelResponse: 'Cancelar respuesta',
      speakQuestion: 'Hablar la pregunta',
      send: 'Enviar',
      cancelRecording: 'Cancelar grabación'
    },
    chatMessage: {
      copyResponse: 'Copiar respuesta',
      sourcesLabel: 'Fuentes: ',
      usefulResponse: 'Respuesta útil',
      notUsefulResponse: 'Respuesta no útil'
    },
    panel: {
      aiSubtitle: 'Inteligencia Artificial',
      historyTooltip: 'Conversaciones anteriores',
      newChatTooltip: 'Limpia la conversación y empieza de nuevo',
      closeTooltip: 'Cerrar',
      historyTitle: 'Conversaciones anteriores',
      historyBack: 'Volver',
      historyLoading: 'Cargando...',
      historyError: 'No fue posible cargar el historial. Intente nuevamente.',
      historyEmpty: 'No hay conversaciones anteriores. Las próximas conversaciones aparecen en esta lista automáticamente.',
      operationPrefix: 'Operación #',
      emptyTitle: '¿Cómo puedo ayudar?',
      emptyText: 'Consulte dudas sobre el sistema, analice datos de clientes y resuelva pendientes.',
      lastCustomerLabel: 'Último cliente',
      streamingDefault: 'Analizando...',
      disclaimer: 'Generado por IA a partir de la base de conocimiento. Confirme información crítica con el soporte.',
      toolStatus: {
        searchCustomers: 'Buscando clientes...',
        getCustomerInfo: 'Cargando datos del cliente...',
        getCustomerOperations: 'Consultando operaciones...',
        getOperationDetail: 'Cargando detalles de la operación...',
        getStablecoinStatus: 'Verificando estado DolsPay...',
        getIntegrationLogs: 'Consultando registros de integración...',
        checkCustomerReadiness: 'Verificando disponibilidad del cliente...',
        getCustomerLimits: 'Consultando límites del cliente...',
        getReceiverDiagnostic: 'Verificando registro DolsPay...',
        getOnboardingTimeline: 'Cargando línea de tiempo de onboarding...',
        getOperationBlockReason: 'Identificando bloqueos...',
        default: 'Consultando datos...'
      },
      suggestions: {
        whatsMissing: '¿Qué falta para que el cliente opere?',
        customerLimit: '¿Cuál es el límite del cliente?',
        receiverRejected: '¿Por qué fue rechazado el receiver?',
        howDolspay: '¿Cómo funciona DolsPay?',
        howCreateStablecoin: '¿Cómo creo una operación stablecoin?',
        whySendNotComplete: '¿Por qué no se completó el envío al exterior?',
        howResendEmail: '¿Cómo reenvío un correo al cliente?',
        howFollowOperation: '¿Cómo sigo mi operación?',
        paymentConfirmed: '¿El pago fue confirmado?',
        howGenerateSwift: '¿Cómo genero el recibo SWIFT?',
        howLongToSend: '¿Cuánto demora el envío?',
        howCreateOperation: '¿Cómo crear una operación?',
        whatOperationStatus: '¿Cuál es el estado de la operación?',
        availableLimits: '¿Qué límites están disponibles?',
        whatMissingToOperate: '¿Qué falta para que el cliente opere?',
        whyBankRejected: '¿Cuál fue el rechazo del banco?',
        myProfit: '¿Cuál es mi ganancia?',
        operationDetails: '¿Detalles de la operación?'
      }
    },
    intro: {
      tagline: 'Nueva agente de inteligencia artificial de Tech Câmbio',
      lead: 'Clara es la especialista de Tech Câmbio. Consulta los datos reales de su operación y explica cómo funciona el sistema, en el panel al lado de la pantalla en que ya está.',
      highlights: {
        knowsYourOp: {
          title: 'Conoce su operación',
          text: '¿Tiene dudas sobre si un cliente tiene límite o está listo para operar Cambio? Pregúntele a Clara'
        },
        systemHelp: {
          title: 'Ayuda sobre el sistema',
          text: 'Su guía de ayuda sobre cómo utilizar el sistema. Desde el registro de clientes hasta el cierre de operaciones.'
        },
        secure: {
          title: 'Totalmente seguro',
          text: 'No crea ni modifica información sin su permiso. Clara le avisa cuando no tiene la información en vez de arriesgarse a una suposición.'
        }
      },
      dontShowToday: 'No mostrar nuevamente hoy',
      laterBtn: 'Ahora no',
      startBtn: 'Conocer ahora'
    },
    contextBar: {
      talkingAbout: 'Hablando sobre',
      clearLabel: 'Limpiar el contexto de la conversación',
      clickToChange: '. Haga clic para cambiar.',
      operationDesc: 'Operación #{id}',
      operationAndCustomerDesc: 'Operación #{id} · {name}'
    },
    customerPicker: {
      title: '¿Sobre qué cliente?',
      loading: 'Buscando...',
      empty: 'Ningún cliente encontrado para "{term}".',
      cancel: 'Cancelar'
    },
    operationPicker: {
      title: '¿Qué operación de {name}?',
      loading: 'Cargando operaciones...',
      empty: 'Ninguna operación encontrada para este cliente.',
      cancel: 'Cancelar'
    },
    spotlight: {
      step: 'Paso 1 de 1',
      closeLabel: 'Cerrar la guía',
      title: 'Clara está aquí arriba',
      text: 'Haga clic en el ícono destacado, en la parte superior de la pantalla, para abrir el panel de Clara IA. Puede conversar con ella mientras sigue trabajando.',
      finishBtn: 'Entendido',
      openBtn: 'Conversar con Clara'
    },
    launcher: {
      openLabel: 'Abrir Clara',
      closeLabel: 'Cerrar Clara',
      openTooltip: 'Clara AI · asistente'
    }
  },

  logger: {
    email: {
      title: 'Registros de Correo',
      preview: 'Ver correo',
      colDate: 'Fecha de registro',
      colSubject: 'Asunto',
      colCustomer: 'Cliente',
      colCorban: 'Corresponsal',
      colBank: 'Banco',
      colActions: 'Acciones',
      searchPlaceholder: 'Buscar por asunto o destinatario',
      optionsTooltip: 'Opciones',
      viewBtn: 'Visualizar',
      resendBtn: 'Reenviar al destinatario',
      resendToOtherBtn: 'Reenviar a otro correo',
      closeBtn: 'Cerrar',
      resendModalTitle: 'Reenviar a otro destinatario',
      sendBtn: 'Enviar',
      cancelBtn: 'Cancelar',
      newEmailLabel: 'Nuevo correo',
      resentSuccess: '¡Correo reenviado!',
      sentSuccess: '¡Correo enviado con éxito!',
      invalidEmailError: 'Por favor, ingrese un correo electrónico válido.',
      noSubject: 'Sin asunto',
      selectTitle: 'Seleccione un correo',
      selectText: 'Elija un envío en la lista al lado para ver el contenido enviado.',
      fromLabel: 'De',
      toLabel: 'Para',
      resendPreviewBtn: 'Reenviar',
      otherRecipientBtn: 'Otro destinatario',
      errors: {
        loadList: 'No fue posible cargar la lista de correos enviados. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
        loadLogs: '¡No fue posible obtener los registros de correos enviados. Intente nuevamente más tarde!',
        loadCount: 'No fue posible cargar la cantidad de correos enviados. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
        loadPreview: 'No fue posible cargar la vista previa del correo. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
        resend: '¡No fue posible reenviar el correo. Intente nuevamente más tarde!',
        send: '¡No fue posible enviar el correo. Intente nuevamente más tarde!'
      }
    },
    whatsapp: {
      title: 'Registros de WhatsApp',
      preview: 'Ver mensaje',
      colDate: 'Fecha de registro',
      colPhone: 'Teléfono',
      colCustomer: 'Cliente',
      colCorban: 'Corresponsal',
      colUser: 'Usuario',
      colOperation: 'Operación',
      colActions: 'Acciones',
      optionsTooltip: 'Opciones',
      viewMessageBtn: 'Ver mensaje',
      closeBtn: 'Cerrar',
      defaultModalTitle: 'Mensaje WhatsApp',
      selectMessage: 'Seleccione un mensaje para visualizar',
      phoneLabel: 'Teléfono:',
      statusLabel: 'Estado:',
      customerLabel: 'Cliente:',
      corbanLabel: 'Corresponsal:',
      userLabel: 'Usuario:',
      operationLabel: 'Operación:',
      sentAtLabel: 'Enviado en:',
      errors: {
        loadList: 'No fue posible cargar la lista de mensajes de WhatsApp enviados. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
        loadCount: 'No fue posible cargar la cantidad de mensajes de WhatsApp enviados. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
        loadMessage: 'No fue posible cargar el texto del mensaje. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
        loadMessages: 'No fue posible obtener los mensajes de WhatsApp enviados. ¡Intente nuevamente más tarde!'
      }
    }
  },

  access: {
    profiles: {
      title: 'Perfiles de acceso',
      newProfile: 'Nuevo perfil',
      add: 'Agregar',
      options: 'Opciones',
      edit: 'Editar',
      delete: 'Eliminar',
      colCode: 'Código',
      colName: 'Nombre',
      colObservation: 'Observación',
      colActions: 'Acciones',
      deleteConfirmTitle: '¿Eliminar perfil?',
      deleteMessage: '¿Desea eliminar el perfil <strong>"{name}"</strong>?',
      successDelete: 'Perfil {id} eliminado con éxito',
      notUsedError: 'El perfil no puede eliminarse porque está en uso.',
      errors: {
        loadList: 'No fue posible cargar la lista de perfiles. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
        deleteProfile: 'No fue posible eliminar el perfil. Intente de nuevo en unos instantes; si continúa, contacte al soporte.'
      }
    },
    form: {
      editTitle: 'Editar perfil',
      addTitle: 'Agregar perfil',
      descriptionLabel: 'Descripción',
      observationLabel: 'Observación',
      categoriesTitle: 'Categorías',
      accessCount: '{n} acceso | {n} accesos',
      actionEnable: 'Mostrar',
      actionDisable: 'Deshabilitar',
      actionHide: 'Ocultar',
      searchLabel: 'Buscar',
      accessHeader: 'Acceso',
      selectCategory: 'Seleccione una categoría',
      cancel: 'Cancelar',
      save: 'Guardar',
      validationError: 'Complete los campos resaltados',
      duplicateError: 'Ya existe un perfil registrado con esa descripción y observación.',
      createdSuccess: 'Perfil {id} creado con éxito',
      updatedSuccess: 'Perfil {id} editado con éxito',
      errors: {
        loadList: 'No fue posible cargar la lista de accesos del perfil. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
        loadProfile: 'No fue posible cargar los datos del perfil. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
        createProfile: 'No fue posible registrar el perfil. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.',
        updateProfile: 'No fue posible guardar los cambios del perfil. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.'
      }
    }
  },

  generic: {
    pageNotFound: {
      title: 'Página no encontrada',
      subtitle: 'La página que busca no existe.',
      backHome: 'Volver al inicio',
      heading: 'La página que intenta acceder no existe o no fue encontrada',
      hint: 'Verifique la dirección ingresada o intente de nuevo.',
      back: 'Volver'
    },
    fileView: {
      notFoundTitle: 'Documento no encontrado',
      notFoundHint: 'El archivo ya no está disponible. Actualice la página (F5) e intente de nuevo; si continúa, hable con soporte.'
    },
    pageNotPermission: {
      title: 'Sin permiso',
      subtitle: 'No tiene permiso para acceder a esta página.',
      backHome: 'Volver al inicio',
      heading: 'No tiene permiso para acceder a esta página',
      hint: 'Póngase en contacto con el administrador del sistema',
      back: 'Volver'
    }
  },

  home: {
    greeting: 'Hola, {name}',
    quotationTimer: 'Cotización se actualiza en {countdown}',
    errors: {
      loadQuotations: 'No fue posible obtener cotizaciones. Actualice la página (F5) e intente de nuevo.',
      loadCommercial: 'No fue posible cargar la cotización comercial. Actualice la página (F5) e intente de nuevo.',
      loadPtax: 'No fue posible cargar la cotización PTAX. Actualice la página (F5) e intente de nuevo.',
      loadCurrencies: 'No fue posible cargar la lista de monedas. Actualice la página (F5) e intente de nuevo.'
    }
  },

  comum: {
    moneyLoaderUi: {
      defaultMessage: 'Espere un momento...'
    },
    operationDocumentTypesUi: {
      didue: 'DUIMP/DU-E',
      swift: 'SWIFT',
      exchangeContract: 'Contrato de cambio',
      paymentReceipt: 'Comprobante de pago',
      others: 'Otros',
      bankSlip: 'Boleto bancario',
      deliveryAuthorization: 'Autorización de entrega',
      invoice: 'Factura comercial (invoice)',
      blAwb: 'BL / AWB',
      miscContracts: 'Contratos varios',
      hedgeContract: 'Contrato de cobertura (hedge)',
      operationProposal: 'Propuesta de operación'
    },
    timelineSteps: {
      preSaleCreated: 'Preventa generada',
      quoteLocked: 'Cotización fijada',
      pixCreated: 'PIX generado',
      pixPaymentConfirmed: 'Pago PIX confirmado',
      paymentNotReceived: 'Pago no recibido',
      stablecoinConversion: 'Conversión a stablecoin',
      stablecoinCredited: 'Crédito de USDC en la billetera',
      stablecoinDebited: 'Débito de USDC en la billetera',
      operationIdentified: 'Identificación de la operación',
      payoutOrderSent: 'Orden de pago enviada',
      payoutRetrying: 'Envío en verificación ({retryCount} intentos)',
      usdCreditConfirmed: 'Confirmación de crédito en USD',
      payoutNotCompleted: 'Envío al beneficiario no completado',
      exchangeContractSigned: 'Contrato de cambio formalizado',
      swiftReceiptAvailable: 'Comprobante SWIFT disponible',
      commissionGenerated: 'Generación de la comisión de cambio',
      operationFinished: 'Operación finalizada',
      statusUnderReview: 'En análisis',
      statusPending: 'Con pendientes',
      statusPendingReview: 'Análisis de pendientes',
      statusSettling: 'En liquidación',
      statusSettled: 'Liquidada',
      statusCancelled: 'Cancelada',
      statusUnresolved: 'Sin solución',
      statusReturned: 'Devuelta al cliente'
    },
    timelineNotes: {
      quoteLockedExchange: 'Nueva cotización establecida para la operación de cambio. {rate}',
      quoteLockedPurchase: 'Nueva cotización establecida para la operación de compra. {rate}',
      quoteSetOnOperation: 'Cotización definida directamente en la operación. {rate}',
      quoteSetByDesk: 'Operación creada sin preventa: cotización definida por la mesa.',
      registeredByDesk: 'Operación registrada directamente por la mesa, sin preventa.',
      preSaleCreated: 'Nueva preventa de compra por un valor de {amount}',
      qrIssued: 'Código QR emitido. Esperando el pago.',
      qrIssuedWithAmount: 'Código QR emitido por un valor de {amount}. Esperando el pago.',
      paymentDataIssuedWithAmount: 'Datos de pago emitidos por un valor de {amount}. Esperando el pago.',
      paymentReceived: 'Recibimos el valor de {amount} a través del banco asociado.',
      operationRegistered: 'Operación de cambio n.º {operationId} registrada.',
      stablecoinPurchased: 'Orden de compra de {amount} enviada y realizada con éxito.',
      stablecoinCredited: 'Saldo de {amount} disponible en la billetera del cliente.',
      stablecoinDebited: 'Débito de {amount} realizado para la liquidación internacional.',
      payoutRequested: 'Enviamos la solicitud al banco asociado para el crédito en cuenta.',
      usdCredited: 'USD disponible en la cuenta bancaria de destino del cliente.',
      exchangeContractIssued: 'Contrato de cambio emitido y vinculado a la operación.',
      swiftAttached: 'Documento SWIFT adjunto. Ya disponible para compartir.',
      settlementDone: 'Liquidación concluida tras confirmar el envío de USD.',
      statusUnderReview: 'Operación n.º {operationId} recibida y enviada para análisis de la mesa de cambio.',
      statusPending: 'Se identificaron pendientes de documentación. Esperando la regularización por parte del cliente.',
      statusPendingReview: 'Documentación reenviada por el cliente. Vuelve al análisis de la mesa de cambio.',
      statusSettling: 'Operación aprobada por la mesa de cambio. Esperando la liquidación financiera.',
      statusSettled: 'Operación de cambio liquidada con éxito. Valores transferidos al beneficiario.',
      statusCancelled: 'Operación cancelada. No se transfirió ningún valor.',
      statusUnresolved: 'Operación cerrada sin solución. Los pendientes no se resolvieron dentro del plazo.',
      statusReturned: 'Pago devuelto a la cuenta del cliente. No se realizó ningún envío al exterior.',
      failure: '{context}: {reason}',
      failureContexts: {
        payoutGeneration: 'Envío en verificación',
        payinReceipt: 'Pago en verificación',
        providerProcessing: 'Procesamiento en verificación'
      },
      failureReasons: {
        bankRejected: 'el banco rechazó la transferencia. Verifique los datos bancarios del beneficiario.',
        accountNotFound: 'no se encontró la cuenta del beneficiario. Verifique los datos bancarios.',
        limitExceeded: 'se superó el límite de transferencia. Nuestro equipo lo está verificando.',
        invalidBeneficiary: 'datos del beneficiario inválidos. Verifique el nombre y los datos bancarios.',
        complianceReview: 'transferencia en análisis de cumplimiento. Nuestro equipo lo está verificando.',
        pixExpired: 'el PIX venció. Genere un nuevo cobro.',
        amountMismatch: 'el valor del pago difiere del esperado.',
        paymentCancelled: 'el pago fue cancelado o reembolsado.',
        underReview: 'nuestro equipo lo está verificando'
      }
    },
    timelineTradStepsUi: {
      quotationLocked: 'Cotización fijada',
      preSaleCreated: 'Preventa generada',
      pixCreated: 'PIX generado',
      operationIdentified: 'Identificación de la operación',
      exchangeContractSigned: 'Contrato de cambio formalizado',
      swiftReceiptAvailable: 'Comprobante SWIFT disponible',
      operationFinished: 'Operación finalizada'
    },
    generalConstantsUi: {
      registerType: {
        exchange: 'Persona humana cambio turismo',
        basicRemittance: 'Persona humana básico',
        completeRemittance: 'Persona humana completo',
        legalPerson: 'Persona jurídica'
      },
      personType: {
        legalPerson: 'Persona jurídica',
        naturalPerson: 'Persona humana'
      },
      maritalStatus: {
        single: 'Soltero(a)',
        married: 'Casado(a)',
        divorced: 'Divorciado(a)',
        stableUnion: 'Unión convivencial',
        widowed: 'Viudo(a)'
      },
      marriageSystem: {
        partialCommunion: 'Comunidad parcial de bienes',
        universalCommunion: 'Comunidad universal de bienes',
        stableUnion: 'Unión convivencial',
        separation: 'Separación de bienes',
        separationFreedomOfChoice: 'Separación de bienes: libertad de elección',
        partialCommunionJusticeAndUnion: 'Comunidad parcial de bienes: justicia y unión'
      },
      identificationDocumentType: {
        rg: 'RG',
        cnh: 'CNH',
        functional: 'Credencial funcional',
        rneRnm: 'RNE/RNM',
        passport: 'Pasaporte',
        dniCedula: 'DNI o cédula extranjera'
      },
      operatingMode: {
        ownAccount: 'Por cuenta propia',
        onBehalfOfThirdParties: 'Por cuenta y orden de terceros. En este caso, informe el nombre y el CNPJ del principal prestador de servicios. Utilice el campo "información adicional"'
      },
      habilitationMode: {
        limited: 'Limitado (antes simplificado)',
        unlimited: 'Ilimitado (antes ordinario)',
        express: 'Expresa'
      },
      paymentMode: {
        advance: 'Anticipado/Al contado (sin DI)',
        ready: 'Inmediata (con DI)',
        both: 'Ambos'
      },
      businessPurposeType: {
        commercial: 'Cambio comercial (importación y exportación)',
        unilateralTransfersAndTourism: 'Cambio, transferencias unilaterales y turismo (disponibilidad, patrimonio, manut. res., etc.',
        financial: 'Cambio financiero (inversión, préstamos, intereses, servicios, etc.',
        nonResidentAccount: 'Cuenta corriente de no residente (TIR)',
        hedgeAndDerivatives: 'Cobertura (hedge) y derivados en el exterior',
        foreignCurrencyAccount: 'Cuenta corriente en moneda extranjera',
        otherProducts: 'Otros productos y servicios (informar)'
      },
      assets: {
        upTo100Thousand: 'Hasta R$ 100 mil reales',
        upTo300Thousand: 'Hasta R$ 300 mil reales',
        upTo500Thousand: 'Hasta R$ 500 mil reales',
        upTo1Million: 'Hasta R$ 1 millón de reales',
        over1Million: 'Más de R$ 1 millón de reales'
      },
      authorizationType: {
        perOperation: 'Por operación',
        sixMonths: 'Por 6 meses'
      },
      calculationType: {
        currencyAmount: 'Monto M.E.',
        brlAmount: 'Monto en reales'
      },
      customerExchangeBanksColumns: {
        createdAt: 'Creado el',
        updatedAt: 'Última modificación',
        name: 'Nombre / Razón social',
        registerProfile: 'Perfil del registro',
        corban: 'Corresponsal',
        email: 'Email',
        flow: 'Flujo',
        actions: 'Acciones'
      }
    },
    appFooterUi: {
      environmentHomologation: 'Homologación',
      environmentProduction: 'Producción',
      environmentDevelopment: 'Desarrollo'
    },
    supportWidgetSessionUi: {
      replyAlert: 'Soporte: {author} respondió. {preview}'
    },
    documentAnalysisUi: {
      high: 'Alta',
      medium: 'Media',
      low: 'Baja',
      mediumHint: 'El documento puede necesitar ajustes',
      lowHint: 'Le recomendamos cambiar este documento'
    },
    timelineModalUtilsUi: {
      payin: 'Pago (BRL)',
      payout: 'Envío (ME)',
      commission: 'Comisión'
    },
    avatarUploadUi: {
      previewAlt: 'Vista previa del avatar'
    },
    buttonUi: {
      processPayment: 'Procesar pago',
      processing: 'Procesando...',
      paid: '¡Pagado!'
    },
    cameraModalUi: {
      capturedPhotoAlt: 'Foto capturada'
    },
    cpfOrCnpjFieldUi: {
      cnpjAriaLabel: 'CNPJ (letras y números)'
    },
    editorUnlayerUi: {
      loadError: 'No fue posible cargar el editor. Verifique su conexión e intente de nuevo.',
      scriptLoadError: 'No fue posible cargar el script del editor. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
      loadTimeout: 'Tiempo de espera agotado al cargar el editor (15s).',
      sdkUnavailable: 'SDK de Unlayer no disponible después de la carga.',
      configUnavailable: 'Configuración de la aplicación no disponible.',
      imageUploadError: 'No fue posible subir la imagen. Verifique que el archivo sea JPG, PNG o PDF e intente de nuevo.',
      imageUploadConnectionError: 'No fue posible subir la imagen. Verifique su conexión.'
    },
    internationalPaymentMethodChipUi: {
      comingSoon: 'Próximamente'
    },
    timelineEventListUi: {
      empty: 'Ningún evento en esta fase',
      observationLabel: 'Obs.:'
    },
    timelinePhaseCardUi: {
      inProgress: 'En curso',
      completed: 'Completada'
    },
    required: '*Obligatorio',
    address: {
      internationalCep: 'Código postal internacional',
      zipCodeLabel: 'Código postal',
      streetLabel: 'Dirección',
      numberLabel: 'Número',
      countryLabel: 'País',
      complementLabel: 'Complemento',
      complementTooltip: 'CASA, GALPÓN, LOCAL, SALA, ETC.',
      neighborhoodLabel: 'Barrio',
      stateLabel: 'Estado',
      stateHint: 'Use la sigla del estado con 2 caracteres (ej: FL, CA, NY)',
      stateMaxChars: 'Máximo 2 caracteres',
      cityLabel: 'Ciudad',
      cityNoDataText: 'Seleccione un Estado para listar las ciudades',
      cityTypeHint: 'Lista de ciudades no disponible en este momento. Escriba el nombre de la ciudad',
      invalidZipCode: 'Código postal inválido'
    },
    bank: {
      bankLabel: 'Banco',
      agencyLabel: 'Agencia',
      accountLabel: 'Cuenta',
      digitLabel: 'Dígito',
      pixKeyLabel: 'Clave Pix'
    },
    internationalBank: {
      accountNameLabel: 'Apodo de la cuenta',
      accountNameTooltip: 'Ej: Cuenta del banco XYZ',
      bankLabel: 'Banco',
      swiftBicLabel: 'Código SWIFT o BIC',
      ibanLabel: 'Número de Cuenta o IBAN',
      ownerNameLabel: 'Nombre del titular',
      abaRoutingLabel: 'Número ABA/ROUTING',
      ffcLabel: 'FFC (For further credit)',
      addIntermediary: '¿Desea registrar un banco intermediario?',
      countryLabel: 'País',
      intermediaryBankNameLabel: 'Nombre del banco intermediario',
      intermediarySwiftAbaLabel: 'Código SWIFT o ABA banco intermediario'
    },
    cpfCnpjField: {
      duplicated: 'Ya existe un registro con este {document}',
      available: '{document} válido y disponible',
      invalid: '{document} inválido. Verifique el número ingresado',
      incomplete: '{document} incompleto'
    },
    phoneField: {
      noCountryFound: 'No se encontró ningún país',
      countryPlaceholder: 'Seleccione un país',
      searchPlaceholder: 'Buscar país...'
    },
    documentInput: {
      deleteTitle: '¿Eliminar adjunto?',
      descriptionLabel: 'Descripción',
      selectOrDragFile: 'Seleccione o arrastre el archivo',
      generateSelfieLink: 'Generar enlace para selfie',
      options: 'Opciones',
      download: 'Descargar',
      view: 'Ver',
      delete: 'Eliminar',
      add: 'Agregar',
      takePhoto: 'Tomar nueva foto',
      fileLabel: 'Archivo',
      sentAt: 'Enviado el {date}',
      defineCountry: 'Definir país',
      remove: 'Quitar',
      downloadingAttachment: 'Descargando adjunto',
      downloadError: 'No fue posible descargar el adjunto. Intente de nuevo; si persiste, contacte al soporte.',
      attachmentDeleted: '¡Adjunto eliminado con éxito!',
      deleteError: 'No fue posible eliminar el adjunto. Intente de nuevo en unos instantes; si persiste, contacte al soporte.',
      fileSizeError: '¡El archivo no puede superar los 10MB!',
      uploadError: 'El adjunto no fue agregado. Verifique que el archivo sea PDF, JPG o PNG e intente de nuevo.',
      descriptionError: 'No fue posible actualizar la descripción del documento. Verifique los datos e intente de nuevo; si persiste, contacte al soporte.',
      onlyOneFile: '¡Solo es posible agregar un adjunto a la vez!',
      onlyImages: '¡Solo se aceptan archivos de imagen!',
      noFileToView: 'No hay archivo para ver.',
      viewError: 'No fue posible abrir el archivo para ver. Intente descargar de nuevo; si persiste, contacte al soporte.',
      unsupportedFormat: 'Formato de archivo no compatible para ver.',
      allowPopups: 'Permita ventanas emergentes para ver el archivo o use Descargar.',
      deleteMessage: '¿Desea realmente eliminar este adjunto? ¡Esta acción no se puede deshacer!'
    },
    documentUploadArea: {
      documentTypeLabel: 'Tipo de documento*',
      documentAlreadyRegistered: 'Documento ya registrado',
      view: 'Ver',
      remove: 'Quitar',
      uploading: 'Enviando documento...',
      browseFile: 'Buscar archivo',
      fileSizeError: '¡El archivo no puede superar los {size}!',
      formatError: 'Formato de archivo no permitido. Use JPEG, PNG, PDF o MP4.',
      existingDocumentFallback: 'Documento adjunto'
    },
    documentUploadWizard: {
      title: 'Agregar documento',
      clickOrDrag: 'Haga clic o arrastre el archivo aquí',
      maxSize: 'Tamaño máximo: 10MB',
      countryLabel: 'País de emisión *',
      cancel: 'Cancelar',
      add: 'Agregar',
      countryRequired: 'Seleccione un país para agregar el documento.',
      onlyOneFile: '¡Solo es posible agregar un archivo a la vez!',
      fileTooLarge: '¡El archivo no puede superar los 10MB!',
      invalidFileType: '¡Tipo de archivo no permitido!',
      selectFileRequired: 'Seleccione un archivo para continuar.',
      descriptionCountryOnly: 'Seleccione el país de emisión del documento.',
      descriptionFileOnly: 'Seleccione el archivo del documento.',
      descriptionBoth: 'Seleccione el archivo y el país de emisión del documento.'
    },
    documentUploadZone: {
      documentNamePlaceholder: 'Ingrese el nombre del documento',
      instructionText: 'Elija un archivo o arrastre y suelte aquí'
    },
    documentCountryModal: {
      title: 'País del documento',
      countryLabel: 'País',
      confirmButton: 'Confirmar',
      cancelButton: 'Cancelar',
      countryRequired: 'Seleccione un país antes de confirmar.',
      updateError: 'No fue posible actualizar el país del documento. Verifique los datos e intente de nuevo; si persiste, contacte al soporte.'
    },
    pendencyModal: {
      title: 'Registrar pendencia',
      alertText: 'Esta información será enviada al cliente en el cuerpo del correo de pendencia de registro.',
      additionalInfo: 'Información complementaria',
      sendEmailLabel: 'Enviar correo de pendencia al cliente'
    },
    observationModal: {
      defaultTitle: 'Observación',
      additionalInfo: 'Información complementaria'
    },
    emptyTable: {
      defaultTitle: 'No hay registros emitidos'
    },
    selectCard: {
      chart: 'Gráfico',
      card: 'Tarjeta'
    },
    quotationCardGroup: {
      exchangeTourism: 'Cambio turismo',
      commercialExchange: 'Cambio comercial (Spot)',
      loading: 'Cargando cotizaciones...'
    },
    activeStatus: {
      active: 'Activo',
      inactive: 'Inactivo'
    },
    releases: {
      title: 'Novedades de Tech Câmbio',
      subtitle: 'Sigue las últimas actualizaciones y mejoras',
      introTitle: 'Mantente al tanto de las novedades',
      introText: 'Descubre las nuevas funcionalidades, correcciones y mejoras que estamos entregando para hacer tu experiencia aún mejor.',
      noUpdates: 'No hay actualizaciones disponibles en este momento.',
      newVersion: '¡Nueva versión!',
      close: 'Cerrar',
      loadError: 'No fue posible cargar las actualizaciones. Por favor, inténtalo de nuevo más tarde.'
    },
    customerSearch: {
      defaultLabel: 'Cliente / CPF / CNPJ',
      loadError: 'No fue posible buscar clientes. Revise el texto de búsqueda e inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    operationSimulator: {
      moveRight: 'Mover simulador a la derecha',
      moveLeft: 'Mover simulador a la izquierda',
      sellExit: 'Venta/Salida',
      buyEntry: 'Compra/Entrada',
      copyMessage: 'Copiar mensaje del cliente',
      clear: 'Limpiar',
      close: 'Cerrar',
      validate: 'Validar',
      validateNewTab: 'Validar en nueva pestaña',
      titleDefault: 'Simulador de Operación',
      titleWithCustomer: 'Simulando Operación | {type} - {name}',
      exchange: 'Cambio',
      remittance: 'Remesa',
      messageSent: 'Mensaje enviado al cliente por WhatsApp.',
      messageSentFallback: 'No fue posible enviar por WhatsApp; mensaje copiado al portapapeles.',
      messageCopied: 'Mensaje copiado al portapapeles',
      messageCopyError: 'No fue posible copiar o enviar el mensaje. Selecciona el texto y cópialo manualmente (Ctrl+C).',
      loadExchangeTypesError: 'No fue posible cargar los tipos de cambio. Actualiza la página (F5) e inténtalo de nuevo; si continúa, contacta al soporte.',
      loadRateError: 'No fue posible cargar la cotización de la moneda. Actualiza la página (F5) e inténtalo de nuevo; si continúa, contacta al soporte.',
      loadDollarError: 'No fue posible cargar la cotización del dólar. Actualiza la página (F5) e inténtalo de nuevo; si continúa, contacta al soporte.'
    },
    avatarUpload: {
      changePhoto: 'Cambiar foto',
      selectPhoto: 'Seleccionar foto',
      formatError: 'Formato de archivo no permitido. Use JPEG o PNG.',
      sizeError: 'El archivo no puede tener más de 5MB.'
    },
    baseModal: {
      save: 'Guardar',
      cancel: 'Cancelar'
    },
    cameraModal: {
      title: 'Capturar Foto',
      positionFace: 'Ubique su rostro aquí',
      loadingCamera: 'Cargando cámara...',
      cameraRequired: 'Acceso a la cámara necesario',
      retry: 'Intentar de nuevo',
      faceDetectedMsg: '¡Rostro detectado! Ahora puede capturar la foto',
      positionFaceMsg: 'Ubique su rostro en el área de la cámara',
      capturedPreview: 'Vista previa de la foto capturada:',
      cancel: 'Cancelar',
      retake: 'Tomar de nuevo',
      capture: 'Capturar',
      confirm: 'Confirmar',
      errors: {
        notAllowed: 'El permiso para acceder a la cámara fue denegado. Haga clic en "Intentar de nuevo" y permita el acceso.',
        notFound: 'No se encontró ninguna cámara en su dispositivo.',
        notReadable: 'La cámara está siendo usada por otra aplicación.',
        default: 'No fue posible acceder a la cámara. Verifique que su navegador permita el acceso.'
      }
    },
    dataTableDocument: {
      addTooltip: 'Agregar {name}',
      downloadTooltip: 'Descargar {name}',
      downloading: 'Descargando {name}',
      downloadError: 'No fue posible descargar el adjunto. Intenta descargarlo de nuevo; si continúa, contacta al soporte.',
      onlyOneFile: '¡Solo es posible agregar un adjunto a la vez!',
      fileSizeError: '¡El archivo no puede tener más de 10MB!',
      uploadSuccess: '¡Documento agregado con éxito!',
      uploadError: 'El adjunto no fue agregado. Verifica que el archivo sea PDF, JPG o PNG e inténtalo de nuevo.'
    },
    federalRevenue: {
      importTooltip: 'Importar datos de la Receita Federal',
      invalidCnpjWarning: 'Por favor, ingresa un CNPJ válido antes de importar los datos.',
      importedSuccess: 'Datos importados con éxito',
      importError: 'No fue posible importar los datos del CNPJ. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.'
    },
    operationContextMenu: {
      viewOperation: 'Ver operación',
      cancelOperation: 'Cancelar Operación',
      relaunchOperation: 'Relanzar operación',
      documents: 'Documentos'
    },
    documentInformedCard: {
      defaultFileName: 'Documento adjunto',
      sentAt: 'Enviado el {date}'
    },
    tableCustomerCell: {
      externalIdTooltip: 'Cliente importado con ID externo {id}',
      viewCustomerTooltip: 'Ver cliente',
      fantasyName: 'Nombre fantasia: {name}'
    },
    rssNews: {
      title: 'Noticias de cambio',
      source: 'Fuente: Investing.com',
      updatedAt: 'Actualizado el {date}',
      loading: 'Cargando noticias...',
      empty: 'No hay noticias disponibles en este momento',
      refreshTooltip: 'Actualizar noticias',
      publishedBy: 'Publicado por {author}',
      loadError: 'No fue posible cargar las noticias. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    copyMessageButton: {
      defaultLabel: 'Copiar mensaje',
      notConfiguredError: 'Plantilla no configurada. Ve a Configuraciones > Mensaje de Operación.',
      copyError: 'No fue posible copiar el mensaje. Selecciona el texto y cópialo manualmente (Ctrl+C).'
    },
    infoPopover: {
      title: 'Descripción de la naturaleza'
    },
    actionsMenu: {
      ariaLabel: 'Opciones'
    }
  },

  operationFilter: {
    title: 'Filtro',
    inactive: '(inactivo)',
    duimpStatus: 'Estado DUIMP',
    buy: 'Compra',
    sell: 'Venta',
    loadAgentsError: 'No fue posible cargar la lista de corresponsales del filtro. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.'
  },

  confirmationWindow: {
    irreversibleDefault: 'Esta acción no se podrá deshacer.',
    defaultMessage: '¿Confirma el cambio?',
    defaultTitle: 'Confirmación',
    confirmPlaceholder: 'Escriba "{word}" para continuar'
  },

  moneyField: {
    minError: 'El valor mínimo permitido es {value}',
    maxError: 'El valor máximo permitido es {value}',
    loadCurrenciesError: 'No fue posible cargar la lista de monedas. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.'
  },

  formCustomer: {
    sectionGuide: {
      ariaLabel: 'Partes del registro',
      personal: 'Sus datos',
      bank: 'Cuentas',
      declarations: 'Declaraciones',
      documents: 'Documentos',
      terms: 'Términos',
      position: '{current} de {total}'
    },
    customerDocumentDuplicateModalUi: {
      title: '{label} ya registrado',
      fixButton: 'Corregir {label}',
      openExistingMessage: 'Este {label} ya pertenece a un registro:',
      openExistingHint: 'Abra el registro existente para actualizar los datos, en lugar de crear otro.',
      openExistingButton: 'Abrir registro existente',
      otherPartnerMessage: 'Este {label} ya está registrado en la plataforma, vinculado a otro socio comercial.',
      otherPartnerHint: 'Para continuar con este cliente, comuníquese con atención al cliente.',
      contactSupportMessage: 'Ya existe un registro con este {label}.',
      contactSupportHint: 'Para continuar, comuníquese con la atención de quien le envió este enlace de registro.',
      understood: 'Entendido'
    },
    accountIntegrationStatusUi: {
      inAnalysis: 'En análisis',
      approved: 'Aprobado',
      rejected: 'Rechazado'
    },
    externalAccessUi: {
      sessionExpired: 'Su sesión expiró. Para continuar con el registro, abra nuevamente el enlace enviado a su correo. (Ref.: HTTP-401)',
      existingPartnerLinked: 'Este socio ya tiene registro en el sistema y será vinculado. Sus datos no se muestran aquí por seguridad.'
    },
    taxDomicileConstantsUi: {
      identificationDocument: 'Doc. de identidad',
      driverLicense: 'Licencia de conducir',
      taxDocument: 'Doc. fiscal',
      identificationDocumentNumber: 'N.º del documento de identidad',
      driverLicenseNumber: 'N.º de la licencia de conducir',
      defaultTaxIdLabel: 'Número de identificación fiscal (TIN)'
    },
    partnerLinkingUi: {
      confirmationTitle: 'Confirmación',
      linkPartnerTitle: '¿Vincular socio?',
      link: 'Vincular',
      divergentDateTitle: 'Fecha divergente',
      understood: 'Entendido',
      loadExistingCustomerError: 'No fue posible cargar los datos del cliente existente. Actualice la página (F5) e intente nuevamente; si continúa, comuníquese con soporte.',
      checkDocumentDateError: 'No fue posible verificar si el documento y la fecha informados ya están registrados. Intente nuevamente en unos instantes; si continúa, comuníquese con soporte.'
    },
    accountRefusalAlertUi: {
      title: 'Una cuenta bancaria fue rechazada por el proveedor | {count} cuentas bancarias fueron rechazadas por el proveedor',
      text: 'Todavía no sirven para operar. Vea el motivo en cada cuenta, corríjalo y envíela de nuevo.',
      action: 'Ver cuentas'
    },
    bankAccountProvidersUi: {
      syncedIn: 'Cuenta sincronizada en {provider}.',
      notSyncedIn: 'La cuenta no se sincronizó en {provider}. Revise los datos de la cuenta y haga clic en Sincronizar nuevamente.',
      linkReactivatedIn: 'Vínculo reactivado en {provider}.',
      accountRecreatedIn: 'Cuenta recreada y vinculada en {provider}.',
      notCheckedIn: 'La cuenta no se verificó en {provider}. Haga clic en Sincronizar nuevamente; si continúa, comuníquese con soporte.',
      noPendingProvider: 'Ningún proveedor pendiente para esta cuenta.',
      syncNotCompleted: 'sincronización no completada',
      partiallySynced: 'Sincronizada en {synced} proveedor(es). No completada en — {failures}',
      syncFailed: 'No fue posible sincronizar. {failures}',
      syncedInCount: 'Cuenta sincronizada en {synced} proveedor(es).',
      notSyncedWithProviders: 'La cuenta no se sincronizó con los proveedores. Revise los datos de la cuenta y haga clic en Sincronizar nuevamente.'
    },
    bankLookupUi: {
      routingWithoutWire: 'Este routing number es solo para ACH y no recibe Wire. Confirme con el banco el routing de Wire (suele ser diferente).',
      routingWithoutAch: 'Este routing number no recibe ACH. Confirme con el banco el routing para ACH.',
      routingNotFound: 'No encontramos este routing number. Revise los 9 dígitos.',
      swiftNotFound: 'No encontramos este código SWIFT. Verifique el código con el banco.',
      ibanNotFound: 'No encontramos este IBAN. Revise el número.'
    },
    walletEmailLockUi: {
      emailLockedHint: 'Correo vinculado a la billetera digital del cliente. Para cambiarlo, comuníquese con soporte.'
    },
    bankAccountProviderConstantsUi: {
      syncedDescription: 'Sincronizado',
      syncedHint: 'Cuenta registrada en este proveedor y disponible para operar',
      notSyncedDescription: 'No sincronizado',
      pendingHint: 'La cuenta todavía no fue enviada a este proveedor. Use el botón de al lado para enviarla.',
      unsupportedDescription: 'No disponible',
      unsupportedHint: 'Este proveedor no opera este tipo de cuenta.',
      notEnabledDescription: 'No habilitado',
      notEnabledHint: 'El cliente todavía no tiene el registro aprobado en este proveedor. La cuenta puede enviarse después de la aprobación.',
      unavailableDescription: 'No disponible',
      unavailableHint: 'Este proveedor todavía no recibe cuentas bancarias a través del sistema.',
      inconsistentDescription: 'Vínculo desactivado',
      inconsistentHint: 'La cuenta ya fue enviada a este proveedor, pero el vínculo local fue desactivado y no puede operar. Use el botón de al lado para conciliar: consulta la cuenta en el proveedor y reactiva el vínculo.',
      pendingFixDescription: 'Corregir registro',
      pendingFixHint: 'El registro de esta cuenta necesita un ajuste antes del envío a este proveedor.',
      refusedDescription: 'Rechazada',
      refusedHint: 'El proveedor rechazó esta cuenta en el último intento. Corrija lo indicado y envíela de nuevo.',
      fallbackHint: 'Situación no informada por el proveedor',
      loadingDescription: 'Consultando',
      loadingHint: 'Buscando la situación en los proveedores',
      payoutBeta: 'Pagos en fase de prueba en este proveedor',
      payoutDisabled: 'Sin pagos por este proveedor en este tipo de cuenta, por el momento'
    },
    stablecoinProviderConstantsUi: {
      approvedDescription: 'Aprobado',
      approvedHint: 'Operaciones habilitadas',
      viewLimitsTooltip: 'Ver límites del cliente',
      verifyingDescription: 'En verificación',
      verifyingHint: 'Registro en análisis en la institución',
      viewVerificationTooltip: 'Ver enlace de verificación',
      complianceRequestDescription: 'Pendiente de compliance',
      complianceRequestHint: 'Documentos adicionales solicitados',
      partiallyRejectedDescription: 'Corrección solicitada',
      partiallyRejectedHint: 'El cliente necesita reenviar documentos por el enlace',
      viewCorrectionTooltip: 'Ver el motivo y el enlace de corrección',
      rejectedDescription: 'Registro rechazado',
      rejectedHint: 'Registro no aprobado por el proveedor',
      deprecatedDescription: 'Cerrado',
      deprecatedHint: 'Registro reemplazado',
      loadingDescription: 'Consultando',
      loadingHint: 'Buscando la situación en el proveedor',
      unlinkedDescription: 'No vinculado',
      unlinkedHint: 'Cliente todavía no enviado al proveedor',
      linkProviderTooltip: 'Vincular proveedor',
      notChosenDescription: 'No elegido',
      notChosenHint: 'Quedó fuera de la elección al agregar el banco',
      sendRegistrationTooltip: 'Enviar el registro a este proveedor',
      notChosenPausedHint: 'No está aceptando clientes nuevos por el momento',
      rejectedReonboardHint: 'Rechazado definitivamente — corrija la ficha y vuelva a registrarlo',
      reonboardTooltip: 'Ver el motivo y volver a registrar',
      viewPendingTooltip: 'Ver pendientes',
      onboardingTooltip: 'Seguir el envío del registro',
      sendingDescription: 'Enviando',
      sendingHint: 'El sistema está enviando los documentos',
      apiVerifyingHint: 'Documentos enviados por el sistema',
      awaitingCustomerDescription: 'Esperando al cliente',
      awaitingCustomerHint: 'El cliente completa el registro por el enlace',
      apiCorrectionHint: 'Cambie los documentos en la ficha y reenvíe',
      apiCorrectionTooltip: 'Ver el motivo y reenviar',
      documentsProgressHint: '{sent} de {total} documentos enviados',
      railsApprovedPendingHint: '{approved} habilitado · {pending} en análisis',
      railsPendingHint: '{pending} en análisis'
    },
    unblockOnboardingUi: {
      title: 'Registro en {name}',
      defaultInstitution: 'la institución',
      close: 'Cerrar',
      rejectionsTitle: 'Lo que la institución pidió corregir',
      fallbackTitle: 'Por qué el cliente debe completar por el enlace',
      checklistEmpty: 'La institución aún no informó qué documentos necesita.',
      documentFallback: 'Documento',
      beneficiaryDocument: 'Socio · {name}',
      summary: {
        approved: 'Registro aprobado. Las operaciones están habilitadas.',
        correction: 'La institución pidió una corrección. Cambie los documentos en la ficha del cliente y reenvíe; no hace falta el enlace.',
        rejected: 'Registro rechazado por la institución.',
        fallback: 'El sistema no pudo enviar todo. Envíe el enlace al cliente para que complete lo que faltó.',
        checkRequested: 'Documentos enviados por el sistema. La institución está analizando el registro.',
        sending: 'El sistema está enviando los documentos del cliente. Esta pantalla se actualiza sola.'
      },
      messages: {
        statusError: 'No fue posible consultar el envío ahora. Intente de nuevo en unos instantes.',
        linkCopied: 'Enlace copiado',
        linkCopyError: 'No fue posible copiar el enlace. Selecciónelo y cópielo manualmente.',
        resubmitSuccess: 'Documentos corregidos reenviados',
        resubmitError: 'Los documentos no fueron reenviados. Verifique si fueron cambiados en la ficha e intente de nuevo.',
        advanceSuccess: 'Envío reanudado',
        advanceError: 'El envío no fue reanudado ahora. Intente de nuevo en unos instantes.'
      },
      documents: {
        NATIONAL_ID: 'Documento de identidad',
        DRIVER_LICENSE: 'Licencia de conducir',
        PASSPORT: 'Pasaporte',
        PROOF_OF_ADDRESS: 'Comprobante de domicilio',
        SELFIE: 'Selfie',
        INCORPORATION_ARTICLES: 'Contrato social',
        INCORPORATION_CERTIFICATE: 'Certificado de la empresa',
        INCUMBENCY_CERTIFICATE: 'Certificado de administradores',
        SHAREHOLDER_REGISTRY: 'Registro de socios',
        STATE_COMPANY_REGISTRY: 'Registro de la empresa'
      },
      sides: {
        FRONT: 'frente',
        BACK: 'dorso'
      },
      uploadStatus: {
        pending: 'esperando envío',
        uploaded: 'enviado',
        failed: 'falló el envío'
      },
      fallbackReasons: {
        missing_document: 'no está en el registro',
        upload_failed: 'no fue aceptado por el envío del sistema',
        missing_beneficiary: 'socio aún sin identificación en la institución',
        check_refused: 'la institución no aceptó pedir el análisis',
        link_only_step: 'solo el cliente puede responderlo por el enlace',
        missing_answers: 'falta una respuesta en el perfil de las operaciones del registro',
        questionnaire_refused: 'el proveedor no aceptó las respuestas del perfil de las operaciones'
      },
      subjects: {
        check: 'Pedido de análisis',
        step: 'Etapa de la institución',
        beneficiary: 'Socio'
      },
      steps: {
        QUESTIONNAIRE: 'Cuestionario',
        SOURCE_OF_FUNDS: 'Comprobante del origen de los fondos',
        DIAGRAM_FLOW: 'Diagrama de las operaciones'
      },
      progress: {
        created: 'Registro creado',
        documents: 'Documentos enviados',
        count: '{sent} de {total}',
        review: 'En análisis',
        afterCustomer: 'después de que el cliente concluya',
        result: 'Resultado'
      },
      actions: {
        resubmit: 'Reenviar documentos corregidos',
        copyLink: 'Copiar enlace para el cliente',
        advance: 'Intentar de nuevo ahora'
      }
    },
    internationalBankConstantsUi: {
      accountTypes: {
        checking: 'Cuenta corriente',
        savings: 'Caja de ahorro'
      },
      accountClasses: {
        individual: 'Individual',
        business: 'Empresarial'
      },
      recipientRelationships: {
        firstParty: 'Parte relacionada',
        employee: 'Empleado',
        independentContractor: 'Prestador de servicios',
        vendorOrSupplier: 'Proveedor',
        subsidiaryOrAffiliate: 'Subsidiaria o afiliada',
        merchantOrPartner: 'Socio comercial',
        customer: 'Cliente',
        landlord: 'Locador',
        family: 'Familiar',
        other: 'Otros'
      },
      speiProtocols: {
        debitCard: 'Tarjeta de débito',
        phoneNumber: 'Número de teléfono'
      },
      usPostalCodeExample: '10115 o 10115-1234'
    },
    swiftPaymentCodesUi: {
      ae_swift_str: 'Turismo y viajes',
      ae_swift_tcs: 'Servicios de telecomunicaciones',
      ae_swift_ipc: 'Regalías / Propiedad intelectual',
      ae_swift_ifs: 'Servicios de información',
      ae_swift_sts: 'Transporte marítimo',
      ae_swift_pms: 'Consultoría profesional y de gestión',
      ae_swift_its: 'Servicios de tecnología de la información',
      ae_swift_gde: 'Exportación de mercaderías (FOB)',
      ae_swift_ots: 'Otros medios de transporte',
      ae_swift_tts: 'Servicios técnicos, comerciales y otros',
      bh_swift_afa: 'Depósito / Cuenta bancaria en el exterior (residentes)',
      bh_swift_afl: 'Depósito / Cuenta bancaria en Baréin (no residentes)',
      bh_swift_ats: 'Transporte aéreo',
      bh_swift_cea: 'Inversión directa en el exterior (participación accionaria)',
      bh_swift_cel: 'Inversión directa en Baréin (participación accionaria)',
      bh_swift_chc: 'Donaciones y contribuciones filantrópicas',
      bh_swift_dla: 'Títulos de deuda en el exterior (largo plazo)',
      bh_swift_dlf: 'Préstamos intragrupo — Exterior',
      bh_swift_dll: 'Títulos de residentes en no relacionadas (largo plazo)',
      bh_swift_doe: 'Dividendos no intragrupo',
      bh_swift_dsa: 'Títulos de deuda en el exterior (corto plazo)',
      bh_swift_dsf: 'Títulos de deuda intragrupo en el exterior',
      bh_swift_dsl: 'Títulos de residentes en no relacionadas (corto plazo)',
      bh_swift_fam: 'Remesa familiar / Remesas de trabajadores',
      bh_swift_fda: 'Derivados financieros — Exterior',
      bh_swift_fdl: 'Derivados financieros — Baréin',
      bh_swift_fia: 'Cuotapartes de fondos de inversión — Exterior',
      bh_swift_fil: 'Cuotapartes de fondos de inversión — Baréin',
      bh_swift_fis: 'Servicios financieros',
      bh_swift_fsa: 'Participaciones accionarias en el exterior (no relacionadas)',
      bh_swift_fsl: 'Participaciones accionarias en Baréin (no relacionadas)',
      bh_swift_gde: 'Exportación de mercaderías (FOB)',
      bh_swift_gdi: 'Importación de mercaderías (CIF)',
      bh_swift_gms: 'Procesamiento, reparación y mantenimiento de mercaderías',
      bh_swift_gos: 'Bienes y servicios gubernamentales',
      bh_swift_gri: 'Ingresos gubernamentales (impuestos, tasas, transferencias)',
      bh_swift_ifs: 'Servicios de información',
      bh_swift_igd: 'Dividendos intragrupo',
      bh_swift_iid: 'Intereses sobre deuda intragrupo',
      bh_swift_ins: 'Servicios de seguros',
      bh_swift_iod: 'Rendimientos de depósitos',
      bh_swift_iol: 'Rendimientos de préstamos',
      bh_swift_ipc: 'Regalías / Propiedad intelectual',
      bh_swift_ish: 'Rendimientos de cuotapartes de fondos',
      bh_swift_isl: 'Intereses sobre títulos (largo plazo)',
      bh_swift_iss: 'Intereses sobre títulos (corto plazo)',
      bh_swift_its: 'Servicios de tecnología de la información',
      bh_swift_ldl: 'Préstamos intragrupo en Baréin (largo plazo)',
      bh_swift_lds: 'Títulos de deuda intragrupo en Baréin',
      bh_swift_lea: 'Arrendamiento en el exterior',
      bh_swift_lel: 'Arrendamiento en Baréin',
      bh_swift_lla: 'Préstamos a no residentes (largo plazo)',
      bh_swift_lll: 'Préstamos de no residentes a residentes (largo plazo)',
      bh_swift_ots: 'Otros medios de transporte',
      bh_swift_pip: 'Ganancias sobre productos islámicos',
      bh_swift_pms: 'Consultoría profesional y de gestión',
      bh_swift_ppa: 'Compra de inmueble en el exterior',
      bh_swift_ppl: 'Compra de inmueble en Baréin',
      bh_swift_prr: 'Ganancias o alquileres de inmuebles',
      bh_swift_prs: 'Servicios personales, culturales, audiovisuales y recreativos',
      bh_swift_rda: 'Títulos de deuda inversa en el exterior',
      bh_swift_rdl: 'Títulos de deuda inversa en Baréin',
      bh_swift_rds: 'Investigación y desarrollo',
      bh_swift_rea: 'Participaciones accionarias inversas en el exterior',
      bh_swift_rel: 'Participaciones accionarias inversas en Baréin',
      bh_swift_rfs: 'Repos sobre títulos extranjeros',
      bh_swift_rls: 'Repos sobre títulos de residentes',
      bh_swift_sal: 'Salario / Remuneración de empleados',
      bh_swift_sco: 'Construcción civil',
      bh_swift_sla: 'Préstamos a no residentes (corto plazo)',
      bh_swift_sll: 'Préstamos de no residentes a residentes (corto plazo)',
      bh_swift_str: 'Turismo y viajes',
      bh_swift_sts: 'Transporte marítimo',
      bh_swift_tcp: 'Créditos comerciales a pagar',
      bh_swift_tcr: 'Créditos comerciales a cobrar',
      bh_swift_tcs: 'Servicios de telecomunicaciones',
      bh_swift_tts: 'Servicios técnicos, comerciales y otros',
      ch_swift_ccdndr: 'Donación filantrópica',
      ch_swift_cctfdr: 'Transferencia de capital transfronteriza',
      ch_swift_cgoddr: 'Comercio de mercaderías transfronterizo',
      ch_swift_cocadr: 'Otras transacciones de cuenta corriente',
      ch_swift_cstrdr: 'Comercio de servicios transfronterizo',
      ch_swift_remtdr: 'Pago transfronterizo (individual)',
      cn_swift_ccdndr: 'Cuenta de capital — Pago/Deuda/Préstamo',
      cn_swift_cctfdr: 'Transferencia de capital transfronteriza',
      cn_swift_cgoddr: 'Comercio de mercaderías transfronterizo',
      cn_swift_cocadr: 'Otras transacciones de cuenta corriente',
      cn_swift_cstrdr: 'Comercio de servicios transfronterizo',
      cn_swift_remtdr: 'Remesa — Pago personal no comercial',
      hk_swift_charitabledonation: 'Donación filantrópica',
      hk_swift_goods: 'Mercaderías',
      hk_swift_personal: 'Uso personal',
      hk_swift_services: 'Servicios',
      jp_swift_101: 'Pago de factura / Compra',
      jp_swift_102: 'Pago de servicios públicos',
      jp_swift_103: 'Recarga de tarjeta prepaga',
      jp_swift_104: 'Órdenes permanentes',
      jp_swift_105: 'Donaciones personales',
      jp_swift_106: 'Asistencia y gastos familiares',
      jp_swift_107: 'Contribución a la seguridad social (individual)',
      jp_swift_108: 'Cuotas de asociaciones',
      jp_swift_109: 'Cuenta de ahorro y financiamiento',
      jp_swift_110: 'Herencia',
      jp_swift_111: 'Indemnización por despido',
      jp_swift_1111: 'Tarjeta de crédito — Pago',
      jp_swift_1112: 'Préstamo personal — Pago',
      jp_swift_201: 'Salarios — Sector público',
      jp_swift_202: 'Salarios — Trabajadores',
      jp_swift_203: 'Salarios — Sector privado',
      jp_swift_301: 'Ingresos por inversiones',
      jp_swift_302: 'Corretaje de inversiones',
      jp_swift_303: 'Seguros',
      jp_swift_305: 'Inversión local',
      jp_swift_306: 'Inversión externa',
      jp_swift_401: 'Flete aéreo',
      jp_swift_402: 'Flete terrestre',
      jp_swift_403: 'Flete marítimo',
      jp_swift_404: 'Turismo y viajes',
      jp_swift_601: 'Exportación — Sector público',
      jp_swift_602: 'Exportación — Sector privado',
      jp_swift_603: 'Importación — Sector público',
      jp_swift_604: 'Importación — Sector privado',
      jp_swift_801: 'Servicios de telecomunicaciones',
      jp_swift_802: 'Servicios financieros',
      jp_swift_803: 'Servicios de tecnología de la información',
      jp_swift_804: 'Consultoría',
      jp_swift_805: 'Construcción civil',
      jp_swift_806: 'Mantenimiento y montaje',
      jp_swift_807: 'Marketing y medios',
      jp_swift_809: 'Servicios médicos y de salud',
      jp_swift_810: 'Servicios culturales, educativos y de entretenimiento',
      jp_swift_811: 'Alquiler',
      jp_swift_812: 'Inmuebles',
      jp_swift_813: 'Impuestos y tasas',
      jp_swift_815: 'Comisiones',
      jp_swift_902: 'Fondos gubernamentales',
      jp_swift_903: 'Fondos del sector privado',
      jp_swift_904: 'Fondos recibidos del exterior',
      jp_swift_1001: 'Remesas de comunidades internacionales y embajadas',
      jp_swift_1002: 'Misiones diplomáticas permanentes',
      jp_swift_1003: 'Misiones diplomáticas temporales',
      jp_swift_1004: 'Ingresos de embajadas jordanas',
      jp_swift_1101: 'Cuotas de préstamos de largo plazo — Sector público',
      jp_swift_1102: 'Intereses de préstamos de largo plazo — Sector público',
      jp_swift_1103: 'Cuotas de préstamos de corto plazo — Sector público',
      jp_swift_1104: 'Intereses de préstamos de corto plazo — Sector público',
      jp_swift_1105: 'Cuotas de préstamos de largo plazo — Sector privado',
      jp_swift_1106: 'Intereses de préstamos de largo plazo — Sector público (privado)',
      jp_swift_1107: 'Cuotas de préstamos de corto plazo — Sector privado',
      jp_swift_1108: 'Intereses de préstamos de corto plazo — Sector privado',
      jp_swift_1109: 'Cuotas de préstamos con garantía gubernamental',
      jp_swift_1110: 'Intereses de préstamos con garantía gubernamental',
      jp_swift_1201: 'Reencaminamiento / Rerouting',
      jp_swift_1202: 'Apoyo a la investigación científica',
      jp_swift_204: 'Salarios del cuerpo diplomático jordano',
      jp_swift_205: 'Salarios del cuerpo diplomático extranjero',
      jp_swift_206: 'Salarios recibidos del exterior',
      jp_swift_207: 'Jubilación civil / militar',
      jp_swift_208: 'Jubilación de la seguridad social',
      jp_swift_209: 'Contribución previsional de empresa',
      jp_swift_304: 'Suscripciones a organizaciones internacionales no monetarias',
      jp_swift_307: 'Garantía de participación en licitación (Tender Bond)',
      jp_swift_501: 'Transferencias de delegaciones gubernamentales',
      jp_swift_502: 'Transferencias de delegaciones del sector privado',
      jp_swift_503: 'Educación gubernamental',
      jp_swift_504: 'Educación — Sector privado',
      jp_swift_701: 'Ayuda a comunidades religiosas',
      jp_swift_702: 'Ayuda a comunidades internacionales',
      jp_swift_703: 'Ayuda a comunidades árabes',
      jp_swift_704: 'Ayuda de la ONU',
      jp_swift_705: 'Ayuda de comunidades benéficas',
      jp_swift_808: 'Servicios de minería',
      jp_swift_814: 'Tasas y tarifas',
      jp_swift_816: 'Tasas de franquicia y licencia',
      jp_swift_817: 'Cobro de cheques',
      jp_swift_818: 'Cuotas de asociación / Anualidad',
      jp_swift_901: 'Fondos municipales',
      ke_swift_airb: 'Transporte aéreo',
      ke_swift_chc: 'Contribuciones filantrópicas / Caridad',
      ke_swift_comu: 'Desarrollo comunitario',
      ke_swift_cons: 'Construcción civil',
      ke_swift_cort: 'Liquidación de operación comercial',
      ke_swift_divd: 'Pago de dividendos',
      ke_swift_educ: 'Gastos de educación',
      ke_swift_foex: 'Cambio / Moneda extranjera',
      ke_swift_govt: 'Pagos gubernamentales',
      ke_swift_hlfd: 'Alimentos y bienes de consumo',
      ke_swift_hlti: 'Plan de salud',
      ke_swift_loan: 'Préstamo',
      ke_swift_mdcs: 'Servicios médicos',
      ke_swift_merc: 'Mercaderías y productos manufacturados',
      ke_swift_paye: 'Pago de salario (PAYE)',
      ke_swift_psco: 'Servicio profesional / Comisión',
      ke_swift_refu: 'Reembolso',
      ke_swift_rent: 'Alquiler de inmueble',
      ke_swift_sala: 'Pago de salario',
      ke_swift_savg: 'Ahorro',
      ke_swift_scho: 'Cuota escolar',
      ke_swift_ship: 'Flete marítimo',
      ke_swift_taxs: 'Pago de impuesto',
      ke_swift_ubil: 'Factura de servicios públicos',
      ke_swift_vatx: 'Pago de IVA',
      ke_swift_whld: 'Retención en la fuente',
      ke_swift_1001: 'Derecho de importación — Petróleo',
      ke_swift_1002: 'Derecho de importación',
      ke_swift_1101: 'Impuesto al consumo — Petróleo',
      ke_swift_1102: 'Impuesto al consumo (Excise Duty)',
      ke_swift_1201: 'IVA — Petróleo',
      ke_swift_1202: 'IVA — Importaciones',
      ke_swift_1206: 'IVA — Petróleo (8%)',
      ke_swift_1501: 'Tasa de modificación',
      ke_swift_1518: 'Tasa de concesión',
      ke_swift_1519: 'Tasas de registro',
      ke_swift_1527: 'Tasa de transbordo (Transshipment)',
      ke_swift_1801: 'Tasas IDF (2,0%)',
      ke_swift_1802: 'IDF / PIF — Petróleo',
      ke_swift_1908: 'Alquiler de depósito aduanero',
      ke_swift_2101: 'Levy de mantenimiento de rutas (RML)',
      ke_swift_2301: 'Levy de regulación del sector petrolero (PRL)',
      ke_swift_2501: 'Pago bruto — Fondo de Desarrollo del Petróleo (PDF)',
      ke_swift_2901: 'Impuesto a las ganancias — PAYE',
      ke_swift_3001: 'Impuesto a las ganancias — Empresas',
      ke_swift_3100: 'Impuesto a las ganancias — Persona humana residente',
      ke_swift_3101: 'Impuesto mensual sobre ingresos por alquiler',
      ke_swift_3103: 'Retención en la fuente — Ingresos por alquiler',
      ke_swift_3200: 'Impuesto a las ganancias — Retención en la fuente',
      ke_swift_3304: 'Impuesto anticipado sobre vehículos',
      ke_swift_3509: 'IVA — Retención en la fuente',
      ke_swift_3514: 'IVA — Impuesto al valor agregado',
      ke_swift_3801: 'Levy de normas (Standards Levy)',
      ke_swift_4103: 'Impuesto de sellos (Stamp Duty)',
      ke_swift_4301: 'Secretaría de Pesca, Acuicultura y Economía Azul',
      ke_swift_4601: 'Certificado sanitario de importación',
      ke_swift_4702: 'Formulario de declaración de importación — Nueces y aceites',
      ke_swift_512: 'Autoridad Nacional de Capacitación Industrial (NITA)',
      ke_swift_6001: 'Levy de Desarrollo Ferroviario de Kenia (RDL)',
      ke_swift_6002: 'Levy de Desarrollo Ferroviario de Kenia (RDL) — Petróleo',
      ke_swift_6101: 'Venta de patente de vehículo (unitaria)',
      ke_swift_6102: 'Venta de par de patentes de vehículo',
      ke_swift_6301: 'Tasa de transferencia de registro de vehículo',
      ke_swift_6401: 'Levy del Superintendente de Navegación Mercante',
      ke_swift_6402: 'Levy del Superintendente de Navegación Mercante (MSS) — Petróleo',
      ke_swift_6501: 'Fondo de seguridad vial',
      ke_swift_6601: 'Impuesto de compra SHMV',
      ke_swift_adtx: 'Impuesto anticipado (Advance Tax)',
      ke_swift_artx: 'Ingresos de agencia (incl. impuesto de sellos, apuestas)',
      ke_swift_bech: 'Beneficio por hijo (Child Benefit)',
      ke_swift_bsd: 'Departamento de Supervisión Bancaria (BSD)',
      ke_swift_bttx: 'Impuesto sobre apuestas (Betting Tax)',
      ke_swift_ccmc: 'Llamadas de margen — Garantía en efectivo',
      ke_swift_cere: 'Ceremonias (funeral, graduación, casamiento)',
      ke_swift_cfr: 'CFR — Costo y flete (transporte marítimo / fluvial) — Incoterms 2010',
      ke_swift_cgtx: 'Impuesto a las ganancias de capital (CGT)',
      ke_swift_clot: 'Gastos de vestimenta',
      ke_swift_cotx: 'Identificación fiscal de empresa (Corporate Tax ID)',
      ke_swift_csdk: 'Pagos al Depositario Central de Valores (CSD)',
      ke_swift_edtx: 'Impuesto al consumo (Excise Duty)',
      ke_swift_farm: 'Agropecuaria',
      ke_swift_fuel: 'Gastos de combustible',
      ke_swift_gokx: 'Pagos y transferencias gubernamentales',
      ke_swift_holi: 'Vacaciones / Turismo',
      ke_swift_ibld: 'Pago de préstamo / Depósito interbancario',
      ke_swift_inpc: 'Prima de seguro automotor',
      ke_swift_insu: 'Prima de seguro',
      ke_swift_inte: 'Intereses',
      ke_swift_intx: 'Impuesto a las ganancias',
      ke_swift_invs: 'Inversiones y títulos financieros',
      ke_swift_istx: 'Impuesto en cuotas (Installment Tax)',
      ke_swift_licf: 'Tasa de licencia',
      ke_swift_lifi: 'Seguro de vida',
      ke_swift_mach: 'Equipos y maquinarias',
      ke_swift_mafc: 'Contribución al Fondo de Asistencia Médica (MAFC)',
      ke_swift_pena: 'Multas y sanciones',
      ke_swift_pl39: 'Tasa de licencia — Bancos comerciales',
      ke_swift_pl40: 'Tasa de licencia — Instituciones de microcrédito con depósito',
      ke_swift_pl41: 'Tasa de licencia — Casas de cambio (Forex Bureaus)',
      ke_swift_pl42: 'Tasa de licencia — Agencias de referencia crediticia',
      ke_swift_pl43: 'Tasa de licencia — Instituciones financieras hipotecarias',
      ke_swift_pl44: 'Tasa de solicitud — Bancos comerciales',
      ke_swift_pl45: 'Tasa de solicitud — Instituciones financieras hipotecarias',
      ke_swift_pl46: 'Tasa de solicitud — Instituciones con depósito',
      ke_swift_pl47: 'Tasa de solicitud — Casas de cambio (Forex Bureaus)',
      ke_swift_pl48: 'Tasa de solicitud — Agencias de referencia crediticia',
      ke_swift_pl49: 'Sanción — Bancos comerciales',
      ke_swift_pl50: 'Sanción — Instituciones financieras hipotecarias',
      ke_swift_pl51: 'Sanción — Instituciones de microcrédito con depósito',
      ke_swift_pl52: 'Sanción — Casas de cambio (Forex Bureaus)',
      ke_swift_pl53: 'Sanción — Agencias de referencia crediticia',
      ke_swift_ppti: 'Seguro patrimonial',
      ke_swift_prpy: 'Compra de inmueble',
      ke_swift_relg: 'Actividades religiosas',
      ke_swift_ritx: 'Impuesto sobre ingresos por alquiler',
      ke_swift_rlwy: 'Ferrocarril / Transporte ferroviario',
      ke_swift_sdtx: 'Impuesto de sellos',
      ke_swift_swlf: 'Sweeps / Financiamiento de liquidez',
      ke_swift_taxr: 'Reembolso de impuesto',
      ke_swift_tbil: 'Factura de telecomunicaciones',
      ke_swift_tith: 'Diezmo y ofrendas',
      ke_swift_totx: 'Impuesto sobre la facturación (Turnover Tax)',
      ke_swift_trac: 'Eliminado del seguimiento',
      ke_swift_vipn: 'Placa de identificación de vehículo (VIPN)',
      za_swift_105: 'Mercaderías — Liquidaciones comerciales',
      za_swift_220: 'Turismo y viajes',
      za_swift_231: 'Seguros y previsión',
      za_swift_242: 'Servicios de construcción',
      za_swift_250: 'Servicios de telecomunicaciones',
      za_swift_251: 'Correo y encomiendas',
      za_swift_265: 'Servicios de computación',
      za_swift_266: 'Servicios de información',
      za_swift_275: 'Regalías / Propiedad intelectual',
      za_swift_276: 'Investigación y desarrollo',
      za_swift_280: 'Servicios de leasing operativo',
      za_swift_285: 'Consultoría jurídica, contable y de gestión',
      za_swift_287: 'Otros servicios empresariales',
      za_swift_288: 'Mantenimiento y reparaciones',
      za_swift_289: 'Arquitectura, ingeniería y servicios técnicos',
      za_swift_290: 'Servicios personales, culturales y recreativos',
      za_swift_291: 'Servicios audiovisuales',
      za_swift_296: 'Servicios de intermediación comercial',
      za_swift_297: 'Otros servicios empresariales diversos',
      za_swift_308: 'Turismo personal / Vacaciones',
      za_swift_401: 'Remuneración de empleados / Rendimientos de inversiones',
      za_swift_10101: 'Transferencias de capital — Condonación de deuda',
      za_swift_10301: 'Transferencias de capital — Inmigrantes',
      za_swift_27201: 'Otras transferencias de capital',
      in_swift_p0001: 'Repatriación — Cartera india en el exterior (acciones)',
      in_swift_p0002: 'Repatriación — Cartera india en el exterior (títulos de deuda)',
      in_swift_p0003: 'Repatriación — Inversión directa india en el exterior (acciones)',
      in_swift_p0004: 'Repatriación — Inversión directa india en el exterior (títulos de deuda)',
      in_swift_p0005: 'Repatriación — Inversión india en el exterior (inmuebles)',
      in_swift_p0006: 'Inversión extranjera directa en la India (acciones)',
      in_swift_p0007: 'Inversión extranjera directa en la India (títulos de deuda)',
      in_swift_p0008: 'Inversión extranjera directa en la India (inmuebles)',
      in_swift_p0009: 'Inversión extranjera de cartera en la India (acciones)',
      in_swift_p0010: 'Inversión extranjera de cartera en la India (títulos de deuda)',
      in_swift_p0011: 'Pago de préstamos a no residentes',
      in_swift_p0012: 'Préstamos de largo y mediano plazo de no residentes a la India (ECB)',
      in_swift_p0013: 'Préstamos de corto plazo de no residentes a la India (crédito comercial)',
      in_swift_p0014: 'Depósitos de no residentes — FCNR(B)/NR(E)RA',
      in_swift_p0015: 'Préstamos y descubiertos bancarios — Cuenta propia (ADs)',
      in_swift_p0016: 'Compra de moneda extranjera contra otra moneda',
      in_swift_p0017: 'Venta de activos no producidos no financieros — Gobierno (patentes, inmuebles, recursos naturales)',
      in_swift_p0019: 'Derivados financieros — Margen, prima y liquidación',
      in_swift_p0020: 'Venta de acciones bajo plan de opciones para empleados (ESOP)',
      in_swift_p0021: 'Otras inversiones — ADRs/GDRs',
      in_swift_p0022: 'Asistencia externa recibida por la India — Préstamos multilaterales y bilaterales',
      in_swift_p0024: 'Transferencias de capital — Gobierno (garantías, subvenciones de inversión)',
      in_swift_p0025: 'Transferencias de capital — No gobierno (garantías, subvenciones de inversión)',
      in_swift_p0028: 'Cobro de exportaciones (valor total de la factura)',
      in_swift_p0029: 'Anticipos recibidos contra contratos de exportación',
      in_swift_p0099: 'Investigación de mercado y encuestas de opinión pública',
      in_swift_p0101: 'Servicios de minería y procesamiento de minerales',
      in_swift_p0102: 'Servicios de agente comisionista',
      in_swift_p0103: 'Comercio mayorista y minorista',
      in_swift_p0104: 'Leasing operativo sin tripulación — Fletamento',
      in_swift_p0105: 'Otros servicios técnicos — Científicos y espaciales',
      in_swift_p0107: 'Servicios audiovisuales — Producción, distribución y exhibición cinematográfica',
      in_swift_p0108: 'Producción, distribución y transmisión de radio y televisión',
      in_swift_p0109: 'Servicios de entretenimiento',
      id_swift_2011: 'Exportación de mercaderías',
      id_swift_2012: 'Importación de mercaderías',
      id_swift_2015: 'Combustible y provisiones (Bunkers & Stores)',
      id_swift_2018: 'Pago anticipado — Exportación/Importación (total)',
      id_swift_2019: 'Pago anticipado — Exportación/Importación (parcial)',
      id_swift_2097: 'Transacción comercial no de exportación/importación — Indonesia',
      id_swift_2098: 'Transacción comercial no de exportación/importación — Exterior',
      id_swift_2127: 'Liquidación de saldos (netting) — Relacionada con exportación',
      id_swift_2129: 'Liquidación de saldos (netting) — No relacionada con exportación',
      id_swift_2150: 'Remesa de ingresos de trabajadores',
      id_swift_2163: 'Ingresos de trabajadores',
      id_swift_2193: 'Compra y venta de activos de marketing no financieros',
      id_swift_2194: 'Compra y venta de contratos, leasing y licencias no financieras',
      id_swift_2197: 'Compra y venta de terrenos',
      id_swift_2198: 'Compra y venta de inmuebles / edificaciones',
      id_swift_2203: 'Inversión de capital en Indonesia',
      id_swift_2204: 'Inversión de capital en el exterior',
      id_swift_2206: 'Desinversión de capital en Indonesia',
      id_swift_2207: 'Desinversión de capital en el exterior',
      id_swift_2221: 'Otorgamiento/desembolso de préstamo — Hasta 1 año',
      id_swift_2222: 'Otorgamiento/desembolso de préstamo — Más de 1 año',
      id_swift_2231: 'Pago de préstamo — Hasta 1 año',
      id_swift_2232: 'Pago de préstamo — Más de 1 año',
      id_swift_2233: 'Arrendamiento financiero (leasing)',
      id_swift_2240: 'Depósito a plazo en Indonesia — Hasta 3 meses',
      id_swift_2241: 'Otros depósitos en Indonesia — Cuenta corriente y call money hasta 3 meses',
      id_swift_2242: 'Depósito en Indonesia — 3 a 6 meses',
      id_swift_2243: 'Depósito en Indonesia — Más de 6 meses',
      id_swift_2244: 'Rescate de depósito a plazo en Indonesia — Hasta 3 meses',
      id_swift_2245: 'Rescate de otros depósitos en Indonesia — Cuenta corriente y call money hasta 3 meses',
      id_swift_2246: 'Rescate de depósito en Indonesia — 3 a 6 meses',
      id_swift_2247: 'Rescate de depósito en Indonesia — Más de 6 meses',
      id_swift_2251: 'Depósito offshore — Cuenta corriente y call money hasta 3 meses',
      id_swift_2252: 'Depósito offshore — Cuenta corriente y call money de más de 3 meses',
      id_swift_2255: 'Rescate de depósito offshore — Cuenta corriente y call money hasta 3 meses',
      id_swift_2256: 'Rescate de depósito offshore — Cuenta corriente y call money de más de 3 meses',
      id_swift_2257: 'Retiro de divisas de cuenta offshore',
      id_swift_2261: 'Cambio spot — Moneda extranjera vs. rupia',
      id_swift_2262: 'Cambio spot — Moneda extranjera vs. otra moneda',
      id_swift_2263: 'Cambio forward — Moneda extranjera vs. rupia',
      id_swift_2264: 'Cambio forward — Moneda extranjera vs. otra moneda',
      id_swift_2271: 'Derivado — Ganancia en forward o similar',
      id_swift_2272: 'Derivado — A cobrar en acuerdo de tasa futura (FRA)',
      id_swift_2273: 'Derivado — A cobrar en swap de tasas de interés o swap de monedas',
      id_swift_2274: 'Derivado — Margen inicial/reembolsable',
      id_swift_2275: 'Derivado — Margen de variación/no reembolsable',
      id_swift_2276: 'Derivado — Prima a cobrar en opciones',
      id_swift_2277: 'Derivado — Capital a cobrar en el 1.er tramo del swap de monedas',
      id_swift_2278: 'Derivado — Capital a cobrar en el último tramo del swap de monedas',
      id_swift_2279: 'Derivado — Prima a cobrar en credit default swap (CDS)',
      id_swift_2280: 'Depósito/devolución de garantía (collateral)',
      id_swift_2282: 'Reembolso — Transacción no de exportación/importación',
      id_swift_2299: 'Otras transacciones de capital/financieras',
      id_swift_2311: 'Acciones — Emitidas por no residente',
      id_swift_2321: 'Títulos de deuda (bonos) — No residente, más de 1 año',
      id_swift_2322: 'Medium Term Notes (MTNs) — No residente, más de 1 año',
      id_swift_2323: 'Otros títulos de largo plazo — No residente, más de 1 año',
      id_swift_2331: 'Letras del Tesoro (Treasury Bills) — No residente, hasta 1 año',
      id_swift_2332: 'Pagarés (PNs/Promes) — No residente, hasta 1 año',
      id_swift_2333: 'Otros títulos de corto plazo — No residente, hasta 1 año',
      id_swift_2341: 'Acciones — Emitidas por residente',
      id_swift_2342: 'Otros títulos de patrimonio (warrant, right) — Residente',
      id_swift_2351: 'Títulos públicos (Government Bonds) — Residente, más de 1 año',
      id_swift_2352: 'Obligaciones negociables corporativas — Residente, más de 1 año',
      id_swift_2353: 'Medium Term Notes (MTNs) — Residente, más de 1 año',
      id_swift_2354: 'Otros títulos de largo plazo — Residente, más de 1 año',
      id_swift_2361: 'SBI / SWBI (Certificados del Banco de Indonesia) — Hasta 1 año',
      id_swift_2362: 'SPN (Letras del Tesoro Nacional de Indonesia) — Hasta 1 año',
      id_swift_2363: 'Pagarés (PNs/Promes) — Residente, hasta 1 año',
      id_swift_2364: 'Certificados de depósito negociables (NCD) — Residente, hasta 1 año',
      id_swift_2365: 'Otros títulos de corto plazo — Residente, hasta 1 año',
      id_swift_2366: 'Certificado de depósito del Banco de Indonesia — Hasta 1 año',
      id_swift_2371: 'Fondos de inversión (Reksadana)',
      id_swift_2372: 'Fondos de inversión negociados (Reksadana)',
      id_swift_2375: 'Venta de títulos de residentes con repo — Propietario, hasta 1 año',
      id_swift_2376: 'Venta de títulos de residentes con repo — Propietario, más de 1 año',
      id_swift_2377: 'Reventa de títulos de residentes con repo — Comprador, hasta 1 año',
      id_swift_2378: 'Reventa de títulos de residentes con repo — Comprador, más de 1 año',
      id_swift_2379: 'Recompra de títulos de residentes con repo — Propietario, hasta 1 año',
      id_swift_2380: 'Recompra de títulos de residentes con repo — Propietario, más de 1 año',
      id_swift_2381: 'Compra de títulos de residentes con repo — Hasta 1 año',
      id_swift_2382: 'Compra de títulos de residentes con repo — Más de 1 año',
      id_swift_2383: 'Factoring con banco en Indonesia — Hasta 1 año',
      id_swift_2384: 'Factoring con banco en Indonesia — Más de 1 año',
      id_swift_2385: 'Factoring con empresa en Indonesia — Hasta 1 año',
      id_swift_2386: 'Factoring con empresa en Indonesia — Más de 1 año',
      id_swift_2387: 'Factoring con banco en el exterior — Hasta 1 año',
      id_swift_2388: 'Factoring con banco en el exterior — Más de 1 año',
      id_swift_2389: 'Factoring con empresa en el exterior — Hasta 1 año',
      id_swift_2390: 'Factoring con empresa en el exterior — Más de 1 año',
      id_swift_2391: 'Gold swap — Pago por el proveedor de efectivo, hasta 1 año',
      id_swift_2392: 'Gold swap — Pago por el proveedor de efectivo, más de 1 año',
      id_swift_2393: 'Gold swap — Devolución por el propietario del oro, hasta 1 año',
      id_swift_2394: 'Gold swap — Devolución por el propietario del oro, más de 1 año',
      id_swift_2395: 'Gold swap — Cobro por el proveedor de efectivo, hasta 1 año',
      id_swift_2396: 'Gold swap — Cobro por el proveedor de efectivo, más de 1 año',
      id_swift_2397: 'Gold swap — Cobro por el propietario del oro, hasta 1 año',
      id_swift_2398: 'Gold swap — Cobro por el propietario del oro, más de 1 año',
      id_swift_2400: 'Procesamiento de mercaderías',
      id_swift_2405: 'Mantenimiento y reparación de mercaderías',
      id_swift_2411: 'Transporte de pasajeros — Marítimo',
      id_swift_2412: 'Transporte de pasajeros — Aéreo',
      id_swift_2413: 'Transporte de pasajeros — Otros medios',
      id_swift_2421: 'Flete de exportación/importación — Marítimo',
      id_swift_2422: 'Flete de exportación/importación — Aéreo',
      id_swift_2423: 'Flete de exportación/importación — Otros medios',
      id_swift_2431: 'Flete no de exportación/importación — Marítimo',
      id_swift_2432: 'Flete no de exportación/importación — Aéreo',
      id_swift_2433: 'Flete no de exportación/importación — Otros medios',
      id_swift_2441: 'Servicios auxiliares de transporte — Marítimo',
      id_swift_2442: 'Servicios auxiliares de transporte — Aéreo',
      id_swift_2443: 'Servicios auxiliares de transporte — Otros medios',
      id_swift_2450: 'Correos y encomiendas',
      id_swift_2461: 'Viaje corporativo',
      id_swift_2462: 'Viaje personal',
      id_swift_2466: 'Servicios de salud en Indonesia',
      id_swift_2467: 'Servicios de salud en el exterior',
      id_swift_2468: 'Educación / Capacitación en Indonesia',
      id_swift_2469: 'Educación / Capacitación en el exterior',
      id_swift_2480: 'Servicios de telecomunicaciones',
      id_swift_2490: 'Servicios de tecnología de la información',
      id_swift_2495: 'Servicios de información',
      id_swift_2501: 'Construcción civil en Indonesia — Hasta 1 año',
      id_swift_2502: 'Construcción civil en Indonesia — Más de 1 año',
      id_swift_2511: 'Construcción civil en el exterior — Hasta 1 año',
      id_swift_2512: 'Construcción civil en el exterior — Más de 1 año',
      id_swift_2521: 'Seguro de vida directo — Prima',
      id_swift_2522: 'Seguro de vida directo — Beneficio',
      id_swift_2523: 'Seguro de carga directo — Prima',
      id_swift_2524: 'Seguro de carga directo — Siniestro',
      id_swift_2525: 'Otros seguros directos — Prima',
      id_swift_2526: 'Otros seguros directos — Siniestro',
      id_swift_2531: 'Reaseguro — Prima',
      id_swift_2532: 'Reaseguro — Siniestro',
      id_swift_2533: 'Reaseguro — Comisión',
      id_swift_2541: 'Servicios auxiliares de seguros',
      id_swift_2546: 'Contribución al fondo de pensión',
      id_swift_2547: 'Beneficio de fondo de pensión',
      id_swift_2550: 'Servicios financieros',
      id_swift_2560: 'Derechos de autor / Propiedad intelectual',
      id_swift_2570: 'Investigación y desarrollo',
      id_swift_2580: 'Servicios jurídicos, contables, de consultoría de gestión y relaciones públicas',
      id_swift_2590: 'Publicidad, investigación de mercado y encuestas',
      id_swift_2600: 'Arquitectura, ingeniería y otros servicios técnicos',
      id_swift_2610: 'Minería, agricultura y gestión de residuos / contaminación',
      id_swift_2615: 'Leasing operativo — Alquiler de bienes',
      id_swift_2616: 'Leasing operativo — Alquiler de transporte sin tripulación',
      id_swift_2630: 'Servicios relacionados con el comercio',
      id_swift_2640: 'Otros servicios empresariales',
      id_swift_2651: 'Arte, cultura y recreación en Indonesia',
      id_swift_2652: 'Arte, cultura y recreación en el exterior',
      id_swift_2660: 'Servicios gubernamentales',
      id_swift_2670: 'Otros servicios',
      id_swift_2701: 'Rendimientos de títulos — No residente, hasta 1 año',
      id_swift_2702: 'Rendimientos de títulos — No residente, más de 1 año',
      id_swift_2705: 'Rendimientos de cuenta corriente, ahorro y depósitos (incl. Mudharabah)',
      id_swift_2710: 'Rendimientos de cuenta de préstamo (incl. leasing, Murabahah, Musyarakah)',
      id_swift_2716: 'Rendimientos de títulos — Residente, hasta 1 año',
      id_swift_2717: 'Rendimientos de títulos — Residente, más de 1 año',
      id_swift_2720: 'Rendimientos de gold swap',
      id_swift_2725: 'Dividendos y ganancias',
      id_swift_2730: 'Tasa recibida por el propietario de títulos — Préstamo de títulos',
      id_swift_2731: 'Tasa recibida por el propietario de títulos — Préstamo de oro o gold swap',
      id_swift_2741: 'Alquiler de terreno',
      id_swift_2742: 'Alquiler de oficina, departamento, vivienda y similares',
      id_swift_2743: 'Alquiler de terreno con oficina/departamento/vivienda y similares',
      id_swift_2751: 'Subvención (efectivo) — Sin obligación de comprar activo fijo',
      id_swift_2752: 'Subvención (efectivo) — Con obligación de comprar activo fijo',
      id_swift_2760: 'Sanción, multa y similares',
      id_swift_2765: 'Impuesto, contribución, restitución y similares',
      id_swift_2766: 'Impuesto a las ganancias y seguridad social',
      id_swift_2767: 'Otros impuestos',
      id_swift_2770: 'Derecho de uso de recursos naturales',
      id_swift_2802: 'Reembolso de exportación',
      id_swift_2803: 'Reembolso de importación',
      id_swift_2804: 'Reembolso — Transacción no de exportación/importación',
      id_swift_2808: 'Capital de trabajo / Cash call — Petróleo y gas',
      id_swift_2809: 'Capital de trabajo / Cash call — No petróleo y gas',
      id_swift_2811: 'Pago anticipado — Bienes no de exportación/importación',
      id_swift_2812: 'Pago anticipado — Seguros',
      id_swift_2813: 'Otros pagos anticipados',
      id_swift_2814: 'Reembolso de tasa de solicitud — IPO y colocación privada',
      id_swift_2815: 'Reembolso de fondo de emergencia',
      id_swift_2821: 'Venta de títulos de no residentes con repo — Propietario, hasta 1 año',
      id_swift_2822: 'Venta de títulos de no residentes con repo — Propietario, más de 1 año',
      id_swift_2823: 'Reventa de títulos de no residentes con repo — Comprador, hasta 1 año',
      id_swift_2824: 'Reventa de títulos de no residentes con repo — Comprador, más de 1 año',
      id_swift_2825: 'Recompra de títulos de no residentes con repo — Propietario, hasta 1 año',
      id_swift_2826: 'Recompra de títulos de no residentes con repo — Propietario, más de 1 año',
      id_swift_2827: 'Compra de títulos de no residentes con repo — Hasta 1 año',
      id_swift_2828: 'Compra de títulos de no residentes con repo — Más de 1 año',
      ph_swift_1010101000: 'IED — Transferencia de capital (acciones)',
      ph_swift_1010102001: 'IED — Transferencia de capital (ganancias reinvertidas)',
      ph_swift_1010102002: 'IED — Transferencia de capital (ganancias reinvertidas — otro capital)',
      ph_swift_1010103001: 'IED — Transferencia de capital (otro capital — préstamos de la controlante)',
      ph_swift_1010103002: 'IED — Transferencia de capital (otro capital — préstamos de afiliadas)',
      ph_swift_1010201000: 'IEC — Transferencia de capital (acciones)',
      ph_swift_1010202001: 'IEC — Transferencia de capital (títulos de deuda / bonos)',
      ph_swift_1010202002: 'IEC — Transferencia de capital (otros títulos de deuda)',
      ph_swift_1010203001: 'IEC — Transferencia de capital (instrumentos del mercado monetario)',
      ph_swift_1010203002: 'IEC — Transferencia de capital (derivados financieros)',
      ph_swift_1010300000: 'Transferencia de capital — Otras inversiones',
      ph_swift_1110100001: 'Transferencias corrientes — Remesas de trabajadores (bancos locales)',
      ph_swift_1110200001: 'Transferencias corrientes — Privadas (remesas en efectivo — USD)',
      ph_swift_1110200002: 'Transferencias corrientes — Privadas (remesas en efectivo — EUR)',
      ph_swift_1110200003: 'Transferencias corrientes — Privadas (remesas en efectivo — JPY)',
      ph_swift_1110200004: 'Transferencias corrientes — Privadas (remesas en efectivo — otra moneda)',
      ph_swift_1110300001: 'Transferencias corrientes — Privadas (subvenciones — organizaciones internacionales)',
      ph_swift_1110300002: 'Transferencias corrientes — Privadas (subvenciones — organizaciones sin fines de lucro)',
      ph_swift_1110300003: 'Transferencias corrientes — Privadas (subvenciones — personas humanas)',
      ph_swift_1110300004: 'Transferencias corrientes — Privadas (subvenciones — otros privados)',
      ph_swift_1110400001: 'Transferencias corrientes — Privadas (siniestros de seguro — vida)',
      ph_swift_1110400002: 'Transferencias corrientes — Privadas (siniestros de seguro — no vida)',
      ph_swift_1110400003: 'Transferencias corrientes — Privadas (siniestros de seguro — reaseguro)',
      ph_swift_1110400004: 'Transferencias corrientes — Privadas (siniestros de seguro — fondos de pensión)',
      ph_swift_1110400005: 'Transferencias corrientes — Privadas (siniestros de seguro — garantías estandarizadas)',
      ph_swift_1110400006: 'Transferencias corrientes — Privadas (siniestros de seguro — otros)',
      ph_swift_1110500001: 'Transferencias corrientes — Privadas (beneficios previsionales — trabajadores locales)',
      ph_swift_1110500002: 'Transferencias corrientes — Privadas (beneficios previsionales — OFWs)',
      ph_swift_1110500003: 'Transferencias corrientes — Privadas (beneficios previsionales — pensión)',
      ph_swift_1110500004: 'Transferencias corrientes — Privadas (beneficios previsionales — anualidad)',
      ph_swift_1110500005: 'Transferencias corrientes — Privadas (beneficios previsionales — otros)',
      ph_swift_1110600001: 'Transferencias corrientes — Privadas (multas y sanciones)',
      ph_swift_1110700001: 'Transferencias corrientes — Privadas (otras transferencias corrientes)',
      ph_swift_1310000001: 'Transferencias corrientes — Gobierno (subvenciones)',
      ph_swift_1310000002: 'Transferencias corrientes — Gobierno (impuestos corrientes sobre la renta y el patrimonio)',
      ph_swift_1310000003: 'Transferencias corrientes — Gobierno (otras transferencias corrientes)',
      ph_swift_1410100001: 'Ingresos — Remuneración de empleados (sueldos y salarios)',
      ph_swift_1410100002: 'Ingresos — Remuneración de empleados (otras remuneraciones)',
      ph_swift_1410200001: 'Ingresos — Renta de inversión (IED — dividendos)',
      ph_swift_1410200002: 'Ingresos — Renta de inversión (IED — ganancias reinvertidas)',
      ph_swift_1410200003: 'Ingresos — Renta de inversión (IED — intereses intercompany)',
      ph_swift_1410200004: 'Ingresos — Renta de inversión (IED — ganancias de sucursal no distribuidas)',
      ph_swift_1410300000: 'Ingresos — Renta de inversión de cartera',
      ph_swift_1410400000: 'Ingresos — Otras rentas de inversión',
      ph_swift_1410500000: 'Ingresos — Renta de reservas',
      ph_swift_1410600000: 'Ingresos — Otras rentas',
      ph_swift_1510000001: 'Exportación de mercaderías — Mercadería general',
      ph_swift_1510000002: 'Exportación de mercaderías — Procesamiento',
      ph_swift_1510000003: 'Exportación de mercaderías — Reparación de bienes',
      ph_swift_1510000004: 'Exportación de mercaderías — Suministros en puertos',
      ph_swift_1510000005: 'Exportación de mercaderías — Oro no monetario',
      ph_swift_1510000006: 'Exportación de mercaderías — Bienes bajo leasing financiero (neto)',
      ph_swift_1510000007: 'Exportación de mercaderías — Otros bienes',
      ph_swift_1510000008: 'Exportación no de mercaderías — Militar',
      ph_swift_1510000009: 'Exportación no de mercaderías — Embajadas',
      ph_swift_1510000010: 'Exportación no de mercaderías — Reparación de bienes',
      ph_swift_1510000011: 'Exportación no de mercaderías — Suministros por transportistas (marítimo)',
      ph_swift_1510000012: 'Exportación no de mercaderías — Suministros por transportistas (aéreo)',
      ph_swift_1510000013: 'Exportación no de mercaderías — Suministros por transportistas (terrestre)',
      ph_swift_1510000014: 'Exportación no de mercaderías — Suministros por transportistas (otros)',
      ph_swift_1510000015: 'Exportación no de mercaderías — Otras exportaciones no de mercaderías',
      ph_swift_1510000016: 'Exportación directa',
      ph_swift_1510000017: 'Exportación indirecta — Procesamiento',
      ph_swift_1510000018: 'Exportación indirecta — Compra y venta',
      ph_swift_1510000019: 'Exportación indirecta — Consignación',
      ph_swift_1510000020: 'Exportación indirecta — Joint venture',
      ph_swift_1510000021: 'Exportación indirecta — Otras',
      ph_swift_1510000023: 'Exportación — Pago anticipado',
      ph_swift_1510000024: 'Exportación — Facturación progresiva',
      ph_swift_1510000025: 'Exportación — Pago total',
      ph_swift_210000001: 'Transporte — Flete marítimo (manifiesto de salida)',
      ph_swift_210000002: 'Transporte — Flete aéreo (manifiesto de salida)',
      ph_swift_210000003: 'Transporte — Flete terrestre',
      ph_swift_210000004: 'Transporte — Pasajeros (marítimo)',
      ph_swift_210000005: 'Transporte — Pasajeros (aéreo)',
      ph_swift_210000006: 'Transporte — Pasajeros (terrestre)',
      ph_swift_210000007: 'Transporte — Servicios portuarios',
      ph_swift_210000008: 'Transporte — Servicios aeroportuarios',
      ph_swift_210000009: 'Transporte — Otros servicios auxiliares',
      ph_swift_210000010: 'Transporte — Otros servicios de transporte',
      ph_swift_510100001: 'Viaje corporativo',
      ph_swift_510200001: 'Viaje personal',
      ph_swift_510200002: 'Viaje personal — Salud',
      ph_swift_510301001: 'Comunicación — Correos / Encomiendas',
      ph_swift_510301002: 'Comunicación — Telecomunicaciones',
      ph_swift_510301003: 'Comunicación — Internet',
      ph_swift_510302001: 'Comunicación — Radiodifusión',
      ph_swift_510302002: 'Comunicación — TV por cable',
      ph_swift_510302003: 'Comunicación — Satélite',
      ph_swift_510303000: 'Comunicación — Otras',
      ph_swift_510401000: 'Construcción civil en el exterior',
      ph_swift_510402001: 'Construcción civil en Filipinas — Sector privado',
      ph_swift_510402002: 'Construcción civil en Filipinas — Gobierno',
      ph_swift_510402003: 'Construcción civil en Filipinas — BOT',
      ph_swift_510402004: 'Construcción civil en Filipinas — Joint venture',
      ph_swift_510402005: 'Construcción civil en Filipinas — EPIRA',
      ph_swift_510402006: 'Construcción civil en Filipinas — Otras',
      ph_swift_510402007: 'Reparaciones y mantenimiento',
      ph_swift_510500001: 'Seguros — Seguro de vida',
      ph_swift_510500002: 'Seguros — No vida',
      ph_swift_510500003: 'Seguros — Reaseguro',
      ph_swift_510500004: 'Seguros — Fondos de pensión',
      ph_swift_510500005: 'Seguros — Garantías estandarizadas',
      ph_swift_510600001: 'Servicios financieros — Intermediación financiera',
      ph_swift_510600002: 'Servicios financieros — Banca de inversión',
      ph_swift_510600003: 'Servicios financieros — Relacionados con seguros',
      ph_swift_510600004: 'Servicios financieros — Relacionados con pensiones',
      ph_swift_510600005: 'Servicios financieros — Otros',
      ph_swift_510700000: 'Computación e información — Software',
      ph_swift_510800001: 'Regalías — Franquicias',
      ph_swift_510800002: 'Regalías — Otras',
      ph_swift_510900000: 'Otros servicios empresariales — Comercialización',
      ph_swift_511000001: 'Otros servicios empresariales — Leasing operativo',
      ph_swift_511000002: 'Otros servicios empresariales — Leasing financiero',
      ph_swift_511100001: 'Otros servicios empresariales — Jurídico',
      ph_swift_511100002: 'Otros servicios empresariales — Contabilidad',
      ph_swift_511100003: 'Otros servicios empresariales — Consultoría de gestión',
      ph_swift_511200000: 'Otros servicios empresariales — Publicidad',
      ph_swift_511300001: 'Otros servicios empresariales — Investigación y desarrollo',
      ph_swift_511300002: 'Otros servicios empresariales — Arquitectura',
      ph_swift_511300003: 'Otros servicios empresariales — Ingeniería',
      ph_swift_511300004: 'Otros servicios empresariales — Agropecuaria',
      ph_swift_511300005: 'Otros servicios empresariales — Minería',
      ph_swift_511300006: 'Otros servicios empresariales — Medio ambiente',
      ph_swift_511300007: 'Otros servicios empresariales — Otros servicios técnicos',
      ph_swift_511300008: 'Otros servicios empresariales — Comercio',
      ph_swift_511400001: 'Servicios gubernamentales — Embajadas y consulados',
      ph_swift_511400002: 'Servicios gubernamentales — Organizaciones internacionales',
      ph_swift_511400003: 'Servicios gubernamentales — Operaciones militares',
      ph_swift_511400004: 'Servicios gubernamentales — Misiones diplomáticas',
      ph_swift_511400005: 'Servicios gubernamentales — Otros',
      ph_swift_511500001: 'Servicios personales — Educación',
      ph_swift_511500002: 'Servicios personales — Salud',
      ph_swift_511500003: 'Servicios personales — Recreación / Cultura / Deportes',
      ph_swift_511500004: 'Servicios personales — Otros',
      ph_swift_511600001: 'Otros servicios — IT-BPO',
      ph_swift_511600002: 'Otros servicios — Turismo',
      ph_swift_511600003: 'Otros servicios — No clasificados',
      ph_swift_511700001: 'Otros servicios — Turismo médico',
      ph_swift_511700002: 'Otros servicios — Jubilación',
      ph_swift_511700003: 'Otros servicios — Otros tipos de turismo',
      ph_swift_610000001: 'Préstamos — Corto plazo (desembolso)',
      ph_swift_610000002: 'Préstamos — Corto plazo (amortización)',
      ph_swift_610000003: 'Préstamos — Largo plazo (desembolso)',
      ph_swift_610000004: 'Préstamos — Largo plazo (amortización)',
      ph_swift_610000005: 'Préstamos — Largo plazo (otros)',
      ph_swift_610000006: 'Crédito comercial — Corto plazo',
      ph_swift_610000007: 'Crédito comercial — Largo plazo',
      ph_swift_710100001: 'Depósitos en moneda extranjera — Entrada (nuevo depósito)',
      ph_swift_710100002: 'Depósitos en moneda extranjera — Entrada (intereses FCDU/EFCDU)',
      ph_swift_710100003: 'Depósitos en moneda extranjera — Entrada (otros)',
      ph_swift_710100004: 'Depósitos en moneda extranjera — Salida (retiro)',
      ph_swift_710100006: 'Depósitos en moneda extranjera — Salida (transferencia a otros bancos)',
      ph_swift_710100007: 'Depósitos en moneda extranjera — Salida (financiamiento de pagos en el exterior)',
      ph_swift_710100008: 'Depósitos en moneda extranjera — Salida (otros)',
      ph_swift_710100009: 'Depósitos en moneda extranjera — Salida (transferencia al BSP)',
      ph_swift_710200001: 'Depósitos interbancarios — Entrada (colocaciones de bancos extranjeros)',
      ph_swift_710200002: 'Depósitos interbancarios — Entrada (transferencias de bancos extranjeros)',
      ph_swift_710200003: 'Depósitos interbancarios — Entrada (otros)',
      ph_swift_710200004: 'Depósitos interbancarios — Salida (retiros de bancos extranjeros)',
      ph_swift_710200009: 'Depósitos interbancarios — Salida (otros)',
      ph_swift_710300001: 'Cuentas nostro — Entrada',
      ph_swift_710300002: 'Cuentas nostro — Entrada (intereses)',
      ph_swift_710300003: 'Cuentas nostro — Entrada (otros)',
      ph_swift_710300004: 'Cuentas nostro — Salida',
      ph_swift_710300009: 'Cuentas nostro — Salida (otros)',
      ph_swift_710400001: 'Otros depósitos — Entrada',
      ph_swift_710400002: 'Otros depósitos — Salida',
      ph_swift_810101001: 'Liquidación de exportación — Carta de crédito a la vista',
      ph_swift_810101002: 'Liquidación de exportación — Carta de crédito a plazo (usance)',
      ph_swift_810101003: 'Liquidación de exportación — Carta de crédito con pago diferido',
      ph_swift_810101004: 'Liquidación de exportación — Carta de crédito con negociación con recurso',
      ph_swift_810101007: 'Liquidación de exportación — Otros tipos de LC',
      ph_swift_810101008: 'Liquidación de exportación — Carta de crédito en moneda extranjera',
      ph_swift_810101011: 'Liquidación de exportación — Otras liquidaciones de LC',
      ph_swift_810102001: 'Liquidación de exportación — Cobranza documentaria (documentos contra pago)',
      ph_swift_810102002: 'Liquidación de exportación — Cobranza documentaria (documentos contra aceptación)',
      ph_swift_810102003: 'Liquidación de exportación — Cobranza simple (clean collection)',
      ph_swift_810102004: 'Liquidación de exportación — Cobranza documentaria (otros tipos de documentos)',
      ph_swift_810102005: 'Liquidación de exportación — Pago parcial anticipado',
      ph_swift_810102006: 'Liquidación de exportación — Pago diferido',
      ph_swift_810102007: 'Liquidación de exportación — Cobranza en moneda extranjera',
      ph_swift_810102008: 'Liquidación de exportación — Otros tipos de cobranza',
      ph_swift_810102009: 'Liquidación de exportación — Cuenta abierta (open account)',
      ph_swift_810201001: 'Liquidación de importación — Carta de crédito a la vista',
      ph_swift_810201002: 'Liquidación de importación — Carta de crédito a plazo (usance)',
      ph_swift_810201003: 'Liquidación de importación — Carta de crédito con pago diferido',
      ph_swift_810201004: 'Liquidación de importación — Otros tipos de LC',
      ph_swift_810202001: 'Liquidación de importación — Cobranza documentaria (documentos contra pago)',
      ph_swift_810202002: 'Liquidación de importación — Cobranza documentaria (documentos contra aceptación)',
      ph_swift_810202003: 'Liquidación de importación — Cobranza simple (clean collection)',
      ph_swift_810202005: 'Liquidación de importación — Cobranza documentaria (otros tipos de documentos)',
      ph_swift_810202006: 'Liquidación de importación — Otros tipos de cobranza',
      ph_swift_910100001: 'Operaciones propias del banco — Entrada (capital)',
      ph_swift_910100002: 'Operaciones propias del banco — Entrada (desembolso de préstamos)',
      ph_swift_910100003: 'Operaciones propias del banco — Entrada (pago de préstamos)',
      ph_swift_910100004: 'Operaciones propias del banco — Entrada (depósitos de bancos extranjeros)',
      ph_swift_910100005: 'Operaciones propias del banco — Entrada (compras de divisas)',
      ph_swift_910100006: 'Operaciones propias del banco — Entrada (renta de inversión)',
      ph_swift_910100007: 'Operaciones propias del banco — Entrada (otros)',
      ph_swift_910100009: 'Operaciones propias del banco — Entrada (transferencias del BSP)',
      ph_swift_910100010: 'Operaciones propias del banco — Entrada (transferencias de bancos extranjeros)',
      ph_swift_910100011: 'Operaciones propias del banco — Entrada (otras transferencias)',
      ph_swift_910200001: 'Operaciones propias del banco — Salida (capital)',
      ph_swift_910200002: 'Operaciones propias del banco — Salida (desembolso de préstamos)',
      ph_swift_910200003: 'Operaciones propias del banco — Salida (pago de préstamos)',
      ph_swift_910200004: 'Operaciones propias del banco — Salida (depósitos en bancos extranjeros)',
      ph_swift_910200005: 'Operaciones propias del banco — Salida (ventas de divisas)',
      ph_swift_910200006: 'Operaciones propias del banco — Salida (renta de inversión)',
      ph_swift_910200007: 'Operaciones propias del banco — Salida (otros)',
      ph_swift_910200009: 'Operaciones propias del banco — Salida (transferencias al BSP)',
      ph_swift_910200010: 'Operaciones propias del banco — Salida (transferencias a bancos extranjeros)',
      ph_swift_910200011: 'Operaciones propias del banco — Salida (otras transferencias)',
      pk_swift_9009: 'Exportación de mercaderías',
      pk_swift_9010: 'Comisión de exportación',
      pk_swift_9011: 'Exportación en consignación',
      pk_swift_9012: 'Exportación a crédito / Pago diferido',
      pk_swift_9013: 'Exportación con seguro de crédito oficial',
      pk_swift_9014: 'Cobro de anticipo previamente pagado para exportación',
      pk_swift_9015: 'Servicios de subcontratista en el exterior',
      pk_swift_9016: 'Servicios de construcción en el exterior',
      pk_swift_9017: 'Mantenimiento y reparación de bienes de capital',
      pk_swift_9018: 'Operación de equipos de transporte — Flete, fletamento',
      pk_swift_9019: 'Salarios de trabajadores paquistaníes en el exterior',
      pk_swift_9020: 'Servicios inmobiliarios — Alquiler',
      pk_swift_9021: 'Subcontratación de servicios (excepto construcción)',
      pk_swift_9022: 'Servicios jurídicos, contables, de publicidad y otros empresariales',
      pk_swift_9023: 'Otros servicios no clasificados',
      pk_swift_9024: 'Servicios de TI — Consultoría, software, datos',
      pk_swift_9025: 'Regalías / Propiedad intelectual',
      pk_swift_9026: 'Dividendos / Ganancias — Inversión directa en el exterior',
      pk_swift_9027: 'Dividendos — Inversión de cartera en el exterior',
      pk_swift_9028: 'Intereses sobre préstamos a empresas extranjeras',
      pk_swift_9029: 'Intereses sobre títulos / obligaciones de no residentes',
      pk_swift_9030: 'Intereses sobre depósitos en moneda extranjera',
      pk_swift_9031: 'Comisión de agentes en Pakistán',
      pk_swift_9032: 'Servicios de navegación marítima — Flete y sobreestadía',
      pk_swift_9033: 'Servicios aéreos — Flete y sobreestadía',
      pk_swift_9041: 'Rendimientos de inversiones en el exterior (fondos comunes, unit trusts)',
      pk_swift_9051: 'Pasaje marítimo de no residentes',
      pk_swift_9052: 'Pasaje aéreo de no residentes',
      pk_swift_9061: 'Tratamiento médico de no residentes en Pakistán',
      pk_swift_9071: 'Educación de no residentes en Pakistán',
      pk_swift_9072: 'Capacitación de extranjeros en Pakistán',
      pk_swift_9073: 'Educación / Capacitación en línea por instituciones paquistaníes',
      pk_swift_9081: 'Cambio por nacionales paquistaníes de visita en el país',
      pk_swift_9082: 'Cambio por turistas extranjeros en Pakistán',
      pk_swift_9083: 'Cobros de visitantes religiosos en Pakistán',
      pk_swift_9084: 'Devolución de divisas no utilizadas — Viaje al exterior',
      pk_swift_9085: 'Devolución de divisas no utilizadas — Hajjis',
      pk_swift_9086: 'Devolución de divisas no utilizadas — Umrah / Ziarat',
      pk_swift_9091: 'Servicios postales de no residentes',
      pk_swift_9092: 'Servicios de courier de no residentes',
      pk_swift_9101: 'Servicios de telecomunicaciones',
      pk_swift_9102: 'Call centers — Servicios prestados',
      pk_swift_9111: 'Remesa de construcción en el exterior',
      pk_swift_9121: 'Seguros de vida y fondos de pensión — Primas',
      pk_swift_9122: 'Remesas de aseguradoras de vida paquistaníes en el exterior',
      pk_swift_9124: 'Reembolso de seguros y pensiones',
      pk_swift_9141: 'Seguros no vida — Primas',
      pk_swift_9146: 'Reembolso de otros seguros directos',
      pk_swift_9151: 'Reaseguro de vida — Primas',
      pk_swift_9152: 'Reaseguro no vida — Primas',
      pk_swift_9161: 'Servicios auxiliares de seguros — Corretaje y agencia',
      pk_swift_9171: 'Servicios financieros — Tasas de intermediación bancaria',
      pk_swift_9172: 'Ejecución de garantías bancarias',
      pk_swift_9173: 'Otros servicios financieros — Banca de inversión, M&A, corretaje',
      pk_swift_9174: 'Reembolso de servicios financieros',
      pk_swift_9181: 'Consultoría de hardware de TI para no residentes',
      pk_swift_9182: 'Servicios de bases de datos para no residentes',
      pk_swift_9183: 'Mantenimiento de computadoras en el exterior para no residentes',
      pk_swift_9184: 'Exportación de software a medida',
      pk_swift_9185: 'Exportación de software empaquetado',
      pk_swift_9186: 'Otros servicios de TI para no residentes',
      pk_swift_9191: 'Servicios de agencia de noticias para no residentes',
      pk_swift_9192: 'Servicios de biblioteca y archivo para no residentes',
      pk_swift_9193: 'Otros servicios de información para no residentes',
      pk_swift_9201: 'Regalías — Propiedad intelectual (patentes, marcas, franquicias)',
      pk_swift_9202: 'Regalías — Derechos de autor audiovisuales',
      pk_swift_9211: 'Servicios de facilitación comercial (finanzas, documentación, aduana)',
      pk_swift_9212: 'Leasing operativo',
      pk_swift_9221: 'Servicios jurídicos',
      pk_swift_9222: 'Servicios de contabilidad y auditoría',
      pk_swift_9230: 'Gestión empresarial y relaciones públicas',
      pk_swift_9231: 'Servicios de publicidad',
      pk_swift_9232: 'Investigación de mercado y encuestas de opinión',
      pk_swift_9233: 'Investigación y desarrollo',
      pk_swift_9234: 'Servicios de arquitectura',
      pk_swift_9235: 'Servicios de ingeniería',
      pk_swift_9236: 'Minería y prospección',
      pk_swift_9237: 'Servicios agropecuarios',
      pk_swift_9238: 'Servicios ambientales',
      pk_swift_9239: 'Otros servicios empresariales diversos',
      pk_swift_9241: 'Servicios audiovisuales — Películas',
      pk_swift_9242: 'Servicios audiovisuales — Radio y TV',
      pk_swift_9243: 'Servicios audiovisuales — VHS, CD, DVD',
      pk_swift_9244: 'Servicios audiovisuales — Multimedia',
      pk_swift_9247: 'Otros servicios audiovisuales',
      pk_swift_9248: 'Servicios personales',
      pk_swift_9249: 'Servicios culturales',
      pk_swift_9250: 'Servicios recreativos',
      pk_swift_9251: 'Servicios educativos',
      pk_swift_9261: 'Servicios a gobiernos no clasificados',
      pk_swift_9262: 'Servicios de salud no clasificados',
      pk_swift_9271: 'Servicios de deportes y recreación',
      pk_swift_9272: 'Servicios a embajadas y consulados',
      pk_swift_9273: 'Servicios a organizaciones internacionales',
      pk_swift_9281: 'Servicios diplomáticos, consulares y gubernamentales',
      pk_swift_9291: 'Otros servicios no clasificados',
      pk_swift_9301: 'Remesas de trabajadores extranjeros residentes en Pakistán',
      pk_swift_9302: 'Transferencias de inmigrantes a Pakistán',
      pk_swift_9303: 'Otras transferencias corrientes',
      pk_swift_9311: 'Asistencia Oficial para el Desarrollo (AOD) — Subvenciones',
      pk_swift_9312: 'Asistencia Oficial para el Desarrollo (AOD) — Préstamos',
      pk_swift_9322: 'Inversión extranjera directa — Acciones en Pakistán',
      pk_swift_9323: 'Préstamos intercompany de la controlante',
      pk_swift_9324: 'Ganancias reinvertidas',
      pk_swift_9331: 'Inversión de cartera — Títulos de deuda de Pakistán',
      pk_swift_9332: 'Inversión de cartera — Acciones de Pakistán',
      pk_swift_9333: 'Otras inversiones de cartera',
      pk_swift_9341: 'Préstamos de instituciones financieras no bancarias del exterior',
      pk_swift_9351: 'Crédito comercial — Importadores de proveedores extranjeros',
      pk_swift_9361: 'Anticipos de compradores extranjeros para exportaciones futuras',
      pk_swift_9381: 'Colocaciones de corto plazo del exterior en bancos de Pakistán',
      pk_swift_9391: 'Moneda extranjera en circulación (billetes y monedas)',
      pk_swift_9401: 'Retiros del SBP de cuentas en el exterior',
      pk_swift_9412: 'Compras y préstamos del FMI',
      pk_swift_9414: 'Asignación de Derechos Especiales de Giro (DEG) por el FMI',
      pk_swift_9421: 'Venta de oro monetario por el SBP',
      pk_swift_9422: 'Préstamos de corto plazo tomados por bancos del exterior',
      pk_swift_9423: 'Colocaciones de bancos en el exterior — Hasta 3 meses',
      pk_swift_9426: 'Colocaciones de bancos en el exterior — 3 meses a 1 año',
      pk_swift_9431: 'Préstamos de corto plazo entre bancos en Pakistán',
      pk_swift_9432: 'Colocaciones interbancarias de corto plazo en Pakistán',
      pk_swift_9433: 'Colocaciones interbancarias de corto plazo del exterior',
      pk_swift_9434: 'Colocaciones interbancarias de corto plazo en Pakistán — Bancos islámicos',
      pk_swift_9435: 'Colocaciones interbancarias de corto plazo del exterior — Bancos islámicos',
      pk_swift_9441: 'Préstamos comerciales de corto plazo del exterior por bancos',
      pk_swift_9442: 'Préstamos comerciales de corto plazo en Pakistán por bancos',
      pk_swift_9443: 'Préstamos comerciales de corto plazo del exterior por bancos islámicos',
      pk_swift_9444: 'Préstamos comerciales de corto plazo en Pakistán por bancos islámicos',
      pk_swift_9445: 'Préstamos comerciales de corto plazo del exterior por NBFI',
      pk_swift_9448: 'Otros préstamos de corto plazo del exterior',
      pk_swift_9451: 'Depósitos en FCBU del SBP / Refinanciamiento de exportaciones',
      pk_swift_9452: 'Depósitos en PKR en el SBP por bancos',
      pk_swift_9453: 'Depósitos NIDA por bancos',
      pk_swift_9454: 'Depósitos NIDA por bancos islámicos',
      pk_swift_9455: 'Depósitos de sucursales de bancos extranjeros en Pakistán',
      pk_swift_9456: 'Depósitos recibidos de personas humanas extranjeras',
      pk_swift_9457: 'Depósitos NRE (Non-Resident External)',
      pk_swift_9458: 'Depósitos NRO (Non-Resident Ordinary)',
      pk_swift_9459: 'Depósitos NREA (Non-Resident External Account)',
      pk_swift_9461: 'Préstamos de largo plazo tomados por bancos del exterior',
      pk_swift_9462: 'Colocaciones de bancos en el exterior — 1 año o más',
      pk_swift_9463: 'Préstamos de largo plazo entre bancos en Pakistán',
      pk_swift_9468: 'Préstamos comerciales de largo plazo del exterior por bancos',
      pk_swift_9469: 'Préstamos comerciales de largo plazo en Pakistán por bancos',
      pk_swift_9470: 'Préstamos comerciales de largo plazo del exterior por bancos islámicos',
      pk_swift_9471: 'Préstamos comerciales de largo plazo en Pakistán por bancos islámicos',
      pk_swift_9472: 'Préstamos comerciales de largo plazo del exterior por NBFI',
      pk_swift_9473: 'Otros préstamos de largo plazo del exterior',
      pk_swift_9474: 'Depósitos interbancarios en moneda extranjera (IBFCD)',
      pk_swift_9475: 'Colocaciones interbancarias de largo plazo en Pakistán',
      pk_swift_9476: 'Colocaciones interbancarias de largo plazo del exterior',
      pk_swift_9477: 'Colocaciones interbancarias de largo plazo en Pakistán — Bancos islámicos',
      pk_swift_9478: 'Colocaciones interbancarias de largo plazo del exterior — Bancos islámicos',
      pk_swift_9479: 'Préstamos subordinados de bancos en el exterior',
      pk_swift_9481: 'Transferencias de la Comisión Nacional de Finanzas (NFC Award)',
      pk_swift_9482: 'Subvenciones de apoyo presupuestario',
      pk_swift_9483: 'Transferencias relacionadas con impuestos',
      pk_swift_9484: 'Subvenciones gubernamentales no clasificadas',
      pk_swift_9491: 'Pakistan Investment Bonds (PIBs)',
      pk_swift_9492: 'Letras del Tesoro (T-Bills)',
      pk_swift_9493: 'Market Treasury Bills (MTBs)',
      pk_swift_9494: 'Eurobonos emitidos por Pakistán',
      pk_swift_9501: 'Inversión directa paquistaní en el exterior — Acciones',
      pk_swift_9502: 'Préstamos intercompany a afiliadas en el exterior',
      pk_swift_9503: 'Desinversión en el exterior',
      pk_swift_9521: 'NFCBA — Crédito no basado en fondos a bancos en el exterior',
      pk_swift_9522: 'Compra de acciones / títulos de empresas extranjeras',
      pk_swift_9523: 'Compra de letras del tesoro de gobiernos extranjeros',
      pk_swift_9524: 'Compra de títulos del tesoro de gobiernos extranjeros',
      pk_swift_9525: 'Compra de certificados de depósito (CDs) de bancos extranjeros',
      pk_swift_9526: 'Compra de fondos comunes / unit trusts por residentes',
      pk_swift_9527: 'Compra de otros instrumentos de cartera de no residentes',
      pk_swift_9528: 'Colocaciones de corto plazo en bancos extranjeros (hasta 1 año)',
      pk_swift_9529: 'Colocaciones de corto plazo en bancos extranjeros (1 a 3 meses)',
      pk_swift_9530: 'Colocaciones de corto plazo en bancos extranjeros (3 meses a 1 año)',
      pk_swift_9531: 'Colocaciones de largo plazo en bancos extranjeros (más de 1 año)',
      pk_swift_9532: 'Colocaciones en bancos extranjeros bajo repo — Corto plazo',
      pk_swift_9533: 'Colocaciones en bancos extranjeros bajo repo — Largo plazo',
      pk_swift_9534: 'Cobros de colocaciones en casas de cambio en el exterior',
      pk_swift_9535: 'Ingresos para la Facilidad de Refinanciamiento de Exportaciones (ERF) en el SBP',
      pk_swift_9536: 'Bancos islámicos — Depósitos Murabaha del exterior',
      pk_swift_9537: 'Bancos islámicos — Depósitos Musharaka del exterior',
      pk_swift_9538: 'Bancos islámicos — Depósitos Ijarah del exterior',
      pk_swift_9539: 'Bancos islámicos — Otros depósitos islámicos del exterior',
      pk_swift_9541: 'Venta de acciones en empresas cotizantes',
      pk_swift_9542: 'Venta de cuotapartes de fondos comunes / unit trusts',
      pk_swift_9543: 'Venta de instrumentos de ahorro nacional',
      pk_swift_9544: 'Venta de otros títulos domésticos a no residentes',
      pk_swift_9545: 'Venta de instrumentos islámicos a no residentes — Sukuk',
      pk_swift_9546: 'Venta de instrumentos islámicos a no residentes — Otros',
      pk_swift_9547: 'Venta de acciones en empresas de capital extranjero',
      pk_swift_9548: 'Venta de cuotapartes de fondos extranjeros',
      pk_swift_9549: 'Venta de otros títulos extranjeros',
      pk_swift_9551: 'Remesas de trabajadores — Canales bancarios oficiales',
      pk_swift_9552: 'Remesas de trabajadores — Iniciativa HRI',
      pk_swift_9553: 'Remesas de trabajadores — Casas de cambio',
      pk_swift_9554: 'Remesas de trabajadores — Agencias internacionales',
      pk_swift_9555: 'Manutención familiar desde el exterior',
      pk_swift_9556: 'Regalos personales o herencia del exterior',
      pk_swift_9561: 'Remesas de donación de personas humanas en el exterior',
      pk_swift_9562: 'Dotaciones del exterior',
      pk_swift_9563: 'Herencia del exterior',
      pk_swift_9564: 'Impuestos y tasas del exterior',
      pk_swift_9565: 'Contribuciones previsionales del exterior',
      pk_swift_9566: 'Multas y sanciones del exterior',
      pk_swift_9572: 'Donaciones filantrópicas del exterior',
      pk_swift_9573: 'Ayuda humanitaria del exterior',
      pk_swift_9574: 'Otras transferencias corrientes del exterior',
      pk_swift_9582: 'Transferencias de capital de personas humanas en el exterior',
      pk_swift_9583: 'Transferencias de capital de empresas en el exterior',
      pk_swift_9584: 'Transferencias de capital de gobiernos en el exterior',
      pk_swift_9592: 'Cancelación de deuda',
      pk_swift_9593: 'Adquisición / Enajenación de activos no producidos no financieros',
      pk_swift_9594: 'Subvenciones de inversión del exterior',
      pk_swift_9595: 'Asunción de deuda del exterior',
      pk_swift_9596: 'Otras transferencias de capital del exterior',
      pk_swift_9597: 'Otros cobros de capital no clasificados',
      pk_swift_9602: 'Reembolso de préstamos comerciales de corto plazo a no residentes',
      pk_swift_9605: 'Reembolso de capital de leasing financiero de corto plazo a no residentes',
      pk_swift_9606: 'Reembolso de préstamos sindicados de corto plazo a no residentes',
      pk_swift_9607: 'Reembolso de otros préstamos de corto plazo a no residentes',
      pk_swift_9608: 'Reembolso de préstamos de corto plazo por el SBP a no residentes',
      pk_swift_9609: 'Otras transacciones financieras de corto plazo',
      pk_swift_9612: 'Reembolso de préstamos comerciales de largo plazo a no residentes',
      pk_swift_9613: 'Reembolso de capital de leasing financiero de largo plazo a no residentes',
      pk_swift_9614: 'Reembolso de préstamos sindicados de largo plazo a no residentes',
      pk_swift_9622: 'Reembolso de otros préstamos de largo plazo a no residentes',
      pk_swift_9623: 'Reembolso de préstamos de largo plazo por el SBP a no residentes',
      pk_swift_9624: 'Intereses sobre préstamos de largo plazo a no residentes',
      pk_swift_9625: 'Otras transacciones financieras de largo plazo',
      pk_swift_9637: 'Captaciones de corto plazo de bancos con otros bancos en Pakistán',
      pk_swift_9638: 'Captaciones de corto plazo de bancos en el exterior',
      pk_swift_9641: 'Captaciones de largo plazo de bancos con otros bancos en Pakistán',
      pk_swift_9642: 'Captaciones de bancos contra saldos de cuentas en moneda extranjera',
      pk_swift_9643: 'Swap de moneda extranjera por bancos en Pakistán — 1 año o más (interbancario)',
      pk_swift_9644: 'Swap de moneda extranjera por bancos en Pakistán — 1 año o más (exterior)',
      pk_swift_9645: 'Rescate de colocaciones en Pakistán o el SBP — 1 año o más',
      pk_swift_9646: 'Rescate de colocaciones en bancos en el exterior — 1 año o más',
      pk_swift_9647: 'Captaciones de largo plazo de no bancos en el exterior',
      pk_swift_9648: 'Remesas de participación accionaria de hasta 10% — Cuentas especiales en moneda extranjera',
      pk_swift_9649: 'Remesas de participación accionaria de más de 10% — Cuentas especiales en moneda extranjera',
      pk_swift_9650: 'Préstamos intercompany de corto plazo (participación >= 10%) — Cuentas FCA especiales',
      pk_swift_9651: 'Préstamos del exterior — Cuentas FCA especiales de empresas',
      pk_swift_9652: 'Qarz-e-Hasna (préstamo islámico sin intereses)',
      pk_swift_9653: 'Remesas para compra de inmuebles y negocios por inmigrantes',
      pk_swift_9654: 'Préstamos intercompany de largo plazo (participación >= 10%) — Cuentas FCA especiales',
      pk_swift_9668: 'Seguro de vida — Primas y suplementos de renta de inversión',
      pk_swift_9669: 'Seguro de vida — Siniestros',
      pk_swift_9673: 'Reembolso de misiones diplomáticas paquistaníes en el exterior',
      pk_swift_9674: 'Préstamos externos de corto plazo del gobierno — Servicio de la deuda',
      pk_swift_9675: 'Reembolsos de préstamos de largo plazo con recursos propios',
      pk_swift_9676: 'Reversión — Reembolso de capital de préstamos externos de largo plazo',
      pk_swift_9677: 'Préstamos externos en efectivo — 1 año o más — Servicio de la deuda',
      pk_swift_9678: 'Reversión de remesas para fines especiales',
      pk_swift_9681: 'Exportación de billetes y monedas en moneda extranjera',
      pk_swift_9682: 'Cheques y órdenes bancarias en moneda extranjera — Venta de billetes',
      pk_swift_9693: 'Superávit de agentes de carga y despachantes',
      pk_swift_9694: 'Devolución de saldo por empresas navieras extranjeras en Pakistán',
      pk_swift_9695: 'Devolución de saldo por aerolíneas extranjeras en Pakistán',
      pk_swift_9697: 'Reembolso de créditos de proveedores no sujetos a servicio de la deuda',
      pk_swift_9698: 'Fondos recibidos en Pakistán de FCA offshore propia (Form R)',
      pk_swift_9699: 'Fondos recibidos en FCA onshore de FCA offshore permitida',
      pk_swift_9703: 'Costo de muestras de exportación',
      pk_swift_9707: 'E-commerce — Productos digitales',
      pk_swift_9708: 'E-commerce — Servicios digitales'
    },
    bankAccountCardUi: {
      accountLine: 'Agencia: {agency} Cuenta: {account}{digit}',
      editNotAllowed: 'Cuenta vinculada a un banco con integración. No se permite editar.',
      deleteNotAllowed: 'Cuenta vinculada a un banco con integración. No se permite eliminar.',
      copyAccountData: 'Copiar datos de la cuenta',
      syncAccountData: 'Sincronizar datos de la cuenta',
      deactivateAccount: 'Desactivar cuenta',
      reactivateAccount: 'Reactivar cuenta',
      copyTitle: '🏦 Datos de la cuenta',
      copyBank: 'Banco: {value}',
      copyAgency: 'Agencia: {value}',
      copyAccount: 'Cuenta: {value}',
      copyDigit: 'Dígito: {value}'
    },
    bankAccountProvidersPanelUi: {
      reasons: {
        providerWithoutAccountSync: 'Este proveedor todavía no recibe cuentas bancarias por el sistema.',
        accountInactive: 'Cuenta inactiva',
        missingPixKey: 'Cuenta sin clave PIX. Registre la clave PIX para enviar la cuenta a este proveedor.',
        accountTypeNotSupported: 'Este proveedor no opera este tipo de cuenta.',
        receiverNotApproved: 'El cliente todavía no tiene el registro aprobado en este proveedor. La cuenta puede enviarse después de la aprobación.',
        deactivatedLink: 'La cuenta ya se envió a este proveedor, pero el vínculo local se desactivó y no puede operar. Conciliar consulta la cuenta en el proveedor y reactiva el vínculo.',
        maskedAccountNumber: 'El número de cuenta está incompleto (solo los últimos dígitos). Edite la cuenta e informe el número completo.',
        missingAccountNumber: 'Falta el número de cuenta. Edite la cuenta e informe el número completo.',
        invalidRoutingNumber: 'El routing number debe tener 9 dígitos (número ABA del banco en EE. UU.). Para un banco fuera de EE. UU., registre la cuenta como SWIFT internacional.',
        missingBankName: 'Falta el nombre del banco. Edite la cuenta e informe el banco (al escribir el routing number se completa automáticamente).',
        missingBeneficiaryName: 'Falta el nombre del beneficiario. Edite la cuenta e informe quién recibe.',
        incompleteWireAddress: 'Dirección incompleta para el envío por Wire: falta {fields}. Complete la dirección del banco en la cuenta.',
        foreignWireBankAddress: 'La dirección del banco debe estar en Estados Unidos para el envío por Wire. En "Dirección del banco", informe la dirección de la sucursal en EE. UU. (dirección, ciudad, estado, código postal y país). Si el banco está fuera de EE. UU., registre la cuenta como SWIFT internacional.',
        foreignWireBeneficiaryAddress: 'Para el envío por Wire, la dirección debe estar en Estados Unidos. En "Dirección del banco", informe la dirección de la sucursal en EE. UU. (dirección, ciudad, estado, código postal y país).',
        refused: {
          beneficiaryNameMismatch: 'El proveedor rechazó la cuenta: una cuenta propia debe estar a nombre del cliente. Si la cuenta es de otra persona o empresa, edite la cuenta, ajuste la relación con el titular y envíela de nuevo.',
          pixKeyInvalid: 'El proveedor rechazó la cuenta: la clave PIX no es válida. Verifique que la clave esté activa y escrita sin espacios, y envíela de nuevo.',
          routingNotWire: 'El proveedor rechazó la cuenta: este routing number (ABA) no acepta wire. Confirme con el banco el ABA para wire y envíela de nuevo.',
          dataIncomplete: 'El proveedor rechazó la cuenta: falta un dato obligatorio. Edite la cuenta, complete los campos y envíela de nuevo.',
          customerNotFound: 'El proveedor no encontró el registro del cliente. Reenvíe el registro en Bancos y Límites y luego envíe la cuenta.',
          generic: 'El proveedor rechazó esta cuenta en el último intento. Revise los datos de la cuenta y envíela de nuevo.'
        },
        addressFields: {
          street_line_1: 'dirección',
          city: 'ciudad',
          state: 'estado',
          postal_code: 'código postal',
          country: 'país'
        }
      },
      providers: 'PROVEEDORES',
      syncAll: 'Sincronizar en todos',
      syncAllTooltip: 'Sincronizar esta cuenta en todos los proveedores disponibles',
      noProviders: 'No hay ningún proveedor activo en el sistema.',
      reconcileTooltip: 'Conciliar con el proveedor: consulta la cuenta allá antes de cambiar cualquier cosa',
      syncAfterFix: 'Sincronizar después de corregir el registro',
      syncThisProvider: 'Sincronizar esta cuenta en este proveedor'
    },
    bankTypeInfoCardUi: {
      title: 'Tipos de registro bancario',
      onlineTitle: 'Banco online',
      onlineText: 'Banco con proceso online, que permite el registro y la operación de forma automática.',
      offlineTitle: 'Banco offline',
      offlineText: 'Proceso tradicional de registro y operación con documentación manual por correo electrónico.',
      signatureTitle: 'Banco con firma',
      signatureText: 'El banco requiere la firma digital del cliente en un formulario específico, con registro y operaciones offline.'
    },
    customerBankUi: {
      notSent: 'No enviado'
    },
    customerBankSelectUi: {
      inactive: '(Inactivo)',
      online: 'Online',
      digitalSignature: 'Firma digital',
      offline: 'Offline'
    },
    customerContactFormDialogUi: {
      editTitle: 'Editar contacto',
      addTitle: 'Agregar contacto',
      fullName: 'Nombre completo *',
      role: 'Función / Cargo',
      department: 'Departamento *',
      customDepartment: 'Nombre del departamento *',
      email: 'Correo electrónico *',
      duimpEmailPrimary: 'Correo electrónico principal DUIMP/DU-E',
      duimpEmailSecondary: 'Correo electrónico secundario DUIMP/DU-E',
      cellphone: 'Celular',
      landline: 'Teléfono fijo',
      notes: 'Observaciones',
      isPrimary: 'Contacto principal del departamento',
      nameMaxLength: 'El nombre debe tener como máximo 255 caracteres',
      roleMaxLength: 'La función debe tener como máximo 100 caracteres',
      customDepartmentMaxLength: 'El departamento personalizado debe tener como máximo 100 caracteres',
      notesMaxLength: 'Las observaciones deben tener como máximo 500 caracteres'
    },
    customerContactListUi: {
      noDepartment: 'Sin departamento'
    },
    customerDirectorsProxiesUi: {
      title: 'Directores y apoderados',
      hasDirectorsQuestion: '¿La empresa tiene directores o apoderados?'
    },
    customerDuimpDueEmailsNotificationsUi: {
      title: 'Notificaciones de DUIMP/DU-E',
      primaryEmail: 'Correo electrónico principal',
      secondaryEmail: 'Correo electrónico secundario'
    },
    customerExchangeBankModalUi: {
      editTitle: 'Editar banco',
      addTitle: 'Agregar banco',
      bankTypesInfo: 'Información sobre los tipos de banco',
      remittanceDescription: 'Operaciones de remesa al exterior',
      tourismDescription: 'Operaciones de turismo y viajes',
      defaultDescription: 'Operación de cambio',
      bankInactive: 'Este banco está inactivo y no se puede usar'
    },
    customerProviderSendingProgressUi: {
      analyzingTitle: 'Analizando los datos del cliente',
      analyzingSubtitle: 'Revisando el registro guardado',
      documentsTitle: 'Verificando los documentos',
      documentsSubtitle: 'Revisando la autenticidad de los archivos',
      sendingTitle: 'Enviando a los bancos asociados',
      sendingSubtitle: 'Esperando la respuesta de cada uno',
      extendedTitle: 'Los bancos asociados todavía están respondiendo',
      extendedSubtitle: 'Esto puede tardar unos segundos más'
    },
    customerExchangeBanksUi: {
      sendLimitApprovalTitle: '¿Enviar la aprobación de límite?',
      sendLimitApprovalMessage: '¿Querés enviarle al cliente la aprobación de límite?',
      bankFallback: 'Banco',
      bankFallbackLower: 'banco',
      thisCustomer: 'este cliente',
      resyncMessage: '<p>Vamos a consultar <b>{bankName}</b> con los datos de <b>{customerName}</b>:</p><ul><li>Verificamos si este registro ya existe dentro del banco;</li><li>Sincronizamos la información de límites operativos para este cliente.</li></ul>',
      noExpiration: 'SIN VENCIMIENTO DEFINIDO',
      naturesCount: '{count} naturaleza | {count} naturalezas',
      inactiveBankSuffix: '{status} (banco inactivo)',
      unknownStatus: 'Estado desconocido',
      dolspayUpdated: 'Registro DolsPay actualizado',
      dolspayPending: 'Se detectaron pendientes en el registro DolsPay',
      dolspayFailed: 'Registro DolsPay no completado'
    },
    customerInternationalBankModalUi: {
      editTitle: 'Editar cuenta bancaria',
      addTitle: 'Agregar cuenta bancaria',
      paymentMethod: 'Método de pago',
      otherMethodsHint: 'Otros métodos quedan disponibles cuando el cliente tiene un banco digital en la pestaña Bancos y límites.',
      continue: 'Continuar',
      rtpRoutingHint: 'Este número de ruteo permite guardar como RTP.'
    },
    customerOperationNatureSelectUi: {
      label: 'Naturaleza de la operación',
      noResults: 'No se encontró ninguna naturaleza para la búsqueda',
      selectBankFirst: 'Seleccioná un banco para ver las naturalezas disponibles',
      selectedCount: '{count} naturalezas seleccionadas'
    },
    customerPartnersUi: {
      nestedTitle: 'Registro del socio - {name}',
      viewFallback: 'Visualización',
      link: 'Vincular'
    },
    customerPartnersShareholdersUi: {
      title: 'Socios y accionistas'
    },
    customerPaymentAccountModalUi: {
      editTitle: 'Editar cuenta de pago',
      addTitle: 'Agregar cuenta de pago'
    },
    customerPaymentAccountsUi: {
      sectionTitle: 'Cuentas para pago',
      sameOwnership: 'Misma titularidad',
      emptyTitle: 'No hay cuentas para pago',
      emptySubtitle: 'Hacé clic en Agregar para registrar una cuenta de la misma titularidad.',
      deleteMessage: '¿Realmente querés eliminar esta cuenta para pago?',
      deleteTitle: '¿Eliminar cuenta de pago?',
      deactivateTitle: 'Desactivar cuenta para pago',
      deactivateMessage: 'Al desactivar esta cuenta, ya no va a aparecer como opción al crear nuevas operaciones. Los registros históricos se conservan.'
    },
    customerPoliticallyExposedPersonUi: {
      subtitle: 'Persona expuesta políticamente'
    },
    customerPreRegistrationModalUi: {
      title: 'Enviá un pre-registro por correo electrónico',
      registerType: 'Tipo de registro',
      fullName: 'Nombre completo',
      phone: 'Teléfono',
      sendByEmail: 'Enviar por correo electrónico',
      exchangeDescription: 'Operaciones de turismo y viajes',
      basicRemittanceDescription: 'Remesas básicas al exterior',
      completeRemittanceDescription: 'Remesas completas al exterior',
      legalPersonDescription: 'Persona jurídica y empresas',
      defaultDescription: 'Registro de cliente'
    },
    customerRegistrationResponsibleUi: {
      title: 'Responsable del registro'
    },
    customerSendDocumentsModalUi: {
      title: 'Enviar documentos',
      stepCustomerDocs: 'Documentos del cliente',
      stepOperationalDocs: 'Documentos complementarios',
      stepPartnersDocs: 'Documentos de los socios',
      stepSummary: 'Resumen',
      cancelConfirmMessage: '¿Seguro que querés cancelar el envío de los documentos? Se van a perder todas las selecciones.',
      partnerFallback: 'Socio',
      loadCustomerDocsError: 'No fue posible cargar los documentos del cliente. Actualizá la página (F5) e intentá de nuevo; si continúa, comunicate con soporte.',
      loadOperationalDocsError: 'No fue posible cargar los documentos complementarios. Actualizá la página (F5) e intentá de nuevo; si continúa, comunicate con soporte.',
      complementNumber: '{type} - Compl. {number}',
      downloadCustomerDocError: 'No fue posible descargar el documento del cliente. Intentá descargarlo de nuevo; si continúa, comunicate con soporte.',
      downloadOperationalDocError: 'No fue posible descargar el documento complementario. Intentá descargarlo de nuevo; si continúa, comunicate con soporte.',
      downloadPartnerDocError: 'No fue posible descargar el documento del socio. Intentá descargarlo de nuevo; si continúa, comunicate con soporte.'
    },
    customerSpreadsUi: {
      partnerFeeTitle: 'Spread predeterminado para stablecoin',
      partnerFeeLabel: 'Spread',
      partnerFeeHint: 'Vale para las operaciones con stablecoin de este cliente: viene completado en la operación y se puede cambiar allí si hace falta. Los spreads de bancos tradicionales están abajo.',
      sectionTitle: 'Spread de remesa',
      notFoundTitle: 'No se encontró ningún spread',
      emptyTitle: 'No hay spreads registrados',
      notFoundSubtitle: 'No se encontró ningún spread para la búsqueda.',
      emptySubtitle: 'Hacé clic en Agregar para empezar.',
      sell: 'Venta',
      buy: 'Compra',
      min: 'Mín',
      rec: 'Rec',
      max: 'Máx',
      minSell: 'Spread mínimo venta(%)',
      recSell: 'Spread recomendado venta(%)',
      maxSell: 'Spread máximo venta(%)',
      minBuy: 'Spread mínimo compra(%)',
      recBuy: 'Spread recomendado compra(%)',
      maxBuy: 'Spread máximo compra(%)'
    },
    customerStablecoinReceiverUi: {
      title: 'Receiver (KYC/AML)',
      receiverId: 'ID del receiver',
      kycLevel: 'Nivel KYC',
      createdAt: 'Fecha de creación',
      updatedAt: 'Última actualización',
      sync: 'Sincronizar',
      notFound: 'No se encontró un receiver para este cliente.',
      statusRejected: 'Rechazado',
      statusUnderReview: 'En análisis'
    },
    customerSummaryHeaderUi: {
      customerPhoto: 'Foto del cliente',
      importedExternalId: 'Cliente importado con ID externo {externalId}',
      copyDocument: 'Copiar {document}',
      cellphone: 'Celular:',
      copyCellphone: 'Copiar celular',
      reactivate: 'Reactivar registro',
      operateTourism: 'Operar Turismo',
      operateRemittance: 'Operar Remesa',
      upgradeRegistration: 'Avanzar registro',
      statusOnDate: '{description} el {date}',
      updatedAt: 'Actualizado el {date}'
    },
    customerTypeSelectorUi: {
      question: '¿Qué tipo de registro querés hacer?'
    },
    customerUpgradeExchangeToBasicModalUi: {
      birthplace: 'Lugar de nacimiento',
      sendReason: 'Motivo del envío'
    },
    customerUpgradeRegistrationModalUi: {
      invalidValue: 'Ingresá un valor válido'
    },
    customerUserAgreementUi: {
      title: 'Acuerdo de usuario',
      attention: 'ATENCIÓN: AL CONTINUAR CON EL REGISTRO, ESTÁS ACEPTANDO LOS SIGUIENTES TÉRMINOS:',
      agree: 'Acepto los términos',
      termsNotConfigured: 'Términos no configurados.',
      termsNotFound: 'No se encontraron los términos.',
      termsLoadError: 'No fue posible cargar los términos.'
    },
    customerWorkUi: {
      title: 'Trabajo'
    },
    documentGenerationStepperUi: {
      title: 'Generar documento',
      loadTemplatesError: 'No fue posible cargar las plantillas disponibles.',
      noTemplates: 'No hay plantillas disponibles para generar documentos.',
      incomeTaxTemplateName: 'Extracto para Impuesto a las Ganancias',
      incomeTaxTemplateDescription: 'Operaciones liquidadas en el año, agrupadas por banco',
      stepSelectDocument: 'Seleccionar documento',
      stepFillData: 'Completar datos',
      stepPreview: 'Vista previa y confirmar',
      generateAndSave: 'Generar y guardar',
      next: 'Siguiente',
      previewError: 'No fue posible generar la vista previa del documento. Intentá de nuevo.'
    },
    documentsSelectionTableUi: {
      uploadDate: 'Fecha de carga',
      selectAll: 'Seleccionar todos ({count}/{total})',
      noDocuments: 'Ningún documento',
      complementNumber: '{type} - Compl. {number}'
    },
    exchangeTypeSelectorUi: {
      operationType: 'Tipo de operación'
    },
    incomeTaxStatementFieldsUi: {
      year: 'Año',
      layout: 'Modelo'
    },
    internationalBankAccountCardUi: {
      resyncStatus: 'Volver a sincronizar estado',
      sendToIntegrator: 'Enviar al integrador bancario',
      beneficiary: 'Beneficiario',
      copyAccountData: 'Copiar datos de la cuenta',
      deactivateAccount: 'Desactivar cuenta',
      reactivateAccount: 'Reactivar cuenta',
      copyTitle: '🏦 Datos de la cuenta en el exterior',
      copyBank: 'Banco: {value}',
      copyName: 'Nombre: {value}',
      copyOwner: 'Titular: {value}',
      copyType: 'Tipo: {value}',
      copySwift: 'Código Swift/BIC: {value}',
      copyRouting: 'Número ABA/Routing: {value}',
      copyFfc: 'FFC (For Further Credit): {value}'
    },
    pdfPreviewUi: {
      generating: 'Generando la vista previa del documento...'
    },
    resyncResultModalUi: {
      title: 'Resultado de la nueva sincronización',
      subEntities: 'Subentidades',
      documents: 'Documentos',
      statusSuccess: 'Éxito',
      statusSkipped: 'Omitido',
      statusFailed: 'No completado'
    },
    sepaFormUi: {
      examplePlaceholder: 'Ej.: {example}'
    },
    thirdPartyFormUi: {
      fullName: 'Nombre completo',
      nationality: 'Nacionalidad',
      maritalStatus: 'Estado civil',
      street: 'Calle'
    },
    unblockOnboardingModalUi: {
      title: 'Registro en {provider}',
      resendTitle: 'Lo que el cliente necesita reenviar:',
      shareLinkText: 'Compartí este enlace con el cliente para que complete la verificación de identidad (KYC) vía Sumsub:',
      verificationLinkLabel: 'Enlace de verificación KYC',
      copyLink: 'Copiar enlace',
      openInNewTab: 'Abrir en una pestaña nueva',
      linkPending: '{provider} va a generar el enlace de verificación en breve. Volvé a verificar más tarde.',
      checkError: 'No fue posible verificar los requisitos ahora. Podés intentar iniciar el onboarding de todos modos, pero el proveedor puede pedir ajustes en el registro durante el proceso.',
      pendingIntro: 'Para iniciar el onboarding en {provider}, corregí los ítems de abajo:',
      goToPartners: '→ Ir a la pestaña Socios',
      rejectedBanner: '{provider} rechazó el registro de este cliente de forma definitiva.',
      reasonTitle: 'Motivo informado:',
      reonboardText: 'Corregí la ficha del cliente y confirmá: se crea un registro nuevo en {provider} con los datos actuales y se genera un nuevo enlace de verificación.',
      notLinkedBanner: 'Este cliente todavía no está vinculado a {provider}.',
      confirmText: 'Al confirmar, el cliente se va a registrar en {provider} y se va a generar un enlace de verificación de identidad (KYC).',
      reonboard: 'Volver a registrar',
      confirmAnyway: 'Confirmar de todos modos',
      correctionRequested: '{provider} pidió una corrección. Enviale al cliente el enlace de abajo para que reenvíe los documentos.',
      alreadyLinked: 'Este cliente ya está vinculado a {provider}, pero todavía no fue aprobado.',
      registeredSuccess: 'Registro realizado con éxito en {provider}.',
      onboardError: 'El registro no se vinculó a {provider}. Revisá los datos del cliente e intentá de nuevo; si continúa, comunicate con soporte.',
      linkExpiresAt: 'Este enlace vale hasta el {date}.',
      linkExpired: 'Este enlace venció el {date}. Generá uno nuevo y envialo al cliente.',
      renewLink: 'Generar nuevo enlace',
      renewAvailableAfter: 'Disponible cuando este enlace venza (3 días después de generado).',
      renewSuccess: 'Nuevo enlace generado. Envialo al cliente.',
      renewError: 'No fue posible generar un nuevo enlace ahora. Intentá de nuevo en unos instantes.'
    },
    formCustomerUi: {
      externalSubtitle: 'Su información se guardará temporalmente en este dispositivo hasta que termine su registro.',
      bankPendingTitle: 'Pendientes con el banco',
      divergentDateTitle: 'Socio con fecha divergente:',
      divergentDateInformedBy: 'la fecha informada por',
      divergentDateDetail: 'fue {informed}, pero la fecha registrada en el sistema es {system}. Verifique cuál dato es el correcto y actualícelo manualmente.',
      missingRegisterType: 'Este cliente no tiene tipo de registro, por eso no se puede mostrar el formulario. Contacte al soporte técnico e informe el ID del cliente.',
      saveAndExit: 'Guardar y salir',
      requestRegistrationUpdate: 'Solicitar actualización del registro',
      requestForeignAccount: 'Solicitar registro de cuenta en el exterior',
      fieldRequired: '{label}: campo obligatorio',
      reviewHighlightedFields: 'Revise los campos destacados antes de enviar al banco.',
      dateNotInformed: 'no informada'
    },
    partnersShareholdersUi: {
      colActions: 'Acciones',
      partnerNameSuffix: '{name} (socio)',
      defaultPartnerName: 'socio',
      partnerDocumentsTitle: 'Documentos de {name}'
    },
    partnerDialogUi: {
      titleLabel: 'Cargo/Función',
      nestedPartnersTitle: 'Socios de este socio (PJ)',
      incompleteDate: 'Fecha incompleta',
      invalidDate: 'Fecha inválida',
      dataMismatch: 'Los datos ingresados no coinciden o no son válidos.'
    },
    partnerWizardUi: {
      docIdentification: 'Documento de identidad',
      docAddressProof: 'Comprobante de domicilio'
    },
    cover: {
      sectionTitle: 'Información inicial'
    },
    contact: {
      sectionTitle: 'Información de contacto'
    },
    address: {
      sectionTitle: 'Dirección'
    },
    compliance: {
      sectionTitle: 'Compliance'
    },
    financial: {
      sectionTitle: 'Datos bancarios en Brasil',
      requiredAccount: 'Es necesario registrar al menos 1 cuenta'
    },
    documents: {
      title: 'Documentos',
      titleLegalPerson: 'Documentos de la Empresa',
      searchPlaceholder: 'Buscar por tipo de documento'
    },
    brazilianBank: {
      sectionTitle: 'Cuentas en Brasil',
      requiredAccount: 'Es necesario registrar al menos 1 cuenta',
      add: 'Agregar',
      emptyTitle: 'Ninguna cuenta bancaria en Brasil',
      emptySubtitle: 'Haga clic en Agregar para registrar una cuenta (PIX, agencia y cuenta).',
      deleteConfirmMessage: '¿Desea realmente eliminar esta cuenta bancaria?',
      deleteConfirmTitle: '¿Eliminar cuenta bancaria?',
      deleteButton: 'Eliminar',
      deactivateTitle: 'Inactivar cuenta bancaria',
      deactivateMessage: 'Al inactivar esta cuenta, ya no aparecerá como opción al crear nuevas operaciones. Los registros históricos se mantienen.',
      deactivateButton: 'Inactivar',
      cancelButton: 'Cancelar',
      syncTempError: 'No fue posible sincronizar con DolsPay en este momento. Intente nuevamente en unos instantes.',
      syncInvalidCharsError: 'Solo se permiten letras, números, espacios y guiones. Revise el nombre del beneficiario y elimine caracteres especiales (acentos, puntos, barras, etc).',
      syncSaveError: 'La cuenta fue guardada, pero DolsPay no aceptó la sincronización: {message}. Corrija el dato indicado y haga clic en Sincronizar.',
      syncFailed: 'No fue posible sincronizar esta cuenta con DolsPay. Revise los datos bancarios e intente de nuevo.',
      syncNotSynced: 'La cuenta fue guardada, pero no fue sincronizada con DolsPay. Haga clic en Sincronizar; si persiste, contacte al soporte.',
      saveBeforeSync: 'Guarde el cliente antes de sincronizar cuentas con DolsPay.',
      alreadyIntegrated: 'Esta cuenta ya está integrada con DolsPay.',
      syncGenericError: 'No fue posible sincronizar cuentas con DolsPay. Intente de nuevo.',
      reactivateSuccess: 'Cuenta reactivada exitosamente.',
      deactivateSuccess: 'Cuenta inactivada exitosamente.',
      toggleStatusError: 'El estado de la cuenta no fue modificado. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
      deleteWithDolspayError: 'Cuenta eliminada, pero DolsPay no confirmó: {message}',
      deleteSuccess: 'Cuenta eliminada exitosamente.',
      deleteError: 'La cuenta no fue eliminada. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.'
    },
    internationalBank: {
      sectionTitle: 'Cuentas en el exterior',
      add: 'Agregar',
      emptyTitle: 'Ninguna cuenta en el exterior',
      emptySubtitle: 'Haga clic en Agregar para registrar una cuenta internacional.',
      deleteConfirmTitle: '¿Eliminar cuenta?',
      deleteConfirmYes: 'Sí',
      deleteConfirmMessageDolspay: 'Esta cuenta también se eliminará en DolsPay. ¿Desea continuar?',
      deleteConfirmMessage: '¿Desea realmente eliminar esta cuenta en el exterior?',
      deactivateTitle: 'Inactivar cuenta bancaria',
      deactivateMessage: 'Al inactivar esta cuenta, ya no aparecerá como opción al crear nuevas operaciones. Los registros históricos se mantienen.',
      deactivateButton: 'Inactivar',
      cancelButton: 'Cancelar',
      bankTypeWire: 'Wire doméstico',
      bankTypeSwift: 'SWIFT internacional',
      bankTypeAch: 'ACH',
      bankTypeRtp: 'RTP Instantáneo',
      bankTypeTransfers3: 'Transfers 3.0',
      bankTypeAchColombia: 'ACH Colombia',
      bankTypeSpei: 'SPEI',
      bankTypeSepa: 'SEPA EUR',
      bankTypeFasterPayments: 'Faster Payments GBP',
      saveBeforeSync: 'Guarde el cliente antes de enviar al integrador bancario.',
      documentRequired: 'El número de documento debe ser completado antes del envío al integrador.',
      noIntegrationBank: 'No se encontró banco de integración elegible para este cliente.',
      syncBankingSuccess: 'Cuenta internacional enviada al integrador exitosamente',
      syncStatusSuccess: 'Estado de integración actualizado exitosamente',
      saveBeforeSyncDolspay: 'Guarde el cliente antes de sincronizar cuentas con DolsPay.',
      syncTempError: 'No fue posible sincronizar con DolsPay en este momento. Intente nuevamente en unos instantes.',
      syncAccessDeniedError: 'Sincronización de cuenta en el exterior no disponible para su perfil. Contacte al soporte si necesita este recurso.',
      syncInvalidCharsError: 'Solo se permiten letras, números, espacios y guiones. Revise el nombre del beneficiario y elimine caracteres especiales (acentos, puntos, barras, etc).',
      syncInvalidSwiftCode: 'El registro del banco no pudo integrarse con DolsPay porque el "Código de pago SWIFT" tiene un valor inválido. Haga clic en el ícono de editar del banco, localice el campo "Código de pago SWIFT", seleccione una de las opciones de la lista (ej: Comercio de mercancías, Servicios, Remesa personal) y guarde nuevamente.',
      syncSaveError: 'La cuenta fue guardada, pero DolsPay no aceptó la sincronización: {message}. Corrija el dato indicado y haga clic en Sincronizar.',
      syncFailed: 'No fue posible sincronizar esta cuenta con DolsPay. Revise los datos bancarios e intente de nuevo.',
      syncGenericError: 'No fue posible sincronizar cuentas con DolsPay. Intente de nuevo.',
      syncSuccess: 'Sincronización con DolsPay realizada exitosamente.',
      alreadyIntegrated: 'Esta cuenta ya está integrada con DolsPay.',
      reactivateSuccess: 'Cuenta reactivada exitosamente.',
      deactivateSuccess: 'Cuenta inactivada exitosamente.',
      toggleStatusError: 'El estado de la cuenta no fue modificado. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
      deleteWithDolspayError: 'Cuenta eliminada, pero DolsPay no confirmó: {message}',
      deleteSuccess: 'Cuenta eliminada exitosamente.',
      deleteError: 'La cuenta no fue eliminada. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.'
    },
    exchangeBanks: {
      sectionTitle: 'Bancos/Naturalezas y Límites',
      searchLabel: 'Buscar',
      addBank: 'Agregar Banco',
      limitAvailable: 'Límite disponible',
      percentUsed: '% utilizado',
      available: 'Disponible',
      labelIn: 'ENTRADA',
      labelOut: 'SALIDA',
      notConfigured: 'No configurado',
      validity: 'VALIDEZ: {date}',
      editTooltip: 'Editar',
      viewPendings: 'Ver Pendencias',
      emptyTitleNoSearch: 'Ningún banco vinculado',
      emptyTitleSearch: 'Ningún banco encontrado',
      emptySubtitleNoSearch: 'Haga clic en Agregar Banco para comenzar.',
      emptySubtitleSearch: 'Ningún banco encontrado para la búsqueda.',
      addBankButton: 'Agregar banco',
      limitApprovedTitle: 'Límite aprobado',
      inputValueIn: 'Valor Entrada',
      inputValueOut: 'Valor Salida',
      inputValue: 'Valor',
      inputExpireAt: 'Fecha de Vencimiento',
      saveButton: 'Guardar',
      cancelButton: 'Cancelar',
      pendingReqTitle: 'Requisitos pendientes',
      closeButton: 'Cerrar',
      signatureTitle: 'Firma digital',
      signatureMessage: '¿Desea enviar la ficha de registro para firma digital del cliente?',
      signatureYes: 'Sí',
      signatureNo: 'No',
      blockBankTitle: 'Bloquear banco',
      blockBankMessage: 'El banco será bloqueado y no podrá ser utilizado en nuevas operaciones.',
      blockReasonLabel: 'Motivo (opcional)',
      blockReasonPlaceholder: 'Describa el motivo del bloqueo, si es necesario',
      blockButton: 'Bloquear',
      resyncTitle: 'Sincronizar datos con {bankName}?',
      resyncButton: 'Sincronizar',
      integrationFallbackTitle: 'Integración bancaria no completada',
      integrationFallbackMessage: 'La integración bancaria no fue completada. ¿Desea mantener el banco registrado por el flujo manual?',
      foreignIntegrationTitle: 'Integración en línea no disponible',
      foreignIntegrationMessage: 'El proceso de integración en línea no está disponible para clientes extranjeros. El registro se realizará por el flujo offline.',
      foreignIntegrationButton: 'Entendido',
      actions: {
        changeLimit: 'Cambiar Límite',
        customerLimits: 'Límites del cliente',
        requestIncrease: 'Solicitar aumento',
        sendBankUpdate: 'Enviar Actualización al Banco',
        generateRegisterForm: 'Generar Ficha de Registro',
        resendRegisterForm: 'Reenviar Ficha de Registro',
        statement: 'Extracto de movimientos',
        integrate: 'Integrar',
        resync: 'Resincronizar datos con el banco',
        inactiveBank: 'Banco inactivo en la lista de bancos: bloqueado para todos los clientes',
        unblockBank: 'Desbloquear banco',
        blockBank: 'Bloquear banco'
      },
      messages: {
        missingCompanyName: 'Razón social no completada',
        missingCnpj: 'CPF/CNPJ no completado',
        docsWithoutCountry: 'Existen documentos sin país definido',
        missingSelfie: 'Selfie del cliente no enviada. Genere el enlace de la selfie en la pestaña Documentos y envíelo al cliente.',
        bankBlockedSuccess: '{bankName} bloqueado exitosamente.',
        bankBlockError: 'No fue posible bloquear el banco. Intente de nuevo.',
        bankUnblockError: 'No fue posible desbloquear el banco. Intente de nuevo.',
        preRegInProgress: 'Ya existe un pre-registro en curso. Aguarde un momento.',
        checkReadinessError: 'No pudimos verificar si el cliente puede ser enviado a este banco. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
        sendToBankDigitalError: 'No fue posible enviar el registro del cliente al banco digital. Revise los documentos del cliente e intente de nuevo; si persiste, contacte al soporte.',
        bankRemovedError: 'No fue posible eliminar el banco. Recargue la página.',
        integratedSuccess: '¡Cliente integrado exitosamente!',
        notSentToBank: 'El registro no fue enviado al banco. Verifique si los datos obligatorios están completos e intente de nuevo.',
        resyncSuccess: 'Datos del cliente resincronizados exitosamente',
        resyncError: 'Los datos del cliente no fueron actualizados en el banco. Intente de nuevo en unos instantes; si persiste, contacte al soporte.',
        bankUpdateError: 'El banco del cliente no fue actualizado. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
        loadBanksError: 'No fue posible cargar la lista de bancos. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
        loadNaturesError: 'No fue posible cargar las naturalezas de operación. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
        loadExchangeTypesError: 'No fue posible cargar los tipos de cambio. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
        limitBankNotFound: 'Datos del banco no encontrados. No fue posible agregar el límite.',
        limitAddedSuccess: '¡Límite agregado exitosamente!',
        limitSaveError: 'No fue posible guardar el límite del cliente. Verifique los valores e intente de nuevo; si persiste, contacte al soporte.',
        limitApprovalSentSuccess: '¡Aprobación de límite enviada exitosamente!',
        limitApprovalSentError: 'No fue posible enviar la aprobación de límite al cliente. Intente de nuevo en unos instantes; si persiste, contacte al soporte.',
        emailUpdateSuccess: '¡Email de actualización de registro enviado al banco exitosamente!',
        bankRegisterUpdateError: 'No fue posible enviar la actualización de registro al banco. Intente de nuevo en unos instantes; si persiste, contacte al soporte.',
        processingInProgress: 'Procesamiento en curso. Actualice la página en instantes.',
        tosAcceptedMessage: 'Términos aceptados. El registro será enviado a {providerName} en instantes.',
        dolsPayBankNotFound: 'Banco DolsPay no encontrado en la lista de bancos disponibles.',
        digitalNatureNotFound: 'Naturaleza de operación digital no encontrada. Intente de nuevo.',
        registerResendSuccess: 'Registro reenviado al banco exitosamente',
        registerResendFailure: 'Reenvío no completado. Intente de nuevo.',
        registerResendInitiated: 'Reenvío iniciado. Aguarde la confirmación.',
        resendNotIdentified: 'No fue posible identificar el cliente. Intente desde la pantalla de edición del registro.',
        resendError: 'El registro no fue reenviado al banco. Verifique las pendencias del cliente e intente de nuevo.',
        checkCustomerDataError: 'No pudimos verificar los datos del cliente. Revise el registro e intente de nuevo.',
        integrationCompleteReloadError: 'Integración completada, pero no fue posible actualizar los datos en pantalla. Recargue la página.',
        downloadingAttachment: 'Descargando adjunto',
        downloadAttachmentError: 'No fue posible descargar el adjunto. Verifique si hay un template vinculado a este banco.',
        limitsLoadError: 'Los límites del cliente no cargaron. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.'
      }
    },
    contactList: {
      saveBefore: 'Guarde el registro del cliente antes de agregar contactos.',
      addContact: 'Agregar contacto',
      filterByDepartment: 'Filtrar por departamento',
      searchLabel: 'Buscar',
      emptyTitle: 'Ningún contacto registrado',
      emptySubtitle: 'Agregue contactos para registrar las personas de cada departamento del cliente.',
      emptySearchTitle: 'Ningún contacto encontrado',
      emptySearchSubtitle: 'Ningún contacto corresponde a los filtros aplicados.',
      deleteTitle: '¿Eliminar contacto?',
      messages: {
        loadError: 'No fue posible cargar los contactos. Actualice la página (F5) e intente de nuevo; si persiste, contacte al soporte.',
        deleteSuccess: 'Contacto eliminado exitosamente.',
        deleteError: 'No fue posible eliminar el contacto. Intente de nuevo en unos instantes; si persiste, contacte al soporte.',
        deleteMessage: '¿Desea eliminar el contacto {name} del departamento {dept}?'
      }
    },
    partners: {
      sectionTitle: 'Socios',
      addButton: 'Agregar',
      linkButton: 'Vincular cliente registrado',
      searchLabel: 'Buscar',
      emptyTitleNoSearch: 'Ningún socio registrado',
      emptyTitleSearch: 'Ningún socio encontrado',
      emptySubtitleNoSearch: 'Haga clic en Agregar para comenzar.',
      emptySubtitleSearch: 'Ningún socio encontrado para la búsqueda.',
      personTypeLegal: 'Persona Jurídica',
      personTypePhysical: 'Persona Física',
      fieldCpfCnpj: 'CPF/CNPJ',
      fieldCellphone: 'Celular',
      fieldEmail: 'E-mail',
      fieldShare: 'Participación',
      tooltipDocuments: 'Ir a documentos',
      tooltipEdit: 'Editar',
      tooltipDelete: 'Eliminar',
      linkModalTitle: 'Vincular socio',
      sharePercent: '% de participación',
      messages: {
        loadPartnerError: 'El registro del socio (cliente {id}) no cargó. Actualice la página e intente de nuevo.',
        requiredFields: 'Por favor, complete todos los campos obligatorios.',
        saveError: 'El socio no fue guardado. Verifique nombre, documento y participación e intente de nuevo; si persiste, contacte al soporte.',
        saveSuccess: 'Socio guardado exitosamente',
        nestedSaveError: 'No fue posible guardar el socio. Intente de nuevo.',
        partnerAdded: '¡Socio del socio vinculado agregado!',
        nestedPartnerAdded: '¡Socio del socio agregado!',
        nestedPartnerUpdated: '¡Socio del socio actualizado exitosamente!',
        partnerShareSum: 'La suma de las participaciones de los socios de este socio debe ser 100%. Actual: {value}%',
        partnerShareOverflow: 'La suma de las participaciones no puede superar el 100%. Actual: {value}%.',
        deleteNestedTitle: '¿Eliminar socio?',
        deleteNestedMessage: '¿Desea realmente eliminar este socio del socio?',
        removeLinkedTitle: '¿Remover socio de la empresa?',
        removeLinkedMessage: '¿Desea remover este socio de la empresa seleccionada? Al confirmar, el socio será desvinculado de la empresa seleccionada pero el registro como cliente continuará activo en el sistema.',
        removeMessage: '¿Desea remover este socio?',
        cancelTitle: '¿Cancelar?',
        cancelEditMessage: 'Hay datos completados, ¿desea realmente cancelar la edición?',
        cancelNewMessage: 'Hay datos completados, ¿desea realmente cancelar el registro?',
        nestedDocumentsSaveError: 'Algunos documentos no fueron guardados. Acceda a la ficha del socio y reenvíe los documentos pendientes.',
        nestedUpdatedWarning: 'Los datos actualizados del socio no cargaron; mostrando los datos de esta pantalla. Actualice la página para ver la versión más reciente.',
        customerNotFound: 'Cliente no encontrado por documento, creando nuevo registro',
        nestedDataIncomplete: 'Los datos anidados pueden no estar completos',
        linkedExists: 'Socio vinculado exitosamente (ya existente)',
        linkedExistsAlready: 'Socio vinculado exitosamente (registro ya existía).',
        notLinkedCreatingNew: 'El socio ya registrado no fue vinculado; se creará un nuevo registro para él.',
        partnerCreated: 'Socio registrado exitosamente',
        partnerCreatedError: 'El socio no fue creado. Verifique los datos e intente de nuevo.',
        fieldRequired: 'Este campo es obligatorio',
        nestedFindInfo: 'Socio anidado {name} será creado como nuevo registro'
      }
    },
    operationalDocuments: {
      sectionTitle: 'Documentos complementarios',
      typePlaceholder: 'Tipo',
      defaultDescription: 'Compl. {num}'
    },
    issuedDocuments: {
      sectionTitle: 'Documentos Emitidos',
      generateButton: 'Generar Documento',
      emptyMessage: 'Ningún documento emitido para este cliente.',
      defaultDescription: 'Autorización'
    },
    kyc: {
      sectionTitle: 'KYC',
      estimatedVolume: 'Volumen anual estimado',
      currency: 'Moneda pretendida',
      destinationCountry: 'País de destino de los fondos'
    },
    formTab: {
      bankChannelsSearch: 'Buscar en cuentas internacionales, Brasil y pago',
      tabs: {
        registrationData: 'Datos de registro',
        contacts: 'Contactos',
        partners: 'Socios',
        bankChannels: 'Canales bancarios',
        documents: 'Documentos',
        limits: 'Bancos/Naturalezas y Límites',
        spreads: 'Spreads',
        kyc: 'KYC',
        history: 'Historial'
      }
    },
    complementaryInfo: {
      sectionTitle: 'Información Complementaria',
      accountPurpose: 'Propósito de la cuenta',
      accountPurposeOther: 'Describa el propósito de la cuenta',
      businessType: 'Tipo de negocio',
      businessIndustry: 'Código de industria (NAICS)',
      estimatedAnnualRevenue: 'Ingresos anuales estimados',
      sourceOfWealth: 'Fuente de riqueza',
      publiclyTraded: 'Empresa que cotiza en bolsa',
      businessDescription: 'Descripción del negocio',
      businessDescriptionHint: 'Describa las actividades del negocio (máximo {max} caracteres)',
      purposeDescriptionRequired: 'La descripción del propósito es obligatoria cuando se selecciona "Otro"',
      minChars: 'Mínimo 3 caracteres',
      maxChars: 'Máximo 512 caracteres'
    },
    operationProfile: {
      businessTitle: 'Perfil de la empresa y de las operaciones',
      individualTitle: 'Perfil de las operaciones',
      groups: {
        company: 'Sobre la empresa',
        operations: 'Operaciones',
        funds: 'Origen de los fondos'
      },
      businessDescriptionHint: 'Cuente qué hace la empresa, para quién y cómo (de {min} a {max} caracteres)',
      businessDescriptionShort: 'Faltan {missing} caracteres: el proveedor pide al menos {min}',
      sourceOfWealthHint: 'Este origen no tiene equivalente en el banco socio: elija la fuente de riqueza más cercana',
      fundsHandlingHint: 'Ej.: recibe de los clientes en una cuenta separada y paga a sus proveedores; o no recibe dinero de clientes',
      fields: {
        mainCountries: 'Otros países donde opera la empresa',
        hasLicenses: '¿Tiene licencia o registro regulatorio?',
        licenseDetails: 'Qué licencia o registro y de qué organismo',
        requiresAmlProgram: '¿Necesita un programa de prevención de lavado de dinero?',
        monthlyVolume: 'Volumen mensual',
        monthlyTransactions: 'Operaciones por mes',
        sendsFundsOnBehalf: '¿Envía dinero en nombre de clientes?',
        sendsFundsOnBehalfDescription: 'Cómo envía dinero en nombre de clientes',
        fundsSource: 'Origen de los fondos',
        fundsSourceDescription: 'De dónde viene el dinero de las operaciones',
        fundsHandlingDetails: 'Cómo pasa el dinero de clientes por la empresa',
        useFor: 'Para qué usará la cuenta',
        employmentStatus: 'Situación laboral',
        occupationIndustry: 'Rubro de actividad',
        netWorth: 'Rango de patrimonio',
        wealthSource: 'Origen del patrimonio',
        txPerMonth: 'Operaciones por mes',
        txVolumePerMonth: 'Volumen por mes'
      },
      options: {
        useFor: {
          Investing: 'Inversiones',
          PaymentToFriendsFamilyorOthers: 'Pagos a familia, amigos o terceros',
          PurchaseDigitalAssets: 'Compra de activos digitales',
          OnlinePurchasesOfGoodsOrServices: 'Compras en línea de productos o servicios',
          Trading: 'Compra y venta de activos (trading)'
        },
        employmentStatus: {
          Employed: 'Empleado',
          SelfEmployed: 'Independiente',
          Retired: 'Jubilado',
          Student: 'Estudiante',
          Unemployed: 'Sin ocupación'
        },
        occupationIndustry: {
          Agriculture: 'Agronegocios',
          ArtsAndEntertainment: 'Artes y entretenimiento',
          Construction: 'Construcción',
          Education: 'Educación',
          FinancialServices: 'Servicios financieros',
          InformationAndTechnology: 'Tecnología de la información',
          Retail: 'Comercio',
          RealEstate: 'Inmuebles',
          BusinessOwner: 'Empresario',
          Healthcare: 'Salud',
          Industrial: 'Industria',
          LegalServices: 'Servicios jurídicos',
          PublicSector: 'Sector público',
          SeniorManagement: 'Alta dirección',
          Other: 'Otro'
        },
        netWorth: {
          UpTo25000: 'Hasta US$ 25 mil',
          Between25001And50000: 'US$ 25 mil a 50 mil',
          Between50001And100000: 'US$ 50 mil a 100 mil',
          Between100001And300000: 'US$ 100 mil a 300 mil',
          Between300001And500000: 'US$ 300 mil a 500 mil',
          Between500001And1000000: 'US$ 500 mil a 1 millón',
          Over1000001: 'Más de US$ 1 millón'
        },
        wealthSource: {
          Salary: 'Salario',
          Savings: 'Ahorros',
          Investments: 'Inversiones',
          CryptoTrading: 'Operaciones con cripto',
          Other: 'Otro'
        },
        txPerMonth: {
          LessThan5: 'Menos de 5',
          Between5And10: 'De 5 a 10',
          MoreThan10: 'Más de 10'
        },
        txVolumePerMonth: {
          LessThan500: 'Hasta US$ 500',
          MoreThan500LessThan2000: 'US$ 500 a 2 mil',
          MoreThan2000: 'Más de US$ 2 mil'
        },
        monthlyVolume: {
          TenToTwentyFiveThousand: 'US$ 10 mil a 25 mil',
          TwentyFiveToFiftyThousand: 'US$ 25 mil a 50 mil',
          FiftyToOneHundredThousand: 'US$ 50 mil a 100 mil',
          OneHundredToTwoHundredFiftyThousand: 'US$ 100 mil a 250 mil',
          TwoHundredFiftyToFiveHundredThousand: 'US$ 250 mil a 500 mil',
          MoreThanFiveHundredThousand: 'Más de US$ 500 mil'
        },
        monthlyTransactions: {
          LessThanTen: 'Menos de 10',
          TenToTwentyFive: 'De 10 a 25',
          TwentyFiveToFifty: 'De 25 a 50',
          FiftyToOneHundred: 'De 50 a 100',
          MoreThanOneHundred: 'Más de 100'
        },
        fundsSource: {
          BusinessRevenue: 'Ingresos del negocio',
          ShareholderFunds: 'Aportes de los socios',
          VcPrivateEquity: 'Fondo de inversión (venture capital o private equity)',
          AssetSale: 'Venta de bienes o participaciones',
          IcoProceeds: 'Oferta de tokens (ICO)',
          CryptoActivityProceeds: 'Actividad con criptoactivos',
          LoanProceeds: 'Préstamo',
          Other: 'Otro'
        }
      }
    },
    pf: {
      coverFields: {
        birthCountry: 'País de nacimiento',
        fullName: 'Nombre completo',
        birthDate: 'Fecha de nacimiento',
        birthplace: 'Lugar de nacimiento',
        sexMale: 'Masculino',
        sexFemale: 'Femenino',
        documentType: 'Tipo de documento',
        documentNumber: 'N° del documento',
        documentIssueDate: 'Fecha de emisión',
        documentDueDate: 'Fecha de vencimiento',
        uf: 'UF',
        issuingAgency: 'Organismo expedidor',
        issuingAgencyOther: 'Organismo expedidor (Otros)',
        issuingAgencyOtherPlaceholder: 'Especifique',
        maritalStatus: 'Estado civil',
        marriageSystem: 'Régimen matrimonial',
        spouseName: 'Nombre completo del cónyuge',
        monthlyIncome: 'Ingreso mensual promedio',
        profession: 'Profesión',
        professionOther: 'Profesión (Otros)',
        professionOtherPlaceholder: 'Especifique',
        operationNature: 'Motivo del envío',
        dependentName: 'Nombre completo del dependiente',
        dependentKinship: 'Grado de parentesco del dependiente',
        assetLabel: 'Patrimonio',
        fatherName: 'Nombre del padre',
        motherName: 'Nombre de la madre',
        documentExpiredHint: 'Este documento está vencido.',
        loadNaturesError: 'No fue posible cargar las naturalezas de operación. Actualice la página (F5) y vuelva a intentarlo; si continúa, comuníquese con soporte.',
        loadProfessionsError: 'No fue posible cargar la lista de profesiones. Actualice la página (F5) y vuelva a intentarlo; si continúa, comuníquese con soporte.',
        loadIssuingAgenciesError: 'No fue posible cargar la lista de organismos emisores. Actualice la página (F5) y vuelva a intentarlo; si continúa, comuníquese con soporte.'
      },
      contactFields: {
        cellphone: 'Teléfono celular',
        email: 'Correo electrónico',
        secondEmail: 'Correo electrónico secundario',
        landline: 'Teléfono fijo'
      },
      work: {
        profession: 'Profesión',
        professionOther: 'Profesión (Otros)',
        professionOtherPlaceholder: 'Especifique',
        company: 'Empresa actual',
        companySector: 'Sector de la empresa',
        position: 'Nombre del cargo',
        loadProfessionsError: 'No fue posible cargar la lista de profesiones. Actualice la página (F5) y vuelva a intentarlo; si continúa, comuníquese con soporte.'
      },
      address: {
        residential: 'Dirección residencial',
        addDelivery: '¿Desea registrar otra dirección de entrega?',
        delivery: 'Dirección de entrega'
      },
      documents: {
        noCountryWarning: 'Este cliente tiene documentos sin país definido. Haga clic en "Definir país" en los documentos señalados para corregir.',
        sixtyKQuestion: '¿Planea operar valores superiores a 60 mil reales por año? Por favor agregue su Declaración de Renta y Recibo.',
        otherDocuments: 'Otros documentos',
        selfieLinkCopied: '¡Enlace de selfie copiado al portapapeles!',
        selfieLinkCopyError: 'No fue posible copiar el enlace. Cópielo manualmente: ',
        selfieLinkGenerateError: 'No se generó el enlace de selfie. Intente nuevamente en unos instantes; si continúa, comuníquese con soporte.',
        selfieNeedSave: 'El cliente debe estar creado para generar el enlace de selfie.'
      },
      politicallyExposed: {
        question: '¿Ejerce o ejerció cargo o función relevante?',
        position: 'Cargo',
        positionCode: 'Código del cargo',
        practiceStart: 'Inicio del ejercicio',
        practiceEnd: 'Fin del ejercicio',
        publicAgency: 'Empresa u organismo público',
        relationshipQuestion: '¿Tiene relación con agente público?',
        relatedName: 'Nombre completo del relacionado',
        relatedPosition: 'Cargo o función',
        relationshipType: 'Tipo de relación / Relación'
      },
      taxDomicile: {
        sectionTitle: 'Domicilio fiscal',
        introExternal: 'Informe todos los países donde usted es residente fiscal. Es el domicilio fiscal — no la nacionalidad — el que define qué documento exige cada país.',
        introAdmin: 'Informe todos los países donde el cliente es residente fiscal. Es el domicilio fiscal, no la nacionalidad, lo que define qué documento exige cada país.',
        primaryLabel: 'Domicilio fiscal principal',
        additionalLabel: 'Domicilio fiscal adicional {index}',
        removeAriaLabel: 'Eliminar {label}',
        countryLabel: 'País',
        documentTypeLabel: 'Tipo de documento',
        addDomicile: 'Agregar domicilio fiscal',
        addAnotherDomicile: 'Agregar otro domicilio fiscal',
        fatcaAlertBefore: 'Domicilio fiscal en los Estados Unidos: el registro será reportado bajo',
        fatcaAlertAfter: '(Foreign Account Tax Compliance Act).',
        crsAlertBefore: 'Domicilio fiscal fuera de Brasil: el registro será reportado bajo',
        crsAlertAfter: '(Common Reporting Standard).'
      },
      taxDomicileAbroad: {
        question: '¿El cliente tiene domicilio fiscal en el exterior - FATCA o CRS?',
        hint: 'FATCA: Foreign Account Tax Compliance Act. CRS: Common Reporting Standard.',
        countryLabel: 'País',
        identificationLabel: 'Número de identificación'
      },
      usPerson: {
        question: '¿El cliente es ciudadano estadounidense?',
        itinLabel: 'Número ITIN'
      }
    },
    pj: {
      cover: {
        operationNature: 'Naturaleza de la Operación',
        legalName: 'Razón Social',
        fantasyName: 'Nombre Fantasía',
        formOfIncorporation: 'Forma de constitución',
        activitySector: 'Sector de actividad',
        mainActivity: 'Actividad principal',
        cnae: 'CNAE',
        numberOfEmployees: 'Cant. de empleados',
        annualGrossRevenue: 'Facturación bruta anual',
        integratedSocialCapital: 'Capital social integralizado',
        assets: 'Patrimonio',
        foundingDate: 'Fecha de fundación',
        lastChangeDate: 'Fecha de última modificación',
        boardElectionDate: 'Fecha de elección de la junta directiva',
        importTitle: '¿Importar datos del Registro Federal?',
        importQuestion: '¿Desea importar los datos del Registro Federal para este CNPJ?',
        importSuccess: 'Datos importados con éxito',
        importError: 'No fue posible importar los datos del CNPJ. Intente nuevamente en unos instantes; si continúa, comuníquese con soporte.',
        loadNaturesError: 'No fue posible cargar las naturalezas de operación. Actualice la página (F5) y vuelva a intentarlo; si continúa, comuníquese con soporte.'
      },
      contact: {
        landline: 'Teléfono fijo',
        website: 'Sitio web',
        cellphone: 'Teléfono celular',
        email: 'Correo electrónico',
        secondEmail: 'Correo electrónico secundario'
      },
      address: {
        commercial: 'Dirección comercial',
        sameForDelivery: 'Usar la misma dirección para correspondencia',
        delivery: 'Dirección de correspondencia'
      },
      compliance: {
        importExportQuestion: '¿Realizó importaciones o exportaciones anteriormente?',
        businessPurpose: 'Propósito de la relación de negocios',
        radarModal: 'Modalidad del Radar:',
        paymentMode: 'Modalidad de Pago:',
        operatingMode: 'Informe el Modo Operante:',
        supplierLabel: 'Proveedor {n}',
        productLabel: 'Producto {n}',
        productTypeLabel: 'Tipo de producto {n}',
        diLabel: 'DI {n}',
        diQuestion: '¿Tiene alguna DI registrada en los últimos 6 meses?',
        crimeQuestion: '¿La empresa y/o sus socios responden (o respondieron) por proceso penal, investigación policial u otras ocurrencias o circunstancias análogas? En caso afirmativo, explique en las informaciones adicionales.',
        estimatedAmount: 'Monto Estimado Anual (US$)',
        additionalInfo: 'Informaciones adicionales'
      },
      documents: {
        noCountryWarning: 'Este cliente tiene documentos sin país definido. Haga clic en "Definir país" en los documentos señalados para corregir.',
        socialContractLabel: 'Contrato social / Estatuto social {n}',
        balancePgdasLabel: 'Balance o PGDAS (Declaración) {n}',
        signedNoticeHint: 'Obligatorio estar firmado por el socio y el contador.',
        othersSection: 'Otros documentos',
        otherDescription: 'Otros'
      },
      directors: {
        fullName: 'Nombre Completo',
        position: 'Cargo',
        termStartDate: 'Fecha de inicio del mandato',
        termEndDate: 'Fecha de fin del mandato',
        addAnother: 'Agregar otro'
      },
      responsible: {
        name: 'Nombre',
        position: 'Cargo',
        email: 'Correo electrónico',
        phone: 'Teléfono'
      },
      wizardStep1: {
        initialInfoTitle: 'Información inicial',
        contactInfoTitle: 'Información de contacto',
        addressTitle: 'Direcciones'
      },
      partnerWizard: {
        titlePersonTypePJ: 'Persona Jurídica',
        titlePersonTypePF: 'Persona Física',
        titleAdd: 'Agregar socio',
        titleEdit: 'Editar socio',
        titleFor: 'para {name}',
        loadingDefault: 'Cargando...',
        loadingSaving: 'Guardando datos del socio...',
        stepBasicData: 'Datos básicos',
        stepAddress: 'Dirección',
        stepDocuments: 'Documentos',
        stepNestedPartners: 'Socios del socio',
        stepSummary: 'Resumen',
        btnBack: 'Volver',
        btnCancel: 'Cancelar',
        btnSave: 'Guardar',
        btnNext: 'Siguiente',
        personTypePF: 'Persona Física',
        personTypePJ: 'Persona Jurídica',
        foreignerLabel: 'Extranjero',
        linkedWarning: 'Cliente vinculado: solo participación editable.',
        unlinkButton: 'Desvincular',
        nameLabel: 'Nombre',
        passportLabel: 'Pasaporte',
        birthDateLabel: 'Fecha de nacimiento',
        legalNameLabel: 'Razón Social',
        foundingDateLabel: 'Fecha de fundación',
        cellphoneLabel: 'Teléfono celular',
        emailLabel: 'Correo electrónico personal',
        shareLabel: '% de participación',
        taxTypeLabel: 'Tipo de identificación fiscal',
        foreignTaxIdLabel: 'ID fiscal extranjero',
        validationShareNumber: 'El porcentaje debe ser un número válido',
        validationShareNegative: 'El porcentaje no puede ser negativo',
        validationShareMax: 'El porcentaje no puede ser mayor que 100%',
        validationShareTotal: 'La suma total no puede superar el 100%. Máximo permitido: {remaining}%',
        validationCpfCnpjDuplicate: 'Este CPF/CNPJ ya está siendo usado por otro socio',
        validationEmailDuplicate: 'Este correo electrónico ya está siendo usado por otro socio',
        missingDocsBefore: 'Complete todos los documentos obligatorios del socio antes de continuar.',
        missingDocsList: 'Complete todos los documentos obligatorios del socio: {list}.',
        foundByCpfBirthDate: 'Encontramos un cliente con este CPF y fecha de nacimiento. ¿Desea vincular y completar los datos automáticamente?',
        birthDateMismatch: 'La fecha de nacimiento informada no corresponde a la registrada para este CPF. Para corregir, acceda a la ficha del cliente vinculado y actualice la fecha de nacimiento.',
        foundByCnpjFoundingDate: 'Encontramos un cliente con este CNPJ y fecha de fundación. ¿Desea vincular y completar los datos automáticamente?',
        foundingDateMismatch: 'La fecha de fundación informada no corresponde a la registrada para este CNPJ. Para corregir, acceda a la ficha del cliente vinculado y actualice la fecha de fundación.',
        linkedSuccess: 'Socio vinculado a cliente existente',
        unlinkedSuccess: 'Vínculo eliminado y datos limpiados.',
        summaryBasicData: 'Datos básicos',
        summaryAddress: 'Dirección',
        summaryNestedPartners: 'Socios del socio',
        summaryDocuments: 'Documentos',
        summaryNameLabel: 'Nombre/Razón Social:',
        summaryCpfCnpjLabel: 'CPF/CNPJ:',
        summaryBirthDateLabel: 'Fecha de nacimiento:',
        summaryFoundingDateLabel: 'Fecha de fundación:',
        summaryEmailLabel: 'Correo electrónico:',
        summaryCellphoneLabel: 'Teléfono celular:',
        summaryShareLabel: 'Participación:',
        summaryNestedShare: 'Participación: {share}%',
        summaryDefaultPartnerName: 'Socio',
        summaryDefaultDocName: 'Documento'
      },
      partnersShareholders: {
        colType: 'Tipo',
        colName: 'Nombre/Razón Social',
        colCpfCnpj: 'CPF/CNPJ',
        colCellphone: 'Teléfono celular',
        colEmail: 'Correo electrónico',
        colAddress: 'Dirección',
        colShare: '% Participación',
        nestedTitle: 'Socios de este socio',
        nestedAddPartner: 'Agregar socio',
        loading: 'Cargando...',
        noNestedPartners: 'Ningún socio registrado.',
        mobileNameLabel: 'Nombre:',
        mobileCpfLabel: 'CPF:',
        mobileCnpjLabel: 'CNPJ:',
        mobileCellphone: 'Teléfono celular:',
        mobileEmail: 'Correo electrónico:',
        mobileAddress: 'Dirección:',
        mobileShare: 'Participación:',
        addPartner: 'Agregar socio',
        linkPartner: 'Vincular socio',
        linkModalTitle: 'Vincular socio',
        linkShareLabel: '% de participación',
        messages: {
          deleteConfirm: '¿Desea realmente eliminar este socio?',
          createCustomerError: 'No fue posible crear el cliente principal. Intente nuevamente.',
          partnerCreateError: 'El registro del socio no fue creado. Verifique los datos e intente nuevamente.',
          nestedPartnersSaveError: 'Los socios de esta empresa socia no fueron guardados. Verifique los datos e intente nuevamente.',
          prepareError: 'No fue posible preparar el registro del socio. Verifique los datos e intente nuevamente; si continúa, comuníquese con soporte.',
          shareSum: 'La suma de las participaciones de los socios de este socio debe ser 100%. Actual: {value}%',
          partnerAdded: '¡Socio agregado!',
          partnerUpdated: '¡Socio actualizado con éxito!',
          nestedPartnerAdded: '¡Socio del socio agregado!',
          nestedPartnerUpdated: '¡Socio del socio actualizado con éxito!',
          nestedCreateError: 'No fue posible crear el registro del socio. Verifique los datos e intente nuevamente; si continúa, comuníquese con soporte.',
          requiredFields: 'Por favor, complete todos los campos obligatorios.',
          alreadyLinked: 'Este cliente ya está vinculado como socio.',
          linkedSuccess: '¡Socio vinculado con éxito!'
        }
      }
    }
  },
  paymentMethods: {
    common: {
      routingNumber: 'Número de enrutamiento',
      routingNumberAba: 'Número de enrutamiento (ABA)',
      accountType: 'Tipo de cuenta',
      accountNumber: 'Número de cuenta',
      beneficiaryName: 'Nombre del beneficiario',
      beneficiaryRelationship: 'Relación con el beneficiario',
      relationship: 'Relación',
      beneficiaryAddressTitle: 'Dirección del beneficiario',
      postalCode: 'Código postal',
      country: 'País',
      stateProvinceRegion: 'Estado/Provincia/Región',
      city: 'Ciudad',
      addressLine1: 'Dirección línea 1',
      addressLine2: 'Dirección línea 2',
      ffc: 'FFC',
      swiftBic: 'Código Swift / BIC',
      swiftBicPlaceholder: 'Ingrese el código Swift/BIC (ej: CHASUS33XXX)',
      maxTwoChars: 'Máximo 2 caracteres',
      invalidUsState: 'Use la sigla del estado en EE. UU. (ej.: FL, NY, CA)'
    },
    achColombia: {
      accountTypeRequired: 'Tipo de cuenta *',
      accountNumberRequired: 'Número de cuenta *',
      bankCode: 'Código del banco *',
      beneficiaryFirstName: 'Primer nombre del beneficiario *',
      beneficiaryLastName: 'Apellido del beneficiario *',
      documentId: 'ID del documento *',
      documentType: 'Tipo de documento *',
      email: 'Email *'
    },
    wire: {
      routingNumberRequired: 'El número de enrutamiento es obligatorio',
      routingNumberNineDigits: 'El número de enrutamiento debe tener exactamente 9 dígitos',
      documentId: 'Número de documento',
      documentIdRequired: 'Número de documento *'
    },
    sepa: {
      ibanLabel: 'IBAN *',
      bicSwift: 'BIC / SWIFT *',
      beneficiaryCountry: 'País del beneficiario *',
      postalCode: 'Código postal *',
      businessBlockedWarning: 'Este país no acepta pagos SEPA para cuentas empresariales. Cambie el tipo de cuenta a "Individual" o use SWIFT Internacional.',
      ibanMinMaxChars: 'El IBAN debe tener entre 15 y 34 caracteres',
      ibanInvalidFormat: 'Formato de IBAN inválido',
      ibanCountryMismatch: 'Este IBAN es de otro país ({ibanCountry}). Para una cuenta en {countryName}, el IBAN debe comenzar con "{beneficiaryCountry}".'
    },
    fasterPayments: {
      sortCode: 'Sort code *',
      sortCodeHint: 'Código de 6 números de la sucursal en el Reino Unido',
      sortCodeInvalid: 'El sort code tiene {digits} números (ej.: 20-00-00)',
      accountNumber: 'Número de cuenta *',
      accountNumberHint: 'Número de cuenta en el Reino Unido, con 8 números',
      accountNumberInvalid: 'El número de cuenta tiene {digits} números',
      beneficiaryCountry: 'País del beneficiario *',
      postalCode: 'Código postal'
    },
    spei: {
      protocol: 'Protocolo *',
      clabeLabel: 'Número de cuenta / CLABE *',
      clabePlaceholder: '18 dígitos (ej: 014027000005555558)',
      debitCardLabel: 'Número de tarjeta de débito *',
      debitCardPlaceholder: '16 dígitos (ej: 4152314189639159)',
      phoneNumLabel: 'Número de teléfono *',
      phoneNumPlaceholder: 'Ej: 5512345678',
      institutionCodeRequired: 'Código de institución *',
      institutionCode: 'Código de institución',
      beneficiaryName: 'Nombre del beneficiario *'
    },
    swift: {
      accountIban: 'Número de cuenta / IBAN',
      confirmAccountIban: 'Confirmar número de cuenta / IBAN',
      accountsMustMatch: 'Los números de cuenta deben ser iguales',
      beneficiaryNameTitle: 'Nombre del beneficiario / Titular de la cuenta',
      swiftPaymentCode: 'Código de pago SWIFT',
      ifscBranch: 'IFSC de la sucursal',
      ifscHint: '11 caracteres, como ICIC0005023',
      beneficiaryAddressTitle: 'Dirección del beneficiario',
      bankAddressTitle: 'Dirección del banco',
      addressLinesHint: 'Líneas 1 y 2 juntas: {current} de {limit} caracteres',
      cityMaxLength: 'La ciudad puede tener como máximo {limit} caracteres',
      addressLinesMaxLength: 'Las líneas 1 y 2 de la dirección juntas pueden tener como máximo {limit} caracteres',
      ifscRequired: 'Ingrese el IFSC de la sucursal del banco en India',
      ifscFormat: 'El IFSC tiene 11 caracteres: 4 letras del banco, un cero y 6 de la sucursal (ej.: ICIC0005023)',
      maxTwoChars: 'Máximo 2 caracteres'
    },
    bankAddress: {
      title: 'Dirección del banco (opcional)',
      hint: 'Dirección del banco receptor (ej.: la sucursal en EE. UU.). Con ella completada, la cuenta tiene más opciones de envío; sin ella, sigue funcionando normalmente.'
    },
    bankAccountHeader: {
      displayName: 'Nombre de visualización',
      displayNameHint: 'Ej: Cuenta personal principal',
      bankName: 'Nombre del banco',
      beneficiaryName: 'Nombre del beneficiario *',
      accountClass: 'Clase de cuenta'
    },
    intermediary: {
      checkboxLabel: 'Registrar banco intermediario',
      bankName: 'Nombre del banco intermediario',
      swiftAba: 'Código SWIFT/ABA'
    },
    business: {
      sectionTitle: 'Datos empresariales (obligatorios para cuenta empresarial)',
      industry: 'Sector (NAICS) *',
      taxId: 'Identificación fiscal (Tax ID)',
      taxIdHint: 'Formato SSN/ITIN: XXX-XX-XXXX',
      phone: 'Teléfono *',
      taxIdInvalid: 'El Tax ID debe tener 9 dígitos (formato SSN/ITIN: XXX-XX-XXXX)'
    },
    transfers3: {
      accountTypeCvuCbu: 'Tipo de cuenta (CVU/CBU) *',
      accountNumberPlaceholder: '22 dígitos',
      accountNumber: 'Número de cuenta *',
      beneficiaryName: 'Nombre del beneficiario *'
    }
  },
  sendDocuments: {
    stepFooter: {
      advance: 'Siguiente',
      back: 'Volver',
      cancel: 'Cancelar',
      sendToBank: 'Enviar al banco',
      cancelSend: 'Cancelar envío'
    },
    stepCustomerDocs: {
      noDocuments: 'No hay documentos'
    },
    stepPartnersDocs: {
      share: 'Participación: {share}%',
      nestedPartnerNoProfile: 'Socio anidado sin registro completo',
      noDocumentsForPartner: 'No se encontraron documentos para este socio',
      partnerNoProfile: 'El socio no tiene registro completo',
      partnerNoProfileDesc: 'Para enviar documentos de este socio, es necesario completar su registro como cliente en el sistema.',
      noPartners: 'Ningún socio registrado',
      noPartnersDesc: 'Este cliente no tiene socios o accionistas registrados.',
      nestedPartnersTitle: 'Socios de este socio'
    },
    stepOperationalDocs: {
      noDocuments: 'No hay documentos complementarios'
    },
    stepSummary: {
      complementaryInfo: 'Información complementaria',
      customerDocs: 'Documentos del cliente',
      noneSelected: 'Ninguno seleccionado',
      operationalDocs: 'Documentos complementarios',
      partnersDocs: 'Documentos de los socios',
      nestedPartnersTitle: 'Socios de este socio'
    },
    resetTosTitle: '¿Reiniciar registro en el banco?',
    resetTosMessage: 'El registro de este cliente fue rechazado por el banco. ¿Desea reiniciar el proceso de aceptación de los términos de servicio?',
    resetTosPrimary: 'Sí, reiniciar',
    resetTosSecondary: 'No, solo guardar',
    pendingLimitTitle: 'Progresión de límite en proceso',
    pendingLimitSubtitle: 'Es necesario realizar contacto con el banco para continuar con la progresión del registro.'
  },
  formOperation: {
    bankFlowTableUi: {
      brlSettlement: 'Reales'
    },
    digitalRemittanceQuotationProgressUi: {
      analyzingTitle: 'Analizando los datos de su operación',
      analyzingSubtitle: 'Esto lleva solo unos segundos',
      comparingTitle: 'Comparando los caminos disponibles',
      comparingSubtitle: 'Consultando a nuestros socios de pago',
      choosingTitle: 'Eligiendo el mejor camino para usted',
      choosingSubtitle: 'Considerando moneda, forma de pago y monto',
      calculatingTitle: 'Calculando su cotización',
      calculatingSubtitle: 'Verificando tasas y montos',
      extendedTitle: 'Estamos analizando las mejores opciones para su operación',
      extendedSubtitle: 'Eligiendo el mejor socio de pago para usted'
    },
    shipmentPostponeValidationUi: {
      required: 'Campo obligatorio.',
      maxLength: 'Máximo de 200 caracteres.',
      invalidFormat: 'Formato no permitido. Aceptados: PDF, JPG, PNG.',
      fileTooLarge: 'El archivo supera el tamaño máximo de 10 MB.',
      selectStage: 'Seleccione la etapa de la mercadería.',
      expectedDateRequired: 'La fecha prevista es obligatoria.',
      expectedDateFuture: 'La fecha prevista debe ser posterior al día actual.',
      observationMaxLength: 'La observación debe tener como máximo 200 caracteres.',
      attachmentRequired: 'Adjunto obligatorio.'
    },
    importDocumentsUi: {
      duimpSaveError: 'No fue posible guardar el documento DUIMP/DU-E. Revise los datos e intente nuevamente; si continúa, comuníquese con soporte.',
      invoiceSaveError: 'No fue posible guardar el documento de Invoice. Revise los datos e intente nuevamente; si continúa, comuníquese con soporte.',
      bankingProductSaveError: 'No fue posible guardar el documento del producto bancario. Revise los datos e intente nuevamente; si continúa, comuníquese con soporte.',
      savedRowNotFound: '{message} No se encontró la fila guardada.'
    },
    authorizationDocumentModalUi: {
      documentTypeLabel: 'Tipo de documento *'
    },
    customerOperationalDocumentsUi: {
      documentsLabel: 'Documentos'
    },
    digitalRemittanceProfitCardUi: {
      approximateProfit: 'Ganancia aproximada',
      fillHintStart: 'Completá los datos de la izquierda y hacé clic en',
      fillHintEnd: 'para ver el resultado aquí.',
      contractor: 'Contratante',
      contractorProfit: 'Ganancia {name}'
    },
    digitalRemittanceQuotationResultUi: {
      renewing: 'Renovando cotización',
      expired: 'Cotización vencida',
      expiresIn: 'Vence en {time}',
      balanceUnavailable: 'No fue posible consultar el saldo de la billetera ahora. El pago solo se envía si el saldo cubre el monto.',
      walletBalance: 'Saldo en la billetera:',
      afterPayment: 'Después de este pago:',
      insufficientBalance: 'El saldo de la billetera no cubre este pago. Reducí el monto o hacé antes un ingreso en la pestaña Pay-in.',
      transferFee: 'Tarifa de transferencia:',
      commercialRate: 'Tipo de cambio comercial',
      providerRate: 'Tipo de cambio {bank}',
      linkSentEmail: 'Valores enviados al cliente a las {time}. El monto final es el que el cliente confirme en el enlace.',
      linkSentNoEmail: 'Enlace generado a las {time}, pero el correo electrónico no se envió. Enviá el enlace al cliente por WhatsApp.',
      walletOut: 'Sale de la billetera del cliente',
      clientPays: 'El cliente paga'
    },
    operationRemittanceUi: {
      nationalAccountItem: 'Banco: {bank} - Sucursal: {agency} - Cuenta: {account} - Dígito: {digit}',
      foreignAccountItem: '{name} - Banco: {bank} - IBAN: {iban} - Código Swift/BIC: {swift} - Número ABA/Routing: {routing}',
      brazilAccount: 'Cuenta en Brasil',
      foreignAccount: 'Cuenta en el exterior',
      noPaymentAccount: 'Este cliente no tiene una cuenta de pago registrada para este banco',
      noIntegratedAccount: 'Este cliente no tiene una cuenta en el exterior aprobada en este banco. Integre una cuenta en el registro del cliente para operar.',
      noWireAccount: 'No tenés cuentas en el exterior del tipo WIRE'
    },
    duimpExternalAccessUi: {
      backToSelection: 'Volver a la selección',
      operationNotFound: 'Operación no encontrada.'
    },
    formOperationUi: {
      outOfHoursDescription: 'El horario para realizar operaciones en línea es de lunes a viernes, de {min} h a {max} h',
      editCustomer: 'Editar cliente',
      selectOtherBank: 'Seleccioná otro banco o intentá nuevamente más tarde.',
      manualQuotationNotice: 'Cotización manual: el sistema no cerrará la operación en {bankName}. Cerrá la orden directamente con {bankName}.',
      lockFailed: 'No fue posible bloquear esta preventa. Intentá nuevamente o esperá unos instantes.',
      lockExpired: 'El bloqueo de esta preventa venció. La página se volverá a cargar.'
    },
    digitalRemittance: {
      quotationError: 'No fue posible generar la cotización',
      paymentError: 'No fue posible generar el pago',
      comingSoon: 'Próximamente',
      amountClearedForCurrency: 'El valor se borró porque aquí es en {currency}. Escríbalo de nuevo.',
      operationDataTitle: 'Datos de la operación',
      walletOriginLabel: 'Sale de',
      walletStablecoinValue: 'Stablecoin en la billetera del cliente',
      useFullBalance: 'Usar saldo total',
      senderCurrencyLabel: 'Moneda origen',
      destinationCurrencyLabel: 'Moneda destino *',
      destinationCurrencyHint: 'En qué moneda recibe la cuenta',
      noCurrencyAvailable: 'Ninguna moneda disponible para este cliente',
      paymentMethodLabel: 'Forma de pago',
      paymentMethodHint: 'Cómo envía el dinero el cliente',
      spreadLabel: 'Spread *',
      corbanLabel: 'Corban',
      bankAccountLabel: 'Cuenta bancaria *',
      noBankAccountForCurrency: 'Ninguna cuenta de este cliente recibe en esta moneda',
      addInternationalAccount: 'Agregar cuenta en el exterior',
      pendingAccountsTitle: 'Cuentas aún no activas para stablecoin',
      pendingAccountsText: 'Sincronice en Canales bancarios, en el registro del cliente, para usar estas cuentas.',
      openBankChannels: 'Abrir Canales bancarios',
      accountHolder: 'Titular',
      copyAccountData: 'Copiar datos de la cuenta',
      routingOptionsFailed: 'No fue posible consultar las monedas y cuentas disponibles para este cliente.',
      retryButton: 'Intentar de nuevo',
      noPayoutOption: 'Este cliente aún no puede recibir pagos. Complete el registro DolsPay en Bancos y Límites, en el registro del cliente.',
      transactionDocumentType: 'Tipo de documento *',
      transactionDocumentId: 'Número del documento *',
      transactionDocumentFile: 'Archivo del documento *',
      fileUploaded: 'Archivo enviado',
      flowSoonTitle: '{label} próximamente',
      flowSoonText: 'Este flujo aún no está disponible en esta pantalla. Para operar ahora, use la pestaña Fiat to Fiat.',
      approvalLinkLabel: 'Enlace para el cliente',
      payOutSentTitle: 'Pago enviado',
      payOutSentText: 'El monto salió de la billetera del cliente hacia la cuenta {account}. La operación aparece como Liquidada, con el comprobante, en cuanto se confirme el pago.',
      newPayment: 'Nuevo pago',
      generateQuotation: 'Generar cotización',
      newQuotation: 'Nueva cotización',
      newOperation: 'Nueva operación',
      goToPresale: 'Ir a preventa',
      payinOnlyReceives: 'Recibe',
      partnerFeeNoDataEntry: 'Ningún spread con porcentaje de entrada',
      partnerFeeNoDataExit: 'Ningún spread con porcentaje de salida',
      partnerFeeNoDataCorbanRange: 'Ningún spread disponible para el corresponsal. Hable con el administrador.',
      partnerFeeNoData: 'Ningún spread registrado',
      amountHintWalletOut: 'El monto es lo que sale de la billetera del cliente',
      amountHintDestination: 'El monto es lo que llega a la cuenta',
      amountHintWalletIn: 'El monto es lo que entra en la billetera del cliente',
      walletStablecoinName: 'USDC en la billetera',
      amountHintCustomerPays: 'El monto es lo que paga el cliente',
      senderCurrencyHintSingle: 'Única opción para este cliente',
      senderCurrencyHintDefault: 'En qué moneda paga el cliente',
      fieldRequired: 'Campo obligatorio',
      descriptionRequiredForWire: 'La descripción es obligatoria para cuentas Wire',
      documentFileRequired: 'El archivo del documento es obligatorio',
      descriptionRequired: 'Descripción *',
      descriptionOptional: 'Descripción (opcional)',
      descriptionHintPayoutDestination: 'Va junto con el pago al banco del beneficiario',
      descriptionHintFiatDestination: 'Aparece en el contrato de cambio y en la transferencia al banco del beneficiario',
      descriptionHintWire: '{base} (obligatoria para cuentas Wire)',
      activeForStablecoin: 'Activas para stablecoin',
      accountDetail_tipo: 'Tipo',
      accountDetail_banco: 'Banco',
      accountDetail_swiftBic: 'Swift/BIC',
      accountDetail_abaRouting: 'ABA/Routing',
      accountDetail_iban: 'IBAN',
      accountDetail_conta: 'Cuenta',
      accountDetail_tipoConta: 'Tipo de cuenta',
      accountDetail_titular: 'Titular',
      modalInitError: 'No se pudo abrir la pantalla de operación. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
      accountDataCopied: 'Datos de la cuenta copiados.',
      saveInternationalBankError: 'La cuenta en el exterior no se guardó. Verifique los datos bancarios del beneficiario e intente de nuevo.',
      quotationRenewedWarning: 'La cotización había vencido y fue renovada. Verifique los valores y genere el pago.',
      quotationNotRenewed: 'La cotización no fue renovada: {errorMessage}. Haga clic en Nueva cotización para generar otra.',
      documentUploadSuccess: '¡Documento enviado con éxito!',
      documentUploadError: 'El documento no fue enviado. Verifique si el archivo es PDF, JPG o PNG e intente de nuevo; si continúa, contacte al soporte.',
      quotationDataCopied: '¡Datos de la cotización copiados!',
      quotationCopyError: 'Los datos no fueron copiados. Seleccione el texto y cópielo manualmente (Ctrl+C).',
      generateQuotationFirst: 'Genere una cotización primero',
      quotationNotGenerated: 'Cotización no generada. Genere una cotización primero.',
      noNatureFound: 'Naturaleza de la operación no encontrada para este banco',
      quotationUnavailable: 'La cotización ya no está disponible. Genere una nueva cotización para continuar.',
      preSaleNotSaved: 'La preventa no se guardó. Haga clic en Nueva cotización e intente de nuevo.',
      payInDataForPayment: 'los datos de pago',
      payInPix: 'el PIX',
      generateDataError: 'No fue posible generar {what}: {errorMessage}',
      preSaleNotSavedRetry: 'La preventa no se guardó. Verifique los datos de la operación e intente de nuevo.',
      paymentSentSuccess: 'Pago enviado. La operación aparece como Liquidada en cuanto se confirme el pago.',
      paymentSendError: 'No fue posible enviar el pago: {payInError}',
      paymentConfirmedSuccess: '¡Pago confirmado con éxito!',
      paymentNotConfirmedForeign: 'El pago no fue confirmado. Cree una nueva operación para generar nuevos datos de pago.',
      pixExpiredNotConfirmed: 'El PIX venció y el pago no fue confirmado. Cree una nueva operación para generar otro código QR.',
      loadOperationDataError: 'Los datos de la operación no cargaron. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
      setCorbanAutoError: 'El corban del cliente no se completó automáticamente. Elija uno de forma manual.',
      loadNatureWarning: 'No fue posible cargar la naturaleza de la operación. Se aplicó la naturaleza estándar de remesa digital.',
      bankSavedReady: '¡Cuenta en el exterior registrada y lista para operar!',
      bankSavedProcessing: 'Cuenta registrada. Está siendo configurada para operar y estará disponible en instantes; si no aparece, actualice la página.',
      loadSpreadsError: 'No fue posible cargar los spreads. Actualice la página e intente de nuevo.',
      loadBankAccountsError: 'No fue posible cargar las cuentas bancarias del cliente. Actualice la página e intente de nuevo.',
      loadCorbansError: 'La lista de corbans no cargó. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
      fillRequiredFields: 'Complete todos los campos obligatorios correctamente',
      chooseBankAccountForCurrency: 'Elija una cuenta bancaria que reciba en esta moneda.',
      quotationRenewFailed: 'No fue posible renovar la cotización. Genere una nueva de forma manual.'
    },
    duimpItemCard: {
      accessKey: 'Clave de acceso',
      value: 'Valor',
      uploadInstruction: 'Elija un archivo o arrastre y suelte aquí',
      downloadDocument: 'Descargar documento',
      removeFile: 'Eliminar archivo',
      removeDuimp: 'Eliminar DUIMP/DU-E',
      addDuimp: 'Agregar DUIMP/DU-E'
    },
    duimpExternal: {
      successTitle: 'Enviado con éxito',
      successMessage: 'Su información fue registrada. Gracias por mantener su operación al día.',
      operationTitle: 'Operación #{id}',
      nature: 'Naturaleza',
      currency: 'Moneda',
      value: 'Valor',
      supplier: 'Proveedor',
      duimpStatus: 'Estado DUIMP',
      operationDate: 'Fecha de la operación',
      originDestination: 'Origen / Destino',
      lastDuimpInserted: 'Última inserción DUIMP',
      existingDuimps: 'DUIMP/DU-E ya enviados',
      shipmentHistory: 'Historial de embarque',
      accessKey: 'Clave de acceso',
      insertedAt: 'Insertado el',
      noDoc: 'Sin doc.',
      shipmentStageTitle: 'Etapa de la mercancía',
      estimatedShippingDate: 'Fecha estimada de embarque:',
      shipmentStageLabel: 'Etapa de la mercancía',
      estimatedDate: 'Fecha estimada',
      blAwbUpload: 'BL/AWB — Elija un archivo o arrastre y suelte aquí',
      observation: 'Observación',
      submitShipment: 'Informar etapa',
      limitAlert: 'Límite máximo de {max} protocolos alcanzado para esta operación.',
      addDuimpTitle: 'Agregar DUIMP/DU-E',
      submitDuimp: 'Enviar DUIMP/DU-E',
      removeFile: 'Eliminar archivo',
      downloadDocument: 'Descargar documento',
      accessKeyRequired: 'Clave de acceso obligatoria.',
      accessKeyMaxLength: 'Máximo 40 caracteres.',
      valueRequired: 'Valor obligatorio',
      valueExceeds: 'El valor supera el pendiente de {prefix}{value}',
      fileRequired: 'Archivo adjunto obligatorio.',
      exceedsMessage: 'El valor informado supera el pendiente de {prefix}{value}',
      shipmentSuccess: 'Etapa de la mercancía registrada con éxito.',
      shipmentError: 'No fue posible registrar la etapa. Intente de nuevo.',
      duimpSuccess: '¡DUIMP/DU-E enviado con éxito!',
      duimpError: 'No fue posible enviar DUIMP/DU-E. Intente de nuevo en unos instantes; si continúa, contacte al soporte.',
      downloadError: 'No fue posible descargar el documento. Intente de nuevo; si continúa, contacte al soporte.',
      operationObservationLabel: 'Observación de la operación'
    },
    invoiceManager: {
      title: 'Gestionar Invoices',
      invoiceNumber: 'Nº de Invoice',
      invoiceDate: 'Fecha de Invoice',
      shippingForecast: 'Previsión de embarque',
      uploadInstruction: 'Elija un archivo o arrastre y suelte aquí',
      downloadDocument: 'Descargar documento',
      removeFile: 'Eliminar archivo',
      removeInvoice: 'Eliminar invoice',
      addInvoice: 'Agregar invoice',
      saveError: 'No fue posible guardar invoices. Revise los datos e intente de nuevo; si continúa, contacte al soporte.',
      saveDocError: 'No fue posible guardar el documento de Invoice. Revise los datos e intente de nuevo; si continúa, contacte al soporte.',
      downloadError: 'No fue posible descargar el documento. Intente de nuevo; si continúa, contacte al soporte.'
    },
    liquidationSelect: {
      receivingFlow: 'Flujo de cobro',
      paymentFlow: 'Flujo de pago',
      liquidationME: 'Liquidación ME',
      liquidationBRL: 'Liquidación BRL',
      holiday: 'Feriado',
      cutoffHint: '⏱ {countdown} para cerrar D+0',
      holidayHint: 'Feriado: {name}',
      required: 'Este campo es obligatorio'
    },
    operationDocumentCard: {
      descriptionPlaceholder: 'Escriba el nombre del documento',
      typePlaceholder: 'Tipo',
      selectTypeError: 'Seleccione el tipo del documento',
      addDocument: 'Agregar documento',
      removeDocument: 'Eliminar documento'
    },
    operationBasicInfo: {
      customerLabel: 'Cliente / CPF / CNPJ',
      cityLabel: 'Ciudad',
      natureLabel: 'Naturaleza',
      bankLabel: 'Banco',
      stablecoinSubtitle: 'Operaciones en stablecoins',
      limitPrefix: 'Límite',
      expiresPrefix: 'Vence el',
      sellOperation: 'Venta/Salida',
      buyOperation: 'Compra/Entrada',
      alertExchangeBuy: 'Su cliente está vendiendo moneda extranjera',
      alertExchangeSell: 'Su cliente está comprando moneda extranjera',
      alertPayIn: 'Su cliente está comprando stablecoin, que queda en su billetera',
      alertPayout: 'Su cliente está enviando stablecoin de su billetera hacia la cuenta de destino',
      duimpPendingTitle: 'Pendientes DUIMP/DU-E',
      duimpPendingText: 'El cliente tiene DUIMP/DU-E con más de 60 días sin actualización.',
      duimpPendingLink: 'Acceda a la Gestión de DUIMP/DU-E',
      noPaymentAccount: 'Este cliente no tiene cuenta de pago registrada para este banco',
      noCorban: '¡Este cliente no tiene un corban!',
      errorLoadCustomers: 'No fue posible buscar los clientes. Revise el texto de búsqueda e intente de nuevo; si continúa, contacte al soporte.',
      errorLoadBanks: 'No fue posible cargar los bancos del cliente. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
      errorLoadTurismoBanks: 'No fue posible cargar los bancos de cambio turismo del cliente. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
      natureLabelReadonly: 'Naturaleza'
    },
    operationBankAccount: {
      titleInternational: 'Cuenta Bancaria Internacional',
      titleBrazil: 'Cuenta Bancaria de Brasil',
      bank: 'Banco',
      iban: 'IBAN',
      swiftBic: 'Código Swift/BIC',
      abaRouting: 'Número ABA/Routing',
      ownerName: 'Nombre del titular',
      ffc: 'FFC',
      intermediaryCountry: 'País Intermediario',
      intermediaryBank: 'Banco Intermediario',
      intermediaryAbaRouting: 'ABA/Routing Intermediario',
      agency: 'Agencia',
      account: 'Cuenta',
      digit: 'Dígito',
      pix: 'PIX'
    },
    operationExchange: {
      bankLabel: 'Banco',
      storeLabel: 'Tienda',
      natureLabel: 'Naturaleza',
      deliveryTypeLabel: 'Forma de entrega',
      amountLabel: 'Cantidad ME',
      customerRateLabel: 'Tasa del cliente',
      spreadLabel: 'Spread',
      profitLabel: 'Ganancia',
      deliveryCostLabel: 'Costo de entrega',
      deliveryDatePickupLabel: 'Fecha de retiro',
      deliveryDateDeliveryLabel: 'Fecha de entrega',
      deliveryTimeLabel: 'Período',
      travelDateLabel: 'Fecha de viaje',
      destinationCountryLabel: 'País de destino',
      customerAccountLabel: 'Cuenta del cliente',
      bankAccountLabel: 'Cuenta del banco',
      observationLabel: 'Observaciones',
      corbanLabel: 'Corban',
      noCorban: '¡Este cliente no tiene un corban!',
      paymentMethodLabel: 'Forma de pago',
      itemTextAccount: 'Banco: {bank} - Agencia: {agency} - Cuenta: {account}',
      errorLoadDeliveryTypes: 'No fue posible cargar los tipos de entrega. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadDeliveryTimes: 'No fue posible cargar los horarios de entrega. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadCorbans: 'No fue posible cargar la lista de corresponsales. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadPaymentMethods: 'No fue posible cargar las formas de pago. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadCustomer: 'No fue posible cargar los datos del cliente. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadExchangeBanks: 'No fue posible cargar los bancos del cliente. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorSearchCustomers: 'No fue posible buscar los clientes. Verifique el texto de búsqueda e inténtelo de nuevo; si continúa, contacte al soporte.',
      cashPaymentWarning: 'El pago en efectivo debe ser retirado en la tienda'
    },
    operationMessages: {
      loadConfigError: 'No fue posible cargar las configuraciones. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      userNotConfigured: 'Su usuario no está configurado para operar. Por favor, contáctese con el responsable del sistema.',
      loadOperationTypesError: 'No fue posible cargar los tipos de operación habilitados para su usuario. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      loadPreSaleError: 'No fue posible cargar los datos de la preventa. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      operationHourError: 'No fue posible {action}. Por favor, inténtelo de nuevo dentro del horario de funcionamiento ({start}h a {end}h)',
      createOperationHourError: 'No fue posible crear la operación. Por favor, inténtelo de nuevo dentro del horario de funcionamiento ({start}h a {end}h)',
      createPreSaleHourError: 'No fue posible crear la preventa. Por favor, inténtelo de nuevo dentro del horario de funcionamiento ({start}h a {end}h)',
      natureRequired: 'Informe la naturaleza de la operación.',
      duimpOverflow: 'La suma de los valores DUIMP/DU-E no puede ser mayor que la cantidad en ME de la operación.',
      copyMessageError: 'No fue posible copiar el mensaje. Verifique los permisos del navegador.',
      bankDisabledWithDesc: 'Este banco no está habilitado para operaciones: {description}',
      bankDisabledDefault: 'Este banco no está habilitado para operaciones en este momento.',
      operationSaved: '¡Operación guardada con éxito!',
      operationSavedWithWarning: 'Operación guardada. {warning}',
      bankQuotationError: 'No fue posible cotizar en {bankName}. Intente actualizar la cotización.',
      bankNoFlows: 'El {bankName} no cotizó ningún flujo de liquidación ahora. Actualice la cotización o inténtelo más tarde.',
      loadCustomerError: 'No fue posible cargar los datos del cliente de la operación. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      loadBanksError: 'No fue posible cargar la lista de bancos. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      loadNaturesError: 'No fue posible cargar la naturaleza de la operación. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      loadCurrenciesError: 'No fue posible cargar la lista de monedas. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      emailClosingError: 'No fue posible enviar el correo de cierre de la operación. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailIndicationError: 'No fue posible enviar el correo de ciencia de indicación. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailIndicationExchangeError: 'No fue posible enviar el correo de ciencia de indicación de la operación de cambio. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailPixError: 'No fue posible enviar el correo de retiro por PIX de la compra de moneda. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailCashError: 'No fue posible enviar el correo de retiro en efectivo de la compra de moneda. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      preSaleSaved: '¡Preventa guardada con éxito!',
      preSaveSaveError: 'No fue posible guardar la preventa. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      preSaleUpdateSaved: '¡Preventa guardada con éxito!',
      preSaleUpdateError: 'No fue posible guardar los cambios de la preventa. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      documentsError: 'La operación fue guardada, pero no fue posible adjuntar los documentos. Abra la operación, verifique los documentos y adjunte de nuevo los que falten; si continúa, contacte al soporte.',
      saveOperationError: 'No fue posible guardar la operación. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      generateWithdrawalError: 'No fue posible generar la autorización de retiro. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      generateWithdrawalMissingData: 'La autorización de retiro no fue generada: faltan datos de quien va a retirar la moneda. Complete en la operación y genere desde la pestaña de documentos.',
      generateWithdrawalSuccess: '¡Autorización de retiro generada automáticamente!',
      emailSellPix: 'No fue posible enviar el correo de retiro por PIX de la venta de moneda. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailSellCash: 'No fue posible enviar el correo de retiro en efectivo de la venta de moneda. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailSellCard: 'No fue posible enviar el correo de retiro con tarjeta de la venta de moneda. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailSellDeliveryPix: 'No fue posible enviar el correo de entrega por PIX de la venta de moneda. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailBankBuyPix: 'No fue posible enviar el correo al banco de retiro por PIX de la compra de moneda. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailBankBuyCash: 'No fue posible enviar el correo al banco de retiro en efectivo de la compra de moneda. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailBankSellPix: 'No fue posible enviar el correo al banco de retiro por PIX de la venta de moneda. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailBankSellCash: 'No fue posible enviar el correo al banco de retiro en efectivo de la venta de moneda. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailBankSellCard: 'No fue posible enviar el correo al banco de retiro con tarjeta de la venta de moneda. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
      emailBankSellDeliveryPix: 'No fue posible enviar el correo al banco de entrega por PIX de la venta de moneda. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.'
    },
    operationRemittance: {
      stablecoinHint: 'Operaciones en stablecoins',
      corbanLabel: 'Corban',
      observationLabel: 'Observaciones',
      countryLabel: 'País',
      addForeignAccountTooltip: 'Agregar cuenta en el exterior',
      addNationalAccountTooltip: 'Agregar cuenta en Brasil',
      copyForeignAccountTooltip: 'Copiar información de la cuenta en el exterior',
      copyNationalAccountTooltip: 'Copiar información de la cuenta en Brasil',
      foreignAccountLabel: 'Cuenta en el exterior',
      nationalAccountLabel: 'Cuenta en Brasil',
      foreignAccountSectionTitle: 'Cuenta bancaria en el exterior - {name}',
      brazilAccountSectionTitle: 'Cuenta bancaria de Brasil',
      fieldBank: 'Banco',
      fieldIban: 'IBAN',
      fieldSwift: 'Código Swift/BIC',
      fieldRouting: 'Número ABA/Routing',
      fieldFfc: 'FFC',
      fieldHolder: 'Nombre del titular',
      fieldAgency: 'Agencia',
      fieldAccount: 'Cuenta',
      fieldDigit: 'Dígito',
      fieldIntermediaryTitle: 'Banco intermediario',
      fieldIntermediaryCountry: 'País',
      fieldIntermediaryBank: 'Banco',
      fieldIntermediaryRouting: 'ABA/Routing',
      amountHintBrl: 'Total de la operación en reales (BRL).',
      amountHintForeign: 'Cantidad en moneda extranjera ({code}).',
      amountHintForeignNoCode: 'Cantidad en moneda extranjera.',
      errorLoadCustomer: 'No fue posible cargar los datos del cliente. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadExchangeBanks: 'No fue posible cargar los bancos del cliente. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorSearchCustomers: 'No fue posible buscar los clientes. Verifique el texto de búsqueda e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadCurrencies: 'No fue posible cargar la lista de divisas. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadCorbans: 'No fue posible cargar la lista de corresponsales. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadCorrespondente: 'No fue posible cargar el corresponsal del cliente. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      copyInfoError: 'No fue posible copiar la información. Inténtelo de nuevo.'
    },
    digitalRemittanceBankSelect: {
      hint: 'Solo bancos digitales (stablecoins)',
      label: 'Banco',
      requiredValidation: 'Campo obligatorio',
      loadBanksError: 'No fue posible cargar los bancos del cliente. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.'
    },
    digitalRemittanceClienteSelect: {
      loadClientsError: 'No fue posible buscar los clientes. Verifique el texto de búsqueda e intente de nuevo; si continúa, contacte al soporte.'
    },
    digitalRemittanceClienteBanco: {
      loadClientError: 'No fue posible cargar los datos del cliente. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.'
    },
    finishOperationModal: {
      title: 'Cierre de operación',
      cardOperationTitle: 'Operación',
      cardTaxesTitle: 'Tributos y costos',
      labelTotal: 'TOTAL',
      labelBankRate: 'Tasa del banco',
      labelQuotation: 'COTIZACIÓN',
      labelCurrency: 'M.E.',
      labelAmountCurrency: 'VALOR M.E.',
      labelCustomerRate: 'TASA DEL CLIENTE',
      labelIof: 'IOF',
      labelTariff: 'TARIFA',
      labelVet: 'VET',
      btnCopyBank: 'Copiar simulación del banco',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      copiedSuccess: 'Simulación del banco copiada.',
      templateNotConfigured: 'Plantilla no configurada. Acceda a Configuraciones > Mensaje de Operación.',
      copyError: 'No fue posible copiar el mensaje. Seleccione el texto y cópielo manualmente (Ctrl+C).'
    },
    bankRateModal: {
      title: 'Cerrar negocio',
      bankRateLabel: 'Tasa del banco',
      btnCopy: 'Copiar simulación',
      btnConfirm: 'Cerrar negocio'
    },
    returnToCustomerModal: {
      title: 'Devuelto al cliente',
      alertText: 'Use cuando el pago del cliente fue devuelto a su cuenta y la salida no va a ocurrir. La operación queda cerrada, el sistema deja de intentar la salida y la comisión no se paga. Esta acción no puede deshacerse.',
      amountLabel: 'Valor devuelto al cliente',
      reasonLabel: 'Motivo',
      btnConfirm: 'Confirmar devolución',
      btnCancel: 'Volver',
      validationAmount: 'Informe el valor devuelto.',
      validationReasonMin: 'Informe el motivo de la devolución.',
      validationReasonMax: 'Máximo de {max} caracteres.'
    },
    operationPreview: {
      summaryTitle: 'Resumen',
      manualRateLabel: 'Ingresar cotización manualmente',
      timerNeedsData: 'Informe el valor y el flujo de liquidación para cotizar en {bankName}',
      timerFrozen: 'Operación congelada',
      timerUpdating: 'Actualizando...',
      timerCountdown: 'Actualizando en {seconds}s',
      errorLoadQuotation: 'No fue posible cargar la cotización de la divisa. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadDollar: 'No fue posible cargar la cotización del dólar. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorBankQuotation: 'No fue posible cotizar en {bankName}. Inténtelo de nuevo.'
    },
    operationPreviewShared: {
      spotLabel: 'Cambio comercial (SPOT)',
      spotLabelBank: 'Cotización {bankName}',
      manualSpotLabel: 'Cambio comercial (SPOT)',
      manualDollarLabel: 'Dólar comercial (para paridad)',
      ptaxAlert: 'No es posible obtener cotización comercial para esta divisa. Se utilizará la cotización de cierre del día anterior.',
      labelIofPct: 'IOF(%)',
      labelIofValue: 'Valor del IOF',
      labelIrPct: 'IR(%)',
      labelIrValue: 'Valor del IR',
      labelCidePct: 'CIDE(%)',
      labelCideValue: 'Valor del CIDE',
      labelTariff: 'Tarifa',
      labelCustomerRate: 'Tasa del cliente',
      labelVet: 'VET (Valor efectivo total)',
      labelTotal: 'Total de la operación',
      labelCustomerPays: 'El cliente paga',
      labelCustomerReceives: 'El cliente recibe',
      btnCopyOperation: 'Copiar datos de la operación',
      templateNotConfigured: 'Plantilla no configurada. Acceda a Configuraciones > Mensaje de Operación.',
      copyError: 'No fue posible copiar el mensaje. Seleccione el texto y cópielo manualmente (Ctrl+C).'
    },
    operationExchangeDeliveryAddress: {
      deliverySectionTitle: 'Datos de entrega',
      receiverQuestion: '¿Quién recibirá la moneda extranjera?',
      radioCustomer: 'El propio cliente',
      radioThirdParty: 'Otra persona indicada',
      thirdPartySectionTitle: 'Datos del tercero designado',
      fieldFullName: 'Nombre completo',
      fieldNationality: 'Nacionalidad',
      fieldMaritalStatus: 'Estado civil',
      fieldCep: 'Código postal',
      fieldStreet: 'Calle',
      fieldNumber: 'Número',
      fieldComplement: 'Complemento',
      fieldNeighborhood: 'Barrio',
      fieldState: 'Estado',
      fieldCity: 'Ciudad',
      fieldDocumentType: 'Tipo de documento',
      fieldCpf: 'CPF',
      fieldRg: 'RG',
      fieldCellphone: 'Celular',
      invalidCep: 'Código postal inválido',
      errorSearchCep: 'No fue posible buscar el código postal. Complete la dirección manualmente.',
      successGenerateDoc: '¡Autorización de retiro generada con éxito!',
      errorGenerateDoc: 'No fue posible generar el documento de autorización. Inténtelo de nuevo; si continúa, contacte al soporte.',
      errorLoadCustomer: 'No fue posible cargar los datos del cliente. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    operationalDocumentsShared: {
      title: 'Documentos de la operación',
      typeLabel: 'Tipo',
      addDocumentLabel: 'Agregar documento',
      contractDoc: 'Contrato de Cambio',
      swiftDoc: 'SWIFT',
      bankSlipDoc: 'Boleto',
      paySlipDoc: 'Comp. de pago',
      titleComex: 'Documentos de Comex',
      btnSendToBank: 'Enviar al banco y cerrar',
      noDataAllAdded: 'Todos los documentos del cliente ya están en la operación',
      successDocumentUpdated: '¡La lista de documentos fue actualizada! Se envió una notificación al banco.',
      errorNotifyBank: 'No fue posible notificar al banco sobre el nuevo documento. Inténtelo de nuevo; si continúa, contacte al soporte.',
      errorNotifyBankOnSend: 'No fue posible enviar notificación al banco. Inténtelo de nuevo; si continúa, contacte al soporte.',
      errorDownload: 'No fue posible descargar el documento. Inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    bankFlowTable: {
      bestRate: 'Mejor tasa'
    },
    bankQuotationCard: {
      bankRateTitle: 'Tasa de {bankName}',
      lockedLabel: 'Bloqueada a las {time}',
      customerRateLabel: 'Tasa del cliente',
      totalLabel: 'Total de la operación',
      refreshButton: 'Actualizar cotización',
      refreshCountdown: 'Actualizando en {seconds}s'
    },
    integratedAccountSelect: {
      internationalPayer: {
        label: 'Cuenta en el exterior de quien paga',
        required: 'Elija la cuenta en el exterior de quien va a pagar esta operación.',
        empty: 'Este cliente no tiene una cuenta en el exterior aprobada en este banco. Integre una cuenta en el registro del cliente para operar.'
      },
      internationalReceiver: {
        label: 'Cuenta en el exterior que recibe',
        required: 'Elija la cuenta en el exterior que va a recibir esta operación.',
        empty: 'Este cliente no tiene una cuenta en el exterior aprobada en este banco. Integre una cuenta en el registro del cliente para operar.'
      },
      national: {
        label: 'Cuenta del cliente en Brasil',
        required: 'Elija la cuenta del cliente en Brasil para esta operación.',
        empty: 'Este cliente no tiene una cuenta activa en Brasil. Registre una cuenta en el registro del cliente para operar.'
      },
      nationalItem: 'Banco {bank} - Ag. {agency} - Cuenta {account}'
    },
    integratedBankQuotation: {
      expired: 'La cotización de {bankName} venció y fue actualizada a {rate}. Verifique la tasa y cierre el negocio de nuevo.'
    },
    integratedNatures: {
      loadError: 'No fue posible cargar las naturalezas integradas con el banco. Intentando de nuevo.'
    },
    chargeEmailHistoryModal: {
      title: 'Historial de solicitud de DUIMPs/DUEs',
      headerDate: 'Fecha/Hora',
      headerAttempt: 'Intento',
      headerStatus: 'Estado',
      headerRecipient: 'Destinatario',
      headerType: 'Tipo',
      headerReason: 'Motivo',
      btnResend: 'Reenviar ahora',
      btnClose: 'Cerrar',
      confirmTitle: 'Confirmar reenvío',
      confirmMessage: '¿Desea reenviar el correo de cobro para esta Invoice?',
      statusSuccess: 'Éxito',
      statusFailed: 'No enviado',
      statusPaused: 'Pausado',
      pausedAlert: 'El cobro automático de esta Invoice está pausado después de varios intentos sin envío. Corrija el motivo indicado en el historial y use Reenviar ahora para retomarlo.',
      isManualLabel: 'Manual',
      isAutoLabel: 'Automático',
      emptyMessage: 'Ningún correo de cobro enviado para esta Invoice.',
      loadError: 'No fue posible cargar el historial.',
      btnRetry: 'Intentar de nuevo',
      resendSuccess: 'Correo reenviado con éxito.',
      resendError: 'No fue posible reenviar el correo. Inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    duimpDueManagerModal: {
      title: 'Gestionar DUIMP/DU-E',
      errorDownload: 'No fue posible descargar el documento. Inténtelo de nuevo; si continúa, contacte al soporte.',
      errorSave: 'No fue posible guardar DUIMP/DU-E. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
      errorUpload: 'No fue posible guardar el documento DUIMP/DU-E. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    duimpTimelineModal: {
      titlePrefix: 'Línea de tiempo — Operación #{id}',
      loadError: 'La línea de tiempo no se cargó. Inténtelo de nuevo.',
      btnRetry: 'Intentar de nuevo',
      emptyMessage: 'Ningún evento registrado para esta operación.'
    },
    editShippingDateModal: {
      title: 'Editar fecha de embarque',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      currentDateLabel: 'Fecha de embarque actual',
      newDateLabel: 'Nueva fecha de embarque',
      noDateLabel: 'No informada',
      nextChargeLabel: 'Próximo cobro previsto:',
      validationRequired: 'Informe la nueva fecha de embarque.',
      successUpdate: 'Fecha de embarque actualizada con éxito.',
      errorUpdate: 'No fue posible actualizar la fecha de embarque. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    shipmentUpdateHistoryModal: {
      title: 'Historial de actualizaciones de embarque',
      labelDate: 'Fecha',
      labelNewForecast: 'Nueva Previsión',
      labelReason: 'Motivo',
      labelObservation: 'Observación',
      labelDocument: 'Documento',
      tooltipDownload: 'Descargar documento',
      emptyMessage: 'Ninguna actualización de embarque registrada.',
      loadError: 'No fue posible cargar el historial.',
      btnRetry: 'Intentar de nuevo'
    },
    authorizationDocumentModal: {
      title: 'Generar Autorización de Retiro',
      btnGenerate: 'Generar y Guardar',
      btnCancel: 'Cancelar',
      customerLabel: 'Cliente (Autorizador)',
      operationLabel: 'Operación',
      authorizationTypeLabel: 'Tipo de Autorización *',
      withdrawerDataTitle: 'Datos del Retirante',
      fullNameLabel: 'Nombre completo *',
      nationalityLabel: 'Nacionalidad *',
      maritalStatusLabel: 'Estado civil *',
      addressLabel: 'Dirección completa *',
      cpfLabel: 'CPF *',
      rgLabel: 'RG',
      validationAuthorizationType: 'Seleccione el tipo de autorización.',
      validationName: 'Informe el nombre del tercero.',
      validationNationality: 'Informe la nacionalidad del tercero.',
      validationMaritalStatus: 'Informe el estado civil del tercero.',
      validationAddress: 'Informe la dirección del tercero.',
      validationDocument: 'Informe el CPF del tercero.',
      successGenerate: 'Autorización generada con éxito.',
      errorGenerate: 'No fue posible generar la autorización. Inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    operationImportData: {
      sectionTitle: 'Datos de Importación / Exportación',
      originCountryLabel: 'País de Origen',
      destinationCountryLabel: 'País de Destino',
      bankingProductQuestion: '¿Esta operación está vinculada a algún producto bancario?',
      bankingProductHint: '(Ej.: Pronamp, Finimp, Capital de Giro, etc.)',
      bankingProductYes: 'Sí',
      bankingProductNo: 'No',
      bankingProductDocumentsTitle: 'Documentos del producto bancario',
      invoicesTitle: 'Facturas de la operación',
      invoiceNumberLabel: 'Nº de Factura',
      invoiceDateLabel: 'Fecha de Factura',
      shippingForecastLabel: 'Previsión de embarque',
      tooltipRemoveFile: 'Eliminar archivo',
      tooltipRemoveDoc: 'Eliminar documento',
      tooltipAddDoc: 'Agregar documento',
      tooltipRemoveInvoice: 'Eliminar factura',
      tooltipAddInvoice: 'Agregar factura',
      duimpTitle: 'DUIMP/DU-E',
      validationBankingProduct: 'Informe si la operación está vinculada a un producto bancario'
    },
    duimpCoverageProgress: {
      finished: 'Finalizado',
      pending: 'Pendiente: {code} {value}',
      pendingNoCode: 'Pendiente: {value}'
    },
    customerOperationalDocuments: {
      sectionTitle: 'Documentos complementarios',
      btnSearch: 'Buscar en el cliente',
      modalTitle: 'Documentos complementarios',
      btnAdd: 'Agregar',
      btnClose: 'Cerrar',
      noDataText: 'Todos los documentos del cliente ya están en la operación',
      errorLoadCustomer: 'No fue posible cargar los datos del cliente. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
    },
    currencySelect: {
      validationRequired: 'Divisa obligatoria',
      noDataText: 'Ninguna divisa disponible'
    },
    cancelConfirmTitle: '¿Cancelar?',
    cancelConfirmPrimary: 'Sí, cancelar',
    cancelConfirmMsgEdit: '¿Hay datos completados, desea realmente cancelar la edición?',
    cancelConfirmMsgNew: '¿Hay datos completados, desea realmente cancelar el registro?',
    bankNotEnabledTitle: 'Este banco no está habilitado para operaciones en este momento',
    cancelButton: 'Cancelar',
    saveButton: 'Guardar',
    viewBankSimulation: 'Ver simulación del banco',
    closeBusinessButton: 'Cerrar negocio',
    savePreSaleButton: 'Guardar preventa',
    updatePreSaleButton: 'Actualizar preventa'
  },
  onboarding: {
    checklist: {
      title: 'Primeros Pasos',
      progress: '{completed}/{total} completados',
      markComplete: 'Marcar como completado',
      next: 'Siguiente',
      stepCompleted: '¡Paso completado con éxito!',
      loadError: 'No fue posible cargar los primeros pasos. Actualice la página (F5) e inténtelo de nuevo.',
      completeError: 'No fue posible marcar el paso como completado. Verifique los datos e inténtelo de nuevo.'
    },
    steps: {
      welcome: 'Bienvenido',
      users: 'Equipo',
      corban: 'Corresponsal',
      banks: 'Bancos',
      spreads: 'Spreads',
      client: 'Primer cliente',
      templates: 'Plantillas',
      triggers: 'Disparadores'
    },
    setupWizard: {
      goToSystem: 'Ir al sistema',
      markComplete: 'Marcar como completado',
      next: 'Siguiente',
      finishSetup: 'Finalizar configuración',
      confirmTitle: 'Confirmar conclusión',
      confirmYes: 'Sí, finalizar',
      confirmPendingBody: 'Hay pasos obligatorios que aún no han sido completados. Sin finalizarlos, no será posible iniciar la operación (comprar o vender moneda extranjera).',
      confirmContinueBody: '¿Desea finalizar de todas formas? Podrá retomar la configuración desde el menú de Configuraciones.',
      setupCompleted: '¡Configuración finalizada! Puede acceder al setup nuevamente en Configuraciones.'
    },
    sidebar: {
      title: 'PRIMEROS PASOS',
      stagesCompleted: '{completed}/{total} etapas completadas',
      mandatory: 'obligatorio',
      helpTitle: '¿Necesita ayuda?',
      helpLink: 'Contactar soporte'
    },
    welcome: {
      features: {
        internationalRemittances: {
          title: 'Remesas Internacionales',
          description: 'Envíe y reciba valores del exterior con cotizaciones en tiempo real y seguimiento completo.'
        },
        dashboard: {
          title: 'Dashboard Operacional',
          description: 'Seguimiento de métricas de operaciones, ganancias y volumen en un panel gerencial completo.'
        },
        customerManagement: {
          title: 'Gestión de Clientes',
          description: 'Registro completo con compliance, flujo de registro y aprobación integrada con el banco.'
        },
        spreads: {
          title: 'Spreads y Comisiones',
          description: 'Configure márgenes por moneda y automatice el cálculo de comisiones para corresponsales.'
        },
        duimp: {
          title: 'Gestión DUIMP/DU-E',
          description: 'Control de importaciones y exportaciones con seguimiento de embarques y cobros automáticos.'
        },
        whatsapp: {
          title: 'WhatsApp Integrado',
          description: 'Comunicación directa con clientes vía WhatsApp con historial centralizado en el sistema.'
        },
        reports: {
          title: 'Informes Gerenciales',
          description: 'Informes operacionales, de ganancias y gestión exportables para toma de decisiones.'
        },
        audit: {
          title: 'Auditoría y Compliance',
          description: 'Registro completo de acciones en el sistema con trazabilidad y conformidad regulatoria.'
        },
        automations: {
          title: 'Automatizaciones',
          description: 'E-mails automáticos, disparadores por evento y notificaciones configurables.'
        },
        whitelabel: {
          title: 'Whitelabel',
          description: 'Personalice colores, logo y plantillas con la identidad visual de su empresa.'
        }
      },
      setupGreeting: '¡Qué bueno tenerte aquí!',
      setupSubtitle: 'Nos alegra recibirte en Tech Câmbio. Preparamos una guía rápida para ayudarte a configurar todo — a tu ritmo, sin prisa.',
      tipTitle: 'Tranquilo',
      tipText: 'Esta configuración dura pocos minutos y puedes volver cuando quieras. Los pasos opcionales pueden configurarse después.',
      whatAwaitsTitle: 'LO QUE TE ESPERA',
      setupFeatures: {
        internationalRemittances: {
          title: 'Remesas Internacionales',
          description: 'Envíe y reciba valores del exterior con cotizaciones en tiempo real.'
        },
        dashboard: {
          title: 'Dashboard Operacional',
          description: 'Métricas de operaciones, ganancias y volumen en un panel completo.'
        },
        customerManagement: {
          title: 'Gestión de Clientes',
          description: 'Registro con compliance, flujo de registro y aprobación integrada.'
        },
        spreads: {
          title: 'Spreads y Comisiones',
          description: 'Márgenes por moneda y cálculo automático de comisiones.'
        },
        automations: {
          title: 'Automatizaciones',
          description: 'E-mails automáticos, disparadores por evento y notificaciones.'
        },
        whitelabel: {
          title: 'Whitelabel',
          description: 'Colores, logo y plantillas con la identidad de su empresa.'
        }
      }
    },
    users: {
      profileHeader: 'Perfil',
      loadError: 'No fue posible cargar usuarios. Actualice la página (F5) e inténtelo de nuevo.',
      setupTitle: 'Forme su equipo',
      setupSubtitle: 'Cada persona que opera el sistema necesita su propio usuario. Así tendrá control de quién hizo qué, con permisos adecuados para cada función.',
      infoCards: {
        security: {
          title: 'Seguridad',
          description: 'Cada acción queda registrada con el nombre de quien la realizó.'
        },
        profiles: {
          title: 'Perfiles de acceso',
          description: 'Controle lo que cada persona puede ver y hacer en el sistema.'
        }
      },
      inviteTitle: 'Invitar colaborador',
      inviteEmailLabel: 'E-mail del colaborador',
      inviteButton: 'Invitar',
      inviteHint: 'El colaborador recibirá un e-mail para crear su contraseña y acceder al sistema con el perfil seleccionado.',
      noInvitesSent: 'Ninguna invitación enviada aún',
      inviteStatusPending: 'Esperando primer acceso',
      inviteStatusAccepted: 'Acceso realizado',
      inviteSentSuccess: '¡Invitación enviada con éxito!',
      inviteSendError: 'No fue posible enviar la invitación. Inténtelo de nuevo en unos instantes.',
      addManually: 'Registrar manualmente',
      manageProfiles: 'Gestionar perfiles'
    },
    corban: {
      registrationDate: 'Fecha de registro',
      loadError: 'No fue posible cargar corresponsales. Actualice la página (F5) e inténtelo de nuevo.',
      setupTitle: 'Su corresponsal bancario',
      setupSubtitle: 'El corresponsal (Corban) es quien intermedia las operaciones de cambio entre sus clientes y los bancos. Sin él registrado, el sistema no puede procesar operaciones.',
      infoCards: {
        mediation: {
          title: 'Intermediación',
          description: 'El Corban conecta a sus clientes con los bancos de cambio.'
        },
        commissions: {
          title: 'Comisiones',
          description: 'Reciba comisiones automáticamente en cada operación cerrada.'
        },
        compliance: {
          title: 'Compliance',
          description: 'Datos de registro y regulatorios en un solo lugar.'
        }
      },
      registeredChip: 'Registrado',
      emailLabel: 'E-mail',
      phoneLabel: 'Teléfono',
      noCorbanText: 'Ningún corresponsal registrado aún',
      addCorbanButton: 'Registrar corresponsal',
      editCorbanButton: 'Editar'
    },
    bank: {
      companyName: 'Razón social',
      loadError: 'La lista de bancos no cargó. Actualice la página (F5) e inténtelo de nuevo.',
      setupTitle: 'Bancos de cambio asociados',
      setupSubtitle: 'Los bancos son los socios que liquidan las operaciones de cambio. El sistema ya viene con los principales bancos pre-registrados — solo active los que va a operar.',
      infoCards: {
        preCadastred: {
          title: 'Pre-registrados',
          description: 'Los principales bancos ya están en el sistema, listos para activar.'
        },
        toggleActive: {
          title: 'Activar y desactivar',
          description: 'Encienda o apague un banco en cualquier momento con un clic.'
        },
        newBanks: {
          title: 'Nuevos bancos',
          description: 'Si necesita un banco que no está aquí, regístrelo manualmente.'
        }
      },
      availableBanksTitle: 'Bancos disponibles',
      addBankButton: 'Registrar nuevo banco',
      viewBanksButton: 'Ver todos los bancos'
    },
    spread: {
      reviewButton: 'Revisar spreads',
      currencyHeader: 'Moneda',
      spreadSell: 'Spread venta (%)',
      spreadBuy: 'Spread compra (%)',
      loadError: 'No fue posible cargar monedas. Actualice la página (F5) e inténtelo de nuevo.',
      setupTitle: 'Sus márgenes de ganancia',
      setupSubtitle: 'El spread es la diferencia entre el cambio comercial y el precio que paga su cliente. Así genera ingresos en cada operación. El sistema ya viene con valores recomendados — ajuste según su estrategia.',
      infoCards: {
        perCurrency: {
          title: 'Margen por moneda',
          description: 'Defina spreads diferentes para cada moneda según su estrategia.'
        },
        directImpact: {
          title: 'Impacto directo',
          description: 'El spread define el precio que sus clientes verán en las cotizaciones.'
        },
        adjustAnytime: {
          title: 'Ajuste en cualquier momento',
          description: 'Cambie los valores cuando lo necesite, sin impactar operaciones cerradas.'
        }
      },
      spreadsByCurrencyTitle: 'Spreads por moneda',
      buyCurrencyLabel: 'Compra',
      sellCurrencyLabel: 'Venta',
      editSpreadsButton: 'Editar spreads',
      viewCurrenciesButton: 'Ver todas las monedas'
    },
    client: {
      createButton: 'Registrar cliente',
      workflowButton: 'Flujo de registro',
      setupTitle: 'Registre su primer cliente',
      setupSubtitle: 'Con el cliente registrado, ya puede crear su primera operación de cambio. El formulario es sencillo y puede completarse después.',
      infoCards: {
        quickRegistration: {
          title: 'Registro rápido',
          description: 'Complete solo los datos esenciales ahora y el resto después.'
        },
        organizedDocs: {
          title: 'Documentación organizada',
          description: 'Adjunte documentos y mantenga todo centralizado en el registro.'
        },
        alwaysEditable: {
          title: 'Siempre editable',
          description: 'Vuelva al registro en cualquier momento para actualizar información.'
        }
      },
      customersRegistered: '{count} cliente(s) registrado(s)',
      canCreateOperations: 'Ya puede crear operaciones de cambio',
      noCustomersText: 'Ningún cliente registrado aún',
      addClientButton: 'Registrar cliente',
      sendRegistrationButton: 'Enviar registro',
      viewClientsButton: 'Ver clientes registrados',
      onboardingFlowTitle: '¿Cómo funciona el flujo de registro?',
      onboardingFlowDesc: 'El registro del cliente pasa por etapas hasta estar listo para operar. Usted controla el progreso por el tablero de Flujo de Registro, moviendo las tarjetas según analiza y aprueba cada etapa.',
      stages: {
        registration: {
          title: '1. Registro',
          description: 'Cree el cliente (PF o PJ) con datos personales, dirección, documentos y cuentas bancarias.'
        },
        submission: {
          title: '2. Envío para análisis',
          description: 'Después de completar el registro, envíelo para análisis. La tarjeta aparece en el tablero de Flujo de Registro.'
        },
        analysis: {
          title: '3. Análisis y aprobación',
          description: 'Analice los datos y documentos. Mueva la tarjeta a Aprobado, Pendiente o Rechazado según corresponda.'
        },
        bankEnable: {
          title: '4. Habilitación en el banco',
          description: 'Agregue el banco de cambio al cliente y siga la aprobación. Cada banco tiene su propio estado.'
        },
        readyToOperate: {
          title: '5. Listo para operar',
          description: 'Con registro finalizado + banco aprobado + límites definidos, el cliente puede realizar operaciones.'
        }
      }
    },
    templates: {
      emailTemplatesTitle: 'Plantillas de e-mail',
      emailTemplatesDesc: 'Cada vez que el sistema envía un e-mail a sus clientes, corresponsales o bancos, utiliza una plantilla como base. La plantilla define el diseño (logo, colores, layout) y el texto del mensaje. Puede personalizar todas las plantillas para que sus e-mails tengan la identidad de su empresa.',
      features: {
        visualEditor: {
          title: 'Editor visual',
          description: 'Edite el contenido de los e-mails usando un editor de texto rico — sin necesitar conocimientos de HTML.'
        },
        autoData: {
          title: 'Datos automáticos',
          description: 'Inserte campos como nombre del cliente o valor de la operación. El sistema los completa automáticamente al enviar.'
        },
        onePerSituation: {
          title: 'Una plantilla por situación',
          description: 'Cada tipo de e-mail (ficha de registro, confirmación, pendencia) tiene su propia plantilla independiente.'
        }
      },
      tip: 'Consejo: personalice las plantillas antes de configurar los disparadores. Así, cuando active el envío automático, los e-mails ya saldrán con la imagen de su empresa.',
      viewTemplatesButton: 'Ver plantillas',
      createTemplateButton: 'Crear plantilla',
      setupTitle: 'Personalice sus comunicaciones',
      setupSubtitle: 'Las plantillas definen la apariencia de los e-mails, mensajes y documentos que reciben sus clientes. El sistema ya viene con modelos listos — personalice con su marca cuando quiera.',
      infoCards: {
        brandIdentity: {
          title: 'Su identidad visual',
          description: 'Logotipo, colores e información de su empresa en los documentos.'
        },
        readyModels: {
          title: 'Modelos listos',
          description: 'Comience con las plantillas estándar y ajuste según la necesidad.'
        },
        preview: {
          title: 'Vista previa',
          description: 'Vea cómo lo recibirán sus clientes antes de activar.'
        }
      },
      availableTemplatesTitle: 'Plantillas disponibles',
      types: {
        email: {
          title: 'E-mails',
          description: 'Notificaciones de registro, operaciones, pendencias y alertas.'
        },
        operationMessage: {
          title: 'Mensajes de operación',
          description: 'Textos listos para enviar al cliente vía WhatsApp o copiar.'
        },
        documents: {
          title: 'Documentos emitidos',
          description: 'Contratos de cambio, comprobantes y fichas de cliente.'
        }
      },
      editTemplatesButton: 'Editar plantillas',
      emailLayoutButton: 'Diseño de e-mail'
    },
    triggers: {
      emailTriggersTitle: 'Disparadores de e-mail',
      emailTriggersDesc: 'El sistema puede enviar e-mails automáticamente en situaciones importantes — como cuando un cliente completa el formulario de registro, cuando una operación cambia de estado, o cuando hay alguna pendencia. Cada e-mail automático se llama "disparador" y usted decide cuáles mantener activos.',
      categoriesTitle: 'Categorías de disparadores',
      categories: {
        customer: {
          title: 'E-mails para el cliente',
          description: 'Envío del formulario de registro, aviso de pendencia, confirmación de cuenta en el exterior y cambio turismo.'
        },
        corban: {
          title: 'E-mails para el corresponsal',
          description: 'Notificaciones de actualización de registro, aprobación de clientes, informes y creación de usuario.'
        },
        bank: {
          title: 'E-mails para el banco',
          description: 'Envío del registro del cliente al banco, actualización de datos y comprobantes de operación.'
        },
        system: {
          title: 'E-mails del sistema',
          description: 'Recuperación de contraseña y notificaciones de seguridad para los usuarios del sistema.'
        }
      },
      categoriesFooter: 'Cada disparador utiliza una de las plantillas que configuró en el paso anterior. Para activar o desactivar un disparador, acceda a la pantalla de configuraciones y cambie el campo "Habilitado" del e-mail deseado.',
      viewSettingsButton: 'Ver configuraciones',
      setupTitle: 'Automatizaciones de e-mail',
      setupSubtitle: 'Los disparadores envían e-mails automáticamente cuando algo ocurre en el sistema — un cliente se registra, una operación se cierra, un documento está pendiente. Active solo los que tienen sentido para su flujo.',
      infoCards: {
        automatic: {
          title: 'Automático',
          description: 'Los e-mails se envían sin acción manual del operador.'
        },
        manageable: {
          title: 'Manejable',
          description: 'Active, desactive y personalice cada disparador en las configuraciones.'
        },
        customizable: {
          title: 'Personalizable',
          description: 'Cada disparador usa una plantilla que puede editar.'
        }
      },
      mainTriggersTitle: 'Principales disparadores',
      triggerItems: {
        sendRegistration: {
          title: 'Envío de formulario de registro',
          description: 'Cuando el operador envía el registro al cliente.'
        },
        registrationComplete: {
          title: 'Registro finalizado',
          description: 'Cuando el cliente completa el formulario.'
        },
        pendingDocs: {
          title: 'Pendencias documentales',
          description: 'Cuando faltan documentos en el registro.'
        },
        operationClosed: {
          title: 'Cierre de operación',
          description: 'Cuando una operación de cambio es concluida.'
        },
        operationCancelled: {
          title: 'Cancelación de operación',
          description: 'Cuando una operación es cancelada.'
        },
        swiftSent: {
          title: 'Comprobante SWIFT',
          description: 'Cuando se envía el comprobante de pago.'
        }
      },
      manageTriggersButton: 'Gestionar todos los disparadores'
    }
  },

  simulator: {
    slider: {
      send: 'Enviar',
      pay: 'El cliente paga'
    },
    optionalCustomer: '(Opcional) Cliente / DNI / CUIT',
    cityLabel: 'Ciudad',
    bankLabel: 'Banco',
    storeLabel: 'Tienda',
    natureLabel: 'Naturaleza',
    currencyAmountLabel: 'Cantidad ME',
    brlAmountLabel: 'Cantidad en Pesos',
    deliveryTypeLabel: 'Forma de Entrega',
    deliveryCostLabel: 'Costo de Entrega',
    spreadLabel: 'Spread',
    customerRateLabel: 'Tasa del Cliente',
    tariffLabel: 'Tarifa',
    spotRateLabel: 'Cambio comercial (SPOT)',
    iofLabel: 'IOF({pct}%)',
    irLabel: 'IR({pct}%)',
    cideLabel: 'CIDE({pct}%)',
    totalLabel: 'Total',
    limitLabel: 'Límite:',
    expiresLabel: 'Vence el:',
    errors: {
      loadCities: 'No fue posible cargar la lista de ciudades. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      loadBanks: 'No fue posible cargar los bancos que atienden la ciudad elegida. Elija la ciudad de nuevo; si continúa, contacte al soporte.',
      loadStores: 'No fue posible cargar las tiendas del banco. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      loadNatures: 'No fue posible cargar las naturalezas de operación. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      loadDeliveryTypes: 'No fue posible cargar los tipos de entrega. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      loadCurrencies: 'No fue posible cargar la lista de monedas. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      loadBankList: 'No fue posible cargar la lista de bancos. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      loadCustomers: 'No fue posible buscar los clientes. Verifique el texto de búsqueda e intente nuevamente; si continúa, contacte al soporte.',
      loadCustomerBanks: 'No fue posible cargar los bancos del cliente. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.',
      loadCustomerData: 'No fue posible cargar los datos del cliente. Actualice la página (F5) e intente nuevamente; si continúa, contacte al soporte.'
    }
  },

  usersControl: {
    tabSystemic: 'Usuarios sistémicos',
    tabCorban: 'Usuarios corbanes',
    tabCustomer: 'Usuarios clientes',
    addUserButton: 'Agregar',
    optionsTooltip: 'Opciones',
    editMenuItem: 'Editar',
    inactivateMenuItem: 'Inactivar',
    resendAccessMenuItem: 'Reenviar acceso',
    modalTitleAdd: 'Agregar usuario',
    modalTitleEdit: 'Editar usuario',
    nameLabel: 'Nombre',
    profileLabel: 'Perfil',
    canOperateLabel: '¿Puede operar?',
    passwordLabel: 'Contraseña',
    colCode: 'Código',
    colProfile: 'Perfil',
    colCreatedAt: 'Fecha de registro',
    colStatus: 'Estado',
    colFirstAccess: '¿Ya realizó primer acceso?',
    colCanOperate: 'Puede operar',
    colActions: 'Acciones',
    statusActive: 'Activo',
    statusInactive: 'Inactivo',
    addSuccess: '¡Usuario registrado con éxito!',
    updateSuccess: '¡{email} fue actualizado con éxito!',
    inactiveSuccess: '¡El {email} fue inactivado con éxito!',
    accessResentSuccess: '¡Acceso reenviado con éxito!',
    inactivateTitle: '¿Inactivar usuario?',
    inactivateMessage: '¿Realmente desea inactivar al usuario {email}?',
    resendEmailTitle: '¿Reenviar correo de acceso?',
    resendEmailMessage: 'Al reenviar el correo de primer acceso, el usuario recibirá un correo con una contraseña provisional y deberá obligatoriamente redefinir la contraseña en el primer acceso.',
    loadProfilesError: 'No fue posible cargar la lista de perfiles de acceso. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadUsersError: 'No fue posible cargar la lista de usuarios. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    addError: 'No fue posible registrar el usuario. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
    updateError: 'No fue posible guardar los cambios del usuario. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
    inactivateError: 'No fue posible inactivar el usuario. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
    accessResentError: 'No fue posible enviar el correo de acceso al usuario. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
    avatarError: 'Los datos del usuario fueron guardados, pero no fue posible enviar la foto. Edite el usuario y envíe la foto de nuevo; si continúa, contacte al soporte.',
    avatarRemoveError: 'No fue posible eliminar la foto del usuario. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.'
  },

  supportRedirect: {
    loading: 'Abriendo el soporte...',
    back: 'Volver',
    errorForbidden: 'Tu perfil no tiene acceso al soporte. Habla con el administrador de tu empresa.',
    errorUnavailable: 'Soporte no disponible en esta instancia.',
    errorDefault: 'No fue posible abrir el soporte. Inténtelo de nuevo en un momento.'
  },

  customersControl: {
    columns: {
      code: 'Código',
      customer: 'Cliente',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      status: 'Estado',
      registrationDate: 'Fecha de registro',
      actions: 'Acciones',
      expandedStatus: 'Estado',
      type: 'Tipo',
      linkedBank: 'Banco vinculado',
      approvedNatures: 'Naturalezas aprobadas',
      entry: 'Entrada',
      exit: 'Salida',
      validity: 'Validez'
    },
    loadCustomerDetailsError: 'No fue posible cargar los detalles del cliente. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadCorbansFilterError: 'No fue posible cargar la lista de corbanes del filtro. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadListError: 'No fue posible cargar la lista de clientes. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadCountError: 'No fue posible cargar la cantidad de clientes. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    preSaveSavedSuccess: '¡Cliente guardado con éxito!',
    preSaveSaveError: 'No fue posible guardar el pre-registro del cliente. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
    resendSuccess: 'Cadastro reenviado al banco con éxito.',
    resendError: 'No fue posible reenviar. Verifique los datos e inténtelo de nuevo.',
    updateRequestSent: '¡Solicitud de actualización de registro enviada con éxito!',
    updateRequestError: 'No fue posible enviar la solicitud de actualización al cliente. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
    firstAccessEmailResent: 'Correo de primer acceso reenviado',
    firstAccessEmailResentError: 'No fue posible reenviar el correo de primer acceso al cliente. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.'
  },

  customersAuthorizationControl: {
    loadListError: 'No fue posible cargar la lista de clientes en análisis. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadCountError: 'No fue posible cargar la cantidad de clientes en análisis. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    limitMissingData: 'No se encontraron los datos del banco o del cliente.',
    limitAdded: '¡Límite agregado con éxito!',
    limitAddError: 'No fue posible agregar el límite del cliente. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
    refreshError: 'Los datos no fueron actualizados. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
  },

  formAuthorizationCustomer: {
    statusUpdated: '¡Estado actualizado con éxito!',
    statusUpdateError: 'No fue posible cambiar la situación del registro del cliente. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
    statusUpdateBankError: 'No fue posible cambiar la situación del registro del cliente en el banco. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
    pendingEmailSent: '¡Correo de pendencia de registro enviado con éxito!',
    pendingEmailError: 'No fue posible enviar el correo de pendencia de registro al cliente. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.'
  },

  externalShortLink: {
    opening: 'Abriendo el enlace',
    unavailable: 'Enlace no disponible'
  },

  customerSelfie: {
    customerSelfieUi: {
      sentSelfieAlt: 'Selfie enviada',
      verificationDoneTitle: 'Verificación completada',
      verificationDoneText: 'Estamos analizando sus documentos y datos para completar su registro. En breve, uno de nuestros especialistas se comunicará con usted',
      goToWebsite: 'Ir al sitio web',
      processingPhoto: 'Procesando la foto',
      qrCodeTitle: 'Continúe desde su celular',
      qrCodeText: 'Escanee el código QR para continuar con la verificación de identidad',
      orCopyLink: 'O copie el enlace:'
    },
    customerNotFound: 'Cliente no encontrado. Redireccionando...',
    selfieNotSent: 'La selfie no fue enviada: la foto no fue reconocida. Tome una nueva foto con el rostro bien iluminado.',
    selfieUploadError: 'La selfie no fue enviada. Verifique su internet e inténtelo de nuevo.',
    qrCodeError: 'No se pudo generar el código QR. Actualice la página e inténtelo de nuevo.',
    linkCopied: '¡Enlace copiado al portapapeles!',
    linkCopyError: 'No fue posible copiar el enlace. Inténtelo manualmente.'
  },

  operationDocumentsExternalAccess: {
    pageTitle: 'Documentos de la operación',
    documentsSection: 'Documentos',
    complementarySection: 'Documentos Complementarios',
    comexSection: 'Documentos de Comex',
    downloadError: 'No fue posible descargar el documento. Inténtelo de nuevo; si continúa, contacte al soporte.',
    loadDocumentsError: 'No fue posible cargar los documentos de la operación. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
  },

  correspondentSpreads: {
    sectionTitle: 'Spread de remesa',
    columns: {
      code: 'Código',
      name: 'Nombre',
      minSpreadSell: 'Spread Mínimo Venta(%)',
      recSpreadSell: 'Spread Recomendado Venta(%)',
      maxSpreadSell: 'Spread Máximo Venta(%)',
      minSpreadBuy: 'Spread Mínimo Compra(%)',
      recSpreadBuy: 'Spread Recomendado Compra(%)',
      maxSpreadBuy: 'Spread Máximo Compra(%)',
      deliveryExemption: 'Valor Para Exención de Delivery($)',
      actions: 'Acciones'
    },
    fields: {
      search: 'Buscar',
      minSpreadSell: 'Spread Mínimo Venta(%)',
      recSpreadSell: 'Spread Recomendado Venta(%)',
      maxSpreadSell: 'Spread Máximo Venta(%)',
      minSpreadBuy: 'Spread Mínimo Compra(%)',
      recSpreadBuy: 'Spread Recomendado Compra(%)',
      maxSpreadBuy: 'Spread Máximo Compra(%)'
    },
    loadCurrenciesError: 'No fue posible cargar la lista de monedas. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    addSpreadError: 'No fue posible agregar el spread. Verifique los valores e inténtelo de nuevo; si continúa, contacte al soporte.',
    saveSpreadError: 'No fue posible guardar los cambios del spread. Verifique los valores e inténtelo de nuevo; si continúa, contacte al soporte.'
  },

  bankCover: {
    loadBankTypesError: 'No fue posible cargar los tipos de banco. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadDocumentModelsError: 'No fue posible cargar la lista de modelos de documento. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadIntegrationsError: 'No fue posible cargar la lista de integraciones bancarias. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    noIntegrationHint: 'Sin integración: el registro sigue por ficha y correo',
    choosePlayerHint: 'Elija el player para definir el tipo de integración',
    signaturePlayerLabel: 'Player de firma',
    integrationPlayerLabel: 'Player de integración',
    signaturePlayerNotConfigured: 'El player {player} aún no tiene credenciales configuradas. El envío de fichas para firma no va a funcionar hasta que sean configuradas en Configuraciones → Firmas.',
    signaturePlayerDefaultNotConfigured: 'Sin un player propio, este banco usa el player predeterminado ({player}), que aún no tiene credenciales configuradas en Configuraciones → Firmas.',
    signaturePlayerNotDefined: 'Ningún player de firma definido para este banco ni como predeterminado en Configuraciones → Firmas. El envío de fichas para firma no va a funcionar.'
  },

  exchangeStores: {
    loadDeliveryTypesError: 'No fue posible cargar los tipos de entrega. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadDeliveryTimesError: 'No fue posible cargar los horarios de entrega. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadWithdrawalDatesError: 'No fue posible cargar las fechas de retiro. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    addStoreError: 'No fue posible agregar la tienda. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
    saveStoreError: 'No fue posible guardar los cambios de la tienda. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.'
  },

  formCustomerMessages: {
    savedWithPending: 'Datos guardados. El registro será enviado al banco automáticamente.',
    pendingNotResolved: 'Pendencias no resueltas. Revise los datos.',
    resubmittedSuccess: '¡Registro reenviado al banco con éxito!',
    resubmitError: 'No fue posible reenviar el registro al banco. Revise los datos e inténtelo de nuevo.',
    externalTitlePJ: 'Registro de Persona Jurídica',
    externalTitleCustomer: 'Registro de Cliente',
    validationRequired: 'Hay campos obligatorios sin completar',
    validationPartnersCpf: 'Todos los socios deben tener CPF/CNPJ informado',
    validationNationalBank: 'Es necesario registrar al menos una cuenta bancaria en Brasil',
    docProofOfAddress: 'Comprobante de dirección de la empresa',
    docRevenue12Months: 'Facturación de los últimos 12 meses',
    docDreOrPgdas: 'DRE o Recibo PGDAS',
    docTypeChangedWarning: 'Ha cambiado el tipo de documento. Verifique si los documentos adjuntos corresponden al nuevo tipo seleccionado.',
    partnerLinkedUpdated: '¡Cliente del socio actualizado!',
    partnerLinkedUpdateError: 'No fue posible actualizar el cliente vinculado al socio. Verifique los datos del socio e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadCustomerError: 'No fue posible cargar el registro del cliente. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    emailAlreadyRegistered: 'Este correo ya está registrado para otro cliente',
    requiredDocsMissing: 'Complete todos los documentos obligatorios de la empresa antes de guardar.',
    requiredDocsNamed: 'Documentos obligatorios de la empresa no completados: {docs}.',
    prepareError: 'Los datos del cliente no fueron preparados para envío. Revise el registro e inténtelo de nuevo.',
    preSaveError: 'No fue posible guardar el pre-registro del cliente. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.',
    createSuccess: '¡Cliente guardado con éxito!',
    finalizeError: 'El registro no fue finalizado. Verifique los campos obligatorios destacados e inténtelo de nuevo.',
    saveError: 'No fue posible guardar el cliente. Verifique los campos del registro e inténtelo de nuevo; si continúa, contacte al soporte.',
    emailTriggerError: 'El cliente fue guardado, pero no fue posible enviar el correo de acceso. Reenvíe el acceso en la lista de clientes; si continúa, contacte al soporte.',
    updateSuccess: '¡Cliente actualizado con éxito!',
    updateError: 'No fue posible actualizar el cliente. Verifique los campos del registro e inténtelo de nuevo; si continúa, contacte al soporte.',
    updateRequestSent: '¡Solicitud de actualización de registro enviada con éxito!',
    updateRequestError: 'No fue posible enviar al cliente la solicitud de actualización de registro. Verifique el correo en el registro e inténtelo de nuevo.',
    bankAccountEmailSent: '¡Correo de solicitud de registro de cuenta enviado con éxito!',
    bankAccountEmailError: 'No fue posible enviar al cliente la solicitud de registro de cuenta en el exterior. Verifique el correo en el registro e inténtelo de nuevo.',
    progressPFComplete: 'Registro progresado a Persona Física Completo y guardado. Ahora puede completar los campos adicionales.',
    progressPFBasic: 'Registro progresado a Persona Física Básico y guardado. Ahora puede completar los campos adicionales.',
    progressError: 'No fue posible progresar el registro. Inténtelo de nuevo.',
    mainCustomerCreating: 'Creando cliente principal...',
    mainCustomerCreated: '¡Cliente principal creado con éxito!',
    mainCustomerError: 'No fue posible crear el cliente principal. Verifique los datos e inténtelo de nuevo.',
    confirmationEmailError: 'El registro fue concluido, pero no fue posible enviar el correo de confirmación al cliente. Verifique el correo en el registro; si continúa, contacte al soporte.',
    partnersShareError: 'La suma de las participaciones de los socios debe ser igual al 100%.',
    generateSelfieNeedCustomer: 'El cliente debe estar creado para generar el link de selfie.',
    generateSelfieAdminNotReady: 'La funcionalidad de envío por correo será implementada. Por ahora, acceda al cliente vía acceso externo para generar el link.',
    generateSelfieExternalOnly: 'El link de selfie solo puede generarse desde el link de registro enviado al cliente. Abra el registro por ese link e inténtelo de nuevo.',
    selfieLinkCopied: '¡Link de selfie copiado al portapapeles!',
    selfieLinkGenerated: 'Link generado: {link}',
    bankPendingLoadError: 'Las pendencias del banco no cargaron. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
  },

  customersAuthorizationBoard: {
    customersAuthorizationControlBoardUi: {
      reactivate: 'Reactivar registro',
      sendToBank: 'Enviar al banco'
    },
    updateBoardError: 'No fue posible actualizar el cuadro de clientes. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadCustomersError: 'No fue posible cargar los clientes en análisis. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    changeStatusError: 'No fue posible cambiar el estado del cliente. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    changeStatusAndRevertError: 'No fue posible cambiar el estado del cliente y la tarjeta volvió a la columna anterior. Inténtelo de nuevo; si continúa, contacte al soporte.',
    pendingEmailSent: '¡Correo de pendencia de registro enviado con éxito!',
    pendingRegistered: '¡Pendencia registrada con éxito!',
    pendingRegisterError: 'No fue posible registrar la pendencia del cliente. Verifique el texto de la pendencia e inténtelo de nuevo; si continúa, contacte al soporte.',
    observationSaved: '¡Observación guardada con éxito!',
    observationSaveError: 'No fue posible guardar la observación. Inténtelo de nuevo; si continúa, contacte al soporte.',
    loadBanksError: 'No fue posible cargar la lista de bancos. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadNaturesError: 'No fue posible cargar las naturalezas de operación. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadExchangeTypesError: 'No fue posible cargar los tipos de cambio. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadCustomerDataError: 'No fue posible cargar el registro completo del cliente. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    bankAdded: '¡Banco agregado con éxito!',
    bankRemoveError: 'No fue posible quitar el banco. Recargue la página.',
    emailResentSuccess: 'Correo de ficha de registro reenviado',
    emailResentError: 'No fue posible reenviar el correo de acceso al cliente. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
    cannotMoveStatus: 'No es posible mover a este estado',
    editObservation: 'Editar observación',
    addObservation: 'Agregar observación',
    observation: 'Observación',
    integrationFallbackTitle: 'Integración bancaria no completada',
    integrationFallbackMsg: 'La integración bancaria no se completó. ¿Desea mantener el banco registrado por el flujo manual?',
    editPendency: 'Editar pendencia',
    finalizedApproved: 'Finalizado y Aprobado',
    rejectedRegistration: 'Registro Rechazado',
    inactiveRegistration: 'Registro Inactivado',
    validationCheckError: 'No pudimos verificar los datos del cliente. Revise el registro e intente de nuevo.',
    autoSaveError: 'Los cambios no fueron guardados. Verifique los campos e intente de nuevo.',
    saveBankError: 'El banco no fue guardado en el registro. Verifique los campos e intente de nuevo.',
    selectStatusLabel: 'Seleccione el estado deseado',
    selectStatusNoData: 'Seleccione un estado',
    additionalInfo: 'Información adicional'
  },

  customersAuthorizationBankBoard: {
    customersAuthorizationControlBankBoardUi: {
      resendToBank: 'Reenviar al banco'
    },
    integratedLabel: 'Integrado',
    customerIntegratedSuccess: '¡Cliente integrado con éxito!',
    updateBoardError: 'No fue posible actualizar el cuadro de bancos de clientes. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadError: 'No fue posible cargar los bancos de los clientes en análisis. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    changeStatusError: 'No fue posible cambiar el estado del banco del cliente. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    changeStatusAndRevertError: 'No fue posible cambiar el estado del banco del cliente y la tarjeta volvió a la columna anterior. Inténtelo de nuevo; si continúa, contacte al soporte.',
    saveLimitError: 'No fue posible guardar el límite del cliente. Verifique los valores e inténtelo de nuevo; si continúa, contacte al soporte.',
    limitAddedInOut: 'Límite agregado de {valueIn} (In) / {valueOut} (Out)',
    limitAdded: 'Límite agregado de {value}',
    observationSaved: '¡Observación guardada con éxito!',
    observationSaveError: 'No fue posible guardar la observación. Inténtelo de nuevo; si continúa, contacte al soporte.',
    pendingEmailSent: '¡Correo de pendencia de registro enviado con éxito!',
    pendingRegistered: '¡Pendencia registrada con éxito!',
    pendingRegisterError: 'No fue posible registrar la pendencia del banco. Verifique el texto de la pendencia e inténtelo de nuevo; si continúa, contacte al soporte.',
    emailResentError: 'No fue posible reenviar el correo de primer acceso. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
    resubmittedSuccess: 'Registro reenviado al banco con éxito',
    cannotMoveStatus: 'No es posible mover a este estado',
    observation: 'Observación',
    customerDataLoadError: 'Los datos del cliente no cargaron. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    emailResentSuccess: 'Correo de primer acceso reenviado',
    retryTosStartError: 'El reenvío al banco no comenzó. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
    retryTosSubmitError: 'El registro no fue reenviado al banco. Verifique las pendencias del cliente e inténtelo de nuevo.',
    editObservation: 'Editar observación',
    addObservation: 'Agregar observación',
    sendToIntegrationTitle: '¿Enviar para integración bancaria?',
    sendToIntegrationMsg: '¿Desea enviar el cliente para integración con {bankName}?',
    foreignCustomerTitle: 'Integración en línea no disponible',
    foreignCustomerMsg: 'El proceso de integración en línea no está disponible para clientes extranjeros. El registro se realizará por el flujo offline.',
    foreignCustomerOk: 'Entendido',
    integrationFallbackTitle: 'Integración bancaria no completada',
    integrationFallbackMsg: 'La integración bancaria no se completó. ¿Desea mantener el banco registrado por el flujo manual?',
    editPendency: 'Editar pendencia',
    rfiPendingFallback: 'Pendencia de compliance (RFI) a la espera de resolución.',
    bankRejectedFallback: 'El banco no aceptó el registro. Revise los datos y documentos del cliente.'
  },

  notificationHistory: {
    notificationBadgesUi: {
      externalOperation: 'Operación externa',
      customerOperation: 'Operación de cliente',
      signedForm: 'Ficha firmada',
      preSale: 'Preventa',
      signedRegistrationForm: 'Ficha de registro firmada',
      notification: 'Notificación',
      registrationSent: 'Registro enviado',
      registrationApproved: 'Registro aprobado',
      registrationPending: 'Registro pendiente',
      registrationFailed: 'Registro no completado',
      duimpUpdated: 'DUIMP actualizado',
      bankStatus: 'Estado bancario',
      limitIncrease: 'Aumento de límite',
      urgentCommission: 'Comisión urgente',
      duimpChargePending: 'Cobro de DUIMP detenido'
    },
    notificationHistoryUi: {
      searchLabel: 'Buscar en el mensaje',
      selectedCount: '{count} seleccionada | {count} seleccionadas',
      open: 'Abrir',
      noLinkedScreen: 'Sin pantalla vinculada'
    },
    loadError: 'No fue posible cargar el historial de notificaciones. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    deleteError: 'No fue posible eliminar la notificación. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
    emptyTitle: 'Ninguna notificación encontrada',
    emptyFilterSubtitle: 'Ningún registro corresponde a los filtros aplicados.',
    emptyDefaultSubtitle: 'Las notificaciones están disponibles por 30 días.',
    deleteMultipleError: 'No fue posible eliminar las notificaciones. Inténtelo de nuevo en unos instantes; si continúa, contacte al soporte.',
    markAsRead: 'Marcar como leída',
    markAsUnread: 'Marcar como no leída',
    statusRead: 'Leída',
    statusUnread: 'No leída',
    statusAll: 'Todas',
    statusUnreadPlural: 'No leídas',
    statusReadPlural: 'Leídas',
    summaryLoading: 'Cargando…',
    summaryNotification: 'notificación',
    summaryNotifications: 'notificaciones',
    summaryNoPending: 'ninguna pendiente',
    summaryUnread: 'no leída',
    summaryUnreadPlural: 'no leídas',
    markReadSingleError: 'No fue posible marcar la notificación como leída.',
    markUnreadSingleError: 'No fue posible marcar la notificación como no leída.',
    markReadMultipleError: 'No fue posible marcar las notificaciones como leídas.',
    markUnreadMultipleError: 'No fue posible marcar las notificaciones como no leídas.',
    period24h: 'Últimas 24h',
    period7days: 'Últimos 7 días',
    period30days: 'Últimos 30 días',
    colType: 'Tipo',
    colNotification: 'Notificación',
    colReceivedAt: 'Recibida el',
    colStatus: 'Estado'
  },

  customerDocumentsExternalAccess: {
    invalidToken: 'Token de acceso inválido o ausente.',
    loadError: 'No fue posible cargar los documentos del registro. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
  },

  interbanksControl: {
    title: 'Interbancario',
    boughtToday: 'Comprado en el día',
    soldToday: 'Vendido en el día',
    balance: 'Saldo',
    operationsTab: 'Operaciones realizadas',
    movementsTab: 'Movimientos',
    totalSelected: 'Total seleccionado',
    registerPurchase: 'Registrar compra',
    loadError: 'No fue posible cargar la lista de operaciones interbancarias. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    columns: {
      operationCode: 'Código de operación',
      meAmount: 'Cantidad ME',
      currency: 'Moneda',
      spot: 'Spot',
      actions: 'Acciones'
    },
    registerPurchaseModal: {
      title: 'Registrar compra',
      purchasedValue: 'Valor comprado',
      spot: 'SPOT',
      bank: 'Banco',
      save: 'Guardar',
      cancel: 'Cancelar'
    }
  },

  correspondentPreFormModal: {
    title: 'Nuevo corresponsal',
    pfDescription: 'Persona natural, titular de la cuenta',
    pjDescription: 'Empresas y CNPJ',
    internationalDescription: 'Agentes en el exterior',
    sendByEmail: 'Enviar por correo',
    submitSuccess: '¡Pre-registro enviado por correo con éxito!',
    submitError: 'No fue posible enviar el pre-registro del corresponsal por correo. Verifique los datos e inténtelo de nuevo; si continúa, contacte al soporte.'
  },

  correspondentIndicated: {
    title: 'Agente Indicador',
    modalTitle: 'Indicado',
    externalIdTooltip: 'Indicador importado con ID externo {id}',
    colName: 'Nombre',
    colFantasyName: 'Nombre de fantasía',
    colEmail: 'Correo',
    colState: 'Estado',
    colCity: 'Ciudad',
    colCreatedAt: 'Creado el',
    colActions: 'Acciones',
    loadError: 'No fue posible cargar los corresponsales indicados. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
  },

  correspondentCover: {
    sectionTitle: 'Datos de registro',
    internationalId: 'Documento de Identificación Internacional',
    legalName: 'Razón Social',
    name: 'Nombre',
    fantasyName: 'Nombre de fantasía',
    accessEmail: 'Correo de acceso',
    landline: 'Teléfono fijo',
    cellphone: 'Celular'
  },

  correspondentContactEmail: {
    sectionTitle: 'Correos operacionales',
    sectionRegister: 'Registro',
    sectionOperation: 'Operación',
    sectionDocumentation: 'Documentación',
    sectionFinancial: 'Financiero',
    firstEmail: 'Primer correo',
    secondEmail: 'Segundo correo',
    thirdEmail: 'Tercer correo'
  },

  correspondentPartnersShareholders: {
    sectionTitle: 'Socios y Accionistas',
    isLegalPerson: '¿Persona Jurídica?',
    legalName: 'Razón Social',
    name: 'Nombre',
    share: '% de participación'
  },

  correspondentAdministrative: {
    sectionTitle: 'Datos administrativos',
    operationTypes: 'Tipos de operación',
    tourismCommission: 'Comisión turismo(%)',
    remittanceCommission: 'Comisión remesa(%)',
    tourismBanks: 'Bancos cambio turismo',
    remittanceBanks: 'Bancos remesa internacional',
    loadExchangeTypesError: 'No fue posible cargar los tipos de cambio. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadBanksError: 'No fue posible cargar la lista de bancos. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
  },

  correspondentInternationalBank: {
    sectionTitle: 'Datos bancarios en el exterior',
    accountQuestion: '¿Desea registrar una cuenta en el exterior?',
    description: 'Cuentas usadas para recibir comisión en el exterior. Los datos siguen el mismo estándar de las cuentas del cliente.',
    addAccount: 'Agregar cuenta',
    emptyTitle: 'Ninguna cuenta en el exterior',
    emptySubtitle: 'Registre la cuenta del corban para recibir en el exterior.',
    confirmRemoveTitle: '¿Eliminar cuenta?',
    confirmRemoveText: 'La cuenta {name} se eliminará del registro al guardar.',
    removeAction: 'Eliminar',
    copySuffix: ' (copia)'
  },

  correspondentFinancial: {
    sectionTitle: 'Datos bancarios en Brasil',
    accountQuestion: '¿Desea registrar una cuenta en Brasil?'
  },

  notices: {
    audience: {
      ALL: 'Todos los usuarios',
      ADMIN: 'Administrativo',
      CORBAN: 'Corbans',
      CUSTOMER: 'Clientes'
    },
    status: {
      active: 'Activo',
      expired: 'Finalizado',
      cancelled: 'Cancelado'
    },
    control: {
      new: 'Nuevo informativo',
      search: 'Buscar',
      empty: 'Ningún informativo registrado.',
      corbanCount: '{count} corban | {count} corbans',
      requiresAck: 'Lectura obligatoria',
      cancel: 'Cancelar informativo',
      cancelTitle: '¿Cancelar informativo?',
      cancelText: 'El informativo "{title}" dejará de mostrarse a todos. Quien ya lo leyó sigue registrado.',
      published: 'Informativo publicado.',
      updated: 'Informativo actualizado.',
      cancelled: 'Informativo cancelado.',
      loadError: 'No fue posible cargar los informativos. Actualice la página e inténtelo de nuevo.',
      saveError: 'No fue posible guardar el informativo. Inténtelo de nuevo; si continúa, contacte al soporte.',
      columns: {
        title: 'Título',
        audience: 'Público',
        period: 'Período',
        requiresAck: 'Confirmación',
        status: 'Estado',
        reads: 'Lecturas',
        createdBy: 'Creado por',
        actions: 'Acciones'
      }
    },
    form: {
      newTitle: 'Nuevo informativo',
      editTitle: 'Editar informativo',
      publish: 'Publicar',
      title: 'Título',
      content: 'Contenido',
      contentRequired: 'Escriba el contenido del informativo.',
      audience: 'Mostrar a',
      corbans: 'Corbans específicos',
      corbansHint: 'Déjelo vacío para alcanzar a todos los corbans.',
      startsAt: 'Mostrar desde',
      endsAt: 'Mostrar hasta',
      requiresAck: 'Exigir confirmación de lectura',
      requiresAckHint: 'La pantalla queda bloqueada hasta que el usuario marque "Leído y enterado".',
      resetReads: 'Exigir nueva confirmación a quien ya lo leyó',
      required: 'Campo obligatorio',
      endsBeforeStart: 'La fecha final no puede ser anterior a la inicial.'
    },
    center: {
      acknowledge: 'Leído y enterado',
      markRead: 'Marcar como leído',
      remaining: '{count} informativo más espera su confirmación. | {count} informativos más esperan su confirmación.',
      ackError: 'No fue posible registrar la lectura. Inténtelo de nuevo.'
    }
  },

  correspondentDocuments: {
    sectionTitle: 'Documentos',
    saveFirst: 'Guarde el registro del corban para adjuntar documentos.',
    uploadLabel: 'Enviar un nuevo documento',
    uploadDefault: 'Elija un archivo o arrástrelo y suéltelo aquí',
    uploadSpecs: 'Formatos JPEG, PNG y PDF, hasta 10MB',
    descriptionLabel: 'Descripción (opcional)',
    send: 'Enviar',
    empty: 'Ningún documento adjunto a este corban.',
    columns: {
      name: 'Archivo',
      description: 'Descripción',
      size: 'Tamaño',
      sentAt: 'Enviado el',
      sentBy: 'Enviado por',
      actions: 'Acciones'
    },
    download: 'Descargar',
    remove: 'Eliminar',
    confirmRemoveTitle: '¿Eliminar documento?',
    confirmRemoveText: 'El archivo {name} se eliminará del registro del corban. Esta acción no se puede deshacer.',
    uploadSuccess: 'Documento enviado con éxito.',
    uploadError: 'No fue posible enviar el documento. Inténtelo de nuevo; si continúa, contacte al soporte.',
    loadError: 'No fue posible cargar los documentos del corban. Actualice la página e inténtelo de nuevo.',
    downloadError: 'No fue posible descargar el documento. Inténtelo de nuevo; si continúa, contacte al soporte.',
    removeSuccess: 'Documento eliminado.',
    removeError: 'No fue posible eliminar el documento. Inténtelo de nuevo; si continúa, contacte al soporte.'
  },

  customerPaymentAccounts: {
    loadBanksError: 'La lista de bancos no cargó. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    bankNotFound: 'Banco de integración no encontrado para esta cuenta.',
    syncSuccess: 'Cuenta de pago sincronizada con éxito',
    accountReactivated: 'Cuenta reactivada con éxito.',
    accountDeactivated: 'Cuenta desactivada con éxito.',
    toggleStatusError: 'El estado de la cuenta no fue cambiado. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    syncError: 'La cuenta de pago no fue sincronizada con el banco. Verifique los datos de la cuenta e inténtelo de nuevo.',
    deactivateButtonLabel: 'Inactivar'
  },

  bankContactEmail: {
    nothingToCopy: 'Nada para copiar: los campos de Persona Jurídica ya están completos.',
    emailsCopied: '{count} correo copiado de Persona Física. | {count} correos copiados de Persona Física.'
  },

  bankBrandAssets: {
    brandAssetValidationUi: {
      embeddedPage: 'contenido de página incrustado',
      eventHandler: 'acción al hacer clic o al abrir',
      scriptLink: 'enlace que ejecuta código',
      tooLarge: 'es demasiado grande: el límite es de {limit} caracteres. Use una versión optimizada del SVG',
      notSvg: 'debe ser un archivo SVG. Exporte la imagen en formato SVG y envíela nuevamente',
      forbiddenContent: 'tiene contenido que no está permitido en una imagen ({content}). Exporte el SVG nuevamente, sin scripts ni interacciones'
    },
    fileReadError: 'No fue posible leer el archivo seleccionado para {fieldLabel}.',
    validationError: '{fieldLabel} {error}.'
  },

  customerBankStatement: {
    noLimits: 'No hay límites registrados para este banco',
    noOperations: 'No hay operaciones realizadas para este banco',
    statementMenuLabel: 'Extracto de movimientos',
    statementTitle: 'Extracto de movimientos - {name} - {bank}',
    startDate: 'Fecha inicial',
    endDate: 'Fecha final',
    applyFilter: 'Aplicar filtro',
    limitAvailableIn: 'Límite disponible entrada',
    limitAvailableOut: 'Límite disponible salida',
    limitAvailable: 'Límite disponible',
    noData: 'No hay información',
    movementIn: 'Movimiento de entrada',
    movementOut: 'Movimiento de salida',
    colDate: 'Fecha',
    colLimitIn: 'Límite de entrada',
    colLimitOut: 'Límite de salida',
    colOperationAmount: 'Valor de operación ME',
    colMoveIn: 'Movimiento de entrada',
    colMoveOut: 'Movimiento de salida',
    colOperationCode: 'Código de operación',
    colActions: 'Acciones'
  },

  customerSummaryHeader: {
    copiedToClipboard: '¡Copiado al portapapeles!',
    copyError: 'No fue posible copiar. Seleccione el texto y cópielo manualmente (Ctrl+C).'
  },

  customerNationalBankModal: {
    editBankTitle: 'Editar cuenta bancaria en Brasil',
    addBankTitle: 'Agregar cuenta bancaria en Brasil',
    integratedAccountUpdates: 'Esta cuenta ya fue enviada a los proveedores. Si cambia la clave PIX, al guardar también se actualiza en ellos.',
    accountAddedPendingSave: 'Cuenta agregada. Guarde el cliente para confirmar.',
    accountSaveErrorFallback: 'La cuenta no fue guardada. Verifique los datos bancarios e intente de nuevo.'
  },

  bankAccountProviderSync: {
    savingWithProviders: 'Guardando la cuenta y enviándola a los proveedores…',
    saved: 'Cuenta guardada.',
    savedSuccess: 'Cuenta guardada con éxito.',
    sentTo: 'Enviada a {providers}.',
    and: 'y',
    providerIssue: '{provider}: {message}',
    sendFailed: 'no fue posible enviarla ahora.',
    inUseNow: 'Esta cuenta entró en una operación ahora y sigue como estaba en este proveedor. Cuando la operación termine, guarde la cuenta de nuevo para actualizar el proveedor.',
    replaceFailed: 'No fue posible cambiar la cuenta en este proveedor ahora, y sigue como estaba allí. Guarde la cuenta de nuevo para intentarlo otra vez.',
    notice: {
      in_progress: 'Cuenta guardada. El envío a los proveedores todavía está en curso; la situación aparece en la tarjeta en instantes.',
      unreachable: 'Cuenta guardada, pero no fue posible comunicarse con los proveedores ahora. Use "Sincronizar" en la tarjeta de la cuenta.'
    }
  },

  customerInternationalBankModal: {
    integratedAccountUpdates: 'Esta cuenta ya fue enviada a los proveedores. Si modifica los datos, al guardar también se actualiza en ellos.',
    requiredFieldsError: 'Hay campos obligatorios sin completar. Revise los campos en rojo.',
    accountSaveError: 'La cuenta no fue guardada. Verifique los datos bancarios e intente de nuevo.'
  },

  customerUpgradeRegistrationModal: {
    assetsRequired: 'El campo Patrimonio es obligatorio.',
    attachIrDocs: 'Adjunte el Recibo y la Declaración de IR para avanzar el registro.',
    confirmTitle: '¿Avanzar registro?',
    confirmMessage: '¿Desea avanzar el registro de este cliente a Persona Física Completo?',
    confirmButtonLabel: 'Avanzar registro',
    infoText: 'Para avanzar el expediente a Persona Física Completo, complete los datos a continuación.',
    patrimonyLabel: 'Patrimonio',
    motherNameLabel: 'Nombre de la madre',
    irReceiptDescription: 'Recibo de impuesto sobre la renta',
    progressionTitle: 'Progresión de registro',
    cancelLabel: 'Cancelar',
    documentsLabel: 'Documentos (obligatorio)',
    declarationIrLabel: 'Declaración de impuesto sobre la renta',
    loadingDocType: 'Cargando tipo del documento…'
  },

  customerUpgradeExchangeToBasicModal: {
    loadNaturesError: 'No fue posible cargar las naturalezas de operación. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.',
    attachAddressProof: 'Adjunte el Comprobante de domicilio para avanzar el registro.',
    confirmTitle: '¿Avanzar registro?',
    confirmMessage: '¿Desea avanzar el registro de este cliente a Persona Física Básico?',
    confirmButtonLabel: 'Avanzar registro',
    infoText: 'Para avanzar el expediente a Persona Física Básico, complete los datos a continuación.',
    documentsLabel: 'Documentos (obligatorio)',
    addressProofDescription: 'Comprobante de domicilio',
    progressionTitle: 'Progresión de registro',
    cancelLabel: 'Cancelar',
    loadingDocType: 'Cargando tipo del documento…'
  },

  correspondentSelect: {
    loadError: 'No fue posible cargar la lista de corresponsales. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
  },

  customerSpreads: {
    loadPartnerFeesError: 'No fue posible cargar la lista de spreads. Actualice la página (F5) e intente de nuevo; si continúa, hable con soporte.',
    loadCurrenciesError: 'No fue posible cargar la lista de monedas. Actualice la página (F5) e inténtelo de nuevo; si continúa, contacte al soporte.'
  },

  incomeTaxStatement: {
    generateError: 'No fue posible generar el extracto. Verifique el año y el modelo elegidos e inténtelo de nuevo; si continúa, contacte al soporte.',
    loadLayoutsError: 'No fue posible cargar los modelos de extracto. Actualice la página e inténtelo de nuevo; si continúa, contacte al soporte.',
    title: 'Extracto para Impuesto sobre la Renta',
    generateButton: 'Generar extracto',
    generateSuccess: 'Extracto generado y guardado en Documentos emitidos.',
    infoText: 'El extracto considera solo las operaciones liquidadas en el año elegido, agrupadas por banco.'
  },

  approvalTermsDialog: {
    versionMeta: 'Versión {version} · actualizado el {updatedAt}'
  },

  stablecoinLimitsDialog: {
    operation: 'Operación: #{operationId}'
  },

  partnerDialog: {
    partnerLinked: 'Socio vinculado a cliente existente',
    linkRemoved: 'Vínculo eliminado y datos limpiados.'
  },

  signatureCredentialsConfiguration: {
    defaultPlayerWarning: 'El player predeterminado ({defaultPlayer}) aún no tiene credenciales configuradas. Los envíos de fichas para firma no funcionarán hasta que sea configurado.'
  },

  documentGenerationStepper: {
    generateSuccess: '¡Documento generado con éxito!',
    generateError: 'No fue posible guardar el documento. Intente de nuevo.'
  },

  customerContactFormDialog: {
    contactUpdated: 'Contacto actualizado con éxito.',
    contactCreated: 'Contacto creado con éxito.',
    contactSaveError: 'No fue posible guardar el contacto. Verifique el nombre, correo y teléfono e intente de nuevo; si continúa, contacte al soporte.'
  },

  unblockOnboardingModal: {
    linkCopied: 'Enlace copiado'
  },

  customerStablecoinReceiver: {
    receiverSynced: 'Receiver sincronizado con éxito',
    loadReceiverError: 'El registro DolsPay del cliente no cargó. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
    syncError: 'El registro DolsPay no fue actualizado. Intente de nuevo en unos instantes; si continúa, contacte al soporte.'
  },

  bankDocumentsExternalAccess: {
    pageTitle: 'Documentos de la Operación',
    pageSubtitle: 'Seguimiento de documentos por el banco',
    downloadDuimpTooltip: 'Descargar documento DUIMP',
    rejectDuimpTitle: 'Rechazar DUIMP',
    pendingValidationTitle: 'Validación pendiente',
    loadError: 'No fue posible cargar la operación. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
    downloadError: 'No fue posible descargar el documento. Intente descargar de nuevo; si continúa, contacte al soporte.',
    duimpApproved: 'DUIMP {protocol} aprobada con éxito.',
    duimpApproveError: 'No fue posible aprobar la DUIMP. Intente de nuevo en unos instantes; si continúa, contacte al soporte.',
    duimpRejected: 'DUIMP {protocol} rechazada.',
    duimpRejectError: 'No fue posible rechazar la DUIMP. Intente de nuevo en unos instantes; si continúa, contacte al soporte.',
    confirmRejectButton: 'Confirmar rechazo',
    invalidLink: 'Enlace inválido o expirado',
    invalidLinkDesc: 'Este enlace ya no es válido. Solicite un nuevo enlace de acceso al equipo responsable.',
    operationTitle: 'Operación #{id}',
    creationDate: 'Fecha de creación',
    analyzeDuimpsHint: 'Analice las DUIMPs a continuación y registre su parecer',
    operationObservation: 'Observación de la operación',
    nature: 'Naturaleza',
    currency: 'Moneda',
    value: 'Valor',
    supplier: 'Proveedor',
    duimpStatus: 'Estado DUIMP',
    originDestination: 'Origen / Destino',
    latestClientUpdate: 'Última actualización del cliente',
    duimpAttached: 'DUIMP/DU-E adjunta',
    observation: 'Observación',
    duimpsSent: 'DUIMP/DU-E enviados',
    duimpsPendingValidation: 'Existen DUIMPs pendientes de validación',
    merchandiseStage: 'Etapa de la mercancía',
    newExpectedDate: 'Nueva fecha prevista',
    accessKey: 'Clave de acceso',
    sentAt: 'Enviado el',
    approveButton: 'Aprobar',
    rejectButton: 'Rechazar',
    historyButton: 'Historial',
    noDuimpsInformed: 'No se ha informado ninguna DUIMP.',
    documentApproved: 'Documento aprobado',
    documentRejected: 'Documento reprobado',
    noDocument: 'Sin doc.',
    invoicesTitle: 'Facturas',
    noInvoicesInformed: 'No se ha informado ninguna factura.',
    invoiceNumberLabel: 'Número',
    shippingForecastLabel: 'Previsión de embarque',
    noOperationDocuments: 'No se ha informado ningún documento de la operación.',
    complementaryDocumentsTitle: 'Documentos complementarios',
    rejectReasonPrompt: 'Informe el motivo del rechazo para la DUIMP {protocol}:',
    rejectReasonLabel: 'Motivo del rechazo',
    rejectReasonMinChars: 'Mínimo 20 caracteres',
    exitWithoutValidationPrompt: 'Todavía no aprobó ni rechazó todas las DUIMPs de esta operación. ¿Desea salir sin completar la validación?'
  },

  remittanceOperationReport: {
    sendToClientConfirmMsg: '¿Desea enviar al cliente?',
    sendToClientConfirmTitle: '¿Enviar al cliente?',
    whatsappConfirmMsg: '¿Desea enviar notificación por WhatsApp al cliente sobre la liquidación (SWIFT)?',
    whatsappConfirmTitle: '¿Notificar por WhatsApp?',
    cancelConfirmMsg: '¿Desea cancelar esta operación?',
    cancelConfirmTitle: '¿Cancelar operación?'
  },

  stablecoinRemittanceOperationReport: {
    sendToClientConfirmMsg: '¿Desea enviar al cliente?',
    sendToClientConfirmTitle: '¿Enviar al cliente?',
    whatsappConfirmMsg: '¿Desea enviar notificación por WhatsApp al cliente sobre la liquidación (SWIFT)?',
    whatsappConfirmTitle: '¿Notificar por WhatsApp?',
    emptyByClient: 'cerradas por el cliente',
    emptyByDesk: 'cerradas por la mesa',
    emptyMessage: 'No hay operaciones de Cambio Remesa {origin} para el período seleccionado.',
    noPayInFound: 'Ningún pago encontrado para esta operación.',
    loadPayInData: 'Los datos del pago no cargaron. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.'
  },

  exchangeOperationReport: {
    cancelConfirmMsg: '¿Desea cancelar esta operación?',
    cancelModalTitle: '¿Cancelar operación?',
    complementaryInfoTitle: 'Información complementaria',
    saveObservationError: 'No fue posible guardar la observación. Verifique los datos e intente de nuevo; si continúa, contacte al soporte.'
  },

  customerSendDocumentsModal: {
    cancelSendTitle: '¿Cancelar envío?'
  },

  duimpDueOperationReport: {
    sendToClientConfirmMsg: '¿Desea enviar al cliente?',
    sendToClientConfirmTitle: '¿Enviar al cliente?',
    cancelConfirmMsg: '¿Desea cancelar esta operación?',
    cancelConfirmTitle: '¿Cancelar operación?',
    noSolutionConfirmMsg: '¿Desea marcar esta operación como Sin Solución?',
    noSolutionConfirmTitle: '¿Sin Solución?',
    resendDocsConfirmMsg: '¿Desea reenviar los documentos de la operación al banco?',
    resendDocsConfirmTitle: '¿Reenviar documentos al banco?'
  },

  customerExchangeBanks: {
    sendToIntegrationMsg: '¿Desea enviar el cliente para integración con {bankName}?',
    sendToIntegrationTitle: '¿Enviar para integración bancaria?'
  },

  digitalRemittanceProfitCard: {
    grossProfit: 'Ganancia bruta',
    totalSpreadTooltip: 'Total del spread cobrado en la operación, antes de la división con el banco.',
    bankProfit: 'Ganancia bancaria:',
    operationalCost: 'Costo operacional',
    netProfit: 'Ganancia neta',
    commissions: 'Comisiones',
    corbanLabel: 'Corban – {percentage}',
    corbanMasterLabel: 'Corban master – {percentage}'
  },

  digitalRemittanceQuotationResult: {
    clientReceivesOnAccount: 'Llega a la cuenta',
    clientReceivesInWallet: 'El cliente recibe en la billetera',
    clientReceives: 'El cliente recibe',
    viewProgress: 'Ver avance',
    viewSentLink: 'Ver enlace enviado',
    sendLinkToClient: 'Enviar enlace al cliente',
    sendPayment: 'Enviar pago',
    generatePixCode: 'Generar código PIX',
    generatePaymentData: 'Generar datos de pago'
  },

  duimpExternalAccess: {
    pageSubtitle: 'Envío de documentos de Comex',
    allPendingTab: 'Todas las Pendencias',
    emptyPending: 'No se encontraron pendencias de DUIMP/DU-E.',
    welcomeModalTitle: 'Pendencia de DUIMP/DU-E',
    welcomeModalAlertTitle: 'Documentos de Comex pendientes',
    welcomeModalBody: 'Recibió este enlace porque hay documentos de Comex pendientes para regularización de su contrato de cambio. Para evitar nuevos cobros y mantener su operación al día, seleccione una de las opciones a continuación.',
    sendNowSubtitle: 'Enviar la DUIMP/DU-E ahora',
    loadError: 'No fue posible cargar pendencias. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.',
    invalidLink: 'Enlace inválido o expirado',
    invalidLinkDesc: 'Este enlace ya no es válido. Solicite un nuevo enlace de acceso al equipo responsable.',
    currentOperationTab: 'Operación Actual',
    currentOperationDocsTab: 'Documentos de la operación actual',
    natureza: 'Naturaleza',
    currency: 'Moneda',
    supplier: 'Proveedor',
    duimpStatus: 'Estado DUIMP',
    createdAt: 'Creación',
    delay: 'Retraso',
    haveAccessKey: 'Tengo la clave de acceso',
    dontHaveKey: 'Aún no tengo',
    informMerchandiseStage: 'Informar el estado de la mercancía',
    downloadError: 'No fue posible descargar el documento. Intente descargar de nuevo; si continúa, contacte al soporte.',
    noDocuments: 'No se encontraron documentos para esta operación.'
  },

  openOperationsReport: {
    chipBuy: 'Compra',
    chipSell: 'Venta',
    typeRemittanceBuy: 'Remesa de Compra',
    typeRemittanceSell: 'Remesa de Venta',
    typeBuyME: 'Compra de M.E.',
    typeSellME: 'Venta de M.E.',
    statusWaiting: 'Esperando',
    statusSendingFromWallet: 'Enviando desde billetera',
    statusWaitingPayment: 'Esperando Pago',
    statusBrlReceived: 'Reales Recibido',
    statusNotCompleted: 'No completado',
    noPayInFound: 'No se encontró ningún Pay In para esta preventa.',
    payinStatusPending: 'Pendiente',
    payinStatusProcessing: 'Esperando Pago',
    payinStatusReceived: 'Reales Recibido',
    payinStatusNotCompleted: 'No completado',
    payinStatusExpired: 'Expirado',
    payinStatusCancelled: 'Cancelado',
    payinStatusIgnored: 'Ignorado',
    payinStatusRefunded: 'Reembolsado',
    payinStatusOnHold: 'En Espera',
    payoutStatusPending: 'Pendiente',
    payoutStatusApprovalRequired: 'Aprobación Necesaria',
    payoutStatusApproved: 'Aprobado',
    payoutStatusProcessing: 'Procesando',
    payoutStatusCompleted: 'Liquidado',
    payoutStatusNotCompleted: 'No completado',
    payoutStatusCancelled: 'Cancelado',
    payoutStatusIgnored: 'Ignorado',
    payoutStatusRefunded: 'Reembolsado',
    payoutStatusOnHold: 'En Espera',
    pixExpired: 'Expirado',
    loadPayInData: 'Los datos del pago no cargaron. Actualice la página (F5) e intente de nuevo; si continúa, contacte al soporte.'
  },

  operationDocuments: {
    sectionTitle: 'Documentos de la operación'
  },

  stablecoinRemittanceOperationManagementReport: {
    profitColumnLabel: 'Ganancia {name}'
  },

  digitalRemittancePixScreen: {
    canCloseNowHint: 'Ya puede cerrar esta pantalla usando los botones de abajo.',
    valuePaid: 'Valor pagado',
    valueToPay: 'Valor a pagar',
    paymentConfirmed: '¡Pago confirmado con éxito!',
    pixExpiredFailed: 'PIX expirado — pago no confirmado.',
    paymentNotConfirmed: 'Pago no confirmado.',
    requoteHintPix: 'Haga clic en "Cotizar nuevamente" para generar un nuevo código PIX con la tasa actual.',
    requoteHintOther: 'Haga clic en "Cotizar nuevamente" para generar nuevos datos de pago con la tasa actual.',
    openBankAndPayPix: 'Abra su banco y pague con el código PIX a continuación.',
    copyPixCodeHint: 'O copie el código PIX:',
    copyButton: 'Copiar',
    copyPixTooltip: 'Copiar código PIX',
    pixCodeUnavailable: 'Código PIX no disponible',
    expirationNotAvailable: 'No disponible',
    expired: 'Expirado',
    paymentConfirmedTimer: 'Pago confirmado',
    pixExpiredTimer: 'PIX expirado',
    paymentNotConfirmedTimer: 'Pago no confirmado',
    waitingPaymentTimer: 'Esperando el pago',
    expiresIn: 'Expira en {time}',
    qrCodeGenerationError: 'El código QR del PIX no fue generado. Copie el código PIX a continuación y envíelo al cliente.',
    pixCopied: '¡Código PIX copiado al portapapeles!',
    pixCopyError: 'No fue posible copiar el código PIX. Intente copiar manualmente.'
  },

  digitalRemittancePixModal: {
    requoteButton: 'Cotizar nuevamente',
    sendPixWhatsAppTooltip: 'Enviar clave PIX al WhatsApp del cliente',
    pixWhatsAppSendSuccess: '¡PIX enviado al WhatsApp del cliente!',
    pixWhatsAppSendError: 'El PIX no fue enviado por WhatsApp. Copie el código PIX y envíelo al cliente por otro canal.',
    newOperationButton: 'Nueva operación',
    sendPixButton: 'Enviar PIX',
    goToOpenOperationsButton: 'Ir a pre-venta',
    paymentViaMethod: 'Pago vía {method}',
    paymentCompleted: '{title} — Completado'
  },

  digitalRemittanceSidebar: {
    summaryTitle: 'Resumen'
  },

  digitalRemittancePaymentInstruction: {
    dataGeneratingHint: 'Los datos de pago se están generando y aparecerán aquí en instantes.',
    accountTypeChecking: 'Corriente',
    accountTypeSavings: 'Ahorro',
    leadClabe: 'Transfiera por SPEI a la CLABE a continuación, desde la cuenta del propio cliente.',
    leadBankTransfer: 'Transfiera por Transfers 3.0 a la cuenta a continuación, desde el CUIT/CUIL del propio cliente.',
    leadCheckoutLink: 'Complete el pago por el enlace a continuación.',
    leadBankDetails: 'Realice una {method} a la cuenta a continuación e informe el código de referencia en la descripción de la transferencia.',
    leadDefault: 'Use los datos a continuación para pagar.',
    leadDebit: 'Débito automático: el valor se debita de la cuenta en EE. UU. que el cliente conectó y autorizó en el enlace.',
    fieldClabe: 'CLABE',
    fieldCbuCvu: 'CBU/CVU',
    fieldAccountType: 'Tipo de cuenta',
    fieldTaxId: 'CUIT del destinatario',
    fieldMemoCode: 'Código de referencia',
    memoRequiredLabel: 'Código de referencia (obligatorio)',
    memoWarning: 'Indique este código en la descripción de la transferencia. Sin él, el pago no se identifica y el monto se devuelve a la cuenta de origen.',
    fieldBankName: 'Banco',
    fieldRoutingNumber: 'Número de ruta',
    fieldAccountNumber: 'Número de cuenta',
    fieldBeneficiaryName: 'Beneficiario',
    fieldBeneficiaryAddress: 'Dirección del beneficiario',
    fieldBankAddress: 'Dirección del banco',
    fieldPaymentLink: 'Enlace de pago',
    copyTooltip: 'Copiar {label}',
    copiedSuccess: '{label} copiado.',
    copyError: 'No fue posible copiar. Seleccione el texto y copie manualmente.'
  },

  bankAccountCard: {
    accountDataCopied: 'Datos de la cuenta copiados.'
  },

  internationalBankAccountCard: {
    accountDataCopied: 'Datos de la cuenta copiados.'
  },

  wizardPjCustomer: {
    actionsUi: {
      next: 'Siguiente',
      finishRegistration: 'Finalizar registro'
    },
    steps: {
      registrationData: 'Datos de Registro',
      compliance: 'Compliance',
      bankingData: 'Datos Bancarios',
      documents: 'Documentos',
      partners: 'Socios',
      userAgreement: 'Acuerdo de Usuario'
    },
    missingDocsGeneric: 'Complete todos los documentos obligatorios de la empresa antes de continuar.',
    docAddressProof: 'Comprobante de domicilio de la empresa',
    docRevenue12m: 'Facturación de los últimos 12 meses',
    docDreOrPgdas: 'DRE o Recibo PGDAS',
    docCnpjCard: 'Tarjeta CNPJ',
    docSocialContract: 'Contrato social / Estatuto social',
    docBalanceOrPgdas: 'Balance o PGDAS (Declaración)',
    missingDocsList: 'Complete todos los documentos obligatorios de la empresa: {docs}.',
    fillRequiredBeforeContinue: 'Por favor, complete todos los campos obligatorios antes de continuar.',
    fillAddressBeforeContinue: 'Complete el domicilio de la empresa antes de continuar.',
    requireBrazilBankAccount: 'Es necesario registrar al menos una cuenta bancaria en Brasil.',
    partnerShareRequired: 'La participación total de los socios debe sumar 100% para continuar.',
    addOnePartnerWithData: 'Agregue al menos un socio y complete todos los datos obligatorios (nombre, documento, correo, celular, domicilio y, para persona física, fecha de nacimiento).',
    addOnePartner: 'Agregue al menos un socio con todos los datos obligatorios completados.',
    partnerShareRequiredFinish: 'La participación total de los socios debe sumar 100% para finalizar el registro.',
    fillPartnerDataRequired: 'Complete todos los datos obligatorios de cada socio (nombre, documento, correo, celular, domicilio y, para persona física, fecha de nacimiento).',
    fillRequiredBeforeFinish: 'Por favor, complete todos los campos obligatorios antes de finalizar.'
  },

  formCurrency: {
    currencyLiquidationConfigUi: {
      title: 'Horarios de liquidación por banco',
      subtitle: 'Definí el horario límite de liquidación para cada banco activo. Todos los bancos deben estar configurados antes de guardar.',
      bulkFillTitle: 'Completar todos los bancos',
      sell: 'Venta',
      buy: 'Compra',
      applyToAll: 'Aplicar a todos',
      bulkFillHint: 'Los horarios ingresados van a sobrescribir los valores ya completados en todos los bancos.',
      emptyState: 'No se encontró ningún banco activo. La moneda se va a crear sin configuración de horarios.'
    }
  },

  supportWidget: {
    supportWidgetHostUi: {
      panelLabel: 'Soporte',
      frameTitle: 'Soporte'
    },
    supportWidgetLauncherUi: {
      open: 'Abrir el soporte',
      dismiss: 'Ocultar el soporte'
    }
  },

  backendErrors: {
    ERR_AUTH_001: 'Usuario o contraseña inválidos',
    ERR_AUTH_002: 'Sesión finalizada. Inicie sesión nuevamente para continuar',
    ERR_AUTH_003: 'Demasiados intentos de acceso. Espere unos minutos antes de intentar nuevamente',
    ERR_AUTH_004: 'Usted no tiene permiso para realizar esta acción',
    ERR_AUTH_005: 'Se requiere autenticación. Inicie sesión para continuar',
    ERR_AUTH_006: 'No fue posible ingresar con {provedor}. Intente nuevamente',
    ERR_AUTH_007: 'Se agotó el tiempo para vincular la cuenta. Haga clic en Iniciar sesión con {provedor} nuevamente',
    ERR_AUTH_008: 'Esta cuenta de {provedor} ya está vinculada a otro acceso. Ingrese con su e-mail y contraseña o use otra cuenta de {provedor}',
    ERR_AUTH_009: 'El ingreso con {provedor} no está disponible en este momento. Use su e-mail y contraseña',
    ERR_AUTH_010: 'No encontramos esa cuenta vinculada. Actualice la página e intente nuevamente',
    ERR_AUTH_011: 'Este acceso abre solo la ficha de registro. Para continuar, use el enlace enviado a su correo electrónico',
    ERR_AUTH_012: 'Este enlace ya no es válido o está incompleto. Pida un nuevo enlace a quien se lo envió',
    ERR_AUTH_013: 'Contraseña actual incorrecta',
    ERR_FX_001: 'Operación no encontrada. Verifique el número de la operación',
    ERR_FX_002: 'Monto fuera de los límites permitidos para su cuenta. Verifique los límites mínimo y máximo disponibles',
    ERR_FX_003: 'Cotización vencida. Solicite una nueva cotización para continuar',
    ERR_FX_004: 'Monto inválido. Verifique el monto indicado e intente nuevamente',
    ERR_FX_005: 'No se encontró un documento obligatorio. Verifique los archivos adjuntos de la operación',
    ERR_FX_006: 'Esta forma de pago no está disponible para esta operación en este momento. Pruebe otra opción',
    ERR_FX_007: 'Modelo de documento no disponible para esta operación. Comuníquese con el soporte técnico',
    ERR_FX_008: 'Festivo no encontrado. Es posible que haya sido eliminado; actualice la página e intente de nuevo.',
    ERR_FX_009: 'Moneda no encontrada. Actualice la página e intente de nuevo.',
    ERR_FX_010: 'El estado de esta operación viene del banco integrado. Use Resincronizar estado para actualizar.',
    ERR_FX_011: 'Esta operación está en el banco integrado y no puede cancelarse desde aquí. Use Resincronizar estado para ver el estado en el banco.',
    ERR_FX_012: 'Esta operación ya fue enviada al banco integrado y no puede editarse. Use Resincronizar estado para ver el estado en el banco.',
    ERR_FX_013: 'La cuenta en el exterior elegida no está aprobada en este banco. Elija una cuenta aprobada.',
    ERR_FX_014: 'La naturaleza elegida todavía no está integrada con este banco. Elija una naturaleza integrada.',
    ERR_FX_015: 'Este banco no tiene la operación integrada. Elija un banco integrado para enviar la operación.',
    ERR_FX_016: 'Elija una cotización del banco antes de guardar la operación.',
    ERR_FX_017: 'La cotización del banco venció. Actualice la cotización y guarde de nuevo.',
    ERR_FX_018: 'Elija la cuenta en el exterior de quien va a pagar esta operación.',
    ERR_FX_019: 'Elija la cuenta en el exterior que va a recibir esta operación.',
    ERR_FX_020: 'Elija la cuenta del cliente en Brasil para esta operación.',
    ERR_FX_021: 'Esta operación no fue enviada a un banco integrado.',
    ERR_FX_022: 'Solo las operaciones con envío al banco no concluido pueden reenviarse al banco.',
    ERR_FX_023: 'Esta operación solo podía reenviarse al banco el día en que fue creada. Cancele la operación y cree otra.',
    ERR_FX_024: 'El banco todavía no tiene registro de esta operación. Reenvíela al banco.',
    ERR_FX_025: 'El documento del banco todavía no fue descargado. Intente de nuevo en unos minutos.',
    ERR_FX_026: 'Este plazo de liquidación no está disponible en el banco ahora. Elija otro plazo.',
    ERR_SC_001: 'Registro de DolsPay no encontrado. Verifique su registro o inicie una nueva activación',
    ERR_SC_002: 'Su registro de DolsPay todavía está en análisis. Siga el estado en la pantalla de registro',
    ERR_SC_003: 'Billetera digital no encontrada. Verifique su registro o ingrese a la pantalla de activación',
    ERR_SC_004: 'Billetera digital inactiva. Ingrese a la pantalla de registro para verificar el estado',
    ERR_SC_005: 'La cuenta bancaria elegida no se encontró en el registro del cliente. Recargue la página y seleccione la cuenta nuevamente',
    ERR_SC_006: 'Pago no encontrado. Verifique el historial de pagos',
    ERR_SC_007: 'Transferencia no encontrada. Verifique el historial de transferencias',
    ERR_SC_008: 'Cotización vencida. Solicite una nueva cotización para continuar',
    ERR_SC_009: 'Monto fuera de los límites permitidos para esta operación. Verifique los límites disponibles',
    ERR_SC_010: 'El servicio de pago no está disponible en este momento. Espere unos minutos e intente nuevamente. Si el problema continúa, comuníquese con soporte e indique la referencia',
    ERR_SC_011: 'En este momento no hay un proveedor disponible para esta operación. Intente nuevamente más tarde o comuníquese con soporte',
    ERR_SC_012: 'DolsPay todavía no está activo para su cuenta. Complete el registro para habilitar esta función',
    ERR_SC_013: 'Cotización no encontrada. Genere una nueva cotización para continuar',
    ERR_SC_014: 'Esta cotización no es compatible con la operación solicitada. Genere una nueva cotización',
    ERR_SC_015: 'Esta cotización ya no está disponible. Genere una nueva cotización para continuar',
    ERR_SC_016: 'Monto inferior al mínimo permitido para transferencias en EUR. Aumente el monto e intente nuevamente',
    ERR_SC_017: 'Cuenta en EUR no aprobada. Registre una cuenta SEPA y espere su aprobación para operar en EUR',
    ERR_SC_018: 'La descripción es obligatoria para transferencias wire. Complete el campo de descripción e intente nuevamente',
    ERR_SC_019: 'No se indicó el documento de transacción obligatorio. Complete todos los campos e intente nuevamente',
    ERR_SC_020: 'Registro ya aprobado y activo. No es necesaria ninguna acción',
    ERR_SC_021: 'Ya existe una solicitud de aumento de límite en análisis. Espere a que finalice antes de enviar una nueva',
    ERR_SC_022: 'No se encontró documentación pendiente. Su registro está al día',
    ERR_SC_023: 'Spread no encontrado. Actualice la página y elija otro',
    ERR_SC_024: 'Servicio temporalmente no disponible. Intente nuevamente en unos instantes',
    ERR_SC_025: 'Solicitud rechazada por motivos de seguridad. Intente nuevamente o genere una nueva solicitud',
    ERR_SC_026: 'Datos del socio incompletos. Verifique el nombre y el porcentaje de participación',
    ERR_SC_027: 'No fue posible enviar el archivo. Verifique su conexión e intente nuevamente',
    ERR_SC_028: 'La transacción en la red no se completó. Verifique el estado de la operación e intente nuevamente',
    ERR_SC_029: 'Socio no vinculado a un registro. Vincule el socio al registro antes de continuar',
    ERR_SC_030: 'Fecha de nacimiento del socio no registrada. Complete la fecha de nacimiento antes de continuar',
    ERR_SC_031: 'CPF del socio no registrado. Complete el CPF antes de continuar',
    ERR_SC_032: 'Domicilio del socio no registrado. Complete el domicilio antes de continuar',
    ERR_SC_033: 'Se solicitó documentación adicional. Ingrese a la pantalla de registro para enviar los documentos pendientes',
    ERR_SC_034: 'La foto del documento no tiene la calidad suficiente. Tome una nueva foto con buena iluminación, sin reflejos y con el documento completo visible',
    ERR_SC_035: 'El documento enviado no es legible. Tome una nueva foto en alta resolución, sin sombras y con todos los datos visibles',
    ERR_SC_036: 'La selfie no coincide con el documento enviado. Tome una nueva selfie en un lugar iluminado, sin anteojos de sol y con el rostro centrado',
    ERR_SC_037: 'No se pudo verificar el documento enviado. Asegúrese de enviar el documento original, sin ediciones ni copias de imágenes',
    ERR_SC_038: 'El banco digital no recibió el archivo. Envíelo nuevamente en formato JPG, PNG o PDF (hasta 3MB)',
    ERR_SC_039: 'Formato de archivo no aceptado por el banco digital. Envíelo en JPG, PNG o PDF',
    ERR_SC_040: 'El archivo supera el tamaño aceptado. Envíe el documento en JPG, PNG o PDF de hasta 3MB',
    ERR_SC_041: 'El enlace del archivo no es válido. Vuelva a subir el documento e intente otra vez',
    ERR_SC_042: 'El banco digital no pudo acceder a los archivos. Envíe los documentos nuevamente en JPG, PNG o PDF',
    ERR_SC_043: 'El comprobante de domicilio fue rechazado. Envíe un documento reciente (últimos 3 meses), legible y con el mismo domicilio registrado',
    ERR_SC_044: 'El documento de identidad enviado está vencido. Envíe un documento vigente (RG, CNH o Pasaporte)',
    ERR_SC_045: 'El e-mail indicado no es válido o no puede recibir mensajes. Actualice el e-mail en el registro e intente nuevamente',
    ERR_SC_046: 'Los documentos enviados no pasaron la verificación automática. Revise la identidad, el comprobante de domicilio y la selfie — todos deben estar legibles y actualizados',
    ERR_SC_047: 'CPF o CNPJ inválido para el banco digital. Verifique que el número esté correcto en el registro',
    ERR_SC_048: 'Debe aceptar los términos de uso antes de continuar. Ingrese a la pantalla de registro para aceptar los términos',
    ERR_SC_049: 'El banco digital no aceptó los datos de la cuenta bancaria. Verifique los datos indicados e intente nuevamente',
    ERR_SC_050: 'Se detectó una foto de pantalla en lugar del documento original. Fotografíe el documento directamente, sin sacar una foto del monitor o de una imagen',
    ERR_SC_051: 'Se detectó una copia de una foto del documento. Envíe una foto original y directa del documento, sin fotografiar otra foto o una impresión',
    ERR_SC_052: 'No se envió el dorso del documento. Envíe el frente y el dorso del documento de identidad',
    ERR_SC_053: 'El tipo de documento seleccionado no corresponde al documento enviado. Verifique que haya seleccionado el tipo correcto (RG, CNH o Pasaporte)',
    ERR_SC_054: 'La selfie no fue aprobada. Tome una nueva selfie en un lugar bien iluminado, sin anteojos de sol, con el rostro centrado y cerca de la cámara',
    ERR_SC_055: 'El nombre en el documento no coincide con el nombre registrado. Verifique que el nombre sea exactamente igual al que figura en el documento',
    ERR_SC_056: 'La fecha de nacimiento en el documento no coincide con la registrada. Corrija la fecha de nacimiento en el registro',
    ERR_SC_057: 'No se identificó la fecha de emisión del documento. Envíe un documento con la fecha de emisión visible',
    ERR_SC_058: 'El teléfono indicado no es válido. Indique el número completo con código de país y código de área (ejemplo: +55 11 99999-9999)',
    ERR_SC_059: 'El proveedor de pago rechazó los datos de la operación. Revise los campos e intente nuevamente. Si el problema persiste, comuníquese con soporte e indique el código de referencia',
    ERR_SC_060: 'A la cuenta bancaria le faltan datos obligatorios. Abra el registro de la cuenta, complete los campos indicados y sincronice nuevamente',
    ERR_SC_061: 'Este método de pago no está disponible en este proveedor. Abra el registro de la cuenta y elija otro método',
    ERR_SC_062: 'Para la selfie y el documento de identidad, envíe una foto en JPG o PNG. No se acepta PDF para este tipo de documento',
    ERR_SC_063: 'La clave PIX indicada no es válida. Verifique que esté activa en el banco y que se haya escrito sin espacios',
    ERR_SC_064: 'Este número de ruta (ABA) no acepta transferencias wire. Confirme con el banco el ABA para wire, que suele ser distinto del que se usa para ACH',
    ERR_SC_065: 'Para una cuenta del propio titular, el nombre del beneficiario debe ser igual al nombre del cliente. Corrija el nombre en el registro de la cuenta',
    ERR_SC_066: 'El monto de esta operación supera el límite permitido por operación. Reduzca el monto o divídalo en más de una operación',
    ERR_SC_067: 'El monto mínimo por operación es de US$ 20,00, o su equivalente en la moneda de envío. Aumente el monto e intente nuevamente',
    ERR_SC_068: 'Este proveedor no está disponible en este momento. Use otro corredor o comuníquese con soporte',
    ERR_SC_069: 'Este proveedor no está aceptando operaciones nuevas en este momento',
    ERR_SC_070: 'Este proveedor no opera este corredor en este momento',
    ERR_SC_072: 'Este proveedor cotiza según el monto enviado. Indique el monto en reales para usar este corredor',
    ERR_SC_073: 'El cliente todavía no tiene un registro aprobado en este proveedor',
    ERR_SC_074: 'El registro del cliente está bloqueado por compliance en este proveedor',
    ERR_SC_075: 'El cliente no tiene una billetera activa en este proveedor',
    ERR_SC_101: 'Para operar solo de entrada o solo de salida, el cliente necesita su propia billetera digital, y todavía no la tiene. Comuníquese con soporte para crearla',
    ERR_SC_076: 'Esta cuenta todavía no está habilitada para recibir pagos. Sincronice la cuenta en Canales bancarios, en el registro del cliente',
    ERR_SC_077: 'El spread seleccionado no está registrado en este proveedor. Sincronice los spreads o elija otro',
    ERR_SC_078: 'El proveedor indicado para este monto no puede atender a este cliente. Ajuste el registro o comuníquese con soporte antes de continuar',
    ERR_SC_079: 'Esta forma de pago está en etapa de pruebas. Verifique los datos de la operación antes de confirmar',
    ERR_SC_080: 'El proveedor preferido de este corredor no pudo atender, y la operación continúa con el alternativo. Verifique el proveedor antes de confirmar',
    ERR_SC_081: 'No fue posible estimar el monto en dólares. Los límites del corredor se verificarán en la cotización',
    ERR_SC_082: 'El proveedor fijo de este cliente no pudo atender esta operación, que continúa según la regla del corredor. Verifique el registro del cliente en ese proveedor',
    ERR_SC_083: 'Desactivar la integración del proveedor también detiene los jobs y los webhooks de las operaciones en curso. Confirme la acción para continuar',
    ERR_SC_084: 'El sistema todavía no sabe ejecutar este corredor en este proveedor. Debe implementarse antes de habilitarse',
    ERR_SC_085: 'Describa por qué existe esta regla. Esa descripción es la que explica después la elección del proveedor',
    ERR_SC_086: 'Indique los proveedores de la regla en orden, cada uno una sola vez. Una regla con un solo proveedor debe quedar sin alternativa',
    ERR_SC_087: 'El rango de montos se superpone con otra regla de la misma ruta. Ajuste los límites antes de guardar',
    ERR_SC_088: 'Indique el motivo del proveedor fijo para este cliente',
    ERR_SC_089: 'Elija un proveedor integrado al sistema para que sea el proveedor fijo de este cliente',
    ERR_SC_090: 'Los nuevos registros están pausados en este proveedor en este momento. Intente nuevamente más tarde o comuníquese con soporte',
    ERR_SC_091: 'Un proveedor de esta regla todavía no tiene esta forma de pago activada. La regla empezará a aplicarse a ese proveedor cuando se active el pago',
    ERR_SC_092: 'Este proveedor ofrece esta forma de pago solo para otro tipo de cliente (persona física o jurídica)',
    ERR_SC_093: 'Indique el tipo de cliente como individual (persona física) o business (persona jurídica), o déjelo vacío para que aplique a todos',
    ERR_SC_094: 'Este proveedor no pudo cotizar esta operación, y esta continuó con el siguiente, si lo había',
    ERR_SC_133: 'El proveedor de pago no aceptó esta operación en este momento. Vuelva a cotizar: la operación continúa con otro proveedor, si lo hay',
    ERR_SC_134: 'Este proveedor no aceptó hace poco una operación con esta forma de pago y queda excluido por algunos minutos. La operación continúa con el siguiente, si lo hay',
    ERR_SC_135: 'El registro del cliente fue aprobado en este proveedor, pero esta forma de pago aún no fue habilitada para él',
    ERR_SC_136: 'Esta cuenta está en una operación en curso. Modifique sus datos cuando la operación termine',
    ERR_SC_137: 'Esta cuenta vino del proveedor con el número enmascarado. Para modificar los datos, ingrese el número completo de la cuenta',
    ERR_SC_138: 'PDF protegido en: {documents}. El banco asociado no acepta PDF con contraseña o bloqueado. Abra el archivo, use Imprimir > Guardar como PDF y adjunte la copia nueva',
    ERR_SC_139: 'El banco asociado no aceptó el archivo de: {documents}. Genere el archivo de nuevo (Imprimir > Guardar como PDF) o envíelo en JPG o PNG',
    ERR_SC_140: 'El débito automático no está disponible para este registro. Pague por transferencia',
    ERR_SC_141: 'Elija la cuenta que va a pagar o conecte una cuenta en EE. UU. a su nombre',
    ERR_SC_142: 'Marque la autorización del débito para continuar',
    ERR_SC_143: 'Su banco no autorizó el débito y no salió ningún valor de su cuenta. Intente con otra cuenta o pague por transferencia',
    ERR_SC_144: 'Para depositar en esta moneda, registre antes una cuenta suya en el país de esa moneda. El depósito debe salir de una cuenta a su nombre',
    ERR_SC_145: 'La cuenta elegida no es suya o no es de esta moneda. Elija otra cuenta para depositar',
    ERR_SC_146: 'Cuenta en libras no aprobada. Registre una cuenta Faster Payments y espere su aprobación para enviar libras',
    ERR_SC_147: 'Pagar en esta moneda no está disponible por el momento. Por ahora, solo se puede enviar al destinatario',
    ERR_SC_148: 'Esta acción no está disponible para esta institución. Actualice la pantalla e intente de nuevo',
    ERR_SC_149: 'Este campo se corrige en la ficha del cliente. Use el botón Completar en la ficha',
    ERR_SC_150: 'Confirme con el código que enviamos a su correo electrónico',
    ERR_SC_151: 'No pudimos leer este código de pago. Revise el código e intente de nuevo',
    ERR_SC_152: 'Este código ya fue pagado o venció y ya no se puede pagar. Pida al emisor un código actualizado',
    ERR_SC_153: 'Este boleto vence antes del próximo día hábil y ya no se puede pagar a tiempo. Pida al emisor un boleto actualizado',
    ERR_SC_154: 'Este código Pix no tiene un valor definido. Pida al destinatario un código Pix con el valor',
    ERR_SC_155: 'Este tipo de cuenta todavía no se puede pagar con la app. Puede pagar boleto, cuentas de servicios, impuestos y Pix copia y pega',
    ERR_SC_156: 'Este spread está fuera del rango permitido para el corresponsal. Elija otro spread e inténtelo de nuevo.',
    ERR_SC_095: 'El servicio de pago no aceptó los datos de esta operación y no informó el motivo. Verifique el monto, la moneda y la cuenta elegida. Si son correctos, comuníquese con soporte e indique la referencia; repetir sin cambiar nada no lo resuelve',
    ERR_SC_096: 'Para pagar en esta moneda, el registro del cliente necesita el documento fiscal del país del pago (en Argentina, el CUIT/CUIL). Inclúyalo en Domicilio fiscal, en el registro del cliente',
    ERR_SC_097: 'Si el pago es en otra moneda, indique el monto en la moneda del pago',
    ERR_SC_106: 'Para un banco en la India, indique el código IFSC de la sucursal: 11 caracteres, como ICIC0005023 (4 letras del banco, un cero y 6 de la sucursal)',
    ERR_SC_102: 'En el pago solo de salida, indique el monto en dólares o en la moneda de destino',
    ERR_SC_103: 'El saldo de la billetera del cliente no cubre este pago. Reduzca el monto o haga antes un ingreso en la pestaña Pay-in',
    ERR_SC_098: 'El monto mínimo para operaciones en euros es de R$ 120,00',
    ERR_SC_099: 'Para pagar en pesos colombianos, registre la cuenta bancaria del cliente en Colombia, con cédula (CC) o NIT, y un celular colombiano (+57) en el registro del cliente',
    ERR_SC_100: 'La cuenta bancaria elegida no está habilitada para operaciones en stablecoin. Recargue la página y seleccione la cuenta nuevamente; si el problema continúa, sincronice la cuenta en la pestaña Canales bancarios del cliente',
    ERR_SC_104: 'La billetera digital de este registro todavía no está lista para esta operación. Comuníquese con atención al cliente',
    ERR_SC_130: 'Estamos preparando la billetera digital del cliente. Esto puede tardar algunos segundos. Intente nuevamente en unos instantes',
    ERR_SC_107: 'Indique un e-mail válido en el registro del cliente para que podamos crear su billetera digital',
    ERR_SC_108: 'Este enlace ya no es válido. Si todavía necesita hacer esta operación, comuníquese con quien le envió el enlace',
    ERR_SC_128: 'Este cliente ya generó el PIX de otra operación en las últimas 24 horas. Verifíquelo antes de enviar otro enlace',
    ERR_SC_129: 'El cliente ya generó el PIX de este enlace. Espere el pago o el vencimiento del PIX para reenviar el enlace',
    ERR_SC_132: 'Ya le enviamos un enlace a este cliente. Enviar otro cancela el anterior',
    ERR_SC_109: 'Apruebe la operación antes de generar el PIX',
    ERR_SC_110: 'No pudimos confirmar su aprobación. Haga clic en Aprobar para intentar nuevamente',
    ERR_SC_111: 'El saldo de la billetera es menor que el monto de esta operación. Comuníquese con atención al cliente',
    ERR_SC_112: 'Demasiados intentos seguidos. Espere unos minutos e intente nuevamente',
    ERR_SC_113: 'Esta operación ya fue aprobada. Ahora solo falta pagar el PIX',
    ERR_SC_114: 'Este cliente aprueba las operaciones desde su propia billetera. Envíele el enlace de la operación',
    ERR_SC_115: 'No pudimos consultar la red en este momento. Intente nuevamente en unos minutos',
    ERR_SC_116: 'La cotización se actualizó. Verifique los nuevos montos antes de aprobar',
    ERR_SC_117: 'Esta operación no puede aprobarse desde el enlace en este momento. Comuníquese con atención al cliente',
    ERR_SC_118: 'Verifique el e-mail: debe ser el mismo del registro',
    ERR_SC_119: 'Este cliente aprueba las operaciones desde su propia billetera digital, que está vinculada al e-mail actual. Para cambiar el e-mail, comuníquese con soporte',
    ERR_SC_120: 'Toda operación la aprueba el cliente en el enlace de la operación. Envíele el enlace',
    ERR_SC_121: 'Monto inferior al mínimo para esta forma de cobro. Aumente el monto e intente nuevamente',
    ERR_SC_122: 'Autorice el pago en su billetera con el código enviado a su e-mail para continuar',
    ERR_SC_123: 'La autorización de su billetera no coincide con este pago. Haga una nueva cotización y autorice nuevamente',
    ERR_SC_124: 'La autorización de su billetera todavía se está confirmando. Espere algunos segundos e intente nuevamente',
    ERR_SC_125: 'Este pago ya fue enviado o se está procesando. Siga su avance antes de intentar nuevamente',
    ERR_SC_126: 'Estamos preparando su billetera para el envío. Espere algunos segundos e intente nuevamente',
    ERR_SC_127: 'No fue posible preparar su billetera en este momento. Intente nuevamente en unos minutos',
    ERR_SC_105: 'La preventa de esta operación ya no está disponible. Genere una nueva cotización para continuar',
    ERR_VAL_001: 'Hay campos obligatorios sin completar. Verifique y complete toda la información solicitada',
    ERR_VAL_002: 'Datos con formato incorrecto. Verifique la información y corríjala antes de continuar',
    ERR_VAL_003: 'No fue posible completar el registro con los datos indicados. Verifique la información e intente nuevamente',
    ERR_VAL_004: 'CPF inválido. Verifique los dígitos e intente nuevamente',
    ERR_VAL_005: 'CNPJ inválido. Verifique los dígitos e intente nuevamente',
    ERR_VAL_006: 'Formato de archivo no aceptado. Envíe un archivo JPG, PNG o PDF',
    ERR_VAL_007: 'Archivo demasiado grande. El tamaño máximo permitido es 5MB',
    ERR_VAL_008: 'Elemento no encontrado. Verifique los datos indicados e intente nuevamente',
    ERR_VAL_009: 'Este elemento ya está registrado. Verifique si ya existe un registro con esos datos',
    ERR_VAL_010: 'Tipo de documento no reconocido. Envíe un documento de identidad (frente o dorso), una selfie, un comprobante de domicilio o el contrato social',
    ERR_VAL_011: 'No se envió ningún archivo. Adjunte el documento e intente nuevamente',
    ERR_VAL_012: 'Para clientes de Brasil, indique un CPF (11 dígitos) o un CNPJ (14 dígitos)',
    ERR_VAL_013: 'Esta clave PIX ya está registrada para este cliente. Elimine la cuenta existente o use otra clave PIX',
    ERR_VAL_014: 'Solo se pueden reactivar registros inactivados o rechazados. Actualice la página para ver el estado actual del cliente',
    ERR_VAL_015: 'Elija a qué estado vuelve el registro: Finalizado o Registro en análisis',
    ERR_VAL_016: 'Indique el motivo de la reactivación. Queda guardado en el historial del cliente',
    ERR_VAL_017: 'Demasiadas búsquedas seguidas. Espere unos segundos e intente nuevamente',
    ERR_VAL_018: 'El CUIT/CUIL informado en Domicilio fiscal (Argentina) no es válido. Revise los 11 dígitos en el documento del cliente',
    ERR_VAL_019: 'El cobro de esta Invoice ya fue enviado hoy. Puede reenviarlo a partir de mañana',
    ERR_VAL_020: 'La plantilla del correo de cobro de DUIMP está desactivada en Configuraciones. Active la plantilla e inténtelo de nuevo',
    ERR_EXT_001: 'Servicio temporalmente no disponible. Espere unos instantes e intente nuevamente',
    ERR_EXT_002: 'La operación tardó más de lo esperado. Verifique su conexión e intente nuevamente',
    ERR_EXT_003: 'No fue posible completar el registro en este momento. Espere unos minutos e intente nuevamente',
    ERR_EXT_004: 'No fue posible procesar el pago en este momento. Verifique su historial antes de intentar nuevamente',
    ERR_EXT_005: 'Servicio no disponible por un problema de configuración. Comuníquese con el soporte técnico',
    ERR_EXT_006: 'La institución no aceptó la respuesta. Revise los campos indicados y envíe de nuevo',
    ERR_INT_001: 'No fue posible procesar la solicitud en este momento. Intente nuevamente y, si el problema persiste, comuníquese con soporte',
    ERR_INT_002: 'No fue posible completar la acción porque este elemento está vinculado a otros registros (por ejemplo, operaciones o cuentas). Ajuste o elimine esos vínculos antes',
    ERR_INT_003: 'El sistema presenta inestabilidad para acceder a los datos. Espere unos instantes e intente nuevamente',
    ERR_INT_004: 'La búsqueda tardó demasiado en responder. Pruebe con un período o filtro más acotado, o espere unos instantes e intente nuevamente'
  }
};
